module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "fb15");
/******/ })
/************************************************************************/
/******/ ({

/***/ "00ee":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

module.exports = String(test) === '[object z]';


/***/ }),

/***/ "0366":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");
var aCallable = __webpack_require__("59ed");
var NATIVE_BIND = __webpack_require__("40d5");

var bind = uncurryThis(uncurryThis.bind);

// optional / simple context binding
module.exports = function (fn, that) {
  aCallable(fn);
  return that === undefined ? fn : NATIVE_BIND ? bind(fn, that) : function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "04f8":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable es/no-symbol -- required for testing */
var V8_VERSION = __webpack_require__("2d00");
var fails = __webpack_require__("d039");

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  var symbol = Symbol();
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  return !String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});


/***/ }),

/***/ "04fe":
/***/ (function(module, exports) {



/***/ }),

/***/ "057f":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable es/no-object-getownpropertynames -- safe */
var classof = __webpack_require__("c6b6");
var toIndexedObject = __webpack_require__("fc6a");
var $getOwnPropertyNames = __webpack_require__("241c").f;
var arraySlice = __webpack_require__("4dae");

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return $getOwnPropertyNames(it);
  } catch (error) {
    return arraySlice(windowNames);
  }
};

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && classof(it) == 'Window'
    ? getWindowNames(it)
    : $getOwnPropertyNames(toIndexedObject(it));
};


/***/ }),

/***/ "06cf":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var call = __webpack_require__("c65b");
var propertyIsEnumerableModule = __webpack_require__("d1e7");
var createPropertyDescriptor = __webpack_require__("5c6c");
var toIndexedObject = __webpack_require__("fc6a");
var toPropertyKey = __webpack_require__("a04b");
var hasOwn = __webpack_require__("1a2d");
var IE8_DOM_DEFINE = __webpack_require__("0cfb");

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPropertyKey(P);
  if (IE8_DOM_DEFINE) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn(O, P)) return createPropertyDescriptor(!call(propertyIsEnumerableModule.f, O, P), O[P]);
};


/***/ }),

/***/ "07fa":
/***/ (function(module, exports, __webpack_require__) {

var toLength = __webpack_require__("50c4");

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
module.exports = function (obj) {
  return toLength(obj.length);
};


/***/ }),

/***/ "0868":
/***/ (function(module, exports) {



/***/ }),

/***/ "0b25":
/***/ (function(module, exports, __webpack_require__) {

var toIntegerOrInfinity = __webpack_require__("5926");
var toLength = __webpack_require__("50c4");

var $RangeError = RangeError;

// `ToIndex` abstract operation
// https://tc39.es/ecma262/#sec-toindex
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toIntegerOrInfinity(it);
  var length = toLength(number);
  if (number !== length) throw $RangeError('Wrong length or index');
  return length;
};


/***/ }),

/***/ "0b42":
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__("e8b5");
var isConstructor = __webpack_require__("68ee");
var isObject = __webpack_require__("861d");
var wellKnownSymbol = __webpack_require__("b622");

var SPECIES = wellKnownSymbol('species');
var $Array = Array;

// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (isConstructor(C) && (C === $Array || isArray(C.prototype))) C = undefined;
    else if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? $Array : C;
};


/***/ }),

/***/ "0b43":
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_SYMBOL = __webpack_require__("04f8");

/* eslint-disable es/no-symbol -- safe */
module.exports = NATIVE_SYMBOL && !!Symbol['for'] && !!Symbol.keyFor;


/***/ }),

/***/ "0c47":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var setToStringTag = __webpack_require__("d44e");

// JSON[@@toStringTag] property
// https://tc39.es/ecma262/#sec-json-@@tostringtag
setToStringTag(global.JSON, 'JSON', true);


/***/ }),

/***/ "0cb2":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");
var toObject = __webpack_require__("7b0b");

var floor = Math.floor;
var charAt = uncurryThis(''.charAt);
var replace = uncurryThis(''.replace);
var stringSlice = uncurryThis(''.slice);
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;

// `GetSubstitution` abstract operation
// https://tc39.es/ecma262/#sec-getsubstitution
module.exports = function (matched, str, position, captures, namedCaptures, replacement) {
  var tailPos = position + matched.length;
  var m = captures.length;
  var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
  if (namedCaptures !== undefined) {
    namedCaptures = toObject(namedCaptures);
    symbols = SUBSTITUTION_SYMBOLS;
  }
  return replace(replacement, symbols, function (match, ch) {
    var capture;
    switch (charAt(ch, 0)) {
      case '$': return '$';
      case '&': return matched;
      case '`': return stringSlice(str, 0, position);
      case "'": return stringSlice(str, tailPos);
      case '<':
        capture = namedCaptures[stringSlice(ch, 1, -1)];
        break;
      default: // \d\d?
        var n = +ch;
        if (n === 0) return match;
        if (n > m) {
          var f = floor(n / 10);
          if (f === 0) return match;
          if (f <= m) return captures[f - 1] === undefined ? charAt(ch, 1) : captures[f - 1] + charAt(ch, 1);
          return match;
        }
        capture = captures[n - 1];
    }
    return capture === undefined ? '' : capture;
  });
};


/***/ }),

/***/ "0cfb":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var fails = __webpack_require__("d039");
var createElement = __webpack_require__("cc12");

// Thanks to IE8 for its funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});


/***/ }),

/***/ "0d26":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");

var $Error = Error;
var replace = uncurryThis(''.replace);

var TEST = (function (arg) { return String($Error(arg).stack); })('zxcasd');
var V8_OR_CHAKRA_STACK_ENTRY = /\n\s*at [^:]*:[^\n]*/;
var IS_V8_OR_CHAKRA_STACK = V8_OR_CHAKRA_STACK_ENTRY.test(TEST);

module.exports = function (stack, dropEntries) {
  if (IS_V8_OR_CHAKRA_STACK && typeof stack == 'string' && !$Error.prepareStackTrace) {
    while (dropEntries--) stack = replace(stack, V8_OR_CHAKRA_STACK_ENTRY, '');
  } return stack;
};


/***/ }),

/***/ "0d51":
/***/ (function(module, exports) {

var $String = String;

module.exports = function (argument) {
  try {
    return $String(argument);
  } catch (error) {
    return 'Object';
  }
};


/***/ }),

/***/ "107c":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");
var global = __webpack_require__("da84");

// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $RegExp = global.RegExp;

module.exports = fails(function () {
  var re = $RegExp('(?<a>b)', 'g');
  return re.exec('b').groups.a !== 'b' ||
    'b'.replace(re, '$<a>c') !== 'bc';
});


/***/ }),

/***/ "1148":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toIntegerOrInfinity = __webpack_require__("5926");
var toString = __webpack_require__("577e");
var requireObjectCoercible = __webpack_require__("1d80");

var $RangeError = RangeError;

// `String.prototype.repeat` method implementation
// https://tc39.es/ecma262/#sec-string.prototype.repeat
module.exports = function repeat(count) {
  var str = toString(requireObjectCoercible(this));
  var result = '';
  var n = toIntegerOrInfinity(count);
  if (n < 0 || n == Infinity) throw $RangeError('Wrong number of repetitions');
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) result += str;
  return result;
};


/***/ }),

/***/ "129f":
/***/ (function(module, exports) {

// `SameValue` abstract operation
// https://tc39.es/ecma262/#sec-samevalue
// eslint-disable-next-line es/no-object-is -- safe
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare -- NaN check
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),

/***/ "12cc":
/***/ (function(module, exports) {



/***/ }),

/***/ "131a":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var setPrototypeOf = __webpack_require__("d2bb");

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
$({ target: 'Object', stat: true }, {
  setPrototypeOf: setPrototypeOf
});


/***/ }),

/***/ "1322":
/***/ (function(module, exports) {



/***/ }),

/***/ "133c":
/***/ (function(module, exports) {



/***/ }),

/***/ "13d2":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");
var isCallable = __webpack_require__("1626");
var hasOwn = __webpack_require__("1a2d");
var DESCRIPTORS = __webpack_require__("83ab");
var CONFIGURABLE_FUNCTION_NAME = __webpack_require__("5e77").CONFIGURABLE;
var inspectSource = __webpack_require__("8925");
var InternalStateModule = __webpack_require__("69f3");

var enforceInternalState = InternalStateModule.enforce;
var getInternalState = InternalStateModule.get;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;

var CONFIGURABLE_LENGTH = DESCRIPTORS && !fails(function () {
  return defineProperty(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
});

var TEMPLATE = String(String).split('String');

var makeBuiltIn = module.exports = function (value, name, options) {
  if (String(name).slice(0, 7) === 'Symbol(') {
    name = '[' + String(name).replace(/^Symbol\(([^)]*)\)/, '$1') + ']';
  }
  if (options && options.getter) name = 'get ' + name;
  if (options && options.setter) name = 'set ' + name;
  if (!hasOwn(value, 'name') || (CONFIGURABLE_FUNCTION_NAME && value.name !== name)) {
    if (DESCRIPTORS) defineProperty(value, 'name', { value: name, configurable: true });
    else value.name = name;
  }
  if (CONFIGURABLE_LENGTH && options && hasOwn(options, 'arity') && value.length !== options.arity) {
    defineProperty(value, 'length', { value: options.arity });
  }
  try {
    if (options && hasOwn(options, 'constructor') && options.constructor) {
      if (DESCRIPTORS) defineProperty(value, 'prototype', { writable: false });
    // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
    } else if (value.prototype) value.prototype = undefined;
  } catch (error) { /* empty */ }
  var state = enforceInternalState(value);
  if (!hasOwn(state, 'source')) {
    state.source = TEMPLATE.join(typeof name == 'string' ? name : '');
  } return value;
};

// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn(function toString() {
  return isCallable(this) && getInternalState(this).source || inspectSource(this);
}, 'toString');


/***/ }),

/***/ "13d5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $reduce = __webpack_require__("d58f").left;
var arrayMethodIsStrict = __webpack_require__("a640");
var CHROME_VERSION = __webpack_require__("2d00");
var IS_NODE = __webpack_require__("605d");

var STRICT_METHOD = arrayMethodIsStrict('reduce');
// Chrome 80-82 has a critical bug
// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
var CHROME_BUG = !IS_NODE && CHROME_VERSION > 79 && CHROME_VERSION < 83;

// `Array.prototype.reduce` method
// https://tc39.es/ecma262/#sec-array.prototype.reduce
$({ target: 'Array', proto: true, forced: !STRICT_METHOD || CHROME_BUG }, {
  reduce: function reduce(callbackfn /* , initialValue */) {
    var length = arguments.length;
    return $reduce(this, callbackfn, length, length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "14c3":
/***/ (function(module, exports, __webpack_require__) {

var call = __webpack_require__("c65b");
var anObject = __webpack_require__("825a");
var isCallable = __webpack_require__("1626");
var classof = __webpack_require__("c6b6");
var regexpExec = __webpack_require__("9263");

var $TypeError = TypeError;

// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (isCallable(exec)) {
    var result = call(exec, R, S);
    if (result !== null) anObject(result);
    return result;
  }
  if (classof(R) === 'RegExp') return call(regexpExec, R, S);
  throw $TypeError('RegExp#exec called on incompatible receiver');
};


/***/ }),

/***/ "14d9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var toObject = __webpack_require__("7b0b");
var lengthOfArrayLike = __webpack_require__("07fa");
var setArrayLength = __webpack_require__("3a34");
var doesNotExceedSafeInteger = __webpack_require__("3511");
var fails = __webpack_require__("d039");

var INCORRECT_TO_LENGTH = fails(function () {
  return [].push.call({ length: 0x100000000 }, 1) !== 4294967297;
});

// V8 and Safari <= 15.4, FF < 23 throws InternalError
// https://bugs.chromium.org/p/v8/issues/detail?id=12681
var SILENT_ON_NON_WRITABLE_LENGTH = !function () {
  try {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty([], 'length', { writable: false }).push();
  } catch (error) {
    return error instanceof TypeError;
  }
}();

// `Array.prototype.push` method
// https://tc39.es/ecma262/#sec-array.prototype.push
$({ target: 'Array', proto: true, arity: 1, forced: INCORRECT_TO_LENGTH || SILENT_ON_NON_WRITABLE_LENGTH }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  push: function push(item) {
    var O = toObject(this);
    var len = lengthOfArrayLike(O);
    var argCount = arguments.length;
    doesNotExceedSafeInteger(len + argCount);
    for (var i = 0; i < argCount; i++) {
      O[len] = arguments[i];
      len++;
    }
    setArrayLength(O, len);
    return len;
  }
});


/***/ }),

/***/ "159b":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var DOMIterables = __webpack_require__("fdbc");
var DOMTokenListPrototype = __webpack_require__("785a");
var forEach = __webpack_require__("17c2");
var createNonEnumerableProperty = __webpack_require__("9112");

var handlePrototype = function (CollectionPrototype) {
  // some Chrome versions have non-configurable methods on DOMTokenList
  if (CollectionPrototype && CollectionPrototype.forEach !== forEach) try {
    createNonEnumerableProperty(CollectionPrototype, 'forEach', forEach);
  } catch (error) {
    CollectionPrototype.forEach = forEach;
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  if (DOMIterables[COLLECTION_NAME]) {
    handlePrototype(global[COLLECTION_NAME] && global[COLLECTION_NAME].prototype);
  }
}

handlePrototype(DOMTokenListPrototype);


/***/ }),

/***/ "1626":
/***/ (function(module, exports, __webpack_require__) {

var $documentAll = __webpack_require__("8ea1");

var documentAll = $documentAll.all;

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
module.exports = $documentAll.IS_HTMLDDA ? function (argument) {
  return typeof argument == 'function' || argument === documentAll;
} : function (argument) {
  return typeof argument == 'function';
};


/***/ }),

/***/ "17c2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $forEach = __webpack_require__("b727").forEach;
var arrayMethodIsStrict = __webpack_require__("a640");

var STRICT_METHOD = arrayMethodIsStrict('forEach');

// `Array.prototype.forEach` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.foreach
module.exports = !STRICT_METHOD ? function forEach(callbackfn /* , thisArg */) {
  return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
// eslint-disable-next-line es/no-array-prototype-foreach -- safe
} : [].forEach;


/***/ }),

/***/ "18a5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var createHTML = __webpack_require__("857a");
var forcedStringHTMLMethod = __webpack_require__("af03");

// `String.prototype.anchor` method
// https://tc39.es/ecma262/#sec-string.prototype.anchor
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('anchor') }, {
  anchor: function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  }
});


/***/ }),

/***/ "19aa":
/***/ (function(module, exports, __webpack_require__) {

var isPrototypeOf = __webpack_require__("3a9b");

var $TypeError = TypeError;

module.exports = function (it, Prototype) {
  if (isPrototypeOf(Prototype, it)) return it;
  throw $TypeError('Incorrect invocation');
};


/***/ }),

/***/ "1a2d":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");
var toObject = __webpack_require__("7b0b");

var hasOwnProperty = uncurryThis({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
module.exports = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject(it), key);
};


/***/ }),

/***/ "1a7e":
/***/ (function(module, exports) {



/***/ }),

/***/ "1be4":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("d066");

module.exports = getBuiltIn('document', 'documentElement');


/***/ }),

/***/ "1c59":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var collection = __webpack_require__("6d61");
var collectionStrong = __webpack_require__("6566");

// `Set` constructor
// https://tc39.es/ecma262/#sec-set-objects
collection('Set', function (init) {
  return function Set() { return init(this, arguments.length ? arguments[0] : undefined); };
}, collectionStrong);


/***/ }),

/***/ "1c7e":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");

var ITERATOR = wellKnownSymbol('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR] = function () {
    return this;
  };
  // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

module.exports = function (exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};


/***/ }),

/***/ "1d80":
/***/ (function(module, exports, __webpack_require__) {

var isNullOrUndefined = __webpack_require__("7234");

var $TypeError = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (isNullOrUndefined(it)) throw $TypeError("Can't call method on " + it);
  return it;
};


/***/ }),

/***/ "1dde":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");
var wellKnownSymbol = __webpack_require__("b622");
var V8_VERSION = __webpack_require__("2d00");

var SPECIES = wellKnownSymbol('species');

module.exports = function (METHOD_NAME) {
  // We can't use this feature detection in V8 since it causes
  // deoptimization and serious performance degradation
  // https://github.com/zloirock/core-js/issues/677
  return V8_VERSION >= 51 || !fails(function () {
    var array = [];
    var constructor = array.constructor = {};
    constructor[SPECIES] = function () {
      return { foo: 1 };
    };
    return array[METHOD_NAME](Boolean).foo !== 1;
  });
};


/***/ }),

/***/ "1f68":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__("83ab");
var defineBuiltInAccessor = __webpack_require__("edd0");
var isObject = __webpack_require__("861d");
var toObject = __webpack_require__("7b0b");
var requireObjectCoercible = __webpack_require__("1d80");

// eslint-disable-next-line es/no-object-getprototypeof -- safe
var getPrototypeOf = Object.getPrototypeOf;
// eslint-disable-next-line es/no-object-setprototypeof -- safe
var setPrototypeOf = Object.setPrototypeOf;
var ObjectPrototype = Object.prototype;
var PROTO = '__proto__';

// `Object.prototype.__proto__` accessor
// https://tc39.es/ecma262/#sec-object.prototype.__proto__
if (DESCRIPTORS && getPrototypeOf && setPrototypeOf && !(PROTO in ObjectPrototype)) try {
  defineBuiltInAccessor(ObjectPrototype, PROTO, {
    configurable: true,
    get: function __proto__() {
      return getPrototypeOf(toObject(this));
    },
    set: function __proto__(proto) {
      var O = requireObjectCoercible(this);
      if (!isObject(proto) && proto !== null || !isObject(O)) return;
      setPrototypeOf(O, proto);
    }
  });
} catch (error) { /* empty */ }


/***/ }),

/***/ "2235":
/***/ (function(module, exports) {



/***/ }),

/***/ "2266":
/***/ (function(module, exports, __webpack_require__) {

var bind = __webpack_require__("0366");
var call = __webpack_require__("c65b");
var anObject = __webpack_require__("825a");
var tryToString = __webpack_require__("0d51");
var isArrayIteratorMethod = __webpack_require__("e95a");
var lengthOfArrayLike = __webpack_require__("07fa");
var isPrototypeOf = __webpack_require__("3a9b");
var getIterator = __webpack_require__("9a1f");
var getIteratorMethod = __webpack_require__("35a1");
var iteratorClose = __webpack_require__("2a62");

var $TypeError = TypeError;

var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

var ResultPrototype = Result.prototype;

module.exports = function (iterable, unboundFunction, options) {
  var that = options && options.that;
  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
  var IS_RECORD = !!(options && options.IS_RECORD);
  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
  var INTERRUPTED = !!(options && options.INTERRUPTED);
  var fn = bind(unboundFunction, that);
  var iterator, iterFn, index, length, result, next, step;

  var stop = function (condition) {
    if (iterator) iteratorClose(iterator, 'normal', condition);
    return new Result(true, condition);
  };

  var callFn = function (value) {
    if (AS_ENTRIES) {
      anObject(value);
      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
    } return INTERRUPTED ? fn(value, stop) : fn(value);
  };

  if (IS_RECORD) {
    iterator = iterable.iterator;
  } else if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod(iterable);
    if (!iterFn) throw $TypeError(tryToString(iterable) + ' is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = lengthOfArrayLike(iterable); length > index; index++) {
        result = callFn(iterable[index]);
        if (result && isPrototypeOf(ResultPrototype, result)) return result;
      } return new Result(false);
    }
    iterator = getIterator(iterable, iterFn);
  }

  next = IS_RECORD ? iterable.next : iterator.next;
  while (!(step = call(next, iterator)).done) {
    try {
      result = callFn(step.value);
    } catch (error) {
      iteratorClose(iterator, 'throw', error);
    }
    if (typeof result == 'object' && result && isPrototypeOf(ResultPrototype, result)) return result;
  } return new Result(false);
};


/***/ }),

/***/ "23a6":
/***/ (function(module, exports) {



/***/ }),

/***/ "23cb":
/***/ (function(module, exports, __webpack_require__) {

var toIntegerOrInfinity = __webpack_require__("5926");

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toIntegerOrInfinity(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};


/***/ }),

/***/ "23dc":
/***/ (function(module, exports, __webpack_require__) {

var setToStringTag = __webpack_require__("d44e");

// Math[@@toStringTag] property
// https://tc39.es/ecma262/#sec-math-@@tostringtag
setToStringTag(Math, 'Math', true);


/***/ }),

/***/ "23e7":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var getOwnPropertyDescriptor = __webpack_require__("06cf").f;
var createNonEnumerableProperty = __webpack_require__("9112");
var defineBuiltIn = __webpack_require__("cb2d");
var defineGlobalProperty = __webpack_require__("6374");
var copyConstructorProperties = __webpack_require__("e893");
var isForced = __webpack_require__("94ca");

/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global;
  } else if (STATIC) {
    target = global[TARGET] || defineGlobalProperty(TARGET, {});
  } else {
    target = (global[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    defineBuiltIn(target, key, sourceProperty, options);
  }
};


/***/ }),

/***/ "241c":
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__("ca84");
var enumBugKeys = __webpack_require__("7839");

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};


/***/ }),

/***/ "25f0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var PROPER_FUNCTION_NAME = __webpack_require__("5e77").PROPER;
var defineBuiltIn = __webpack_require__("cb2d");
var anObject = __webpack_require__("825a");
var $toString = __webpack_require__("577e");
var fails = __webpack_require__("d039");
var getRegExpFlags = __webpack_require__("90d8");

var TO_STRING = 'toString';
var RegExpPrototype = RegExp.prototype;
var nativeToString = RegExpPrototype[TO_STRING];

var NOT_GENERIC = fails(function () { return nativeToString.call({ source: 'a', flags: 'b' }) != '/a/b'; });
// FF44- RegExp#toString has a wrong name
var INCORRECT_NAME = PROPER_FUNCTION_NAME && nativeToString.name != TO_STRING;

// `RegExp.prototype.toString` method
// https://tc39.es/ecma262/#sec-regexp.prototype.tostring
if (NOT_GENERIC || INCORRECT_NAME) {
  defineBuiltIn(RegExp.prototype, TO_STRING, function toString() {
    var R = anObject(this);
    var pattern = $toString(R.source);
    var flags = $toString(getRegExpFlags(R));
    return '/' + pattern + '/' + flags;
  }, { unsafe: true });
}


/***/ }),

/***/ "2626":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__("d066");
var definePropertyModule = __webpack_require__("9bf2");
var wellKnownSymbol = __webpack_require__("b622");
var DESCRIPTORS = __webpack_require__("83ab");

var SPECIES = wellKnownSymbol('species');

module.exports = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn(CONSTRUCTOR_NAME);
  var defineProperty = definePropertyModule.f;

  if (DESCRIPTORS && Constructor && !Constructor[SPECIES]) {
    defineProperty(Constructor, SPECIES, {
      configurable: true,
      get: function () { return this; }
    });
  }
};


/***/ }),

/***/ "2a62":
/***/ (function(module, exports, __webpack_require__) {

var call = __webpack_require__("c65b");
var anObject = __webpack_require__("825a");
var getMethod = __webpack_require__("dc4a");

module.exports = function (iterator, kind, value) {
  var innerResult, innerError;
  anObject(iterator);
  try {
    innerResult = getMethod(iterator, 'return');
    if (!innerResult) {
      if (kind === 'throw') throw value;
      return value;
    }
    innerResult = call(innerResult, iterator);
  } catch (error) {
    innerError = true;
    innerResult = error;
  }
  if (kind === 'throw') throw value;
  if (innerError) throw innerResult;
  anObject(innerResult);
  return value;
};


/***/ }),

/***/ "2b3d":
/***/ (function(module, exports, __webpack_require__) {

// TODO: Remove this module from `core-js@4` since it's replaced to module below
__webpack_require__("4002");


/***/ }),

/***/ "2ba4":
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_BIND = __webpack_require__("40d5");

var FunctionPrototype = Function.prototype;
var apply = FunctionPrototype.apply;
var call = FunctionPrototype.call;

// eslint-disable-next-line es/no-reflect -- safe
module.exports = typeof Reflect == 'object' && Reflect.apply || (NATIVE_BIND ? call.bind(apply) : function () {
  return call.apply(apply, arguments);
});


/***/ }),

/***/ "2c15":
/***/ (function(module, exports) {

module.exports = require("kind-of");

/***/ }),

/***/ "2d00":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var userAgent = __webpack_require__("342f");

var process = global.process;
var Deno = global.Deno;
var versions = process && process.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

module.exports = version;


/***/ }),

/***/ "3410":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var fails = __webpack_require__("d039");
var toObject = __webpack_require__("7b0b");
var nativeGetPrototypeOf = __webpack_require__("e163");
var CORRECT_PROTOTYPE_GETTER = __webpack_require__("e177");

var FAILS_ON_PRIMITIVES = fails(function () { nativeGetPrototypeOf(1); });

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES, sham: !CORRECT_PROTOTYPE_GETTER }, {
  getPrototypeOf: function getPrototypeOf(it) {
    return nativeGetPrototypeOf(toObject(it));
  }
});



/***/ }),

/***/ "342f":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("d066");

module.exports = getBuiltIn('navigator', 'userAgent') || '';


/***/ }),

/***/ "3511":
/***/ (function(module, exports) {

var $TypeError = TypeError;
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF; // 2 ** 53 - 1 == 9007199254740991

module.exports = function (it) {
  if (it > MAX_SAFE_INTEGER) throw $TypeError('Maximum allowed index exceeded');
  return it;
};


/***/ }),

/***/ "35a1":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("f5df");
var getMethod = __webpack_require__("dc4a");
var isNullOrUndefined = __webpack_require__("7234");
var Iterators = __webpack_require__("3f8c");
var wellKnownSymbol = __webpack_require__("b622");

var ITERATOR = wellKnownSymbol('iterator');

module.exports = function (it) {
  if (!isNullOrUndefined(it)) return getMethod(it, ITERATOR)
    || getMethod(it, '@@iterator')
    || Iterators[classof(it)];
};


/***/ }),

/***/ "37e8":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var V8_PROTOTYPE_DEFINE_BUG = __webpack_require__("aed9");
var definePropertyModule = __webpack_require__("9bf2");
var anObject = __webpack_require__("825a");
var toIndexedObject = __webpack_require__("fc6a");
var objectKeys = __webpack_require__("df75");

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
exports.f = DESCRIPTORS && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var props = toIndexedObject(Properties);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], props[key]);
  return O;
};


/***/ }),

/***/ "3a34":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__("83ab");
var isArray = __webpack_require__("e8b5");

var $TypeError = TypeError;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Safari < 13 does not throw an error in this case
var SILENT_ON_NON_WRITABLE_LENGTH_SET = DESCRIPTORS && !function () {
  // makes no sense without proper strict mode support
  if (this !== undefined) return true;
  try {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty([], 'length', { writable: false }).length = 1;
  } catch (error) {
    return error instanceof TypeError;
  }
}();

module.exports = SILENT_ON_NON_WRITABLE_LENGTH_SET ? function (O, length) {
  if (isArray(O) && !getOwnPropertyDescriptor(O, 'length').writable) {
    throw $TypeError('Cannot set read only .length');
  } return O.length = length;
} : function (O, length) {
  return O.length = length;
};


/***/ }),

/***/ "3a9b":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");

module.exports = uncurryThis({}.isPrototypeOf);


/***/ }),

/***/ "3ae1":
/***/ (function(module, exports) {



/***/ }),

/***/ "3bbe":
/***/ (function(module, exports, __webpack_require__) {

var isCallable = __webpack_require__("1626");

var $String = String;
var $TypeError = TypeError;

module.exports = function (argument) {
  if (typeof argument == 'object' || isCallable(argument)) return argument;
  throw $TypeError("Can't set " + $String(argument) + ' as a prototype');
};


/***/ }),

/***/ "3ca3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var charAt = __webpack_require__("6547").charAt;
var toString = __webpack_require__("577e");
var InternalStateModule = __webpack_require__("69f3");
var defineIterator = __webpack_require__("c6d2");
var createIterResultObject = __webpack_require__("4754");

var STRING_ITERATOR = 'String Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);

// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
defineIterator(String, 'String', function (iterated) {
  setInternalState(this, {
    type: STRING_ITERATOR,
    string: toString(iterated),
    index: 0
  });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return createIterResultObject(undefined, true);
  point = charAt(string, index);
  state.index += point.length;
  return createIterResultObject(point, false);
});


/***/ }),

/***/ "3f8c":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "4002":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`
__webpack_require__("3ca3");
var $ = __webpack_require__("23e7");
var DESCRIPTORS = __webpack_require__("83ab");
var USE_NATIVE_URL = __webpack_require__("f354");
var global = __webpack_require__("da84");
var bind = __webpack_require__("0366");
var uncurryThis = __webpack_require__("e330");
var defineBuiltIn = __webpack_require__("cb2d");
var defineBuiltInAccessor = __webpack_require__("edd0");
var anInstance = __webpack_require__("19aa");
var hasOwn = __webpack_require__("1a2d");
var assign = __webpack_require__("60da");
var arrayFrom = __webpack_require__("4df4");
var arraySlice = __webpack_require__("4dae");
var codeAt = __webpack_require__("6547").codeAt;
var toASCII = __webpack_require__("5fb2");
var $toString = __webpack_require__("577e");
var setToStringTag = __webpack_require__("d44e");
var validateArgumentsLength = __webpack_require__("d6d6");
var URLSearchParamsModule = __webpack_require__("5352");
var InternalStateModule = __webpack_require__("69f3");

var setInternalState = InternalStateModule.set;
var getInternalURLState = InternalStateModule.getterFor('URL');
var URLSearchParams = URLSearchParamsModule.URLSearchParams;
var getInternalSearchParamsState = URLSearchParamsModule.getState;

var NativeURL = global.URL;
var TypeError = global.TypeError;
var parseInt = global.parseInt;
var floor = Math.floor;
var pow = Math.pow;
var charAt = uncurryThis(''.charAt);
var exec = uncurryThis(/./.exec);
var join = uncurryThis([].join);
var numberToString = uncurryThis(1.0.toString);
var pop = uncurryThis([].pop);
var push = uncurryThis([].push);
var replace = uncurryThis(''.replace);
var shift = uncurryThis([].shift);
var split = uncurryThis(''.split);
var stringSlice = uncurryThis(''.slice);
var toLowerCase = uncurryThis(''.toLowerCase);
var unshift = uncurryThis([].unshift);

var INVALID_AUTHORITY = 'Invalid authority';
var INVALID_SCHEME = 'Invalid scheme';
var INVALID_HOST = 'Invalid host';
var INVALID_PORT = 'Invalid port';

var ALPHA = /[a-z]/i;
// eslint-disable-next-line regexp/no-obscure-range -- safe
var ALPHANUMERIC = /[\d+-.a-z]/i;
var DIGIT = /\d/;
var HEX_START = /^0x/i;
var OCT = /^[0-7]+$/;
var DEC = /^\d+$/;
var HEX = /^[\da-f]+$/i;
/* eslint-disable regexp/no-control-character -- safe */
var FORBIDDEN_HOST_CODE_POINT = /[\0\t\n\r #%/:<>?@[\\\]^|]/;
var FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT = /[\0\t\n\r #/:<>?@[\\\]^|]/;
var LEADING_AND_TRAILING_C0_CONTROL_OR_SPACE = /^[\u0000-\u0020]+|[\u0000-\u0020]+$/g;
var TAB_AND_NEW_LINE = /[\t\n\r]/g;
/* eslint-enable regexp/no-control-character -- safe */
var EOF;

// https://url.spec.whatwg.org/#ipv4-number-parser
var parseIPv4 = function (input) {
  var parts = split(input, '.');
  var partsLength, numbers, index, part, radix, number, ipv4;
  if (parts.length && parts[parts.length - 1] == '') {
    parts.length--;
  }
  partsLength = parts.length;
  if (partsLength > 4) return input;
  numbers = [];
  for (index = 0; index < partsLength; index++) {
    part = parts[index];
    if (part == '') return input;
    radix = 10;
    if (part.length > 1 && charAt(part, 0) == '0') {
      radix = exec(HEX_START, part) ? 16 : 8;
      part = stringSlice(part, radix == 8 ? 1 : 2);
    }
    if (part === '') {
      number = 0;
    } else {
      if (!exec(radix == 10 ? DEC : radix == 8 ? OCT : HEX, part)) return input;
      number = parseInt(part, radix);
    }
    push(numbers, number);
  }
  for (index = 0; index < partsLength; index++) {
    number = numbers[index];
    if (index == partsLength - 1) {
      if (number >= pow(256, 5 - partsLength)) return null;
    } else if (number > 255) return null;
  }
  ipv4 = pop(numbers);
  for (index = 0; index < numbers.length; index++) {
    ipv4 += numbers[index] * pow(256, 3 - index);
  }
  return ipv4;
};

// https://url.spec.whatwg.org/#concept-ipv6-parser
// eslint-disable-next-line max-statements -- TODO
var parseIPv6 = function (input) {
  var address = [0, 0, 0, 0, 0, 0, 0, 0];
  var pieceIndex = 0;
  var compress = null;
  var pointer = 0;
  var value, length, numbersSeen, ipv4Piece, number, swaps, swap;

  var chr = function () {
    return charAt(input, pointer);
  };

  if (chr() == ':') {
    if (charAt(input, 1) != ':') return;
    pointer += 2;
    pieceIndex++;
    compress = pieceIndex;
  }
  while (chr()) {
    if (pieceIndex == 8) return;
    if (chr() == ':') {
      if (compress !== null) return;
      pointer++;
      pieceIndex++;
      compress = pieceIndex;
      continue;
    }
    value = length = 0;
    while (length < 4 && exec(HEX, chr())) {
      value = value * 16 + parseInt(chr(), 16);
      pointer++;
      length++;
    }
    if (chr() == '.') {
      if (length == 0) return;
      pointer -= length;
      if (pieceIndex > 6) return;
      numbersSeen = 0;
      while (chr()) {
        ipv4Piece = null;
        if (numbersSeen > 0) {
          if (chr() == '.' && numbersSeen < 4) pointer++;
          else return;
        }
        if (!exec(DIGIT, chr())) return;
        while (exec(DIGIT, chr())) {
          number = parseInt(chr(), 10);
          if (ipv4Piece === null) ipv4Piece = number;
          else if (ipv4Piece == 0) return;
          else ipv4Piece = ipv4Piece * 10 + number;
          if (ipv4Piece > 255) return;
          pointer++;
        }
        address[pieceIndex] = address[pieceIndex] * 256 + ipv4Piece;
        numbersSeen++;
        if (numbersSeen == 2 || numbersSeen == 4) pieceIndex++;
      }
      if (numbersSeen != 4) return;
      break;
    } else if (chr() == ':') {
      pointer++;
      if (!chr()) return;
    } else if (chr()) return;
    address[pieceIndex++] = value;
  }
  if (compress !== null) {
    swaps = pieceIndex - compress;
    pieceIndex = 7;
    while (pieceIndex != 0 && swaps > 0) {
      swap = address[pieceIndex];
      address[pieceIndex--] = address[compress + swaps - 1];
      address[compress + --swaps] = swap;
    }
  } else if (pieceIndex != 8) return;
  return address;
};

var findLongestZeroSequence = function (ipv6) {
  var maxIndex = null;
  var maxLength = 1;
  var currStart = null;
  var currLength = 0;
  var index = 0;
  for (; index < 8; index++) {
    if (ipv6[index] !== 0) {
      if (currLength > maxLength) {
        maxIndex = currStart;
        maxLength = currLength;
      }
      currStart = null;
      currLength = 0;
    } else {
      if (currStart === null) currStart = index;
      ++currLength;
    }
  }
  if (currLength > maxLength) {
    maxIndex = currStart;
    maxLength = currLength;
  }
  return maxIndex;
};

// https://url.spec.whatwg.org/#host-serializing
var serializeHost = function (host) {
  var result, index, compress, ignore0;
  // ipv4
  if (typeof host == 'number') {
    result = [];
    for (index = 0; index < 4; index++) {
      unshift(result, host % 256);
      host = floor(host / 256);
    } return join(result, '.');
  // ipv6
  } else if (typeof host == 'object') {
    result = '';
    compress = findLongestZeroSequence(host);
    for (index = 0; index < 8; index++) {
      if (ignore0 && host[index] === 0) continue;
      if (ignore0) ignore0 = false;
      if (compress === index) {
        result += index ? ':' : '::';
        ignore0 = true;
      } else {
        result += numberToString(host[index], 16);
        if (index < 7) result += ':';
      }
    }
    return '[' + result + ']';
  } return host;
};

var C0ControlPercentEncodeSet = {};
var fragmentPercentEncodeSet = assign({}, C0ControlPercentEncodeSet, {
  ' ': 1, '"': 1, '<': 1, '>': 1, '`': 1
});
var pathPercentEncodeSet = assign({}, fragmentPercentEncodeSet, {
  '#': 1, '?': 1, '{': 1, '}': 1
});
var userinfoPercentEncodeSet = assign({}, pathPercentEncodeSet, {
  '/': 1, ':': 1, ';': 1, '=': 1, '@': 1, '[': 1, '\\': 1, ']': 1, '^': 1, '|': 1
});

var percentEncode = function (chr, set) {
  var code = codeAt(chr, 0);
  return code > 0x20 && code < 0x7F && !hasOwn(set, chr) ? chr : encodeURIComponent(chr);
};

// https://url.spec.whatwg.org/#special-scheme
var specialSchemes = {
  ftp: 21,
  file: null,
  http: 80,
  https: 443,
  ws: 80,
  wss: 443
};

// https://url.spec.whatwg.org/#windows-drive-letter
var isWindowsDriveLetter = function (string, normalized) {
  var second;
  return string.length == 2 && exec(ALPHA, charAt(string, 0))
    && ((second = charAt(string, 1)) == ':' || (!normalized && second == '|'));
};

// https://url.spec.whatwg.org/#start-with-a-windows-drive-letter
var startsWithWindowsDriveLetter = function (string) {
  var third;
  return string.length > 1 && isWindowsDriveLetter(stringSlice(string, 0, 2)) && (
    string.length == 2 ||
    ((third = charAt(string, 2)) === '/' || third === '\\' || third === '?' || third === '#')
  );
};

// https://url.spec.whatwg.org/#single-dot-path-segment
var isSingleDot = function (segment) {
  return segment === '.' || toLowerCase(segment) === '%2e';
};

// https://url.spec.whatwg.org/#double-dot-path-segment
var isDoubleDot = function (segment) {
  segment = toLowerCase(segment);
  return segment === '..' || segment === '%2e.' || segment === '.%2e' || segment === '%2e%2e';
};

// States:
var SCHEME_START = {};
var SCHEME = {};
var NO_SCHEME = {};
var SPECIAL_RELATIVE_OR_AUTHORITY = {};
var PATH_OR_AUTHORITY = {};
var RELATIVE = {};
var RELATIVE_SLASH = {};
var SPECIAL_AUTHORITY_SLASHES = {};
var SPECIAL_AUTHORITY_IGNORE_SLASHES = {};
var AUTHORITY = {};
var HOST = {};
var HOSTNAME = {};
var PORT = {};
var FILE = {};
var FILE_SLASH = {};
var FILE_HOST = {};
var PATH_START = {};
var PATH = {};
var CANNOT_BE_A_BASE_URL_PATH = {};
var QUERY = {};
var FRAGMENT = {};

var URLState = function (url, isBase, base) {
  var urlString = $toString(url);
  var baseState, failure, searchParams;
  if (isBase) {
    failure = this.parse(urlString);
    if (failure) throw TypeError(failure);
    this.searchParams = null;
  } else {
    if (base !== undefined) baseState = new URLState(base, true);
    failure = this.parse(urlString, null, baseState);
    if (failure) throw TypeError(failure);
    searchParams = getInternalSearchParamsState(new URLSearchParams());
    searchParams.bindURL(this);
    this.searchParams = searchParams;
  }
};

URLState.prototype = {
  type: 'URL',
  // https://url.spec.whatwg.org/#url-parsing
  // eslint-disable-next-line max-statements -- TODO
  parse: function (input, stateOverride, base) {
    var url = this;
    var state = stateOverride || SCHEME_START;
    var pointer = 0;
    var buffer = '';
    var seenAt = false;
    var seenBracket = false;
    var seenPasswordToken = false;
    var codePoints, chr, bufferCodePoints, failure;

    input = $toString(input);

    if (!stateOverride) {
      url.scheme = '';
      url.username = '';
      url.password = '';
      url.host = null;
      url.port = null;
      url.path = [];
      url.query = null;
      url.fragment = null;
      url.cannotBeABaseURL = false;
      input = replace(input, LEADING_AND_TRAILING_C0_CONTROL_OR_SPACE, '');
    }

    input = replace(input, TAB_AND_NEW_LINE, '');

    codePoints = arrayFrom(input);

    while (pointer <= codePoints.length) {
      chr = codePoints[pointer];
      switch (state) {
        case SCHEME_START:
          if (chr && exec(ALPHA, chr)) {
            buffer += toLowerCase(chr);
            state = SCHEME;
          } else if (!stateOverride) {
            state = NO_SCHEME;
            continue;
          } else return INVALID_SCHEME;
          break;

        case SCHEME:
          if (chr && (exec(ALPHANUMERIC, chr) || chr == '+' || chr == '-' || chr == '.')) {
            buffer += toLowerCase(chr);
          } else if (chr == ':') {
            if (stateOverride && (
              (url.isSpecial() != hasOwn(specialSchemes, buffer)) ||
              (buffer == 'file' && (url.includesCredentials() || url.port !== null)) ||
              (url.scheme == 'file' && !url.host)
            )) return;
            url.scheme = buffer;
            if (stateOverride) {
              if (url.isSpecial() && specialSchemes[url.scheme] == url.port) url.port = null;
              return;
            }
            buffer = '';
            if (url.scheme == 'file') {
              state = FILE;
            } else if (url.isSpecial() && base && base.scheme == url.scheme) {
              state = SPECIAL_RELATIVE_OR_AUTHORITY;
            } else if (url.isSpecial()) {
              state = SPECIAL_AUTHORITY_SLASHES;
            } else if (codePoints[pointer + 1] == '/') {
              state = PATH_OR_AUTHORITY;
              pointer++;
            } else {
              url.cannotBeABaseURL = true;
              push(url.path, '');
              state = CANNOT_BE_A_BASE_URL_PATH;
            }
          } else if (!stateOverride) {
            buffer = '';
            state = NO_SCHEME;
            pointer = 0;
            continue;
          } else return INVALID_SCHEME;
          break;

        case NO_SCHEME:
          if (!base || (base.cannotBeABaseURL && chr != '#')) return INVALID_SCHEME;
          if (base.cannotBeABaseURL && chr == '#') {
            url.scheme = base.scheme;
            url.path = arraySlice(base.path);
            url.query = base.query;
            url.fragment = '';
            url.cannotBeABaseURL = true;
            state = FRAGMENT;
            break;
          }
          state = base.scheme == 'file' ? FILE : RELATIVE;
          continue;

        case SPECIAL_RELATIVE_OR_AUTHORITY:
          if (chr == '/' && codePoints[pointer + 1] == '/') {
            state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
            pointer++;
          } else {
            state = RELATIVE;
            continue;
          } break;

        case PATH_OR_AUTHORITY:
          if (chr == '/') {
            state = AUTHORITY;
            break;
          } else {
            state = PATH;
            continue;
          }

        case RELATIVE:
          url.scheme = base.scheme;
          if (chr == EOF) {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            url.path = arraySlice(base.path);
            url.query = base.query;
          } else if (chr == '/' || (chr == '\\' && url.isSpecial())) {
            state = RELATIVE_SLASH;
          } else if (chr == '?') {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            url.path = arraySlice(base.path);
            url.query = '';
            state = QUERY;
          } else if (chr == '#') {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            url.path = arraySlice(base.path);
            url.query = base.query;
            url.fragment = '';
            state = FRAGMENT;
          } else {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            url.path = arraySlice(base.path);
            url.path.length--;
            state = PATH;
            continue;
          } break;

        case RELATIVE_SLASH:
          if (url.isSpecial() && (chr == '/' || chr == '\\')) {
            state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
          } else if (chr == '/') {
            state = AUTHORITY;
          } else {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            state = PATH;
            continue;
          } break;

        case SPECIAL_AUTHORITY_SLASHES:
          state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
          if (chr != '/' || charAt(buffer, pointer + 1) != '/') continue;
          pointer++;
          break;

        case SPECIAL_AUTHORITY_IGNORE_SLASHES:
          if (chr != '/' && chr != '\\') {
            state = AUTHORITY;
            continue;
          } break;

        case AUTHORITY:
          if (chr == '@') {
            if (seenAt) buffer = '%40' + buffer;
            seenAt = true;
            bufferCodePoints = arrayFrom(buffer);
            for (var i = 0; i < bufferCodePoints.length; i++) {
              var codePoint = bufferCodePoints[i];
              if (codePoint == ':' && !seenPasswordToken) {
                seenPasswordToken = true;
                continue;
              }
              var encodedCodePoints = percentEncode(codePoint, userinfoPercentEncodeSet);
              if (seenPasswordToken) url.password += encodedCodePoints;
              else url.username += encodedCodePoints;
            }
            buffer = '';
          } else if (
            chr == EOF || chr == '/' || chr == '?' || chr == '#' ||
            (chr == '\\' && url.isSpecial())
          ) {
            if (seenAt && buffer == '') return INVALID_AUTHORITY;
            pointer -= arrayFrom(buffer).length + 1;
            buffer = '';
            state = HOST;
          } else buffer += chr;
          break;

        case HOST:
        case HOSTNAME:
          if (stateOverride && url.scheme == 'file') {
            state = FILE_HOST;
            continue;
          } else if (chr == ':' && !seenBracket) {
            if (buffer == '') return INVALID_HOST;
            failure = url.parseHost(buffer);
            if (failure) return failure;
            buffer = '';
            state = PORT;
            if (stateOverride == HOSTNAME) return;
          } else if (
            chr == EOF || chr == '/' || chr == '?' || chr == '#' ||
            (chr == '\\' && url.isSpecial())
          ) {
            if (url.isSpecial() && buffer == '') return INVALID_HOST;
            if (stateOverride && buffer == '' && (url.includesCredentials() || url.port !== null)) return;
            failure = url.parseHost(buffer);
            if (failure) return failure;
            buffer = '';
            state = PATH_START;
            if (stateOverride) return;
            continue;
          } else {
            if (chr == '[') seenBracket = true;
            else if (chr == ']') seenBracket = false;
            buffer += chr;
          } break;

        case PORT:
          if (exec(DIGIT, chr)) {
            buffer += chr;
          } else if (
            chr == EOF || chr == '/' || chr == '?' || chr == '#' ||
            (chr == '\\' && url.isSpecial()) ||
            stateOverride
          ) {
            if (buffer != '') {
              var port = parseInt(buffer, 10);
              if (port > 0xFFFF) return INVALID_PORT;
              url.port = (url.isSpecial() && port === specialSchemes[url.scheme]) ? null : port;
              buffer = '';
            }
            if (stateOverride) return;
            state = PATH_START;
            continue;
          } else return INVALID_PORT;
          break;

        case FILE:
          url.scheme = 'file';
          if (chr == '/' || chr == '\\') state = FILE_SLASH;
          else if (base && base.scheme == 'file') {
            if (chr == EOF) {
              url.host = base.host;
              url.path = arraySlice(base.path);
              url.query = base.query;
            } else if (chr == '?') {
              url.host = base.host;
              url.path = arraySlice(base.path);
              url.query = '';
              state = QUERY;
            } else if (chr == '#') {
              url.host = base.host;
              url.path = arraySlice(base.path);
              url.query = base.query;
              url.fragment = '';
              state = FRAGMENT;
            } else {
              if (!startsWithWindowsDriveLetter(join(arraySlice(codePoints, pointer), ''))) {
                url.host = base.host;
                url.path = arraySlice(base.path);
                url.shortenPath();
              }
              state = PATH;
              continue;
            }
          } else {
            state = PATH;
            continue;
          } break;

        case FILE_SLASH:
          if (chr == '/' || chr == '\\') {
            state = FILE_HOST;
            break;
          }
          if (base && base.scheme == 'file' && !startsWithWindowsDriveLetter(join(arraySlice(codePoints, pointer), ''))) {
            if (isWindowsDriveLetter(base.path[0], true)) push(url.path, base.path[0]);
            else url.host = base.host;
          }
          state = PATH;
          continue;

        case FILE_HOST:
          if (chr == EOF || chr == '/' || chr == '\\' || chr == '?' || chr == '#') {
            if (!stateOverride && isWindowsDriveLetter(buffer)) {
              state = PATH;
            } else if (buffer == '') {
              url.host = '';
              if (stateOverride) return;
              state = PATH_START;
            } else {
              failure = url.parseHost(buffer);
              if (failure) return failure;
              if (url.host == 'localhost') url.host = '';
              if (stateOverride) return;
              buffer = '';
              state = PATH_START;
            } continue;
          } else buffer += chr;
          break;

        case PATH_START:
          if (url.isSpecial()) {
            state = PATH;
            if (chr != '/' && chr != '\\') continue;
          } else if (!stateOverride && chr == '?') {
            url.query = '';
            state = QUERY;
          } else if (!stateOverride && chr == '#') {
            url.fragment = '';
            state = FRAGMENT;
          } else if (chr != EOF) {
            state = PATH;
            if (chr != '/') continue;
          } break;

        case PATH:
          if (
            chr == EOF || chr == '/' ||
            (chr == '\\' && url.isSpecial()) ||
            (!stateOverride && (chr == '?' || chr == '#'))
          ) {
            if (isDoubleDot(buffer)) {
              url.shortenPath();
              if (chr != '/' && !(chr == '\\' && url.isSpecial())) {
                push(url.path, '');
              }
            } else if (isSingleDot(buffer)) {
              if (chr != '/' && !(chr == '\\' && url.isSpecial())) {
                push(url.path, '');
              }
            } else {
              if (url.scheme == 'file' && !url.path.length && isWindowsDriveLetter(buffer)) {
                if (url.host) url.host = '';
                buffer = charAt(buffer, 0) + ':'; // normalize windows drive letter
              }
              push(url.path, buffer);
            }
            buffer = '';
            if (url.scheme == 'file' && (chr == EOF || chr == '?' || chr == '#')) {
              while (url.path.length > 1 && url.path[0] === '') {
                shift(url.path);
              }
            }
            if (chr == '?') {
              url.query = '';
              state = QUERY;
            } else if (chr == '#') {
              url.fragment = '';
              state = FRAGMENT;
            }
          } else {
            buffer += percentEncode(chr, pathPercentEncodeSet);
          } break;

        case CANNOT_BE_A_BASE_URL_PATH:
          if (chr == '?') {
            url.query = '';
            state = QUERY;
          } else if (chr == '#') {
            url.fragment = '';
            state = FRAGMENT;
          } else if (chr != EOF) {
            url.path[0] += percentEncode(chr, C0ControlPercentEncodeSet);
          } break;

        case QUERY:
          if (!stateOverride && chr == '#') {
            url.fragment = '';
            state = FRAGMENT;
          } else if (chr != EOF) {
            if (chr == "'" && url.isSpecial()) url.query += '%27';
            else if (chr == '#') url.query += '%23';
            else url.query += percentEncode(chr, C0ControlPercentEncodeSet);
          } break;

        case FRAGMENT:
          if (chr != EOF) url.fragment += percentEncode(chr, fragmentPercentEncodeSet);
          break;
      }

      pointer++;
    }
  },
  // https://url.spec.whatwg.org/#host-parsing
  parseHost: function (input) {
    var result, codePoints, index;
    if (charAt(input, 0) == '[') {
      if (charAt(input, input.length - 1) != ']') return INVALID_HOST;
      result = parseIPv6(stringSlice(input, 1, -1));
      if (!result) return INVALID_HOST;
      this.host = result;
    // opaque host
    } else if (!this.isSpecial()) {
      if (exec(FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT, input)) return INVALID_HOST;
      result = '';
      codePoints = arrayFrom(input);
      for (index = 0; index < codePoints.length; index++) {
        result += percentEncode(codePoints[index], C0ControlPercentEncodeSet);
      }
      this.host = result;
    } else {
      input = toASCII(input);
      if (exec(FORBIDDEN_HOST_CODE_POINT, input)) return INVALID_HOST;
      result = parseIPv4(input);
      if (result === null) return INVALID_HOST;
      this.host = result;
    }
  },
  // https://url.spec.whatwg.org/#cannot-have-a-username-password-port
  cannotHaveUsernamePasswordPort: function () {
    return !this.host || this.cannotBeABaseURL || this.scheme == 'file';
  },
  // https://url.spec.whatwg.org/#include-credentials
  includesCredentials: function () {
    return this.username != '' || this.password != '';
  },
  // https://url.spec.whatwg.org/#is-special
  isSpecial: function () {
    return hasOwn(specialSchemes, this.scheme);
  },
  // https://url.spec.whatwg.org/#shorten-a-urls-path
  shortenPath: function () {
    var path = this.path;
    var pathSize = path.length;
    if (pathSize && (this.scheme != 'file' || pathSize != 1 || !isWindowsDriveLetter(path[0], true))) {
      path.length--;
    }
  },
  // https://url.spec.whatwg.org/#concept-url-serializer
  serialize: function () {
    var url = this;
    var scheme = url.scheme;
    var username = url.username;
    var password = url.password;
    var host = url.host;
    var port = url.port;
    var path = url.path;
    var query = url.query;
    var fragment = url.fragment;
    var output = scheme + ':';
    if (host !== null) {
      output += '//';
      if (url.includesCredentials()) {
        output += username + (password ? ':' + password : '') + '@';
      }
      output += serializeHost(host);
      if (port !== null) output += ':' + port;
    } else if (scheme == 'file') output += '//';
    output += url.cannotBeABaseURL ? path[0] : path.length ? '/' + join(path, '/') : '';
    if (query !== null) output += '?' + query;
    if (fragment !== null) output += '#' + fragment;
    return output;
  },
  // https://url.spec.whatwg.org/#dom-url-href
  setHref: function (href) {
    var failure = this.parse(href);
    if (failure) throw TypeError(failure);
    this.searchParams.update();
  },
  // https://url.spec.whatwg.org/#dom-url-origin
  getOrigin: function () {
    var scheme = this.scheme;
    var port = this.port;
    if (scheme == 'blob') try {
      return new URLConstructor(scheme.path[0]).origin;
    } catch (error) {
      return 'null';
    }
    if (scheme == 'file' || !this.isSpecial()) return 'null';
    return scheme + '://' + serializeHost(this.host) + (port !== null ? ':' + port : '');
  },
  // https://url.spec.whatwg.org/#dom-url-protocol
  getProtocol: function () {
    return this.scheme + ':';
  },
  setProtocol: function (protocol) {
    this.parse($toString(protocol) + ':', SCHEME_START);
  },
  // https://url.spec.whatwg.org/#dom-url-username
  getUsername: function () {
    return this.username;
  },
  setUsername: function (username) {
    var codePoints = arrayFrom($toString(username));
    if (this.cannotHaveUsernamePasswordPort()) return;
    this.username = '';
    for (var i = 0; i < codePoints.length; i++) {
      this.username += percentEncode(codePoints[i], userinfoPercentEncodeSet);
    }
  },
  // https://url.spec.whatwg.org/#dom-url-password
  getPassword: function () {
    return this.password;
  },
  setPassword: function (password) {
    var codePoints = arrayFrom($toString(password));
    if (this.cannotHaveUsernamePasswordPort()) return;
    this.password = '';
    for (var i = 0; i < codePoints.length; i++) {
      this.password += percentEncode(codePoints[i], userinfoPercentEncodeSet);
    }
  },
  // https://url.spec.whatwg.org/#dom-url-host
  getHost: function () {
    var host = this.host;
    var port = this.port;
    return host === null ? ''
      : port === null ? serializeHost(host)
      : serializeHost(host) + ':' + port;
  },
  setHost: function (host) {
    if (this.cannotBeABaseURL) return;
    this.parse(host, HOST);
  },
  // https://url.spec.whatwg.org/#dom-url-hostname
  getHostname: function () {
    var host = this.host;
    return host === null ? '' : serializeHost(host);
  },
  setHostname: function (hostname) {
    if (this.cannotBeABaseURL) return;
    this.parse(hostname, HOSTNAME);
  },
  // https://url.spec.whatwg.org/#dom-url-port
  getPort: function () {
    var port = this.port;
    return port === null ? '' : $toString(port);
  },
  setPort: function (port) {
    if (this.cannotHaveUsernamePasswordPort()) return;
    port = $toString(port);
    if (port == '') this.port = null;
    else this.parse(port, PORT);
  },
  // https://url.spec.whatwg.org/#dom-url-pathname
  getPathname: function () {
    var path = this.path;
    return this.cannotBeABaseURL ? path[0] : path.length ? '/' + join(path, '/') : '';
  },
  setPathname: function (pathname) {
    if (this.cannotBeABaseURL) return;
    this.path = [];
    this.parse(pathname, PATH_START);
  },
  // https://url.spec.whatwg.org/#dom-url-search
  getSearch: function () {
    var query = this.query;
    return query ? '?' + query : '';
  },
  setSearch: function (search) {
    search = $toString(search);
    if (search == '') {
      this.query = null;
    } else {
      if ('?' == charAt(search, 0)) search = stringSlice(search, 1);
      this.query = '';
      this.parse(search, QUERY);
    }
    this.searchParams.update();
  },
  // https://url.spec.whatwg.org/#dom-url-searchparams
  getSearchParams: function () {
    return this.searchParams.facade;
  },
  // https://url.spec.whatwg.org/#dom-url-hash
  getHash: function () {
    var fragment = this.fragment;
    return fragment ? '#' + fragment : '';
  },
  setHash: function (hash) {
    hash = $toString(hash);
    if (hash == '') {
      this.fragment = null;
      return;
    }
    if ('#' == charAt(hash, 0)) hash = stringSlice(hash, 1);
    this.fragment = '';
    this.parse(hash, FRAGMENT);
  },
  update: function () {
    this.query = this.searchParams.serialize() || null;
  }
};

// `URL` constructor
// https://url.spec.whatwg.org/#url-class
var URLConstructor = function URL(url /* , base */) {
  var that = anInstance(this, URLPrototype);
  var base = validateArgumentsLength(arguments.length, 1) > 1 ? arguments[1] : undefined;
  var state = setInternalState(that, new URLState(url, false, base));
  if (!DESCRIPTORS) {
    that.href = state.serialize();
    that.origin = state.getOrigin();
    that.protocol = state.getProtocol();
    that.username = state.getUsername();
    that.password = state.getPassword();
    that.host = state.getHost();
    that.hostname = state.getHostname();
    that.port = state.getPort();
    that.pathname = state.getPathname();
    that.search = state.getSearch();
    that.searchParams = state.getSearchParams();
    that.hash = state.getHash();
  }
};

var URLPrototype = URLConstructor.prototype;

var accessorDescriptor = function (getter, setter) {
  return {
    get: function () {
      return getInternalURLState(this)[getter]();
    },
    set: setter && function (value) {
      return getInternalURLState(this)[setter](value);
    },
    configurable: true,
    enumerable: true
  };
};

if (DESCRIPTORS) {
  // `URL.prototype.href` accessors pair
  // https://url.spec.whatwg.org/#dom-url-href
  defineBuiltInAccessor(URLPrototype, 'href', accessorDescriptor('serialize', 'setHref'));
  // `URL.prototype.origin` getter
  // https://url.spec.whatwg.org/#dom-url-origin
  defineBuiltInAccessor(URLPrototype, 'origin', accessorDescriptor('getOrigin'));
  // `URL.prototype.protocol` accessors pair
  // https://url.spec.whatwg.org/#dom-url-protocol
  defineBuiltInAccessor(URLPrototype, 'protocol', accessorDescriptor('getProtocol', 'setProtocol'));
  // `URL.prototype.username` accessors pair
  // https://url.spec.whatwg.org/#dom-url-username
  defineBuiltInAccessor(URLPrototype, 'username', accessorDescriptor('getUsername', 'setUsername'));
  // `URL.prototype.password` accessors pair
  // https://url.spec.whatwg.org/#dom-url-password
  defineBuiltInAccessor(URLPrototype, 'password', accessorDescriptor('getPassword', 'setPassword'));
  // `URL.prototype.host` accessors pair
  // https://url.spec.whatwg.org/#dom-url-host
  defineBuiltInAccessor(URLPrototype, 'host', accessorDescriptor('getHost', 'setHost'));
  // `URL.prototype.hostname` accessors pair
  // https://url.spec.whatwg.org/#dom-url-hostname
  defineBuiltInAccessor(URLPrototype, 'hostname', accessorDescriptor('getHostname', 'setHostname'));
  // `URL.prototype.port` accessors pair
  // https://url.spec.whatwg.org/#dom-url-port
  defineBuiltInAccessor(URLPrototype, 'port', accessorDescriptor('getPort', 'setPort'));
  // `URL.prototype.pathname` accessors pair
  // https://url.spec.whatwg.org/#dom-url-pathname
  defineBuiltInAccessor(URLPrototype, 'pathname', accessorDescriptor('getPathname', 'setPathname'));
  // `URL.prototype.search` accessors pair
  // https://url.spec.whatwg.org/#dom-url-search
  defineBuiltInAccessor(URLPrototype, 'search', accessorDescriptor('getSearch', 'setSearch'));
  // `URL.prototype.searchParams` getter
  // https://url.spec.whatwg.org/#dom-url-searchparams
  defineBuiltInAccessor(URLPrototype, 'searchParams', accessorDescriptor('getSearchParams'));
  // `URL.prototype.hash` accessors pair
  // https://url.spec.whatwg.org/#dom-url-hash
  defineBuiltInAccessor(URLPrototype, 'hash', accessorDescriptor('getHash', 'setHash'));
}

// `URL.prototype.toJSON` method
// https://url.spec.whatwg.org/#dom-url-tojson
defineBuiltIn(URLPrototype, 'toJSON', function toJSON() {
  return getInternalURLState(this).serialize();
}, { enumerable: true });

// `URL.prototype.toString` method
// https://url.spec.whatwg.org/#URL-stringification-behavior
defineBuiltIn(URLPrototype, 'toString', function toString() {
  return getInternalURLState(this).serialize();
}, { enumerable: true });

if (NativeURL) {
  var nativeCreateObjectURL = NativeURL.createObjectURL;
  var nativeRevokeObjectURL = NativeURL.revokeObjectURL;
  // `URL.createObjectURL` method
  // https://developer.mozilla.org/en-US/docs/Web/API/URL/createObjectURL
  if (nativeCreateObjectURL) defineBuiltIn(URLConstructor, 'createObjectURL', bind(nativeCreateObjectURL, NativeURL));
  // `URL.revokeObjectURL` method
  // https://developer.mozilla.org/en-US/docs/Web/API/URL/revokeObjectURL
  if (nativeRevokeObjectURL) defineBuiltIn(URLConstructor, 'revokeObjectURL', bind(nativeRevokeObjectURL, NativeURL));
}

setToStringTag(URLConstructor, 'URL');

$({ global: true, constructor: true, forced: !USE_NATIVE_URL, sham: !DESCRIPTORS }, {
  URL: URLConstructor
});


/***/ }),

/***/ "408a":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");

// `thisNumberValue` abstract operation
// https://tc39.es/ecma262/#sec-thisnumbervalue
module.exports = uncurryThis(1.0.valueOf);


/***/ }),

/***/ "40d5":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

module.exports = !fails(function () {
  // eslint-disable-next-line es/no-function-prototype-bind -- safe
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});


/***/ }),

/***/ "4198":
/***/ (function(module, exports) {



/***/ }),

/***/ "428f":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");

module.exports = global;


/***/ }),

/***/ "44ad":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");
var fails = __webpack_require__("d039");
var classof = __webpack_require__("c6b6");

var $Object = Object;
var split = uncurryThis(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) == 'String' ? split(it, '') : $Object(it);
} : $Object;


/***/ }),

/***/ "44d2":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");
var create = __webpack_require__("7c73");
var defineProperty = __webpack_require__("9bf2").f;

var UNSCOPABLES = wellKnownSymbol('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] == undefined) {
  defineProperty(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create(null)
  });
}

// add a key to Array.prototype[@@unscopables]
module.exports = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};


/***/ }),

/***/ "4754":
/***/ (function(module, exports) {

// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
module.exports = function (value, done) {
  return { value: value, done: done };
};


/***/ }),

/***/ "4840":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("825a");
var aConstructor = __webpack_require__("5087");
var isNullOrUndefined = __webpack_require__("7234");
var wellKnownSymbol = __webpack_require__("b622");

var SPECIES = wellKnownSymbol('species');

// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
module.exports = function (O, defaultConstructor) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || isNullOrUndefined(S = anObject(C)[SPECIES]) ? defaultConstructor : aConstructor(S);
};


/***/ }),

/***/ "485a":
/***/ (function(module, exports, __webpack_require__) {

var call = __webpack_require__("c65b");
var isCallable = __webpack_require__("1626");
var isObject = __webpack_require__("861d");

var $TypeError = TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
module.exports = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  if (isCallable(fn = input.valueOf) && !isObject(val = call(fn, input))) return val;
  if (pref !== 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  throw $TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "48ad":
/***/ (function(module, exports) {



/***/ }),

/***/ "498a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $trim = __webpack_require__("58a8").trim;
var forcedStringTrimMethod = __webpack_require__("c8d2");

// `String.prototype.trim` method
// https://tc39.es/ecma262/#sec-string.prototype.trim
$({ target: 'String', proto: true, forced: forcedStringTrimMethod('trim') }, {
  trim: function trim() {
    return $trim(this);
  }
});


/***/ }),

/***/ "4b11":
/***/ (function(module, exports) {

// eslint-disable-next-line es/no-typed-arrays -- safe
module.exports = typeof ArrayBuffer != 'undefined' && typeof DataView != 'undefined';


/***/ }),

/***/ "4d64":
/***/ (function(module, exports, __webpack_require__) {

var toIndexedObject = __webpack_require__("fc6a");
var toAbsoluteIndex = __webpack_require__("23cb");
var lengthOfArrayLike = __webpack_require__("07fa");

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = lengthOfArrayLike(O);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};


/***/ }),

/***/ "4dae":
/***/ (function(module, exports, __webpack_require__) {

var toAbsoluteIndex = __webpack_require__("23cb");
var lengthOfArrayLike = __webpack_require__("07fa");
var createProperty = __webpack_require__("8418");

var $Array = Array;
var max = Math.max;

module.exports = function (O, start, end) {
  var length = lengthOfArrayLike(O);
  var k = toAbsoluteIndex(start, length);
  var fin = toAbsoluteIndex(end === undefined ? length : end, length);
  var result = $Array(max(fin - k, 0));
  for (var n = 0; k < fin; k++, n++) createProperty(result, n, O[k]);
  result.length = n;
  return result;
};


/***/ }),

/***/ "4de4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $filter = __webpack_require__("b727").filter;
var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('filter');

// `Array.prototype.filter` method
// https://tc39.es/ecma262/#sec-array.prototype.filter
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "4df4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var bind = __webpack_require__("0366");
var call = __webpack_require__("c65b");
var toObject = __webpack_require__("7b0b");
var callWithSafeIterationClosing = __webpack_require__("9bdd");
var isArrayIteratorMethod = __webpack_require__("e95a");
var isConstructor = __webpack_require__("68ee");
var lengthOfArrayLike = __webpack_require__("07fa");
var createProperty = __webpack_require__("8418");
var getIterator = __webpack_require__("9a1f");
var getIteratorMethod = __webpack_require__("35a1");

var $Array = Array;

// `Array.from` method implementation
// https://tc39.es/ecma262/#sec-array.from
module.exports = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
  var O = toObject(arrayLike);
  var IS_CONSTRUCTOR = isConstructor(this);
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
  var mapping = mapfn !== undefined;
  if (mapping) mapfn = bind(mapfn, argumentsLength > 2 ? arguments[2] : undefined);
  var iteratorMethod = getIteratorMethod(O);
  var index = 0;
  var length, result, step, iterator, next, value;
  // if the target is not iterable or it's an array with the default iterator - use a simple case
  if (iteratorMethod && !(this === $Array && isArrayIteratorMethod(iteratorMethod))) {
    iterator = getIterator(O, iteratorMethod);
    next = iterator.next;
    result = IS_CONSTRUCTOR ? new this() : [];
    for (;!(step = call(next, iterator)).done; index++) {
      value = mapping ? callWithSafeIterationClosing(iterator, mapfn, [step.value, index], true) : step.value;
      createProperty(result, index, value);
    }
  } else {
    length = lengthOfArrayLike(O);
    result = IS_CONSTRUCTOR ? new this(length) : $Array(length);
    for (;length > index; index++) {
      value = mapping ? mapfn(O[index], index) : O[index];
      createProperty(result, index, value);
    }
  }
  result.length = index;
  return result;
};


/***/ }),

/***/ "4ec9":
/***/ (function(module, exports, __webpack_require__) {

// TODO: Remove this module from `core-js@4` since it's replaced to module below
__webpack_require__("6f48");


/***/ }),

/***/ "4fad":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");
var isObject = __webpack_require__("861d");
var classof = __webpack_require__("c6b6");
var ARRAY_BUFFER_NON_EXTENSIBLE = __webpack_require__("d86b");

// eslint-disable-next-line es/no-object-isextensible -- safe
var $isExtensible = Object.isExtensible;
var FAILS_ON_PRIMITIVES = fails(function () { $isExtensible(1); });

// `Object.isExtensible` method
// https://tc39.es/ecma262/#sec-object.isextensible
module.exports = (FAILS_ON_PRIMITIVES || ARRAY_BUFFER_NON_EXTENSIBLE) ? function isExtensible(it) {
  if (!isObject(it)) return false;
  if (ARRAY_BUFFER_NON_EXTENSIBLE && classof(it) == 'ArrayBuffer') return false;
  return $isExtensible ? $isExtensible(it) : true;
} : $isExtensible;


/***/ }),

/***/ "5087":
/***/ (function(module, exports, __webpack_require__) {

var isConstructor = __webpack_require__("68ee");
var tryToString = __webpack_require__("0d51");

var $TypeError = TypeError;

// `Assert: IsConstructor(argument) is true`
module.exports = function (argument) {
  if (isConstructor(argument)) return argument;
  throw $TypeError(tryToString(argument) + ' is not a constructor');
};


/***/ }),

/***/ "50c4":
/***/ (function(module, exports, __webpack_require__) {

var toIntegerOrInfinity = __webpack_require__("5926");

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function (argument) {
  return argument > 0 ? min(toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


/***/ }),

/***/ "5319":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var apply = __webpack_require__("2ba4");
var call = __webpack_require__("c65b");
var uncurryThis = __webpack_require__("e330");
var fixRegExpWellKnownSymbolLogic = __webpack_require__("d784");
var fails = __webpack_require__("d039");
var anObject = __webpack_require__("825a");
var isCallable = __webpack_require__("1626");
var isNullOrUndefined = __webpack_require__("7234");
var toIntegerOrInfinity = __webpack_require__("5926");
var toLength = __webpack_require__("50c4");
var toString = __webpack_require__("577e");
var requireObjectCoercible = __webpack_require__("1d80");
var advanceStringIndex = __webpack_require__("8aa5");
var getMethod = __webpack_require__("dc4a");
var getSubstitution = __webpack_require__("0cb2");
var regExpExec = __webpack_require__("14c3");
var wellKnownSymbol = __webpack_require__("b622");

var REPLACE = wellKnownSymbol('replace');
var max = Math.max;
var min = Math.min;
var concat = uncurryThis([].concat);
var push = uncurryThis([].push);
var stringIndexOf = uncurryThis(''.indexOf);
var stringSlice = uncurryThis(''.slice);

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var REPLACE_KEEPS_$0 = (function () {
  // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
  return 'a'.replace(/./, '$0') === '$0';
})();

// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = (function () {
  if (/./[REPLACE]) {
    return /./[REPLACE]('a', '$0') === '';
  }
  return false;
})();

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  // eslint-disable-next-line regexp/no-useless-dollar-replacements -- false positive
  return ''.replace(re, '$<a>') !== '7';
});

// @@replace logic
fixRegExpWellKnownSymbolLogic('replace', function (_, nativeReplace, maybeCallNative) {
  var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';

  return [
    // `String.prototype.replace` method
    // https://tc39.es/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = requireObjectCoercible(this);
      var replacer = isNullOrUndefined(searchValue) ? undefined : getMethod(searchValue, REPLACE);
      return replacer
        ? call(replacer, searchValue, O, replaceValue)
        : call(nativeReplace, toString(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
    function (string, replaceValue) {
      var rx = anObject(this);
      var S = toString(string);

      if (
        typeof replaceValue == 'string' &&
        stringIndexOf(replaceValue, UNSAFE_SUBSTITUTE) === -1 &&
        stringIndexOf(replaceValue, '$<') === -1
      ) {
        var res = maybeCallNative(nativeReplace, rx, S, replaceValue);
        if (res.done) return res.value;
      }

      var functionalReplace = isCallable(replaceValue);
      if (!functionalReplace) replaceValue = toString(replaceValue);

      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;

        push(results, result);
        if (!global) break;

        var matchStr = toString(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }

      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];

        var matched = toString(result[0]);
        var position = max(min(toIntegerOrInfinity(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) push(captures, maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = concat([matched], captures, position, S);
          if (namedCaptures !== undefined) push(replacerArgs, namedCaptures);
          var replacement = toString(apply(replaceValue, undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += stringSlice(S, nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + stringSlice(S, nextSourcePosition);
    }
  ];
}, !REPLACE_SUPPORTS_NAMED_GROUPS || !REPLACE_KEEPS_$0 || REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);


/***/ }),

/***/ "5352":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`
__webpack_require__("e260");
var $ = __webpack_require__("23e7");
var global = __webpack_require__("da84");
var call = __webpack_require__("c65b");
var uncurryThis = __webpack_require__("e330");
var DESCRIPTORS = __webpack_require__("83ab");
var USE_NATIVE_URL = __webpack_require__("f354");
var defineBuiltIn = __webpack_require__("cb2d");
var defineBuiltIns = __webpack_require__("6964");
var setToStringTag = __webpack_require__("d44e");
var createIteratorConstructor = __webpack_require__("dcc3");
var InternalStateModule = __webpack_require__("69f3");
var anInstance = __webpack_require__("19aa");
var isCallable = __webpack_require__("1626");
var hasOwn = __webpack_require__("1a2d");
var bind = __webpack_require__("0366");
var classof = __webpack_require__("f5df");
var anObject = __webpack_require__("825a");
var isObject = __webpack_require__("861d");
var $toString = __webpack_require__("577e");
var create = __webpack_require__("7c73");
var createPropertyDescriptor = __webpack_require__("5c6c");
var getIterator = __webpack_require__("9a1f");
var getIteratorMethod = __webpack_require__("35a1");
var validateArgumentsLength = __webpack_require__("d6d6");
var wellKnownSymbol = __webpack_require__("b622");
var arraySort = __webpack_require__("addb");

var ITERATOR = wellKnownSymbol('iterator');
var URL_SEARCH_PARAMS = 'URLSearchParams';
var URL_SEARCH_PARAMS_ITERATOR = URL_SEARCH_PARAMS + 'Iterator';
var setInternalState = InternalStateModule.set;
var getInternalParamsState = InternalStateModule.getterFor(URL_SEARCH_PARAMS);
var getInternalIteratorState = InternalStateModule.getterFor(URL_SEARCH_PARAMS_ITERATOR);
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Avoid NodeJS experimental warning
var safeGetBuiltIn = function (name) {
  if (!DESCRIPTORS) return global[name];
  var descriptor = getOwnPropertyDescriptor(global, name);
  return descriptor && descriptor.value;
};

var nativeFetch = safeGetBuiltIn('fetch');
var NativeRequest = safeGetBuiltIn('Request');
var Headers = safeGetBuiltIn('Headers');
var RequestPrototype = NativeRequest && NativeRequest.prototype;
var HeadersPrototype = Headers && Headers.prototype;
var RegExp = global.RegExp;
var TypeError = global.TypeError;
var decodeURIComponent = global.decodeURIComponent;
var encodeURIComponent = global.encodeURIComponent;
var charAt = uncurryThis(''.charAt);
var join = uncurryThis([].join);
var push = uncurryThis([].push);
var replace = uncurryThis(''.replace);
var shift = uncurryThis([].shift);
var splice = uncurryThis([].splice);
var split = uncurryThis(''.split);
var stringSlice = uncurryThis(''.slice);

var plus = /\+/g;
var sequences = Array(4);

var percentSequence = function (bytes) {
  return sequences[bytes - 1] || (sequences[bytes - 1] = RegExp('((?:%[\\da-f]{2}){' + bytes + '})', 'gi'));
};

var percentDecode = function (sequence) {
  try {
    return decodeURIComponent(sequence);
  } catch (error) {
    return sequence;
  }
};

var deserialize = function (it) {
  var result = replace(it, plus, ' ');
  var bytes = 4;
  try {
    return decodeURIComponent(result);
  } catch (error) {
    while (bytes) {
      result = replace(result, percentSequence(bytes--), percentDecode);
    }
    return result;
  }
};

var find = /[!'()~]|%20/g;

var replacements = {
  '!': '%21',
  "'": '%27',
  '(': '%28',
  ')': '%29',
  '~': '%7E',
  '%20': '+'
};

var replacer = function (match) {
  return replacements[match];
};

var serialize = function (it) {
  return replace(encodeURIComponent(it), find, replacer);
};

var URLSearchParamsIterator = createIteratorConstructor(function Iterator(params, kind) {
  setInternalState(this, {
    type: URL_SEARCH_PARAMS_ITERATOR,
    iterator: getIterator(getInternalParamsState(params).entries),
    kind: kind
  });
}, 'Iterator', function next() {
  var state = getInternalIteratorState(this);
  var kind = state.kind;
  var step = state.iterator.next();
  var entry = step.value;
  if (!step.done) {
    step.value = kind === 'keys' ? entry.key : kind === 'values' ? entry.value : [entry.key, entry.value];
  } return step;
}, true);

var URLSearchParamsState = function (init) {
  this.entries = [];
  this.url = null;

  if (init !== undefined) {
    if (isObject(init)) this.parseObject(init);
    else this.parseQuery(typeof init == 'string' ? charAt(init, 0) === '?' ? stringSlice(init, 1) : init : $toString(init));
  }
};

URLSearchParamsState.prototype = {
  type: URL_SEARCH_PARAMS,
  bindURL: function (url) {
    this.url = url;
    this.update();
  },
  parseObject: function (object) {
    var iteratorMethod = getIteratorMethod(object);
    var iterator, next, step, entryIterator, entryNext, first, second;

    if (iteratorMethod) {
      iterator = getIterator(object, iteratorMethod);
      next = iterator.next;
      while (!(step = call(next, iterator)).done) {
        entryIterator = getIterator(anObject(step.value));
        entryNext = entryIterator.next;
        if (
          (first = call(entryNext, entryIterator)).done ||
          (second = call(entryNext, entryIterator)).done ||
          !call(entryNext, entryIterator).done
        ) throw TypeError('Expected sequence with length 2');
        push(this.entries, { key: $toString(first.value), value: $toString(second.value) });
      }
    } else for (var key in object) if (hasOwn(object, key)) {
      push(this.entries, { key: key, value: $toString(object[key]) });
    }
  },
  parseQuery: function (query) {
    if (query) {
      var attributes = split(query, '&');
      var index = 0;
      var attribute, entry;
      while (index < attributes.length) {
        attribute = attributes[index++];
        if (attribute.length) {
          entry = split(attribute, '=');
          push(this.entries, {
            key: deserialize(shift(entry)),
            value: deserialize(join(entry, '='))
          });
        }
      }
    }
  },
  serialize: function () {
    var entries = this.entries;
    var result = [];
    var index = 0;
    var entry;
    while (index < entries.length) {
      entry = entries[index++];
      push(result, serialize(entry.key) + '=' + serialize(entry.value));
    } return join(result, '&');
  },
  update: function () {
    this.entries.length = 0;
    this.parseQuery(this.url.query);
  },
  updateURL: function () {
    if (this.url) this.url.update();
  }
};

// `URLSearchParams` constructor
// https://url.spec.whatwg.org/#interface-urlsearchparams
var URLSearchParamsConstructor = function URLSearchParams(/* init */) {
  anInstance(this, URLSearchParamsPrototype);
  var init = arguments.length > 0 ? arguments[0] : undefined;
  setInternalState(this, new URLSearchParamsState(init));
};

var URLSearchParamsPrototype = URLSearchParamsConstructor.prototype;

defineBuiltIns(URLSearchParamsPrototype, {
  // `URLSearchParams.prototype.append` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-append
  append: function append(name, value) {
    validateArgumentsLength(arguments.length, 2);
    var state = getInternalParamsState(this);
    push(state.entries, { key: $toString(name), value: $toString(value) });
    state.updateURL();
  },
  // `URLSearchParams.prototype.delete` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-delete
  'delete': function (name) {
    validateArgumentsLength(arguments.length, 1);
    var state = getInternalParamsState(this);
    var entries = state.entries;
    var key = $toString(name);
    var index = 0;
    while (index < entries.length) {
      if (entries[index].key === key) splice(entries, index, 1);
      else index++;
    }
    state.updateURL();
  },
  // `URLSearchParams.prototype.get` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-get
  get: function get(name) {
    validateArgumentsLength(arguments.length, 1);
    var entries = getInternalParamsState(this).entries;
    var key = $toString(name);
    var index = 0;
    for (; index < entries.length; index++) {
      if (entries[index].key === key) return entries[index].value;
    }
    return null;
  },
  // `URLSearchParams.prototype.getAll` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-getall
  getAll: function getAll(name) {
    validateArgumentsLength(arguments.length, 1);
    var entries = getInternalParamsState(this).entries;
    var key = $toString(name);
    var result = [];
    var index = 0;
    for (; index < entries.length; index++) {
      if (entries[index].key === key) push(result, entries[index].value);
    }
    return result;
  },
  // `URLSearchParams.prototype.has` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-has
  has: function has(name) {
    validateArgumentsLength(arguments.length, 1);
    var entries = getInternalParamsState(this).entries;
    var key = $toString(name);
    var index = 0;
    while (index < entries.length) {
      if (entries[index++].key === key) return true;
    }
    return false;
  },
  // `URLSearchParams.prototype.set` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-set
  set: function set(name, value) {
    validateArgumentsLength(arguments.length, 1);
    var state = getInternalParamsState(this);
    var entries = state.entries;
    var found = false;
    var key = $toString(name);
    var val = $toString(value);
    var index = 0;
    var entry;
    for (; index < entries.length; index++) {
      entry = entries[index];
      if (entry.key === key) {
        if (found) splice(entries, index--, 1);
        else {
          found = true;
          entry.value = val;
        }
      }
    }
    if (!found) push(entries, { key: key, value: val });
    state.updateURL();
  },
  // `URLSearchParams.prototype.sort` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-sort
  sort: function sort() {
    var state = getInternalParamsState(this);
    arraySort(state.entries, function (a, b) {
      return a.key > b.key ? 1 : -1;
    });
    state.updateURL();
  },
  // `URLSearchParams.prototype.forEach` method
  forEach: function forEach(callback /* , thisArg */) {
    var entries = getInternalParamsState(this).entries;
    var boundFunction = bind(callback, arguments.length > 1 ? arguments[1] : undefined);
    var index = 0;
    var entry;
    while (index < entries.length) {
      entry = entries[index++];
      boundFunction(entry.value, entry.key, this);
    }
  },
  // `URLSearchParams.prototype.keys` method
  keys: function keys() {
    return new URLSearchParamsIterator(this, 'keys');
  },
  // `URLSearchParams.prototype.values` method
  values: function values() {
    return new URLSearchParamsIterator(this, 'values');
  },
  // `URLSearchParams.prototype.entries` method
  entries: function entries() {
    return new URLSearchParamsIterator(this, 'entries');
  }
}, { enumerable: true });

// `URLSearchParams.prototype[@@iterator]` method
defineBuiltIn(URLSearchParamsPrototype, ITERATOR, URLSearchParamsPrototype.entries, { name: 'entries' });

// `URLSearchParams.prototype.toString` method
// https://url.spec.whatwg.org/#urlsearchparams-stringification-behavior
defineBuiltIn(URLSearchParamsPrototype, 'toString', function toString() {
  return getInternalParamsState(this).serialize();
}, { enumerable: true });

setToStringTag(URLSearchParamsConstructor, URL_SEARCH_PARAMS);

$({ global: true, constructor: true, forced: !USE_NATIVE_URL }, {
  URLSearchParams: URLSearchParamsConstructor
});

// Wrap `fetch` and `Request` for correct work with polyfilled `URLSearchParams`
if (!USE_NATIVE_URL && isCallable(Headers)) {
  var headersHas = uncurryThis(HeadersPrototype.has);
  var headersSet = uncurryThis(HeadersPrototype.set);

  var wrapRequestOptions = function (init) {
    if (isObject(init)) {
      var body = init.body;
      var headers;
      if (classof(body) === URL_SEARCH_PARAMS) {
        headers = init.headers ? new Headers(init.headers) : new Headers();
        if (!headersHas(headers, 'content-type')) {
          headersSet(headers, 'content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
        return create(init, {
          body: createPropertyDescriptor(0, $toString(body)),
          headers: createPropertyDescriptor(0, headers)
        });
      }
    } return init;
  };

  if (isCallable(nativeFetch)) {
    $({ global: true, enumerable: true, dontCallGetSet: true, forced: true }, {
      fetch: function fetch(input /* , init */) {
        return nativeFetch(input, arguments.length > 1 ? wrapRequestOptions(arguments[1]) : {});
      }
    });
  }

  if (isCallable(NativeRequest)) {
    var RequestConstructor = function Request(input /* , init */) {
      anInstance(this, RequestPrototype);
      return new NativeRequest(input, arguments.length > 1 ? wrapRequestOptions(arguments[1]) : {});
    };

    RequestPrototype.constructor = RequestConstructor;
    RequestConstructor.prototype = RequestPrototype;

    $({ global: true, constructor: true, dontCallGetSet: true, forced: true }, {
      Request: RequestConstructor
    });
  }
}

module.exports = {
  URLSearchParams: URLSearchParamsConstructor,
  getState: getInternalParamsState
};


/***/ }),

/***/ "5692":
/***/ (function(module, exports, __webpack_require__) {

var IS_PURE = __webpack_require__("c430");
var store = __webpack_require__("c6cd");

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.26.0',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2014-2022 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.26.0/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});


/***/ }),

/***/ "56ef":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("d066");
var uncurryThis = __webpack_require__("e330");
var getOwnPropertyNamesModule = __webpack_require__("241c");
var getOwnPropertySymbolsModule = __webpack_require__("7418");
var anObject = __webpack_require__("825a");

var concat = uncurryThis([].concat);

// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
};


/***/ }),

/***/ "577e":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("f5df");

var $String = String;

module.exports = function (argument) {
  if (classof(argument) === 'Symbol') throw TypeError('Cannot convert a Symbol value to a string');
  return $String(argument);
};


/***/ }),

/***/ "57b9":
/***/ (function(module, exports, __webpack_require__) {

var call = __webpack_require__("c65b");
var getBuiltIn = __webpack_require__("d066");
var wellKnownSymbol = __webpack_require__("b622");
var defineBuiltIn = __webpack_require__("cb2d");

module.exports = function () {
  var Symbol = getBuiltIn('Symbol');
  var SymbolPrototype = Symbol && Symbol.prototype;
  var valueOf = SymbolPrototype && SymbolPrototype.valueOf;
  var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

  if (SymbolPrototype && !SymbolPrototype[TO_PRIMITIVE]) {
    // `Symbol.prototype[@@toPrimitive]` method
    // https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
    // eslint-disable-next-line no-unused-vars -- required for .length
    defineBuiltIn(SymbolPrototype, TO_PRIMITIVE, function (hint) {
      return call(valueOf, this);
    }, { arity: 1 });
  }
};


/***/ }),

/***/ "5899":
/***/ (function(module, exports) {

// a string of all valid unicode whitespaces
module.exports = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002' +
  '\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),

/***/ "58a8":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");
var requireObjectCoercible = __webpack_require__("1d80");
var toString = __webpack_require__("577e");
var whitespaces = __webpack_require__("5899");

var replace = uncurryThis(''.replace);
var whitespace = '[' + whitespaces + ']';
var ltrim = RegExp('^' + whitespace + whitespace + '*');
var rtrim = RegExp(whitespace + whitespace + '*$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod = function (TYPE) {
  return function ($this) {
    var string = toString(requireObjectCoercible($this));
    if (TYPE & 1) string = replace(string, ltrim, '');
    if (TYPE & 2) string = replace(string, rtrim, '');
    return string;
  };
};

module.exports = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
  start: createMethod(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimend
  end: createMethod(2),
  // `String.prototype.trim` method
  // https://tc39.es/ecma262/#sec-string.prototype.trim
  trim: createMethod(3)
};


/***/ }),

/***/ "5926":
/***/ (function(module, exports, __webpack_require__) {

var trunc = __webpack_require__("b42e");

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
module.exports = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- NaN check
  return number !== number || number === 0 ? 0 : trunc(number);
};


/***/ }),

/***/ "59ed":
/***/ (function(module, exports, __webpack_require__) {

var isCallable = __webpack_require__("1626");
var tryToString = __webpack_require__("0d51");

var $TypeError = TypeError;

// `Assert: IsCallable(argument) is true`
module.exports = function (argument) {
  if (isCallable(argument)) return argument;
  throw $TypeError(tryToString(argument) + ' is not a function');
};


/***/ }),

/***/ "5a47":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var NATIVE_SYMBOL = __webpack_require__("04f8");
var fails = __webpack_require__("d039");
var getOwnPropertySymbolsModule = __webpack_require__("7418");
var toObject = __webpack_require__("7b0b");

// V8 ~ Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FORCED = !NATIVE_SYMBOL || fails(function () { getOwnPropertySymbolsModule.f(1); });

// `Object.getOwnPropertySymbols` method
// https://tc39.es/ecma262/#sec-object.getownpropertysymbols
$({ target: 'Object', stat: true, forced: FORCED }, {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    var $getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
    return $getOwnPropertySymbols ? $getOwnPropertySymbols(toObject(it)) : [];
  }
});


/***/ }),

/***/ "5b2b":
/***/ (function(module, exports) {



/***/ }),

/***/ "5c6c":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "5d64":
/***/ (function(module, exports) {



/***/ }),

/***/ "5e77":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var hasOwn = __webpack_require__("1a2d");

var FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn(FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS || (DESCRIPTORS && getDescriptor(FunctionPrototype, 'name').configurable));

module.exports = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};


/***/ }),

/***/ "5fb2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// based on https://github.com/bestiejs/punycode.js/blob/master/punycode.js
var uncurryThis = __webpack_require__("e330");

var maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1
var base = 36;
var tMin = 1;
var tMax = 26;
var skew = 38;
var damp = 700;
var initialBias = 72;
var initialN = 128; // 0x80
var delimiter = '-'; // '\x2D'
var regexNonASCII = /[^\0-\u007E]/; // non-ASCII chars
var regexSeparators = /[.\u3002\uFF0E\uFF61]/g; // RFC 3490 separators
var OVERFLOW_ERROR = 'Overflow: input needs wider integers to process';
var baseMinusTMin = base - tMin;

var $RangeError = RangeError;
var exec = uncurryThis(regexSeparators.exec);
var floor = Math.floor;
var fromCharCode = String.fromCharCode;
var charCodeAt = uncurryThis(''.charCodeAt);
var join = uncurryThis([].join);
var push = uncurryThis([].push);
var replace = uncurryThis(''.replace);
var split = uncurryThis(''.split);
var toLowerCase = uncurryThis(''.toLowerCase);

/**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 */
var ucs2decode = function (string) {
  var output = [];
  var counter = 0;
  var length = string.length;
  while (counter < length) {
    var value = charCodeAt(string, counter++);
    if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
      // It's a high surrogate, and there is a next character.
      var extra = charCodeAt(string, counter++);
      if ((extra & 0xFC00) == 0xDC00) { // Low surrogate.
        push(output, ((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
      } else {
        // It's an unmatched surrogate; only append this code unit, in case the
        // next code unit is the high surrogate of a surrogate pair.
        push(output, value);
        counter--;
      }
    } else {
      push(output, value);
    }
  }
  return output;
};

/**
 * Converts a digit/integer into a basic code point.
 */
var digitToBasic = function (digit) {
  //  0..25 map to ASCII a..z or A..Z
  // 26..35 map to ASCII 0..9
  return digit + 22 + 75 * (digit < 26);
};

/**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 */
var adapt = function (delta, numPoints, firstTime) {
  var k = 0;
  delta = firstTime ? floor(delta / damp) : delta >> 1;
  delta += floor(delta / numPoints);
  while (delta > baseMinusTMin * tMax >> 1) {
    delta = floor(delta / baseMinusTMin);
    k += base;
  }
  return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
};

/**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 */
var encode = function (input) {
  var output = [];

  // Convert the input in UCS-2 to an array of Unicode code points.
  input = ucs2decode(input);

  // Cache the length.
  var inputLength = input.length;

  // Initialize the state.
  var n = initialN;
  var delta = 0;
  var bias = initialBias;
  var i, currentValue;

  // Handle the basic code points.
  for (i = 0; i < input.length; i++) {
    currentValue = input[i];
    if (currentValue < 0x80) {
      push(output, fromCharCode(currentValue));
    }
  }

  var basicLength = output.length; // number of basic code points.
  var handledCPCount = basicLength; // number of code points that have been handled;

  // Finish the basic string with a delimiter unless it's empty.
  if (basicLength) {
    push(output, delimiter);
  }

  // Main encoding loop:
  while (handledCPCount < inputLength) {
    // All non-basic code points < n have been handled already. Find the next larger one:
    var m = maxInt;
    for (i = 0; i < input.length; i++) {
      currentValue = input[i];
      if (currentValue >= n && currentValue < m) {
        m = currentValue;
      }
    }

    // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>, but guard against overflow.
    var handledCPCountPlusOne = handledCPCount + 1;
    if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
      throw $RangeError(OVERFLOW_ERROR);
    }

    delta += (m - n) * handledCPCountPlusOne;
    n = m;

    for (i = 0; i < input.length; i++) {
      currentValue = input[i];
      if (currentValue < n && ++delta > maxInt) {
        throw $RangeError(OVERFLOW_ERROR);
      }
      if (currentValue == n) {
        // Represent delta as a generalized variable-length integer.
        var q = delta;
        var k = base;
        while (true) {
          var t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
          if (q < t) break;
          var qMinusT = q - t;
          var baseMinusT = base - t;
          push(output, fromCharCode(digitToBasic(t + qMinusT % baseMinusT)));
          q = floor(qMinusT / baseMinusT);
          k += base;
        }

        push(output, fromCharCode(digitToBasic(q)));
        bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
        delta = 0;
        handledCPCount++;
      }
    }

    delta++;
    n++;
  }
  return join(output, '');
};

module.exports = function (input) {
  var encoded = [];
  var labels = split(replace(toLowerCase(input), regexSeparators, '\u002E'), '.');
  var i, label;
  for (i = 0; i < labels.length; i++) {
    label = labels[i];
    push(encoded, exec(regexNonASCII, label) ? 'xn--' + encode(label) : label);
  }
  return join(encoded, '.');
};


/***/ }),

/***/ "6011":
/***/ (function(module, exports) {



/***/ }),

/***/ "605d":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("c6b6");
var global = __webpack_require__("da84");

module.exports = classof(global.process) == 'process';


/***/ }),

/***/ "6062":
/***/ (function(module, exports, __webpack_require__) {

// TODO: Remove this module from `core-js@4` since it's replaced to module below
__webpack_require__("1c59");


/***/ }),

/***/ "60da":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__("83ab");
var uncurryThis = __webpack_require__("e330");
var call = __webpack_require__("c65b");
var fails = __webpack_require__("d039");
var objectKeys = __webpack_require__("df75");
var getOwnPropertySymbolsModule = __webpack_require__("7418");
var propertyIsEnumerableModule = __webpack_require__("d1e7");
var toObject = __webpack_require__("7b0b");
var IndexedObject = __webpack_require__("44ad");

// eslint-disable-next-line es/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var defineProperty = Object.defineProperty;
var concat = uncurryThis([].concat);

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
module.exports = !$assign || fails(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS && $assign({ b: 1 }, $assign(defineProperty({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line es/no-symbol -- safe
  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return $assign({}, A)[symbol] != 7 || objectKeys($assign({}, B)).join('') != alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? concat(objectKeys(S), getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || call(propertyIsEnumerable, S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),

/***/ "621a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("da84");
var uncurryThis = __webpack_require__("e330");
var DESCRIPTORS = __webpack_require__("83ab");
var NATIVE_ARRAY_BUFFER = __webpack_require__("4b11");
var FunctionName = __webpack_require__("5e77");
var createNonEnumerableProperty = __webpack_require__("9112");
var defineBuiltIns = __webpack_require__("6964");
var fails = __webpack_require__("d039");
var anInstance = __webpack_require__("19aa");
var toIntegerOrInfinity = __webpack_require__("5926");
var toLength = __webpack_require__("50c4");
var toIndex = __webpack_require__("0b25");
var IEEE754 = __webpack_require__("77a7");
var getPrototypeOf = __webpack_require__("e163");
var setPrototypeOf = __webpack_require__("d2bb");
var getOwnPropertyNames = __webpack_require__("241c").f;
var defineProperty = __webpack_require__("9bf2").f;
var arrayFill = __webpack_require__("81d5");
var arraySlice = __webpack_require__("4dae");
var setToStringTag = __webpack_require__("d44e");
var InternalStateModule = __webpack_require__("69f3");

var PROPER_FUNCTION_NAME = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var getInternalState = InternalStateModule.get;
var setInternalState = InternalStateModule.set;
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length';
var WRONG_INDEX = 'Wrong index';
var NativeArrayBuffer = global[ARRAY_BUFFER];
var $ArrayBuffer = NativeArrayBuffer;
var ArrayBufferPrototype = $ArrayBuffer && $ArrayBuffer[PROTOTYPE];
var $DataView = global[DATA_VIEW];
var DataViewPrototype = $DataView && $DataView[PROTOTYPE];
var ObjectPrototype = Object.prototype;
var Array = global.Array;
var RangeError = global.RangeError;
var fill = uncurryThis(arrayFill);
var reverse = uncurryThis([].reverse);

var packIEEE754 = IEEE754.pack;
var unpackIEEE754 = IEEE754.unpack;

var packInt8 = function (number) {
  return [number & 0xFF];
};

var packInt16 = function (number) {
  return [number & 0xFF, number >> 8 & 0xFF];
};

var packInt32 = function (number) {
  return [number & 0xFF, number >> 8 & 0xFF, number >> 16 & 0xFF, number >> 24 & 0xFF];
};

var unpackInt32 = function (buffer) {
  return buffer[3] << 24 | buffer[2] << 16 | buffer[1] << 8 | buffer[0];
};

var packFloat32 = function (number) {
  return packIEEE754(number, 23, 4);
};

var packFloat64 = function (number) {
  return packIEEE754(number, 52, 8);
};

var addGetter = function (Constructor, key) {
  defineProperty(Constructor[PROTOTYPE], key, { get: function () { return getInternalState(this)[key]; } });
};

var get = function (view, count, index, isLittleEndian) {
  var intIndex = toIndex(index);
  var store = getInternalState(view);
  if (intIndex + count > store.byteLength) throw RangeError(WRONG_INDEX);
  var bytes = getInternalState(store.buffer).bytes;
  var start = intIndex + store.byteOffset;
  var pack = arraySlice(bytes, start, start + count);
  return isLittleEndian ? pack : reverse(pack);
};

var set = function (view, count, index, conversion, value, isLittleEndian) {
  var intIndex = toIndex(index);
  var store = getInternalState(view);
  if (intIndex + count > store.byteLength) throw RangeError(WRONG_INDEX);
  var bytes = getInternalState(store.buffer).bytes;
  var start = intIndex + store.byteOffset;
  var pack = conversion(+value);
  for (var i = 0; i < count; i++) bytes[start + i] = pack[isLittleEndian ? i : count - i - 1];
};

if (!NATIVE_ARRAY_BUFFER) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, ArrayBufferPrototype);
    var byteLength = toIndex(length);
    setInternalState(this, {
      bytes: fill(Array(byteLength), 0),
      byteLength: byteLength
    });
    if (!DESCRIPTORS) this.byteLength = byteLength;
  };

  ArrayBufferPrototype = $ArrayBuffer[PROTOTYPE];

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, DataViewPrototype);
    anInstance(buffer, ArrayBufferPrototype);
    var bufferLength = getInternalState(buffer).byteLength;
    var offset = toIntegerOrInfinity(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    setInternalState(this, {
      buffer: buffer,
      byteLength: byteLength,
      byteOffset: offset
    });
    if (!DESCRIPTORS) {
      this.buffer = buffer;
      this.byteLength = byteLength;
      this.byteOffset = offset;
    }
  };

  DataViewPrototype = $DataView[PROTOTYPE];

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, 'byteLength');
    addGetter($DataView, 'buffer');
    addGetter($DataView, 'byteLength');
    addGetter($DataView, 'byteOffset');
  }

  defineBuiltIns(DataViewPrototype, {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments.length > 1 ? arguments[1] : undefined);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments.length > 1 ? arguments[1] : undefined);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackInt32(get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : undefined));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackInt32(get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : undefined)) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : undefined), 23);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments.length > 1 ? arguments[1] : undefined), 52);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packInt8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packInt8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packInt16, value, arguments.length > 2 ? arguments[2] : undefined);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packInt16, value, arguments.length > 2 ? arguments[2] : undefined);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packInt32, value, arguments.length > 2 ? arguments[2] : undefined);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packInt32, value, arguments.length > 2 ? arguments[2] : undefined);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packFloat32, value, arguments.length > 2 ? arguments[2] : undefined);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packFloat64, value, arguments.length > 2 ? arguments[2] : undefined);
    }
  });
} else {
  var INCORRECT_ARRAY_BUFFER_NAME = PROPER_FUNCTION_NAME && NativeArrayBuffer.name !== ARRAY_BUFFER;
  /* eslint-disable no-new -- required for testing */
  if (!fails(function () {
    NativeArrayBuffer(1);
  }) || !fails(function () {
    new NativeArrayBuffer(-1);
  }) || fails(function () {
    new NativeArrayBuffer();
    new NativeArrayBuffer(1.5);
    new NativeArrayBuffer(NaN);
    return NativeArrayBuffer.length != 1 || INCORRECT_ARRAY_BUFFER_NAME && !CONFIGURABLE_FUNCTION_NAME;
  })) {
    /* eslint-enable no-new -- required for testing */
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, ArrayBufferPrototype);
      return new NativeArrayBuffer(toIndex(length));
    };

    $ArrayBuffer[PROTOTYPE] = ArrayBufferPrototype;

    for (var keys = getOwnPropertyNames(NativeArrayBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) {
        createNonEnumerableProperty($ArrayBuffer, key, NativeArrayBuffer[key]);
      }
    }

    ArrayBufferPrototype.constructor = $ArrayBuffer;
  } else if (INCORRECT_ARRAY_BUFFER_NAME && CONFIGURABLE_FUNCTION_NAME) {
    createNonEnumerableProperty(NativeArrayBuffer, 'name', ARRAY_BUFFER);
  }

  // WebKit bug - the same parent prototype for typed arrays and data view
  if (setPrototypeOf && getPrototypeOf(DataViewPrototype) !== ObjectPrototype) {
    setPrototypeOf(DataViewPrototype, ObjectPrototype);
  }

  // iOS Safari 7.x bug
  var testView = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = uncurryThis(DataViewPrototype.setInt8);
  testView.setInt8(0, 2147483648);
  testView.setInt8(1, 2147483649);
  if (testView.getInt8(0) || !testView.getInt8(1)) defineBuiltIns(DataViewPrototype, {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8(this, byteOffset, value << 24 >> 24);
    }
  }, { unsafe: true });
}

setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);

module.exports = {
  ArrayBuffer: $ArrayBuffer,
  DataView: $DataView
};


/***/ }),

/***/ "6374":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;

module.exports = function (key, value) {
  try {
    defineProperty(global, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global[key] = value;
  } return value;
};


/***/ }),

/***/ "64a0":
/***/ (function(module, exports) {



/***/ }),

/***/ "64a6":
/***/ (function(module, exports) {



/***/ }),

/***/ "6547":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");
var toIntegerOrInfinity = __webpack_require__("5926");
var toString = __webpack_require__("577e");
var requireObjectCoercible = __webpack_require__("1d80");

var charAt = uncurryThis(''.charAt);
var charCodeAt = uncurryThis(''.charCodeAt);
var stringSlice = uncurryThis(''.slice);

var createMethod = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = toString(requireObjectCoercible($this));
    var position = toIntegerOrInfinity(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = charCodeAt(S, position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING
          ? charAt(S, position)
          : first
        : CONVERT_TO_STRING
          ? stringSlice(S, position, position + 2)
          : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

module.exports = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod(true)
};


/***/ }),

/***/ "6566":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var defineProperty = __webpack_require__("9bf2").f;
var create = __webpack_require__("7c73");
var defineBuiltIns = __webpack_require__("6964");
var bind = __webpack_require__("0366");
var anInstance = __webpack_require__("19aa");
var isNullOrUndefined = __webpack_require__("7234");
var iterate = __webpack_require__("2266");
var defineIterator = __webpack_require__("c6d2");
var createIterResultObject = __webpack_require__("4754");
var setSpecies = __webpack_require__("2626");
var DESCRIPTORS = __webpack_require__("83ab");
var fastKey = __webpack_require__("f183").fastKey;
var InternalStateModule = __webpack_require__("69f3");

var setInternalState = InternalStateModule.set;
var internalStateGetterFor = InternalStateModule.getterFor;

module.exports = {
  getConstructor: function (wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
    var Constructor = wrapper(function (that, iterable) {
      anInstance(that, Prototype);
      setInternalState(that, {
        type: CONSTRUCTOR_NAME,
        index: create(null),
        first: undefined,
        last: undefined,
        size: 0
      });
      if (!DESCRIPTORS) that.size = 0;
      if (!isNullOrUndefined(iterable)) iterate(iterable, that[ADDER], { that: that, AS_ENTRIES: IS_MAP });
    });

    var Prototype = Constructor.prototype;

    var getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);

    var define = function (that, key, value) {
      var state = getInternalState(that);
      var entry = getEntry(that, key);
      var previous, index;
      // change existing entry
      if (entry) {
        entry.value = value;
      // create new entry
      } else {
        state.last = entry = {
          index: index = fastKey(key, true),
          key: key,
          value: value,
          previous: previous = state.last,
          next: undefined,
          removed: false
        };
        if (!state.first) state.first = entry;
        if (previous) previous.next = entry;
        if (DESCRIPTORS) state.size++;
        else that.size++;
        // add to index
        if (index !== 'F') state.index[index] = entry;
      } return that;
    };

    var getEntry = function (that, key) {
      var state = getInternalState(that);
      // fast case
      var index = fastKey(key);
      var entry;
      if (index !== 'F') return state.index[index];
      // frozen object case
      for (entry = state.first; entry; entry = entry.next) {
        if (entry.key == key) return entry;
      }
    };

    defineBuiltIns(Prototype, {
      // `{ Map, Set }.prototype.clear()` methods
      // https://tc39.es/ecma262/#sec-map.prototype.clear
      // https://tc39.es/ecma262/#sec-set.prototype.clear
      clear: function clear() {
        var that = this;
        var state = getInternalState(that);
        var data = state.index;
        var entry = state.first;
        while (entry) {
          entry.removed = true;
          if (entry.previous) entry.previous = entry.previous.next = undefined;
          delete data[entry.index];
          entry = entry.next;
        }
        state.first = state.last = undefined;
        if (DESCRIPTORS) state.size = 0;
        else that.size = 0;
      },
      // `{ Map, Set }.prototype.delete(key)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.delete
      // https://tc39.es/ecma262/#sec-set.prototype.delete
      'delete': function (key) {
        var that = this;
        var state = getInternalState(that);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.next;
          var prev = entry.previous;
          delete state.index[entry.index];
          entry.removed = true;
          if (prev) prev.next = next;
          if (next) next.previous = prev;
          if (state.first == entry) state.first = next;
          if (state.last == entry) state.last = prev;
          if (DESCRIPTORS) state.size--;
          else that.size--;
        } return !!entry;
      },
      // `{ Map, Set }.prototype.forEach(callbackfn, thisArg = undefined)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.foreach
      // https://tc39.es/ecma262/#sec-set.prototype.foreach
      forEach: function forEach(callbackfn /* , that = undefined */) {
        var state = getInternalState(this);
        var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        var entry;
        while (entry = entry ? entry.next : state.first) {
          boundFunction(entry.value, entry.key, this);
          // revert to the last existing entry
          while (entry && entry.removed) entry = entry.previous;
        }
      },
      // `{ Map, Set}.prototype.has(key)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.has
      // https://tc39.es/ecma262/#sec-set.prototype.has
      has: function has(key) {
        return !!getEntry(this, key);
      }
    });

    defineBuiltIns(Prototype, IS_MAP ? {
      // `Map.prototype.get(key)` method
      // https://tc39.es/ecma262/#sec-map.prototype.get
      get: function get(key) {
        var entry = getEntry(this, key);
        return entry && entry.value;
      },
      // `Map.prototype.set(key, value)` method
      // https://tc39.es/ecma262/#sec-map.prototype.set
      set: function set(key, value) {
        return define(this, key === 0 ? 0 : key, value);
      }
    } : {
      // `Set.prototype.add(value)` method
      // https://tc39.es/ecma262/#sec-set.prototype.add
      add: function add(value) {
        return define(this, value = value === 0 ? 0 : value, value);
      }
    });
    if (DESCRIPTORS) defineProperty(Prototype, 'size', {
      get: function () {
        return getInternalState(this).size;
      }
    });
    return Constructor;
  },
  setStrong: function (Constructor, CONSTRUCTOR_NAME, IS_MAP) {
    var ITERATOR_NAME = CONSTRUCTOR_NAME + ' Iterator';
    var getInternalCollectionState = internalStateGetterFor(CONSTRUCTOR_NAME);
    var getInternalIteratorState = internalStateGetterFor(ITERATOR_NAME);
    // `{ Map, Set }.prototype.{ keys, values, entries, @@iterator }()` methods
    // https://tc39.es/ecma262/#sec-map.prototype.entries
    // https://tc39.es/ecma262/#sec-map.prototype.keys
    // https://tc39.es/ecma262/#sec-map.prototype.values
    // https://tc39.es/ecma262/#sec-map.prototype-@@iterator
    // https://tc39.es/ecma262/#sec-set.prototype.entries
    // https://tc39.es/ecma262/#sec-set.prototype.keys
    // https://tc39.es/ecma262/#sec-set.prototype.values
    // https://tc39.es/ecma262/#sec-set.prototype-@@iterator
    defineIterator(Constructor, CONSTRUCTOR_NAME, function (iterated, kind) {
      setInternalState(this, {
        type: ITERATOR_NAME,
        target: iterated,
        state: getInternalCollectionState(iterated),
        kind: kind,
        last: undefined
      });
    }, function () {
      var state = getInternalIteratorState(this);
      var kind = state.kind;
      var entry = state.last;
      // revert to the last existing entry
      while (entry && entry.removed) entry = entry.previous;
      // get next entry
      if (!state.target || !(state.last = entry = entry ? entry.next : state.state.first)) {
        // or finish the iteration
        state.target = undefined;
        return createIterResultObject(undefined, true);
      }
      // return step by kind
      if (kind == 'keys') return createIterResultObject(entry.key, false);
      if (kind == 'values') return createIterResultObject(entry.value, false);
      return createIterResultObject([entry.key, entry.value], false);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // `{ Map, Set }.prototype[@@species]` accessors
    // https://tc39.es/ecma262/#sec-get-map-@@species
    // https://tc39.es/ecma262/#sec-get-set-@@species
    setSpecies(CONSTRUCTOR_NAME);
  }
};


/***/ }),

/***/ "65f0":
/***/ (function(module, exports, __webpack_require__) {

var arraySpeciesConstructor = __webpack_require__("0b42");

// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray, length) {
  return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
};


/***/ }),

/***/ "6642":
/***/ (function(module, exports) {



/***/ }),

/***/ "68ee":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");
var fails = __webpack_require__("d039");
var isCallable = __webpack_require__("1626");
var classof = __webpack_require__("f5df");
var getBuiltIn = __webpack_require__("d066");
var inspectSource = __webpack_require__("8925");

var noop = function () { /* empty */ };
var empty = [];
var construct = getBuiltIn('Reflect', 'construct');
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec = uncurryThis(constructorRegExp.exec);
var INCORRECT_TO_STRING = !constructorRegExp.exec(noop);

var isConstructorModern = function isConstructor(argument) {
  if (!isCallable(argument)) return false;
  try {
    construct(noop, empty, argument);
    return true;
  } catch (error) {
    return false;
  }
};

var isConstructorLegacy = function isConstructor(argument) {
  if (!isCallable(argument)) return false;
  switch (classof(argument)) {
    case 'AsyncFunction':
    case 'GeneratorFunction':
    case 'AsyncGeneratorFunction': return false;
  }
  try {
    // we can't check .prototype since constructors produced by .bind haven't it
    // `Function#toString` throws on some built-it function in some legacy engines
    // (for example, `DOMQuad` and similar in FF41-)
    return INCORRECT_TO_STRING || !!exec(constructorRegExp, inspectSource(argument));
  } catch (error) {
    return true;
  }
};

isConstructorLegacy.sham = true;

// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
module.exports = !construct || fails(function () {
  var called;
  return isConstructorModern(isConstructorModern.call)
    || !isConstructorModern(Object)
    || !isConstructorModern(function () { called = true; })
    || called;
}) ? isConstructorLegacy : isConstructorModern;


/***/ }),

/***/ "6964":
/***/ (function(module, exports, __webpack_require__) {

var defineBuiltIn = __webpack_require__("cb2d");

module.exports = function (target, src, options) {
  for (var key in src) defineBuiltIn(target, key, src[key], options);
  return target;
};


/***/ }),

/***/ "69f3":
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_WEAK_MAP = __webpack_require__("cdce");
var global = __webpack_require__("da84");
var isObject = __webpack_require__("861d");
var createNonEnumerableProperty = __webpack_require__("9112");
var hasOwn = __webpack_require__("1a2d");
var shared = __webpack_require__("c6cd");
var sharedKey = __webpack_require__("f772");
var hiddenKeys = __webpack_require__("d012");

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError = global.TypeError;
var WeakMap = global.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared.state) {
  var store = shared.state || (shared.state = new WeakMap());
  /* eslint-disable no-self-assign -- prototype methods protection */
  store.get = store.get;
  store.has = store.has;
  store.set = store.set;
  /* eslint-enable no-self-assign -- prototype methods protection */
  set = function (it, metadata) {
    if (store.has(it)) throw TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    store.set(it, metadata);
    return metadata;
  };
  get = function (it) {
    return store.get(it) || {};
  };
  has = function (it) {
    return store.has(it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    if (hasOwn(it, STATE)) throw TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};


/***/ }),

/***/ "6c42":
/***/ (function(module, exports) {

module.exports = require("merge");

/***/ }),

/***/ "6d61":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var global = __webpack_require__("da84");
var uncurryThis = __webpack_require__("e330");
var isForced = __webpack_require__("94ca");
var defineBuiltIn = __webpack_require__("cb2d");
var InternalMetadataModule = __webpack_require__("f183");
var iterate = __webpack_require__("2266");
var anInstance = __webpack_require__("19aa");
var isCallable = __webpack_require__("1626");
var isNullOrUndefined = __webpack_require__("7234");
var isObject = __webpack_require__("861d");
var fails = __webpack_require__("d039");
var checkCorrectnessOfIteration = __webpack_require__("1c7e");
var setToStringTag = __webpack_require__("d44e");
var inheritIfRequired = __webpack_require__("7156");

module.exports = function (CONSTRUCTOR_NAME, wrapper, common) {
  var IS_MAP = CONSTRUCTOR_NAME.indexOf('Map') !== -1;
  var IS_WEAK = CONSTRUCTOR_NAME.indexOf('Weak') !== -1;
  var ADDER = IS_MAP ? 'set' : 'add';
  var NativeConstructor = global[CONSTRUCTOR_NAME];
  var NativePrototype = NativeConstructor && NativeConstructor.prototype;
  var Constructor = NativeConstructor;
  var exported = {};

  var fixMethod = function (KEY) {
    var uncurriedNativeMethod = uncurryThis(NativePrototype[KEY]);
    defineBuiltIn(NativePrototype, KEY,
      KEY == 'add' ? function add(value) {
        uncurriedNativeMethod(this, value === 0 ? 0 : value);
        return this;
      } : KEY == 'delete' ? function (key) {
        return IS_WEAK && !isObject(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
      } : KEY == 'get' ? function get(key) {
        return IS_WEAK && !isObject(key) ? undefined : uncurriedNativeMethod(this, key === 0 ? 0 : key);
      } : KEY == 'has' ? function has(key) {
        return IS_WEAK && !isObject(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
      } : function set(key, value) {
        uncurriedNativeMethod(this, key === 0 ? 0 : key, value);
        return this;
      }
    );
  };

  var REPLACE = isForced(
    CONSTRUCTOR_NAME,
    !isCallable(NativeConstructor) || !(IS_WEAK || NativePrototype.forEach && !fails(function () {
      new NativeConstructor().entries().next();
    }))
  );

  if (REPLACE) {
    // create collection constructor
    Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
    InternalMetadataModule.enable();
  } else if (isForced(CONSTRUCTOR_NAME, true)) {
    var instance = new Constructor();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~ Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    // eslint-disable-next-line no-new -- required for testing
    var ACCEPT_ITERABLES = checkCorrectnessOfIteration(function (iterable) { new NativeConstructor(iterable); });
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new NativeConstructor();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });

    if (!ACCEPT_ITERABLES) {
      Constructor = wrapper(function (dummy, iterable) {
        anInstance(dummy, NativePrototype);
        var that = inheritIfRequired(new NativeConstructor(), dummy, Constructor);
        if (!isNullOrUndefined(iterable)) iterate(iterable, that[ADDER], { that: that, AS_ENTRIES: IS_MAP });
        return that;
      });
      Constructor.prototype = NativePrototype;
      NativePrototype.constructor = Constructor;
    }

    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }

    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);

    // weak collections should not contains .clear method
    if (IS_WEAK && NativePrototype.clear) delete NativePrototype.clear;
  }

  exported[CONSTRUCTOR_NAME] = Constructor;
  $({ global: true, constructor: true, forced: Constructor != NativeConstructor }, exported);

  setToStringTag(Constructor, CONSTRUCTOR_NAME);

  if (!IS_WEAK) common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);

  return Constructor;
};


/***/ }),

/***/ "6f48":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var collection = __webpack_require__("6d61");
var collectionStrong = __webpack_require__("6566");

// `Map` constructor
// https://tc39.es/ecma262/#sec-map-objects
collection('Map', function (init) {
  return function Map() { return init(this, arguments.length ? arguments[0] : undefined); };
}, collectionStrong);


/***/ }),

/***/ "6f9e":
/***/ (function(module, exports) {



/***/ }),

/***/ "7156":
/***/ (function(module, exports, __webpack_require__) {

var isCallable = __webpack_require__("1626");
var isObject = __webpack_require__("861d");
var setPrototypeOf = __webpack_require__("d2bb");

// makes subclassing work correct for wrapped built-ins
module.exports = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
    // it can work only with native `setPrototypeOf`
    setPrototypeOf &&
    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    isCallable(NewTarget = dummy.constructor) &&
    NewTarget !== Wrapper &&
    isObject(NewTargetPrototype = NewTarget.prototype) &&
    NewTargetPrototype !== Wrapper.prototype
  ) setPrototypeOf($this, NewTargetPrototype);
  return $this;
};


/***/ }),

/***/ "7234":
/***/ (function(module, exports) {

// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
module.exports = function (it) {
  return it === null || it === undefined;
};


/***/ }),

/***/ "729a":
/***/ (function(module, exports) {



/***/ }),

/***/ "7418":
/***/ (function(module, exports) {

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ "7609":
/***/ (function(module, exports) {



/***/ }),

/***/ "77a7":
/***/ (function(module, exports) {

// IEEE754 conversions based on https://github.com/feross/ieee754
var $Array = Array;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;

var pack = function (number, mantissaLength, bytes) {
  var buffer = $Array(bytes);
  var exponentLength = bytes * 8 - mantissaLength - 1;
  var eMax = (1 << exponentLength) - 1;
  var eBias = eMax >> 1;
  var rt = mantissaLength === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var sign = number < 0 || number === 0 && 1 / number < 0 ? 1 : 0;
  var index = 0;
  var exponent, mantissa, c;
  number = abs(number);
  // eslint-disable-next-line no-self-compare -- NaN check
  if (number != number || number === Infinity) {
    // eslint-disable-next-line no-self-compare -- NaN check
    mantissa = number != number ? 1 : 0;
    exponent = eMax;
  } else {
    exponent = floor(log(number) / LN2);
    c = pow(2, -exponent);
    if (number * c < 1) {
      exponent--;
      c *= 2;
    }
    if (exponent + eBias >= 1) {
      number += rt / c;
    } else {
      number += rt * pow(2, 1 - eBias);
    }
    if (number * c >= 2) {
      exponent++;
      c /= 2;
    }
    if (exponent + eBias >= eMax) {
      mantissa = 0;
      exponent = eMax;
    } else if (exponent + eBias >= 1) {
      mantissa = (number * c - 1) * pow(2, mantissaLength);
      exponent = exponent + eBias;
    } else {
      mantissa = number * pow(2, eBias - 1) * pow(2, mantissaLength);
      exponent = 0;
    }
  }
  while (mantissaLength >= 8) {
    buffer[index++] = mantissa & 255;
    mantissa /= 256;
    mantissaLength -= 8;
  }
  exponent = exponent << mantissaLength | mantissa;
  exponentLength += mantissaLength;
  while (exponentLength > 0) {
    buffer[index++] = exponent & 255;
    exponent /= 256;
    exponentLength -= 8;
  }
  buffer[--index] |= sign * 128;
  return buffer;
};

var unpack = function (buffer, mantissaLength) {
  var bytes = buffer.length;
  var exponentLength = bytes * 8 - mantissaLength - 1;
  var eMax = (1 << exponentLength) - 1;
  var eBias = eMax >> 1;
  var nBits = exponentLength - 7;
  var index = bytes - 1;
  var sign = buffer[index--];
  var exponent = sign & 127;
  var mantissa;
  sign >>= 7;
  while (nBits > 0) {
    exponent = exponent * 256 + buffer[index--];
    nBits -= 8;
  }
  mantissa = exponent & (1 << -nBits) - 1;
  exponent >>= -nBits;
  nBits += mantissaLength;
  while (nBits > 0) {
    mantissa = mantissa * 256 + buffer[index--];
    nBits -= 8;
  }
  if (exponent === 0) {
    exponent = 1 - eBias;
  } else if (exponent === eMax) {
    return mantissa ? NaN : sign ? -Infinity : Infinity;
  } else {
    mantissa = mantissa + pow(2, mantissaLength);
    exponent = exponent - eBias;
  } return (sign ? -1 : 1) * mantissa * pow(2, exponent - mantissaLength);
};

module.exports = {
  pack: pack,
  unpack: unpack
};


/***/ }),

/***/ "7839":
/***/ (function(module, exports) {

// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];


/***/ }),

/***/ "785a":
/***/ (function(module, exports, __webpack_require__) {

// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var documentCreateElement = __webpack_require__("cc12");

var classList = documentCreateElement('span').classList;
var DOMTokenListPrototype = classList && classList.constructor && classList.constructor.prototype;

module.exports = DOMTokenListPrototype === Object.prototype ? undefined : DOMTokenListPrototype;


/***/ }),

/***/ "790c":
/***/ (function(module, exports) {

module.exports = require("dom-to-image");

/***/ }),

/***/ "7b0b":
/***/ (function(module, exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__("1d80");

var $Object = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function (argument) {
  return $Object(requireObjectCoercible(argument));
};


/***/ }),

/***/ "7c73":
/***/ (function(module, exports, __webpack_require__) {

/* global ActiveXObject -- old IE, WSH */
var anObject = __webpack_require__("825a");
var definePropertiesModule = __webpack_require__("37e8");
var enumBugKeys = __webpack_require__("7839");
var hiddenKeys = __webpack_require__("d012");
var html = __webpack_require__("1be4");
var documentCreateElement = __webpack_require__("cc12");
var sharedKey = __webpack_require__("f772");

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
};


/***/ }),

/***/ "7d7e":
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_BIND = __webpack_require__("40d5");

var FunctionPrototype = Function.prototype;
var call = FunctionPrototype.call;
var uncurryThisWithBind = NATIVE_BIND && FunctionPrototype.bind.bind(call, call);

module.exports = NATIVE_BIND ? uncurryThisWithBind : function (fn) {
  return function () {
    return call.apply(fn, arguments);
  };
};


/***/ }),

/***/ "81d5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toObject = __webpack_require__("7b0b");
var toAbsoluteIndex = __webpack_require__("23cb");
var lengthOfArrayLike = __webpack_require__("07fa");

// `Array.prototype.fill` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.fill
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = lengthOfArrayLike(O);
  var argumentsLength = arguments.length;
  var index = toAbsoluteIndex(argumentsLength > 1 ? arguments[1] : undefined, length);
  var end = argumentsLength > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),

/***/ "81f2":
/***/ (function(module, exports) {

module.exports = require("debounce");

/***/ }),

/***/ "8208":
/***/ (function(module, exports) {



/***/ }),

/***/ "821e":
/***/ (function(module, exports) {

module.exports = require("is-plain-object");

/***/ }),

/***/ "825a":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");

var $String = String;
var $TypeError = TypeError;

// `Assert: Type(argument) is Object`
module.exports = function (argument) {
  if (isObject(argument)) return argument;
  throw $TypeError($String(argument) + ' is not an object');
};


/***/ }),

/***/ "83ab":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

// Detect IE8's incomplete defineProperty implementation
module.exports = !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});


/***/ }),

/***/ "8418":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toPropertyKey = __webpack_require__("a04b");
var definePropertyModule = __webpack_require__("9bf2");
var createPropertyDescriptor = __webpack_require__("5c6c");

module.exports = function (object, key, value) {
  var propertyKey = toPropertyKey(key);
  if (propertyKey in object) definePropertyModule.f(object, propertyKey, createPropertyDescriptor(0, value));
  else object[propertyKey] = value;
};


/***/ }),

/***/ "841b":
/***/ (function(module, exports) {



/***/ }),

/***/ "841c":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var call = __webpack_require__("c65b");
var fixRegExpWellKnownSymbolLogic = __webpack_require__("d784");
var anObject = __webpack_require__("825a");
var isNullOrUndefined = __webpack_require__("7234");
var requireObjectCoercible = __webpack_require__("1d80");
var sameValue = __webpack_require__("129f");
var toString = __webpack_require__("577e");
var getMethod = __webpack_require__("dc4a");
var regExpExec = __webpack_require__("14c3");

// @@search logic
fixRegExpWellKnownSymbolLogic('search', function (SEARCH, nativeSearch, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.es/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = requireObjectCoercible(this);
      var searcher = isNullOrUndefined(regexp) ? undefined : getMethod(regexp, SEARCH);
      return searcher ? call(searcher, regexp, O) : new RegExp(regexp)[SEARCH](toString(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@search
    function (string) {
      var rx = anObject(this);
      var S = toString(string);
      var res = maybeCallNative(nativeSearch, rx, S);

      if (res.done) return res.value;

      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});


/***/ }),

/***/ "857a":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");
var requireObjectCoercible = __webpack_require__("1d80");
var toString = __webpack_require__("577e");

var quot = /"/g;
var replace = uncurryThis(''.replace);

// `CreateHTML` abstract operation
// https://tc39.es/ecma262/#sec-createhtml
module.exports = function (string, tag, attribute, value) {
  var S = toString(requireObjectCoercible(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + replace(toString(value), quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};


/***/ }),

/***/ "860c":
/***/ (function(module, exports) {

module.exports = require("leaflet");

/***/ }),

/***/ "861d":
/***/ (function(module, exports, __webpack_require__) {

var isCallable = __webpack_require__("1626");
var $documentAll = __webpack_require__("8ea1");

var documentAll = $documentAll.all;

module.exports = $documentAll.IS_HTMLDDA ? function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it) || it === documentAll;
} : function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it);
};


/***/ }),

/***/ "8875":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// addapted from the document.currentScript polyfill by Adam Miller
// MIT license
// source: https://github.com/amiller-gh/currentScript-polyfill

// added support for Firefox https://bugzilla.mozilla.org/show_bug.cgi?id=1620505

(function (root, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
}(typeof self !== 'undefined' ? self : this, function () {
  function getCurrentScript () {
    var descriptor = Object.getOwnPropertyDescriptor(document, 'currentScript')
    // for chrome
    if (!descriptor && 'currentScript' in document && document.currentScript) {
      return document.currentScript
    }

    // for other browsers with native support for currentScript
    if (descriptor && descriptor.get !== getCurrentScript && document.currentScript) {
      return document.currentScript
    }
  
    // IE 8-10 support script readyState
    // IE 11+ & Firefox support stack trace
    try {
      throw new Error();
    }
    catch (err) {
      // Find the second match for the "at" string to get file src url from stack.
      var ieStackRegExp = /.*at [^(]*\((.*):(.+):(.+)\)$/ig,
        ffStackRegExp = /@([^@]*):(\d+):(\d+)\s*$/ig,
        stackDetails = ieStackRegExp.exec(err.stack) || ffStackRegExp.exec(err.stack),
        scriptLocation = (stackDetails && stackDetails[1]) || false,
        line = (stackDetails && stackDetails[2]) || false,
        currentLocation = document.location.href.replace(document.location.hash, ''),
        pageSource,
        inlineScriptSourceRegExp,
        inlineScriptSource,
        scripts = document.getElementsByTagName('script'); // Live NodeList collection
  
      if (scriptLocation === currentLocation) {
        pageSource = document.documentElement.outerHTML;
        inlineScriptSourceRegExp = new RegExp('(?:[^\\n]+?\\n){0,' + (line - 2) + '}[^<]*<script>([\\d\\D]*?)<\\/script>[\\d\\D]*', 'i');
        inlineScriptSource = pageSource.replace(inlineScriptSourceRegExp, '$1').trim();
      }
  
      for (var i = 0; i < scripts.length; i++) {
        // If ready state is interactive, return the script tag
        if (scripts[i].readyState === 'interactive') {
          return scripts[i];
        }
  
        // If src matches, return the script tag
        if (scripts[i].src === scriptLocation) {
          return scripts[i];
        }
  
        // If inline source matches, return the script tag
        if (
          scriptLocation === currentLocation &&
          scripts[i].innerHTML &&
          scripts[i].innerHTML.trim() === inlineScriptSource
        ) {
          return scripts[i];
        }
      }
  
      // If no match, return null
      return null;
    }
  };

  return getCurrentScript
}));


/***/ }),

/***/ "8925":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");
var isCallable = __webpack_require__("1626");
var store = __webpack_require__("c6cd");

var functionToString = uncurryThis(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable(store.inspectSource)) {
  store.inspectSource = function (it) {
    return functionToString(it);
  };
}

module.exports = store.inspectSource;


/***/ }),

/***/ "89fa":
/***/ (function(module, exports) {



/***/ }),

/***/ "8a5d":
/***/ (function(module, exports) {



/***/ }),

/***/ "8aa5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var charAt = __webpack_require__("6547").charAt;

// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? charAt(S, index).length : 1);
};


/***/ }),

/***/ "8b1b":
/***/ (function(module, exports) {



/***/ }),

/***/ "8bcc":
/***/ (function(module, exports) {



/***/ }),

/***/ "8ea1":
/***/ (function(module, exports) {

var documentAll = typeof document == 'object' && document.all;

// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var IS_HTMLDDA = typeof documentAll == 'undefined' && documentAll !== undefined;

module.exports = {
  all: documentAll,
  IS_HTMLDDA: IS_HTMLDDA
};


/***/ }),

/***/ "8f14":
/***/ (function(module, exports) {



/***/ }),

/***/ "90d8":
/***/ (function(module, exports, __webpack_require__) {

var call = __webpack_require__("c65b");
var hasOwn = __webpack_require__("1a2d");
var isPrototypeOf = __webpack_require__("3a9b");
var regExpFlags = __webpack_require__("ad6d");

var RegExpPrototype = RegExp.prototype;

module.exports = function (R) {
  var flags = R.flags;
  return flags === undefined && !('flags' in RegExpPrototype) && !hasOwn(R, 'flags') && isPrototypeOf(RegExpPrototype, R)
    ? call(regExpFlags, R) : flags;
};


/***/ }),

/***/ "90e3":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");

var id = 0;
var postfix = Math.random();
var toString = uncurryThis(1.0.toString);

module.exports = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString(++id + postfix, 36);
};


/***/ }),

/***/ "9112":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var definePropertyModule = __webpack_require__("9bf2");
var createPropertyDescriptor = __webpack_require__("5c6c");

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "9263":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* eslint-disable regexp/no-empty-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */
/* eslint-disable regexp/no-useless-quantifier -- testing */
var call = __webpack_require__("c65b");
var uncurryThis = __webpack_require__("e330");
var toString = __webpack_require__("577e");
var regexpFlags = __webpack_require__("ad6d");
var stickyHelpers = __webpack_require__("9f7f");
var shared = __webpack_require__("5692");
var create = __webpack_require__("7c73");
var getInternalState = __webpack_require__("69f3").get;
var UNSUPPORTED_DOT_ALL = __webpack_require__("fce3");
var UNSUPPORTED_NCG = __webpack_require__("107c");

var nativeReplace = shared('native-string-replace', String.prototype.replace);
var nativeExec = RegExp.prototype.exec;
var patchedExec = nativeExec;
var charAt = uncurryThis(''.charAt);
var indexOf = uncurryThis(''.indexOf);
var replace = uncurryThis(''.replace);
var stringSlice = uncurryThis(''.slice);

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  call(nativeExec, re1, 'a');
  call(nativeExec, re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

var UNSUPPORTED_Y = stickyHelpers.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG;

if (PATCH) {
  patchedExec = function exec(string) {
    var re = this;
    var state = getInternalState(re);
    var str = toString(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;

    if (raw) {
      raw.lastIndex = re.lastIndex;
      result = call(patchedExec, raw, str);
      re.lastIndex = raw.lastIndex;
      return result;
    }

    var groups = state.groups;
    var sticky = UNSUPPORTED_Y && re.sticky;
    var flags = call(regexpFlags, re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = replace(flags, 'y', '');
      if (indexOf(flags, 'g') === -1) {
        flags += 'g';
      }

      strCopy = stringSlice(str, re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && charAt(str, re.lastIndex - 1) !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = call(nativeExec, sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = stringSlice(match.input, charsAdded);
        match[0] = stringSlice(match[0], charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn't work for /(.?)?/
      call(nativeReplace, match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    if (match && groups) {
      match.groups = object = create(null);
      for (i = 0; i < groups.length; i++) {
        group = groups[i];
        object[group[0]] = match[group[1]];
      }
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),

/***/ "944a":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("d066");
var defineWellKnownSymbol = __webpack_require__("e065");
var setToStringTag = __webpack_require__("d44e");

// `Symbol.toStringTag` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.tostringtag
defineWellKnownSymbol('toStringTag');

// `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
setToStringTag(getBuiltIn('Symbol'), 'Symbol');


/***/ }),

/***/ "94ca":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");
var isCallable = __webpack_require__("1626");

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : isCallable(detection) ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;


/***/ }),

/***/ "9588":
/***/ (function(module, exports) {

module.exports = require("file-saver");

/***/ }),

/***/ "9861":
/***/ (function(module, exports, __webpack_require__) {

// TODO: Remove this module from `core-js@4` since it's replaced to module below
__webpack_require__("5352");


/***/ }),

/***/ "99af":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var fails = __webpack_require__("d039");
var isArray = __webpack_require__("e8b5");
var isObject = __webpack_require__("861d");
var toObject = __webpack_require__("7b0b");
var lengthOfArrayLike = __webpack_require__("07fa");
var doesNotExceedSafeInteger = __webpack_require__("3511");
var createProperty = __webpack_require__("8418");
var arraySpeciesCreate = __webpack_require__("65f0");
var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");
var wellKnownSymbol = __webpack_require__("b622");
var V8_VERSION = __webpack_require__("2d00");

var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable');

// We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679
var IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION >= 51 || !fails(function () {
  var array = [];
  array[IS_CONCAT_SPREADABLE] = false;
  return array.concat()[0] !== array;
});

var SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('concat');

var isConcatSpreadable = function (O) {
  if (!isObject(O)) return false;
  var spreadable = O[IS_CONCAT_SPREADABLE];
  return spreadable !== undefined ? !!spreadable : isArray(O);
};

var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !SPECIES_SUPPORT;

// `Array.prototype.concat` method
// https://tc39.es/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species
$({ target: 'Array', proto: true, arity: 1, forced: FORCED }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  concat: function concat(arg) {
    var O = toObject(this);
    var A = arraySpeciesCreate(O, 0);
    var n = 0;
    var i, k, length, len, E;
    for (i = -1, length = arguments.length; i < length; i++) {
      E = i === -1 ? O : arguments[i];
      if (isConcatSpreadable(E)) {
        len = lengthOfArrayLike(E);
        doesNotExceedSafeInteger(n + len);
        for (k = 0; k < len; k++, n++) if (k in E) createProperty(A, n, E[k]);
      } else {
        doesNotExceedSafeInteger(n + 1);
        createProperty(A, n++, E);
      }
    }
    A.length = n;
    return A;
  }
});


/***/ }),

/***/ "9a1f":
/***/ (function(module, exports, __webpack_require__) {

var call = __webpack_require__("c65b");
var aCallable = __webpack_require__("59ed");
var anObject = __webpack_require__("825a");
var tryToString = __webpack_require__("0d51");
var getIteratorMethod = __webpack_require__("35a1");

var $TypeError = TypeError;

module.exports = function (argument, usingIterator) {
  var iteratorMethod = arguments.length < 2 ? getIteratorMethod(argument) : usingIterator;
  if (aCallable(iteratorMethod)) return anObject(call(iteratorMethod, argument));
  throw $TypeError(tryToString(argument) + ' is not iterable');
};


/***/ }),

/***/ "9bdd":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("825a");
var iteratorClose = __webpack_require__("2a62");

// call something on iterator step with safe closing on error
module.exports = function (iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
  } catch (error) {
    iteratorClose(iterator, 'throw', error);
  }
};


/***/ }),

/***/ "9bf2":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var IE8_DOM_DEFINE = __webpack_require__("0cfb");
var V8_PROTOTYPE_DEFINE_BUG = __webpack_require__("aed9");
var anObject = __webpack_require__("825a");
var toPropertyKey = __webpack_require__("a04b");

var $TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? V8_PROTOTYPE_DEFINE_BUG ? function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE in Attributes ? Attributes[CONFIGURABLE] : current[CONFIGURABLE],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw $TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "9d47":
/***/ (function(module, exports) {



/***/ }),

/***/ "9e19":
/***/ (function(module, exports) {



/***/ }),

/***/ "9f7f":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");
var global = __webpack_require__("da84");

// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $RegExp = global.RegExp;

var UNSUPPORTED_Y = fails(function () {
  var re = $RegExp('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') != null;
});

// UC Browser bug
// https://github.com/zloirock/core-js/issues/1008
var MISSED_STICKY = UNSUPPORTED_Y || fails(function () {
  return !$RegExp('a', 'y').sticky;
});

var BROKEN_CARET = UNSUPPORTED_Y || fails(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = $RegExp('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') != null;
});

module.exports = {
  BROKEN_CARET: BROKEN_CARET,
  MISSED_STICKY: MISSED_STICKY,
  UNSUPPORTED_Y: UNSUPPORTED_Y
};


/***/ }),

/***/ "a04b":
/***/ (function(module, exports, __webpack_require__) {

var toPrimitive = __webpack_require__("c04e");
var isSymbol = __webpack_require__("d9b5");

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
module.exports = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};


/***/ }),

/***/ "a076":
/***/ (function(module, exports) {



/***/ }),

/***/ "a1b0":
/***/ (function(module, exports) {



/***/ }),

/***/ "a4d3":
/***/ (function(module, exports, __webpack_require__) {

// TODO: Remove this module from `core-js@4` since it's split to modules listed below
__webpack_require__("d9f5");
__webpack_require__("b4f8");
__webpack_require__("c513");
__webpack_require__("e9c4");
__webpack_require__("5a47");


/***/ }),

/***/ "a640":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__("d039");

module.exports = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call -- required for testing
    method.call(null, argument || function () { return 1; }, 1);
  });
};


/***/ }),

/***/ "a646":
/***/ (function(module, exports) {



/***/ }),

/***/ "a683":
/***/ (function(module, exports) {



/***/ }),

/***/ "a845":
/***/ (function(module, exports) {



/***/ }),

/***/ "a9e3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__("83ab");
var global = __webpack_require__("da84");
var uncurryThis = __webpack_require__("e330");
var isForced = __webpack_require__("94ca");
var defineBuiltIn = __webpack_require__("cb2d");
var hasOwn = __webpack_require__("1a2d");
var inheritIfRequired = __webpack_require__("7156");
var isPrototypeOf = __webpack_require__("3a9b");
var isSymbol = __webpack_require__("d9b5");
var toPrimitive = __webpack_require__("c04e");
var fails = __webpack_require__("d039");
var getOwnPropertyNames = __webpack_require__("241c").f;
var getOwnPropertyDescriptor = __webpack_require__("06cf").f;
var defineProperty = __webpack_require__("9bf2").f;
var thisNumberValue = __webpack_require__("408a");
var trim = __webpack_require__("58a8").trim;

var NUMBER = 'Number';
var NativeNumber = global[NUMBER];
var NumberPrototype = NativeNumber.prototype;
var TypeError = global.TypeError;
var arraySlice = uncurryThis(''.slice);
var charCodeAt = uncurryThis(''.charCodeAt);

// `ToNumeric` abstract operation
// https://tc39.es/ecma262/#sec-tonumeric
var toNumeric = function (value) {
  var primValue = toPrimitive(value, 'number');
  return typeof primValue == 'bigint' ? primValue : toNumber(primValue);
};

// `ToNumber` abstract operation
// https://tc39.es/ecma262/#sec-tonumber
var toNumber = function (argument) {
  var it = toPrimitive(argument, 'number');
  var first, third, radix, maxCode, digits, length, index, code;
  if (isSymbol(it)) throw TypeError('Cannot convert a Symbol value to a number');
  if (typeof it == 'string' && it.length > 2) {
    it = trim(it);
    first = charCodeAt(it, 0);
    if (first === 43 || first === 45) {
      third = charCodeAt(it, 2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (charCodeAt(it, 1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal of /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal of /^0o[0-7]+$/i
        default: return +it;
      }
      digits = arraySlice(it, 2);
      length = digits.length;
      for (index = 0; index < length; index++) {
        code = charCodeAt(digits, index);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

// `Number` constructor
// https://tc39.es/ecma262/#sec-number-constructor
if (isForced(NUMBER, !NativeNumber(' 0o1') || !NativeNumber('0b1') || NativeNumber('+0x1'))) {
  var NumberWrapper = function Number(value) {
    var n = arguments.length < 1 ? 0 : NativeNumber(toNumeric(value));
    var dummy = this;
    // check on 1..constructor(foo) case
    return isPrototypeOf(NumberPrototype, dummy) && fails(function () { thisNumberValue(dummy); })
      ? inheritIfRequired(Object(n), dummy, NumberWrapper) : n;
  };
  for (var keys = DESCRIPTORS ? getOwnPropertyNames(NativeNumber) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES2015 (in case, if modules with ES2015 Number statics required before):
    'EPSILON,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,isFinite,isInteger,isNaN,isSafeInteger,parseFloat,parseInt,' +
    // ESNext
    'fromString,range'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (hasOwn(NativeNumber, key = keys[j]) && !hasOwn(NumberWrapper, key)) {
      defineProperty(NumberWrapper, key, getOwnPropertyDescriptor(NativeNumber, key));
    }
  }
  NumberWrapper.prototype = NumberPrototype;
  NumberPrototype.constructor = NumberWrapper;
  defineBuiltIn(global, NUMBER, NumberWrapper, { constructor: true });
}


/***/ }),

/***/ "ab36":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");
var createNonEnumerableProperty = __webpack_require__("9112");

// `InstallErrorCause` abstract operation
// https://tc39.es/proposal-error-cause/#sec-errorobjects-install-error-cause
module.exports = function (O, options) {
  if (isObject(options) && 'cause' in options) {
    createNonEnumerableProperty(O, 'cause', options.cause);
  }
};


/***/ }),

/***/ "ac1f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var exec = __webpack_require__("9263");

// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$({ target: 'RegExp', proto: true, forced: /./.exec !== exec }, {
  exec: exec
});


/***/ }),

/***/ "ace4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var uncurryThis = __webpack_require__("e330");
var fails = __webpack_require__("d039");
var ArrayBufferModule = __webpack_require__("621a");
var anObject = __webpack_require__("825a");
var toAbsoluteIndex = __webpack_require__("23cb");
var toLength = __webpack_require__("50c4");
var speciesConstructor = __webpack_require__("4840");

var ArrayBuffer = ArrayBufferModule.ArrayBuffer;
var DataView = ArrayBufferModule.DataView;
var DataViewPrototype = DataView.prototype;
var nativeArrayBufferSlice = uncurryThis(ArrayBuffer.prototype.slice);
var getUint8 = uncurryThis(DataViewPrototype.getUint8);
var setUint8 = uncurryThis(DataViewPrototype.setUint8);

var INCORRECT_SLICE = fails(function () {
  return !new ArrayBuffer(2).slice(1, undefined).byteLength;
});

// `ArrayBuffer.prototype.slice` method
// https://tc39.es/ecma262/#sec-arraybuffer.prototype.slice
$({ target: 'ArrayBuffer', proto: true, unsafe: true, forced: INCORRECT_SLICE }, {
  slice: function slice(start, end) {
    if (nativeArrayBufferSlice && end === undefined) {
      return nativeArrayBufferSlice(anObject(this), start); // FF fix
    }
    var length = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, length);
    var fin = toAbsoluteIndex(end === undefined ? length : end, length);
    var result = new (speciesConstructor(this, ArrayBuffer))(toLength(fin - first));
    var viewSource = new DataView(this);
    var viewTarget = new DataView(result);
    var index = 0;
    while (first < fin) {
      setUint8(viewTarget, index++, getUint8(viewSource, first++));
    } return result;
  }
});


/***/ }),

/***/ "ad6d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__("825a");

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.hasIndices) result += 'd';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.unicodeSets) result += 'v';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),

/***/ "addb":
/***/ (function(module, exports, __webpack_require__) {

var arraySlice = __webpack_require__("4dae");

var floor = Math.floor;

var mergeSort = function (array, comparefn) {
  var length = array.length;
  var middle = floor(length / 2);
  return length < 8 ? insertionSort(array, comparefn) : merge(
    array,
    mergeSort(arraySlice(array, 0, middle), comparefn),
    mergeSort(arraySlice(array, middle), comparefn),
    comparefn
  );
};

var insertionSort = function (array, comparefn) {
  var length = array.length;
  var i = 1;
  var element, j;

  while (i < length) {
    j = i;
    element = array[i];
    while (j && comparefn(array[j - 1], element) > 0) {
      array[j] = array[--j];
    }
    if (j !== i++) array[j] = element;
  } return array;
};

var merge = function (array, left, right, comparefn) {
  var llength = left.length;
  var rlength = right.length;
  var lindex = 0;
  var rindex = 0;

  while (lindex < llength || rindex < rlength) {
    array[lindex + rindex] = (lindex < llength && rindex < rlength)
      ? comparefn(left[lindex], right[rindex]) <= 0 ? left[lindex++] : right[rindex++]
      : lindex < llength ? left[lindex++] : right[rindex++];
  } return array;
};

module.exports = mergeSort;


/***/ }),

/***/ "ae93":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__("d039");
var isCallable = __webpack_require__("1626");
var isObject = __webpack_require__("861d");
var create = __webpack_require__("7c73");
var getPrototypeOf = __webpack_require__("e163");
var defineBuiltIn = __webpack_require__("cb2d");
var wellKnownSymbol = __webpack_require__("b622");
var IS_PURE = __webpack_require__("c430");

var ITERATOR = wellKnownSymbol('iterator');
var BUGGY_SAFARI_ITERATORS = false;

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = !isObject(IteratorPrototype) || fails(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype[ITERATOR].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype = {};
else if (IS_PURE) IteratorPrototype = create(IteratorPrototype);

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable(IteratorPrototype[ITERATOR])) {
  defineBuiltIn(IteratorPrototype, ITERATOR, function () {
    return this;
  });
}

module.exports = {
  IteratorPrototype: IteratorPrototype,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};


/***/ }),

/***/ "aeb0":
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__("9bf2").f;

module.exports = function (Target, Source, key) {
  key in Target || defineProperty(Target, key, {
    configurable: true,
    get: function () { return Source[key]; },
    set: function (it) { Source[key] = it; }
  });
};


/***/ }),

/***/ "aed9":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var fails = __webpack_require__("d039");

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
module.exports = DESCRIPTORS && fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype != 42;
});


/***/ }),

/***/ "af03":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

// check the existence of a method, lowercase
// of a tag and escaping quotes in arguments
module.exports = function (METHOD_NAME) {
  return fails(function () {
    var test = ''[METHOD_NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  });
};


/***/ }),

/***/ "af6f":
/***/ (function(module, exports) {



/***/ }),

/***/ "aff7":
/***/ (function(module, exports) {



/***/ }),

/***/ "b041":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var TO_STRING_TAG_SUPPORT = __webpack_require__("00ee");
var classof = __webpack_require__("f5df");

// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
module.exports = TO_STRING_TAG_SUPPORT ? {}.toString : function toString() {
  return '[object ' + classof(this) + ']';
};


/***/ }),

/***/ "b0c0":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var FUNCTION_NAME_EXISTS = __webpack_require__("5e77").EXISTS;
var uncurryThis = __webpack_require__("e330");
var defineProperty = __webpack_require__("9bf2").f;

var FunctionPrototype = Function.prototype;
var functionToString = uncurryThis(FunctionPrototype.toString);
var nameRE = /function\b(?:\s|\/\*[\S\s]*?\*\/|\/\/[^\n\r]*[\n\r]+)*([^\s(/]*)/;
var regExpExec = uncurryThis(nameRE.exec);
var NAME = 'name';

// Function instances `.name` property
// https://tc39.es/ecma262/#sec-function-instances-name
if (DESCRIPTORS && !FUNCTION_NAME_EXISTS) {
  defineProperty(FunctionPrototype, NAME, {
    configurable: true,
    get: function () {
      try {
        return regExpExec(nameRE, functionToString(this))[1];
      } catch (error) {
        return '';
      }
    }
  });
}


/***/ }),

/***/ "b230":
/***/ (function(module, exports) {



/***/ }),

/***/ "b42e":
/***/ (function(module, exports) {

var ceil = Math.ceil;
var floor = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
module.exports = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor : ceil)(n);
};


/***/ }),

/***/ "b4f8":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var getBuiltIn = __webpack_require__("d066");
var hasOwn = __webpack_require__("1a2d");
var toString = __webpack_require__("577e");
var shared = __webpack_require__("5692");
var NATIVE_SYMBOL_REGISTRY = __webpack_require__("0b43");

var StringToSymbolRegistry = shared('string-to-symbol-registry');
var SymbolToStringRegistry = shared('symbol-to-string-registry');

// `Symbol.for` method
// https://tc39.es/ecma262/#sec-symbol.for
$({ target: 'Symbol', stat: true, forced: !NATIVE_SYMBOL_REGISTRY }, {
  'for': function (key) {
    var string = toString(key);
    if (hasOwn(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
    var symbol = getBuiltIn('Symbol')(string);
    StringToSymbolRegistry[string] = symbol;
    SymbolToStringRegistry[symbol] = string;
    return symbol;
  }
});


/***/ }),

/***/ "b50e":
/***/ (function(module, exports) {

module.exports = require("@rosgidromet/leaflet-extensions");

/***/ }),

/***/ "b5b8":
/***/ (function(module, exports) {



/***/ }),

/***/ "b622":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var shared = __webpack_require__("5692");
var hasOwn = __webpack_require__("1a2d");
var uid = __webpack_require__("90e3");
var NATIVE_SYMBOL = __webpack_require__("04f8");
var USE_SYMBOL_AS_UID = __webpack_require__("fdbf");

var WellKnownSymbolsStore = shared('wks');
var Symbol = global.Symbol;
var symbolFor = Symbol && Symbol['for'];
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol : Symbol && Symbol.withoutSetter || uid;

module.exports = function (name) {
  if (!hasOwn(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL || typeof WellKnownSymbolsStore[name] == 'string')) {
    var description = 'Symbol.' + name;
    if (NATIVE_SYMBOL && hasOwn(Symbol, name)) {
      WellKnownSymbolsStore[name] = Symbol[name];
    } else if (USE_SYMBOL_AS_UID && symbolFor) {
      WellKnownSymbolsStore[name] = symbolFor(description);
    } else {
      WellKnownSymbolsStore[name] = createWellKnownSymbol(description);
    }
  } return WellKnownSymbolsStore[name];
};


/***/ }),

/***/ "b636":
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__("e065");

// `Symbol.asyncIterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.asynciterator
defineWellKnownSymbol('asyncIterator');


/***/ }),

/***/ "b64b":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var toObject = __webpack_require__("7b0b");
var nativeKeys = __webpack_require__("df75");
var fails = __webpack_require__("d039");

var FAILS_ON_PRIMITIVES = fails(function () { nativeKeys(1); });

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES }, {
  keys: function keys(it) {
    return nativeKeys(toObject(it));
  }
});


/***/ }),

/***/ "b680":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var uncurryThis = __webpack_require__("e330");
var toIntegerOrInfinity = __webpack_require__("5926");
var thisNumberValue = __webpack_require__("408a");
var $repeat = __webpack_require__("1148");
var fails = __webpack_require__("d039");

var $RangeError = RangeError;
var $String = String;
var floor = Math.floor;
var repeat = uncurryThis($repeat);
var stringSlice = uncurryThis(''.slice);
var nativeToFixed = uncurryThis(1.0.toFixed);

var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};

var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

var multiply = function (data, n, c) {
  var index = -1;
  var c2 = c;
  while (++index < 6) {
    c2 += n * data[index];
    data[index] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};

var divide = function (data, n) {
  var index = 6;
  var c = 0;
  while (--index >= 0) {
    c += data[index];
    data[index] = floor(c / n);
    c = (c % n) * 1e7;
  }
};

var dataToString = function (data) {
  var index = 6;
  var s = '';
  while (--index >= 0) {
    if (s !== '' || index === 0 || data[index] !== 0) {
      var t = $String(data[index]);
      s = s === '' ? t : s + repeat('0', 7 - t.length) + t;
    }
  } return s;
};

var FORCED = fails(function () {
  return nativeToFixed(0.00008, 3) !== '0.000' ||
    nativeToFixed(0.9, 0) !== '1' ||
    nativeToFixed(1.255, 2) !== '1.25' ||
    nativeToFixed(1000000000000000128.0, 0) !== '1000000000000000128';
}) || !fails(function () {
  // V8 ~ Android 4.3-
  nativeToFixed({});
});

// `Number.prototype.toFixed` method
// https://tc39.es/ecma262/#sec-number.prototype.tofixed
$({ target: 'Number', proto: true, forced: FORCED }, {
  toFixed: function toFixed(fractionDigits) {
    var number = thisNumberValue(this);
    var fractDigits = toIntegerOrInfinity(fractionDigits);
    var data = [0, 0, 0, 0, 0, 0];
    var sign = '';
    var result = '0';
    var e, z, j, k;

    // TODO: ES2018 increased the maximum number of fraction digits to 100, need to improve the implementation
    if (fractDigits < 0 || fractDigits > 20) throw $RangeError('Incorrect fraction digits');
    // eslint-disable-next-line no-self-compare -- NaN check
    if (number != number) return 'NaN';
    if (number <= -1e21 || number >= 1e21) return $String(number);
    if (number < 0) {
      sign = '-';
      number = -number;
    }
    if (number > 1e-21) {
      e = log(number * pow(2, 69, 1)) - 69;
      z = e < 0 ? number * pow(2, -e, 1) : number / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(data, 0, z);
        j = fractDigits;
        while (j >= 7) {
          multiply(data, 1e7, 0);
          j -= 7;
        }
        multiply(data, pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(data, 1 << 23);
          j -= 23;
        }
        divide(data, 1 << j);
        multiply(data, 1, 1);
        divide(data, 2);
        result = dataToString(data);
      } else {
        multiply(data, 0, z);
        multiply(data, 1 << -e, 0);
        result = dataToString(data) + repeat('0', fractDigits);
      }
    }
    if (fractDigits > 0) {
      k = result.length;
      result = sign + (k <= fractDigits
        ? '0.' + repeat('0', fractDigits - k) + result
        : stringSlice(result, 0, k - fractDigits) + '.' + stringSlice(result, k - fractDigits));
    } else {
      result = sign + result;
    } return result;
  }
});


/***/ }),

/***/ "b727":
/***/ (function(module, exports, __webpack_require__) {

var bind = __webpack_require__("0366");
var uncurryThis = __webpack_require__("e330");
var IndexedObject = __webpack_require__("44ad");
var toObject = __webpack_require__("7b0b");
var lengthOfArrayLike = __webpack_require__("07fa");
var arraySpeciesCreate = __webpack_require__("65f0");

var push = uncurryThis([].push);

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var createMethod = function (TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var IS_FILTER_REJECT = TYPE == 7;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject($this);
    var self = IndexedObject(O);
    var boundFunction = bind(callbackfn, that);
    var length = lengthOfArrayLike(self);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push(target, value);      // filter
        } else switch (TYPE) {
          case 4: return false;             // every
          case 7: push(target, value);      // filterReject
        }
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

module.exports = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: createMethod(0),
  // `Array.prototype.map` method
  // https://tc39.es/ecma262/#sec-array.prototype.map
  map: createMethod(1),
  // `Array.prototype.filter` method
  // https://tc39.es/ecma262/#sec-array.prototype.filter
  filter: createMethod(2),
  // `Array.prototype.some` method
  // https://tc39.es/ecma262/#sec-array.prototype.some
  some: createMethod(3),
  // `Array.prototype.every` method
  // https://tc39.es/ecma262/#sec-array.prototype.every
  every: createMethod(4),
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: createMethod(5),
  // `Array.prototype.findIndex` method
  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod(6),
  // `Array.prototype.filterReject` method
  // https://github.com/tc39/proposal-array-filtering
  filterReject: createMethod(7)
};


/***/ }),

/***/ "b980":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");
var createPropertyDescriptor = __webpack_require__("5c6c");

module.exports = !fails(function () {
  var error = Error('a');
  if (!('stack' in error)) return true;
  // eslint-disable-next-line es/no-object-defineproperty -- safe
  Object.defineProperty(error, 'stack', createPropertyDescriptor(1, 7));
  return error.stack !== 7;
});


/***/ }),

/***/ "bae3":
/***/ (function(module, exports) {



/***/ }),

/***/ "bb2f":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

module.exports = !fails(function () {
  // eslint-disable-next-line es/no-object-isextensible, es/no-object-preventextensions -- required for testing
  return Object.isExtensible(Object.preventExtensions({}));
});


/***/ }),

/***/ "c04e":
/***/ (function(module, exports, __webpack_require__) {

var call = __webpack_require__("c65b");
var isObject = __webpack_require__("861d");
var isSymbol = __webpack_require__("d9b5");
var getMethod = __webpack_require__("dc4a");
var ordinaryToPrimitive = __webpack_require__("485a");
var wellKnownSymbol = __webpack_require__("b622");

var $TypeError = TypeError;
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
module.exports = function (input, pref) {
  if (!isObject(input) || isSymbol(input)) return input;
  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call(exoticToPrim, input, pref);
    if (!isObject(result) || isSymbol(result)) return result;
    throw $TypeError("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};


/***/ }),

/***/ "c0eb":
/***/ (function(module, exports) {



/***/ }),

/***/ "c19f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var global = __webpack_require__("da84");
var arrayBufferModule = __webpack_require__("621a");
var setSpecies = __webpack_require__("2626");

var ARRAY_BUFFER = 'ArrayBuffer';
var ArrayBuffer = arrayBufferModule[ARRAY_BUFFER];
var NativeArrayBuffer = global[ARRAY_BUFFER];

// `ArrayBuffer` constructor
// https://tc39.es/ecma262/#sec-arraybuffer-constructor
$({ global: true, constructor: true, forced: NativeArrayBuffer !== ArrayBuffer }, {
  ArrayBuffer: ArrayBuffer
});

setSpecies(ARRAY_BUFFER);


/***/ }),

/***/ "c430":
/***/ (function(module, exports) {

module.exports = false;


/***/ }),

/***/ "c513":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var hasOwn = __webpack_require__("1a2d");
var isSymbol = __webpack_require__("d9b5");
var tryToString = __webpack_require__("0d51");
var shared = __webpack_require__("5692");
var NATIVE_SYMBOL_REGISTRY = __webpack_require__("0b43");

var SymbolToStringRegistry = shared('symbol-to-string-registry');

// `Symbol.keyFor` method
// https://tc39.es/ecma262/#sec-symbol.keyfor
$({ target: 'Symbol', stat: true, forced: !NATIVE_SYMBOL_REGISTRY }, {
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(tryToString(sym) + ' is not a symbol');
    if (hasOwn(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
  }
});


/***/ }),

/***/ "c566":
/***/ (function(module, exports) {



/***/ }),

/***/ "c65b":
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_BIND = __webpack_require__("40d5");

var call = Function.prototype.call;

module.exports = NATIVE_BIND ? call.bind(call) : function () {
  return call.apply(call, arguments);
};


/***/ }),

/***/ "c6b6":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThisRaw = __webpack_require__("7d7e");

var toString = uncurryThisRaw({}.toString);
var stringSlice = uncurryThisRaw(''.slice);

module.exports = function (it) {
  return stringSlice(toString(it), 8, -1);
};


/***/ }),

/***/ "c6cd":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var defineGlobalProperty = __webpack_require__("6374");

var SHARED = '__core-js_shared__';
var store = global[SHARED] || defineGlobalProperty(SHARED, {});

module.exports = store;


/***/ }),

/***/ "c6d2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var call = __webpack_require__("c65b");
var IS_PURE = __webpack_require__("c430");
var FunctionName = __webpack_require__("5e77");
var isCallable = __webpack_require__("1626");
var createIteratorConstructor = __webpack_require__("dcc3");
var getPrototypeOf = __webpack_require__("e163");
var setPrototypeOf = __webpack_require__("d2bb");
var setToStringTag = __webpack_require__("d44e");
var createNonEnumerableProperty = __webpack_require__("9112");
var defineBuiltIn = __webpack_require__("cb2d");
var wellKnownSymbol = __webpack_require__("b622");
var Iterators = __webpack_require__("3f8c");
var IteratorsCore = __webpack_require__("ae93");

var PROPER_FUNCTION_NAME = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR = wellKnownSymbol('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

module.exports = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (!isCallable(CurrentIteratorPrototype[ITERATOR])) {
          defineBuiltIn(CurrentIteratorPrototype, ITERATOR, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
      if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (PROPER_FUNCTION_NAME && DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    if (!IS_PURE && CONFIGURABLE_FUNCTION_NAME) {
      createNonEnumerableProperty(IterablePrototype, 'name', VALUES);
    } else {
      INCORRECT_VALUES_NAME = true;
      defaultIterator = function values() { return call(nativeIterator, this); };
    }
  }

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        defineBuiltIn(IterablePrototype, KEY, methods[KEY]);
      }
    } else $({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  // define iterator
  if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) {
    defineBuiltIn(IterablePrototype, ITERATOR, defaultIterator, { name: DEFAULT });
  }
  Iterators[NAME] = defaultIterator;

  return methods;
};


/***/ }),

/***/ "c723":
/***/ (function(module, exports) {



/***/ }),

/***/ "c8ba":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "c8d2":
/***/ (function(module, exports, __webpack_require__) {

var PROPER_FUNCTION_NAME = __webpack_require__("5e77").PROPER;
var fails = __webpack_require__("d039");
var whitespaces = __webpack_require__("5899");

var non = '\u200B\u0085\u180E';

// check that a method works with the correct list
// of whitespaces and has a correct name
module.exports = function (METHOD_NAME) {
  return fails(function () {
    return !!whitespaces[METHOD_NAME]()
      || non[METHOD_NAME]() !== non
      || (PROPER_FUNCTION_NAME && whitespaces[METHOD_NAME].name !== METHOD_NAME);
  });
};


/***/ }),

/***/ "c962":
/***/ (function(module, exports) {



/***/ }),

/***/ "ca84":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");
var hasOwn = __webpack_require__("1a2d");
var toIndexedObject = __webpack_require__("fc6a");
var indexOf = __webpack_require__("4d64").indexOf;
var hiddenKeys = __webpack_require__("d012");

var push = uncurryThis([].push);

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn(hiddenKeys, key) && hasOwn(O, key) && push(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn(O, key = names[i++])) {
    ~indexOf(result, key) || push(result, key);
  }
  return result;
};


/***/ }),

/***/ "cb2d":
/***/ (function(module, exports, __webpack_require__) {

var isCallable = __webpack_require__("1626");
var definePropertyModule = __webpack_require__("9bf2");
var makeBuiltIn = __webpack_require__("13d2");
var defineGlobalProperty = __webpack_require__("6374");

module.exports = function (O, key, value, options) {
  if (!options) options = {};
  var simple = options.enumerable;
  var name = options.name !== undefined ? options.name : key;
  if (isCallable(value)) makeBuiltIn(value, name, options);
  if (options.global) {
    if (simple) O[key] = value;
    else defineGlobalProperty(key, value);
  } else {
    try {
      if (!options.unsafe) delete O[key];
      else if (O[key]) simple = true;
    } catch (error) { /* empty */ }
    if (simple) O[key] = value;
    else definePropertyModule.f(O, key, {
      value: value,
      enumerable: false,
      configurable: !options.nonConfigurable,
      writable: !options.nonWritable
    });
  } return O;
};


/***/ }),

/***/ "cc12":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var isObject = __webpack_require__("861d");

var document = global.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};


/***/ }),

/***/ "cdce":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var isCallable = __webpack_require__("1626");

var WeakMap = global.WeakMap;

module.exports = isCallable(WeakMap) && /native code/.test(String(WeakMap));


/***/ }),

/***/ "d012":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "d039":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};


/***/ }),

/***/ "d066":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var isCallable = __webpack_require__("1626");

var aFunction = function (argument) {
  return isCallable(argument) ? argument : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global[namespace]) : global[namespace] && global[namespace][method];
};


/***/ }),

/***/ "d1e7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;


/***/ }),

/***/ "d28b":
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__("e065");

// `Symbol.iterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.iterator
defineWellKnownSymbol('iterator');


/***/ }),

/***/ "d2bb":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable no-proto -- safe */
var uncurryThis = __webpack_require__("e330");
var anObject = __webpack_require__("825a");
var aPossiblePrototype = __webpack_require__("3bbe");

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    setter = uncurryThis(Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set);
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);


/***/ }),

/***/ "d3b7":
/***/ (function(module, exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__("00ee");
var defineBuiltIn = __webpack_require__("cb2d");
var toString = __webpack_require__("b041");

// `Object.prototype.toString` method
// https://tc39.es/ecma262/#sec-object.prototype.tostring
if (!TO_STRING_TAG_SUPPORT) {
  defineBuiltIn(Object.prototype, 'toString', toString, { unsafe: true });
}


/***/ }),

/***/ "d44e":
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__("9bf2").f;
var hasOwn = __webpack_require__("1a2d");
var wellKnownSymbol = __webpack_require__("b622");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');

module.exports = function (target, TAG, STATIC) {
  if (target && !STATIC) target = target.prototype;
  if (target && !hasOwn(target, TO_STRING_TAG)) {
    defineProperty(target, TO_STRING_TAG, { configurable: true, value: TAG });
  }
};


/***/ }),

/***/ "d58f":
/***/ (function(module, exports, __webpack_require__) {

var aCallable = __webpack_require__("59ed");
var toObject = __webpack_require__("7b0b");
var IndexedObject = __webpack_require__("44ad");
var lengthOfArrayLike = __webpack_require__("07fa");

var $TypeError = TypeError;

// `Array.prototype.{ reduce, reduceRight }` methods implementation
var createMethod = function (IS_RIGHT) {
  return function (that, callbackfn, argumentsLength, memo) {
    aCallable(callbackfn);
    var O = toObject(that);
    var self = IndexedObject(O);
    var length = lengthOfArrayLike(O);
    var index = IS_RIGHT ? length - 1 : 0;
    var i = IS_RIGHT ? -1 : 1;
    if (argumentsLength < 2) while (true) {
      if (index in self) {
        memo = self[index];
        index += i;
        break;
      }
      index += i;
      if (IS_RIGHT ? index < 0 : length <= index) {
        throw $TypeError('Reduce of empty array with no initial value');
      }
    }
    for (;IS_RIGHT ? index >= 0 : length > index; index += i) if (index in self) {
      memo = callbackfn(memo, self[index], index, O);
    }
    return memo;
  };
};

module.exports = {
  // `Array.prototype.reduce` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduce
  left: createMethod(false),
  // `Array.prototype.reduceRight` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduceright
  right: createMethod(true)
};


/***/ }),

/***/ "d6d6":
/***/ (function(module, exports) {

var $TypeError = TypeError;

module.exports = function (passed, required) {
  if (passed < required) throw $TypeError('Not enough arguments');
  return passed;
};


/***/ }),

/***/ "d784":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// TODO: Remove from `core-js@4` since it's moved to entry points
__webpack_require__("ac1f");
var uncurryThis = __webpack_require__("e330");
var defineBuiltIn = __webpack_require__("cb2d");
var regexpExec = __webpack_require__("9263");
var fails = __webpack_require__("d039");
var wellKnownSymbol = __webpack_require__("b622");
var createNonEnumerableProperty = __webpack_require__("9112");

var SPECIES = wellKnownSymbol('species');
var RegExpPrototype = RegExp.prototype;

module.exports = function (KEY, exec, FORCED, SHAM) {
  var SYMBOL = wellKnownSymbol(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () { execCalled = true; return null; };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    FORCED
  ) {
    var uncurriedNativeRegExpMethod = uncurryThis(/./[SYMBOL]);
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      var uncurriedNativeMethod = uncurryThis(nativeMethod);
      var $exec = regexp.exec;
      if ($exec === regexpExec || $exec === RegExpPrototype.exec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: uncurriedNativeRegExpMethod(regexp, str, arg2) };
        }
        return { done: true, value: uncurriedNativeMethod(str, regexp, arg2) };
      }
      return { done: false };
    });

    defineBuiltIn(String.prototype, KEY, methods[0]);
    defineBuiltIn(RegExpPrototype, SYMBOL, methods[1]);
  }

  if (SHAM) createNonEnumerableProperty(RegExpPrototype[SYMBOL], 'sham', true);
};


/***/ }),

/***/ "d7c9":
/***/ (function(module, exports) {

module.exports = require("vue2-perfect-scrollbar");

/***/ }),

/***/ "d81d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $map = __webpack_require__("b727").map;
var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('map');

// `Array.prototype.map` method
// https://tc39.es/ecma262/#sec-array.prototype.map
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "d86b":
/***/ (function(module, exports, __webpack_require__) {

// FF26- bug: ArrayBuffers are non-extensible, but Object.isExtensible does not report it
var fails = __webpack_require__("d039");

module.exports = fails(function () {
  if (typeof ArrayBuffer == 'function') {
    var buffer = new ArrayBuffer(8);
    // eslint-disable-next-line es/no-object-isextensible, es/no-object-defineproperty -- safe
    if (Object.isExtensible(buffer)) Object.defineProperty(buffer, 'a', { value: 8 });
  }
});


/***/ }),

/***/ "d9b5":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("d066");
var isCallable = __webpack_require__("1626");
var isPrototypeOf = __webpack_require__("3a9b");
var USE_SYMBOL_AS_UID = __webpack_require__("fdbf");

var $Object = Object;

module.exports = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn('Symbol');
  return isCallable($Symbol) && isPrototypeOf($Symbol.prototype, $Object(it));
};


/***/ }),

/***/ "d9e2":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable no-unused-vars -- required for functions `.length` */
var $ = __webpack_require__("23e7");
var global = __webpack_require__("da84");
var apply = __webpack_require__("2ba4");
var wrapErrorConstructorWithCause = __webpack_require__("e5cb");

var WEB_ASSEMBLY = 'WebAssembly';
var WebAssembly = global[WEB_ASSEMBLY];

var FORCED = Error('e', { cause: 7 }).cause !== 7;

var exportGlobalErrorCauseWrapper = function (ERROR_NAME, wrapper) {
  var O = {};
  O[ERROR_NAME] = wrapErrorConstructorWithCause(ERROR_NAME, wrapper, FORCED);
  $({ global: true, constructor: true, arity: 1, forced: FORCED }, O);
};

var exportWebAssemblyErrorCauseWrapper = function (ERROR_NAME, wrapper) {
  if (WebAssembly && WebAssembly[ERROR_NAME]) {
    var O = {};
    O[ERROR_NAME] = wrapErrorConstructorWithCause(WEB_ASSEMBLY + '.' + ERROR_NAME, wrapper, FORCED);
    $({ target: WEB_ASSEMBLY, stat: true, constructor: true, arity: 1, forced: FORCED }, O);
  }
};

// https://github.com/tc39/proposal-error-cause
exportGlobalErrorCauseWrapper('Error', function (init) {
  return function Error(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('EvalError', function (init) {
  return function EvalError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('RangeError', function (init) {
  return function RangeError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('ReferenceError', function (init) {
  return function ReferenceError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('SyntaxError', function (init) {
  return function SyntaxError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('TypeError', function (init) {
  return function TypeError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('URIError', function (init) {
  return function URIError(message) { return apply(init, this, arguments); };
});
exportWebAssemblyErrorCauseWrapper('CompileError', function (init) {
  return function CompileError(message) { return apply(init, this, arguments); };
});
exportWebAssemblyErrorCauseWrapper('LinkError', function (init) {
  return function LinkError(message) { return apply(init, this, arguments); };
});
exportWebAssemblyErrorCauseWrapper('RuntimeError', function (init) {
  return function RuntimeError(message) { return apply(init, this, arguments); };
});


/***/ }),

/***/ "d9f5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var global = __webpack_require__("da84");
var call = __webpack_require__("c65b");
var uncurryThis = __webpack_require__("e330");
var IS_PURE = __webpack_require__("c430");
var DESCRIPTORS = __webpack_require__("83ab");
var NATIVE_SYMBOL = __webpack_require__("04f8");
var fails = __webpack_require__("d039");
var hasOwn = __webpack_require__("1a2d");
var isPrototypeOf = __webpack_require__("3a9b");
var anObject = __webpack_require__("825a");
var toIndexedObject = __webpack_require__("fc6a");
var toPropertyKey = __webpack_require__("a04b");
var $toString = __webpack_require__("577e");
var createPropertyDescriptor = __webpack_require__("5c6c");
var nativeObjectCreate = __webpack_require__("7c73");
var objectKeys = __webpack_require__("df75");
var getOwnPropertyNamesModule = __webpack_require__("241c");
var getOwnPropertyNamesExternal = __webpack_require__("057f");
var getOwnPropertySymbolsModule = __webpack_require__("7418");
var getOwnPropertyDescriptorModule = __webpack_require__("06cf");
var definePropertyModule = __webpack_require__("9bf2");
var definePropertiesModule = __webpack_require__("37e8");
var propertyIsEnumerableModule = __webpack_require__("d1e7");
var defineBuiltIn = __webpack_require__("cb2d");
var shared = __webpack_require__("5692");
var sharedKey = __webpack_require__("f772");
var hiddenKeys = __webpack_require__("d012");
var uid = __webpack_require__("90e3");
var wellKnownSymbol = __webpack_require__("b622");
var wrappedWellKnownSymbolModule = __webpack_require__("e538");
var defineWellKnownSymbol = __webpack_require__("e065");
var defineSymbolToPrimitive = __webpack_require__("57b9");
var setToStringTag = __webpack_require__("d44e");
var InternalStateModule = __webpack_require__("69f3");
var $forEach = __webpack_require__("b727").forEach;

var HIDDEN = sharedKey('hidden');
var SYMBOL = 'Symbol';
var PROTOTYPE = 'prototype';

var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(SYMBOL);

var ObjectPrototype = Object[PROTOTYPE];
var $Symbol = global.Symbol;
var SymbolPrototype = $Symbol && $Symbol[PROTOTYPE];
var TypeError = global.TypeError;
var QObject = global.QObject;
var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
var nativeDefineProperty = definePropertyModule.f;
var nativeGetOwnPropertyNames = getOwnPropertyNamesExternal.f;
var nativePropertyIsEnumerable = propertyIsEnumerableModule.f;
var push = uncurryThis([].push);

var AllSymbols = shared('symbols');
var ObjectPrototypeSymbols = shared('op-symbols');
var WellKnownSymbolsStore = shared('wks');

// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var USE_SETTER = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDescriptor = DESCRIPTORS && fails(function () {
  return nativeObjectCreate(nativeDefineProperty({}, 'a', {
    get: function () { return nativeDefineProperty(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (O, P, Attributes) {
  var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor(ObjectPrototype, P);
  if (ObjectPrototypeDescriptor) delete ObjectPrototype[P];
  nativeDefineProperty(O, P, Attributes);
  if (ObjectPrototypeDescriptor && O !== ObjectPrototype) {
    nativeDefineProperty(ObjectPrototype, P, ObjectPrototypeDescriptor);
  }
} : nativeDefineProperty;

var wrap = function (tag, description) {
  var symbol = AllSymbols[tag] = nativeObjectCreate(SymbolPrototype);
  setInternalState(symbol, {
    type: SYMBOL,
    tag: tag,
    description: description
  });
  if (!DESCRIPTORS) symbol.description = description;
  return symbol;
};

var $defineProperty = function defineProperty(O, P, Attributes) {
  if (O === ObjectPrototype) $defineProperty(ObjectPrototypeSymbols, P, Attributes);
  anObject(O);
  var key = toPropertyKey(P);
  anObject(Attributes);
  if (hasOwn(AllSymbols, key)) {
    if (!Attributes.enumerable) {
      if (!hasOwn(O, HIDDEN)) nativeDefineProperty(O, HIDDEN, createPropertyDescriptor(1, {}));
      O[HIDDEN][key] = true;
    } else {
      if (hasOwn(O, HIDDEN) && O[HIDDEN][key]) O[HIDDEN][key] = false;
      Attributes = nativeObjectCreate(Attributes, { enumerable: createPropertyDescriptor(0, false) });
    } return setSymbolDescriptor(O, key, Attributes);
  } return nativeDefineProperty(O, key, Attributes);
};

var $defineProperties = function defineProperties(O, Properties) {
  anObject(O);
  var properties = toIndexedObject(Properties);
  var keys = objectKeys(properties).concat($getOwnPropertySymbols(properties));
  $forEach(keys, function (key) {
    if (!DESCRIPTORS || call($propertyIsEnumerable, properties, key)) $defineProperty(O, key, properties[key]);
  });
  return O;
};

var $create = function create(O, Properties) {
  return Properties === undefined ? nativeObjectCreate(O) : $defineProperties(nativeObjectCreate(O), Properties);
};

var $propertyIsEnumerable = function propertyIsEnumerable(V) {
  var P = toPropertyKey(V);
  var enumerable = call(nativePropertyIsEnumerable, this, P);
  if (this === ObjectPrototype && hasOwn(AllSymbols, P) && !hasOwn(ObjectPrototypeSymbols, P)) return false;
  return enumerable || !hasOwn(this, P) || !hasOwn(AllSymbols, P) || hasOwn(this, HIDDEN) && this[HIDDEN][P]
    ? enumerable : true;
};

var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
  var it = toIndexedObject(O);
  var key = toPropertyKey(P);
  if (it === ObjectPrototype && hasOwn(AllSymbols, key) && !hasOwn(ObjectPrototypeSymbols, key)) return;
  var descriptor = nativeGetOwnPropertyDescriptor(it, key);
  if (descriptor && hasOwn(AllSymbols, key) && !(hasOwn(it, HIDDEN) && it[HIDDEN][key])) {
    descriptor.enumerable = true;
  }
  return descriptor;
};

var $getOwnPropertyNames = function getOwnPropertyNames(O) {
  var names = nativeGetOwnPropertyNames(toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (!hasOwn(AllSymbols, key) && !hasOwn(hiddenKeys, key)) push(result, key);
  });
  return result;
};

var $getOwnPropertySymbols = function (O) {
  var IS_OBJECT_PROTOTYPE = O === ObjectPrototype;
  var names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (hasOwn(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || hasOwn(ObjectPrototype, key))) {
      push(result, AllSymbols[key]);
    }
  });
  return result;
};

// `Symbol` constructor
// https://tc39.es/ecma262/#sec-symbol-constructor
if (!NATIVE_SYMBOL) {
  $Symbol = function Symbol() {
    if (isPrototypeOf(SymbolPrototype, this)) throw TypeError('Symbol is not a constructor');
    var description = !arguments.length || arguments[0] === undefined ? undefined : $toString(arguments[0]);
    var tag = uid(description);
    var setter = function (value) {
      if (this === ObjectPrototype) call(setter, ObjectPrototypeSymbols, value);
      if (hasOwn(this, HIDDEN) && hasOwn(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDescriptor(this, tag, createPropertyDescriptor(1, value));
    };
    if (DESCRIPTORS && USE_SETTER) setSymbolDescriptor(ObjectPrototype, tag, { configurable: true, set: setter });
    return wrap(tag, description);
  };

  SymbolPrototype = $Symbol[PROTOTYPE];

  defineBuiltIn(SymbolPrototype, 'toString', function toString() {
    return getInternalState(this).tag;
  });

  defineBuiltIn($Symbol, 'withoutSetter', function (description) {
    return wrap(uid(description), description);
  });

  propertyIsEnumerableModule.f = $propertyIsEnumerable;
  definePropertyModule.f = $defineProperty;
  definePropertiesModule.f = $defineProperties;
  getOwnPropertyDescriptorModule.f = $getOwnPropertyDescriptor;
  getOwnPropertyNamesModule.f = getOwnPropertyNamesExternal.f = $getOwnPropertyNames;
  getOwnPropertySymbolsModule.f = $getOwnPropertySymbols;

  wrappedWellKnownSymbolModule.f = function (name) {
    return wrap(wellKnownSymbol(name), name);
  };

  if (DESCRIPTORS) {
    // https://github.com/tc39/proposal-Symbol-description
    nativeDefineProperty(SymbolPrototype, 'description', {
      configurable: true,
      get: function description() {
        return getInternalState(this).description;
      }
    });
    if (!IS_PURE) {
      defineBuiltIn(ObjectPrototype, 'propertyIsEnumerable', $propertyIsEnumerable, { unsafe: true });
    }
  }
}

$({ global: true, constructor: true, wrap: true, forced: !NATIVE_SYMBOL, sham: !NATIVE_SYMBOL }, {
  Symbol: $Symbol
});

$forEach(objectKeys(WellKnownSymbolsStore), function (name) {
  defineWellKnownSymbol(name);
});

$({ target: SYMBOL, stat: true, forced: !NATIVE_SYMBOL }, {
  useSetter: function () { USE_SETTER = true; },
  useSimple: function () { USE_SETTER = false; }
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL, sham: !DESCRIPTORS }, {
  // `Object.create` method
  // https://tc39.es/ecma262/#sec-object.create
  create: $create,
  // `Object.defineProperty` method
  // https://tc39.es/ecma262/#sec-object.defineproperty
  defineProperty: $defineProperty,
  // `Object.defineProperties` method
  // https://tc39.es/ecma262/#sec-object.defineproperties
  defineProperties: $defineProperties,
  // `Object.getOwnPropertyDescriptor` method
  // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL }, {
  // `Object.getOwnPropertyNames` method
  // https://tc39.es/ecma262/#sec-object.getownpropertynames
  getOwnPropertyNames: $getOwnPropertyNames
});

// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
defineSymbolToPrimitive();

// `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
setToStringTag($Symbol, SYMBOL);

hiddenKeys[HIDDEN] = true;


/***/ }),

/***/ "da84":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof global == 'object' && global) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "dbb4":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var DESCRIPTORS = __webpack_require__("83ab");
var ownKeys = __webpack_require__("56ef");
var toIndexedObject = __webpack_require__("fc6a");
var getOwnPropertyDescriptorModule = __webpack_require__("06cf");
var createProperty = __webpack_require__("8418");

// `Object.getOwnPropertyDescriptors` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
$({ target: 'Object', stat: true, sham: !DESCRIPTORS }, {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIndexedObject(object);
    var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
    var keys = ownKeys(O);
    var result = {};
    var index = 0;
    var key, descriptor;
    while (keys.length > index) {
      descriptor = getOwnPropertyDescriptor(O, key = keys[index++]);
      if (descriptor !== undefined) createProperty(result, key, descriptor);
    }
    return result;
  }
});


/***/ }),

/***/ "dc4a":
/***/ (function(module, exports, __webpack_require__) {

var aCallable = __webpack_require__("59ed");
var isNullOrUndefined = __webpack_require__("7234");

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
module.exports = function (V, P) {
  var func = V[P];
  return isNullOrUndefined(func) ? undefined : aCallable(func);
};


/***/ }),

/***/ "dca8":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var FREEZING = __webpack_require__("bb2f");
var fails = __webpack_require__("d039");
var isObject = __webpack_require__("861d");
var onFreeze = __webpack_require__("f183").onFreeze;

// eslint-disable-next-line es/no-object-freeze -- safe
var $freeze = Object.freeze;
var FAILS_ON_PRIMITIVES = fails(function () { $freeze(1); });

// `Object.freeze` method
// https://tc39.es/ecma262/#sec-object.freeze
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES, sham: !FREEZING }, {
  freeze: function freeze(it) {
    return $freeze && isObject(it) ? $freeze(onFreeze(it)) : it;
  }
});


/***/ }),

/***/ "dcc3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var IteratorPrototype = __webpack_require__("ae93").IteratorPrototype;
var create = __webpack_require__("7c73");
var createPropertyDescriptor = __webpack_require__("5c6c");
var setToStringTag = __webpack_require__("d44e");
var Iterators = __webpack_require__("3f8c");

var returnThis = function () { return this; };

module.exports = function (IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create(IteratorPrototype, { next: createPropertyDescriptor(+!ENUMERABLE_NEXT, next) });
  setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
  Iterators[TO_STRING_TAG] = returnThis;
  return IteratorConstructor;
};


/***/ }),

/***/ "dd13":
/***/ (function(module, exports) {



/***/ }),

/***/ "ddb0":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var DOMIterables = __webpack_require__("fdbc");
var DOMTokenListPrototype = __webpack_require__("785a");
var ArrayIteratorMethods = __webpack_require__("e260");
var createNonEnumerableProperty = __webpack_require__("9112");
var wellKnownSymbol = __webpack_require__("b622");

var ITERATOR = wellKnownSymbol('iterator');
var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var ArrayValues = ArrayIteratorMethods.values;

var handlePrototype = function (CollectionPrototype, COLLECTION_NAME) {
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
      createNonEnumerableProperty(CollectionPrototype, ITERATOR, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR] = ArrayValues;
    }
    if (!CollectionPrototype[TO_STRING_TAG]) {
      createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
    }
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  handlePrototype(global[COLLECTION_NAME] && global[COLLECTION_NAME].prototype, COLLECTION_NAME);
}

handlePrototype(DOMTokenListPrototype, 'DOMTokenList');


/***/ }),

/***/ "df75":
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__("ca84");
var enumBugKeys = __webpack_require__("7839");

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
module.exports = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};


/***/ }),

/***/ "e01a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// `Symbol.prototype.description` getter
// https://tc39.es/ecma262/#sec-symbol.prototype.description

var $ = __webpack_require__("23e7");
var DESCRIPTORS = __webpack_require__("83ab");
var global = __webpack_require__("da84");
var uncurryThis = __webpack_require__("e330");
var hasOwn = __webpack_require__("1a2d");
var isCallable = __webpack_require__("1626");
var isPrototypeOf = __webpack_require__("3a9b");
var toString = __webpack_require__("577e");
var defineProperty = __webpack_require__("9bf2").f;
var copyConstructorProperties = __webpack_require__("e893");

var NativeSymbol = global.Symbol;
var SymbolPrototype = NativeSymbol && NativeSymbol.prototype;

if (DESCRIPTORS && isCallable(NativeSymbol) && (!('description' in SymbolPrototype) ||
  // Safari 12 bug
  NativeSymbol().description !== undefined
)) {
  var EmptyStringDescriptionStore = {};
  // wrap Symbol constructor for correct work with undefined description
  var SymbolWrapper = function Symbol() {
    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : toString(arguments[0]);
    var result = isPrototypeOf(SymbolPrototype, this)
      ? new NativeSymbol(description)
      // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
      : description === undefined ? NativeSymbol() : NativeSymbol(description);
    if (description === '') EmptyStringDescriptionStore[result] = true;
    return result;
  };

  copyConstructorProperties(SymbolWrapper, NativeSymbol);
  SymbolWrapper.prototype = SymbolPrototype;
  SymbolPrototype.constructor = SymbolWrapper;

  var NATIVE_SYMBOL = String(NativeSymbol('test')) == 'Symbol(test)';
  var thisSymbolValue = uncurryThis(SymbolPrototype.valueOf);
  var symbolDescriptiveString = uncurryThis(SymbolPrototype.toString);
  var regexp = /^Symbol\((.*)\)[^)]+$/;
  var replace = uncurryThis(''.replace);
  var stringSlice = uncurryThis(''.slice);

  defineProperty(SymbolPrototype, 'description', {
    configurable: true,
    get: function description() {
      var symbol = thisSymbolValue(this);
      if (hasOwn(EmptyStringDescriptionStore, symbol)) return '';
      var string = symbolDescriptiveString(symbol);
      var desc = NATIVE_SYMBOL ? stringSlice(string, 7, -1) : replace(string, regexp, '$1');
      return desc === '' ? undefined : desc;
    }
  });

  $({ global: true, constructor: true, forced: true }, {
    Symbol: SymbolWrapper
  });
}


/***/ }),

/***/ "e065":
/***/ (function(module, exports, __webpack_require__) {

var path = __webpack_require__("428f");
var hasOwn = __webpack_require__("1a2d");
var wrappedWellKnownSymbolModule = __webpack_require__("e538");
var defineProperty = __webpack_require__("9bf2").f;

module.exports = function (NAME) {
  var Symbol = path.Symbol || (path.Symbol = {});
  if (!hasOwn(Symbol, NAME)) defineProperty(Symbol, NAME, {
    value: wrappedWellKnownSymbolModule.f(NAME)
  });
};


/***/ }),

/***/ "e163":
/***/ (function(module, exports, __webpack_require__) {

var hasOwn = __webpack_require__("1a2d");
var isCallable = __webpack_require__("1626");
var toObject = __webpack_require__("7b0b");
var sharedKey = __webpack_require__("f772");
var CORRECT_PROTOTYPE_GETTER = __webpack_require__("e177");

var IE_PROTO = sharedKey('IE_PROTO');
var $Object = Object;
var ObjectPrototype = $Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
module.exports = CORRECT_PROTOTYPE_GETTER ? $Object.getPrototypeOf : function (O) {
  var object = toObject(O);
  if (hasOwn(object, IE_PROTO)) return object[IE_PROTO];
  var constructor = object.constructor;
  if (isCallable(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof $Object ? ObjectPrototype : null;
};


/***/ }),

/***/ "e177":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

module.exports = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});


/***/ }),

/***/ "e260":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toIndexedObject = __webpack_require__("fc6a");
var addToUnscopables = __webpack_require__("44d2");
var Iterators = __webpack_require__("3f8c");
var InternalStateModule = __webpack_require__("69f3");
var defineProperty = __webpack_require__("9bf2").f;
var defineIterator = __webpack_require__("c6d2");
var createIterResultObject = __webpack_require__("4754");
var IS_PURE = __webpack_require__("c430");
var DESCRIPTORS = __webpack_require__("83ab");

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
module.exports = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return createIterResultObject(undefined, true);
  }
  if (kind == 'keys') return createIterResultObject(index, false);
  if (kind == 'values') return createIterResultObject(target[index], false);
  return createIterResultObject([index, target[index]], false);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var values = Iterators.Arguments = Iterators.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

// V8 ~ Chrome 45- bug
if (!IS_PURE && DESCRIPTORS && values.name !== 'values') try {
  defineProperty(values, 'name', { value: 'values' });
} catch (error) { /* empty */ }


/***/ }),

/***/ "e31d":
/***/ (function(module, exports) {



/***/ }),

/***/ "e330":
/***/ (function(module, exports, __webpack_require__) {

var classofRaw = __webpack_require__("c6b6");
var uncurryThisRaw = __webpack_require__("7d7e");

module.exports = function (fn) {
  // Nashorn bug:
  //   https://github.com/zloirock/core-js/issues/1128
  //   https://github.com/zloirock/core-js/issues/1130
  if (classofRaw(fn) === 'Function') return uncurryThisRaw(fn);
};


/***/ }),

/***/ "e351":
/***/ (function(module, exports) {

module.exports = require("print-js");

/***/ }),

/***/ "e391":
/***/ (function(module, exports, __webpack_require__) {

var toString = __webpack_require__("577e");

module.exports = function (argument, $default) {
  return argument === undefined ? arguments.length < 2 ? '' : $default : toString(argument);
};


/***/ }),

/***/ "e439":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var fails = __webpack_require__("d039");
var toIndexedObject = __webpack_require__("fc6a");
var nativeGetOwnPropertyDescriptor = __webpack_require__("06cf").f;
var DESCRIPTORS = __webpack_require__("83ab");

var FAILS_ON_PRIMITIVES = fails(function () { nativeGetOwnPropertyDescriptor(1); });
var FORCED = !DESCRIPTORS || FAILS_ON_PRIMITIVES;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
$({ target: 'Object', stat: true, forced: FORCED, sham: !DESCRIPTORS }, {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(it, key) {
    return nativeGetOwnPropertyDescriptor(toIndexedObject(it), key);
  }
});


/***/ }),

/***/ "e538":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");

exports.f = wellKnownSymbol;


/***/ }),

/***/ "e5cb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__("d066");
var hasOwn = __webpack_require__("1a2d");
var createNonEnumerableProperty = __webpack_require__("9112");
var isPrototypeOf = __webpack_require__("3a9b");
var setPrototypeOf = __webpack_require__("d2bb");
var copyConstructorProperties = __webpack_require__("e893");
var proxyAccessor = __webpack_require__("aeb0");
var inheritIfRequired = __webpack_require__("7156");
var normalizeStringArgument = __webpack_require__("e391");
var installErrorCause = __webpack_require__("ab36");
var clearErrorStack = __webpack_require__("0d26");
var ERROR_STACK_INSTALLABLE = __webpack_require__("b980");
var DESCRIPTORS = __webpack_require__("83ab");
var IS_PURE = __webpack_require__("c430");

module.exports = function (FULL_NAME, wrapper, FORCED, IS_AGGREGATE_ERROR) {
  var STACK_TRACE_LIMIT = 'stackTraceLimit';
  var OPTIONS_POSITION = IS_AGGREGATE_ERROR ? 2 : 1;
  var path = FULL_NAME.split('.');
  var ERROR_NAME = path[path.length - 1];
  var OriginalError = getBuiltIn.apply(null, path);

  if (!OriginalError) return;

  var OriginalErrorPrototype = OriginalError.prototype;

  // V8 9.3- bug https://bugs.chromium.org/p/v8/issues/detail?id=12006
  if (!IS_PURE && hasOwn(OriginalErrorPrototype, 'cause')) delete OriginalErrorPrototype.cause;

  if (!FORCED) return OriginalError;

  var BaseError = getBuiltIn('Error');

  var WrappedError = wrapper(function (a, b) {
    var message = normalizeStringArgument(IS_AGGREGATE_ERROR ? b : a, undefined);
    var result = IS_AGGREGATE_ERROR ? new OriginalError(a) : new OriginalError();
    if (message !== undefined) createNonEnumerableProperty(result, 'message', message);
    if (ERROR_STACK_INSTALLABLE) createNonEnumerableProperty(result, 'stack', clearErrorStack(result.stack, 2));
    if (this && isPrototypeOf(OriginalErrorPrototype, this)) inheritIfRequired(result, this, WrappedError);
    if (arguments.length > OPTIONS_POSITION) installErrorCause(result, arguments[OPTIONS_POSITION]);
    return result;
  });

  WrappedError.prototype = OriginalErrorPrototype;

  if (ERROR_NAME !== 'Error') {
    if (setPrototypeOf) setPrototypeOf(WrappedError, BaseError);
    else copyConstructorProperties(WrappedError, BaseError, { name: true });
  } else if (DESCRIPTORS && STACK_TRACE_LIMIT in OriginalError) {
    proxyAccessor(WrappedError, OriginalError, STACK_TRACE_LIMIT);
    proxyAccessor(WrappedError, OriginalError, 'prepareStackTrace');
  }

  copyConstructorProperties(WrappedError, OriginalError);

  if (!IS_PURE) try {
    // Safari 13- bug: WebAssembly errors does not have a proper `.name`
    if (OriginalErrorPrototype.name !== ERROR_NAME) {
      createNonEnumerableProperty(OriginalErrorPrototype, 'name', ERROR_NAME);
    }
    OriginalErrorPrototype.constructor = WrappedError;
  } catch (error) { /* empty */ }

  return WrappedError;
};


/***/ }),

/***/ "e893":
/***/ (function(module, exports, __webpack_require__) {

var hasOwn = __webpack_require__("1a2d");
var ownKeys = __webpack_require__("56ef");
var getOwnPropertyDescriptorModule = __webpack_require__("06cf");
var definePropertyModule = __webpack_require__("9bf2");

module.exports = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn(target, key) && !(exceptions && hasOwn(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};


/***/ }),

/***/ "e8b5":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("c6b6");

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
module.exports = Array.isArray || function isArray(argument) {
  return classof(argument) == 'Array';
};


/***/ }),

/***/ "e95a":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");
var Iterators = __webpack_require__("3f8c");

var ITERATOR = wellKnownSymbol('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
};


/***/ }),

/***/ "e9c4":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var getBuiltIn = __webpack_require__("d066");
var apply = __webpack_require__("2ba4");
var call = __webpack_require__("c65b");
var uncurryThis = __webpack_require__("e330");
var fails = __webpack_require__("d039");
var isArray = __webpack_require__("e8b5");
var isCallable = __webpack_require__("1626");
var isObject = __webpack_require__("861d");
var isSymbol = __webpack_require__("d9b5");
var arraySlice = __webpack_require__("f36a");
var NATIVE_SYMBOL = __webpack_require__("04f8");

var $stringify = getBuiltIn('JSON', 'stringify');
var exec = uncurryThis(/./.exec);
var charAt = uncurryThis(''.charAt);
var charCodeAt = uncurryThis(''.charCodeAt);
var replace = uncurryThis(''.replace);
var numberToString = uncurryThis(1.0.toString);

var tester = /[\uD800-\uDFFF]/g;
var low = /^[\uD800-\uDBFF]$/;
var hi = /^[\uDC00-\uDFFF]$/;

var WRONG_SYMBOLS_CONVERSION = !NATIVE_SYMBOL || fails(function () {
  var symbol = getBuiltIn('Symbol')();
  // MS Edge converts symbol values to JSON as {}
  return $stringify([symbol]) != '[null]'
    // WebKit converts symbol values to JSON as null
    || $stringify({ a: symbol }) != '{}'
    // V8 throws on boxed symbols
    || $stringify(Object(symbol)) != '{}';
});

// https://github.com/tc39/proposal-well-formed-stringify
var ILL_FORMED_UNICODE = fails(function () {
  return $stringify('\uDF06\uD834') !== '"\\udf06\\ud834"'
    || $stringify('\uDEAD') !== '"\\udead"';
});

var stringifyWithSymbolsFix = function (it, replacer) {
  var args = arraySlice(arguments);
  var $replacer = replacer;
  if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
  if (!isArray(replacer)) replacer = function (key, value) {
    if (isCallable($replacer)) value = call($replacer, this, key, value);
    if (!isSymbol(value)) return value;
  };
  args[1] = replacer;
  return apply($stringify, null, args);
};

var fixIllFormed = function (match, offset, string) {
  var prev = charAt(string, offset - 1);
  var next = charAt(string, offset + 1);
  if ((exec(low, match) && !exec(hi, next)) || (exec(hi, match) && !exec(low, prev))) {
    return '\\u' + numberToString(charCodeAt(match, 0), 16);
  } return match;
};

if ($stringify) {
  // `JSON.stringify` method
  // https://tc39.es/ecma262/#sec-json.stringify
  $({ target: 'JSON', stat: true, arity: 3, forced: WRONG_SYMBOLS_CONVERSION || ILL_FORMED_UNICODE }, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    stringify: function stringify(it, replacer, space) {
      var args = arraySlice(arguments);
      var result = apply(WRONG_SYMBOLS_CONVERSION ? stringifyWithSymbolsFix : $stringify, null, args);
      return ILL_FORMED_UNICODE && typeof result == 'string' ? replace(result, tester, fixIllFormed) : result;
    }
  });
}


/***/ }),

/***/ "ea73":
/***/ (function(module, exports) {



/***/ }),

/***/ "edd0":
/***/ (function(module, exports, __webpack_require__) {

var makeBuiltIn = __webpack_require__("13d2");
var defineProperty = __webpack_require__("9bf2");

module.exports = function (target, name, descriptor) {
  if (descriptor.get) makeBuiltIn(descriptor.get, name, { getter: true });
  if (descriptor.set) makeBuiltIn(descriptor.set, name, { setter: true });
  return defineProperty.f(target, name, descriptor);
};


/***/ }),

/***/ "ef86":
/***/ (function(module, exports) {



/***/ }),

/***/ "f183":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var uncurryThis = __webpack_require__("e330");
var hiddenKeys = __webpack_require__("d012");
var isObject = __webpack_require__("861d");
var hasOwn = __webpack_require__("1a2d");
var defineProperty = __webpack_require__("9bf2").f;
var getOwnPropertyNamesModule = __webpack_require__("241c");
var getOwnPropertyNamesExternalModule = __webpack_require__("057f");
var isExtensible = __webpack_require__("4fad");
var uid = __webpack_require__("90e3");
var FREEZING = __webpack_require__("bb2f");

var REQUIRED = false;
var METADATA = uid('meta');
var id = 0;

var setMetadata = function (it) {
  defineProperty(it, METADATA, { value: {
    objectID: 'O' + id++, // object ID
    weakData: {}          // weak collections IDs
  } });
};

var fastKey = function (it, create) {
  // return a primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!hasOwn(it, METADATA)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMetadata(it);
  // return object ID
  } return it[METADATA].objectID;
};

var getWeakData = function (it, create) {
  if (!hasOwn(it, METADATA)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMetadata(it);
  // return the store of weak collections IDs
  } return it[METADATA].weakData;
};

// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZING && REQUIRED && isExtensible(it) && !hasOwn(it, METADATA)) setMetadata(it);
  return it;
};

var enable = function () {
  meta.enable = function () { /* empty */ };
  REQUIRED = true;
  var getOwnPropertyNames = getOwnPropertyNamesModule.f;
  var splice = uncurryThis([].splice);
  var test = {};
  test[METADATA] = 1;

  // prevent exposing of metadata key
  if (getOwnPropertyNames(test).length) {
    getOwnPropertyNamesModule.f = function (it) {
      var result = getOwnPropertyNames(it);
      for (var i = 0, length = result.length; i < length; i++) {
        if (result[i] === METADATA) {
          splice(result, i, 1);
          break;
        }
      } return result;
    };

    $({ target: 'Object', stat: true, forced: true }, {
      getOwnPropertyNames: getOwnPropertyNamesExternalModule.f
    });
  }
};

var meta = module.exports = {
  enable: enable,
  fastKey: fastKey,
  getWeakData: getWeakData,
  onFreeze: onFreeze
};

hiddenKeys[METADATA] = true;


/***/ }),

/***/ "f266":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "f354":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");
var wellKnownSymbol = __webpack_require__("b622");
var IS_PURE = __webpack_require__("c430");

var ITERATOR = wellKnownSymbol('iterator');

module.exports = !fails(function () {
  // eslint-disable-next-line unicorn/relative-url-style -- required for testing
  var url = new URL('b?a=1&b=2&c=3', 'http://a');
  var searchParams = url.searchParams;
  var result = '';
  url.pathname = 'c%20d';
  searchParams.forEach(function (value, key) {
    searchParams['delete']('b');
    result += key + value;
  });
  return (IS_PURE && !url.toJSON)
    || !searchParams.sort
    || url.href !== 'http://a/c%20d?a=1&c=3'
    || searchParams.get('c') !== '3'
    || String(new URLSearchParams('?a=1')) !== 'a=1'
    || !searchParams[ITERATOR]
    // throws in Edge
    || new URL('https://a@b').username !== 'a'
    || new URLSearchParams(new URLSearchParams('a=b')).get('a') !== 'b'
    // not punycoded in Edge
    || new URL('http://тест').host !== 'xn--e1aybc'
    // not escaped in Chrome 62-
    || new URL('http://a#б').hash !== '#%D0%B1'
    // fails in Chrome 66-
    || result !== 'a1c3'
    // throws in Safari
    || new URL('http://x', undefined).host !== 'x';
});


/***/ }),

/***/ "f36a":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");

module.exports = uncurryThis([].slice);


/***/ }),

/***/ "f5df":
/***/ (function(module, exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__("00ee");
var isCallable = __webpack_require__("1626");
var classofRaw = __webpack_require__("c6b6");
var wellKnownSymbol = __webpack_require__("b622");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var $Object = Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = $Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && isCallable(O.callee) ? 'Arguments' : result;
};


/***/ }),

/***/ "f759":
/***/ (function(module, exports) {



/***/ }),

/***/ "f772":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("5692");
var uid = __webpack_require__("90e3");

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};


/***/ }),

/***/ "f940":
/***/ (function(module, exports) {



/***/ }),

/***/ "fb15":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "VMap", function() { return /* reexport */ v_map; });
__webpack_require__.d(__webpack_exports__, "VMapSimple", function() { return /* reexport */ v_map_simple; });
__webpack_require__.d(__webpack_exports__, "VMapOsmTileLayer", function() { return /* reexport */ v_map_osm_tile_layer; });
__webpack_require__.d(__webpack_exports__, "VMapOcmTileLayer", function() { return /* reexport */ v_map_ocm_tile_layer; });
__webpack_require__.d(__webpack_exports__, "VMapMapboxTileLayer", function() { return /* reexport */ v_map_mapbox_tile_layer; });
__webpack_require__.d(__webpack_exports__, "VMapArcGisAeroTileLayer", function() { return /* reexport */ v_map_arc_gis_aero_tile_layer; });
__webpack_require__.d(__webpack_exports__, "VMapArcGisTileLayer", function() { return /* reexport */ v_map_arc_gis_tile_layer; });
__webpack_require__.d(__webpack_exports__, "VMapYandexTileLayer", function() { return /* reexport */ v_map_yandex_tile_layer; });
__webpack_require__.d(__webpack_exports__, "VMapGoogleTileLayer", function() { return /* reexport */ v_map_google_tile_layer; });
__webpack_require__.d(__webpack_exports__, "VMapCadastreTileLayer", function() { return /* reexport */ v_map_cadastre_tile_layer; });
__webpack_require__.d(__webpack_exports__, "VMapSputnikTileLayer", function() { return /* reexport */ v_map_sputnik_tile_layer; });
__webpack_require__.d(__webpack_exports__, "VMapClientLayer", function() { return /* reexport */ v_map_client_layer; });
__webpack_require__.d(__webpack_exports__, "VMapServerLayer", function() { return /* reexport */ v_map_server_layer; });
__webpack_require__.d(__webpack_exports__, "VMapGroupLayer", function() { return /* reexport */ v_map_group_layer; });
__webpack_require__.d(__webpack_exports__, "VMapEmptyLayer", function() { return /* reexport */ v_map_empty_layer; });
__webpack_require__.d(__webpack_exports__, "VMapWmsLayer", function() { return /* reexport */ v_map_wms_layer; });
__webpack_require__.d(__webpack_exports__, "VMapTrackLayer", function() { return /* reexport */ v_map_track_layer; });
__webpack_require__.d(__webpack_exports__, "VMapPane", function() { return /* reexport */ v_map_pane; });
__webpack_require__.d(__webpack_exports__, "VMapMarkerIcon", function() { return /* reexport */ v_map_marker_icon; });
__webpack_require__.d(__webpack_exports__, "VMapTrackerIcon", function() { return /* reexport */ v_map_tracker_icon; });
__webpack_require__.d(__webpack_exports__, "VMapPathStyle", function() { return /* reexport */ v_map_path_style; });
__webpack_require__.d(__webpack_exports__, "VMapClusterIcon", function() { return /* reexport */ v_map_cluster_icon; });
__webpack_require__.d(__webpack_exports__, "VMapLayerPanel", function() { return /* reexport */ v_map_layer_panel; });
__webpack_require__.d(__webpack_exports__, "VMapSidebar", function() { return /* reexport */ v_map_sidebar; });
__webpack_require__.d(__webpack_exports__, "VMapTree", function() { return /* reexport */ v_map_tree; });
__webpack_require__.d(__webpack_exports__, "VMapTreeLayer", function() { return /* reexport */ v_map_tree_layer; });
__webpack_require__.d(__webpack_exports__, "VMapPanel", function() { return /* reexport */ v_map_panel; });
__webpack_require__.d(__webpack_exports__, "VMapList", function() { return /* reexport */ v_map_list; });
__webpack_require__.d(__webpack_exports__, "VMapCard", function() { return /* reexport */ v_map_card; });
__webpack_require__.d(__webpack_exports__, "VMapSearch", function() { return /* reexport */ v_map_search; });
__webpack_require__.d(__webpack_exports__, "VMapPopup", function() { return /* reexport */ v_map_popup; });
__webpack_require__.d(__webpack_exports__, "VMapPopupContent", function() { return /* reexport */ v_map_popup_content; });
__webpack_require__.d(__webpack_exports__, "VMapPopupToolbar", function() { return /* reexport */ v_map_popup_toolbar; });
__webpack_require__.d(__webpack_exports__, "VMapSingleSelection", function() { return /* reexport */ v_map_single_selection; });
__webpack_require__.d(__webpack_exports__, "VMapZoomControl", function() { return /* reexport */ v_map_zoom_control; });
__webpack_require__.d(__webpack_exports__, "VMapLayersControl", function() { return /* reexport */ v_map_layers_control; });
__webpack_require__.d(__webpack_exports__, "VMapRulerControl", function() { return /* reexport */ v_map_ruler_control; });
__webpack_require__.d(__webpack_exports__, "VMapHeatmapControl", function() { return /* reexport */ v_map_heatmap_control; });
__webpack_require__.d(__webpack_exports__, "VMapFullscreenControl", function() { return /* reexport */ v_map_fullscreen_control; });
__webpack_require__.d(__webpack_exports__, "VMapEditControl", function() { return /* reexport */ v_map_edit_control; });
__webpack_require__.d(__webpack_exports__, "VMapLocationControl", function() { return /* reexport */ v_map_location_control; });
__webpack_require__.d(__webpack_exports__, "VMapPrintControl", function() { return /* reexport */ v_map_print_control; });
__webpack_require__.d(__webpack_exports__, "VMapRoutesControl", function() { return /* reexport */ v_map_routes_control; });
__webpack_require__.d(__webpack_exports__, "VMapSearchControl", function() { return /* reexport */ v_map_search_control; });
__webpack_require__.d(__webpack_exports__, "VMapScaleControl", function() { return /* reexport */ v_map_scale_control; });
__webpack_require__.d(__webpack_exports__, "VMapTileLayer", function() { return /* reexport */ v_map_tile_layer; });
__webpack_require__.d(__webpack_exports__, "VMapWmsTileLayer", function() { return /* reexport */ v_map_wms_tile_layer; });
__webpack_require__.d(__webpack_exports__, "VMapEsriVectorTileLayer", function() { return /* reexport */ v_map_esri_vector_tile_layer; });
__webpack_require__.d(__webpack_exports__, "VMapSvgOverlay", function() { return /* reexport */ v_map_svg_overlay; });
__webpack_require__.d(__webpack_exports__, "VMapLoadMore", function() { return /* reexport */ v_map_load_more; });
__webpack_require__.d(__webpack_exports__, "VMapLoading", function() { return /* reexport */ v_map_loading; });
__webpack_require__.d(__webpack_exports__, "VMapHeatmapObserver", function() { return /* reexport */ v_map_heatmap_observer; });
__webpack_require__.d(__webpack_exports__, "VMapSearchMarkerIcon", function() { return /* reexport */ v_map_search_marker_icon; });
__webpack_require__.d(__webpack_exports__, "VMapSearchPopup", function() { return /* reexport */ v_map_search_popup; });
__webpack_require__.d(__webpack_exports__, "VMapRouteHistory", function() { return /* reexport */ v_map_route_history; });
__webpack_require__.d(__webpack_exports__, "VMapHeatmapHandler", function() { return /* reexport */ v_map_heatmap_handler; });
__webpack_require__.d(__webpack_exports__, "VMapEditHandler", function() { return /* reexport */ v_map_edit_handler; });
__webpack_require__.d(__webpack_exports__, "VMapEditObjectHandler", function() { return /* reexport */ v_map_edit_object_handler; });
__webpack_require__.d(__webpack_exports__, "VMapDeleteObjectHandler", function() { return /* reexport */ v_map_delete_object_handler; });
__webpack_require__.d(__webpack_exports__, "VMapFitHandler", function() { return /* reexport */ v_map_fit_handler; });
__webpack_require__.d(__webpack_exports__, "VMapPicketHandler", function() { return /* reexport */ v_map_picket_handler; });
__webpack_require__.d(__webpack_exports__, "VMapFollowHandler", function() { return /* reexport */ v_map_follow_handler; });
__webpack_require__.d(__webpack_exports__, "VMapTooltipHandler", function() { return /* reexport */ v_map_tooltip_handler; });
__webpack_require__.d(__webpack_exports__, "VMapLinePointHandler", function() { return /* reexport */ v_map_line_point_handler; });
__webpack_require__.d(__webpack_exports__, "makeCancel", function() { return /* reexport */ make_cancel; });
__webpack_require__.d(__webpack_exports__, "isCancel", function() { return /* reexport */ is_cancel; });
__webpack_require__.d(__webpack_exports__, "locale", function() { return /* reexport */ utils_locale; });
__webpack_require__.d(__webpack_exports__, "leafletUtil", function() { return /* reexport */ leafletUtil; });
__webpack_require__.d(__webpack_exports__, "backgroundStyleEnum", function() { return /* reexport */ background_style_enum; });
__webpack_require__.d(__webpack_exports__, "formatLatLng", function() { return /* reexport */ format_latlng; });
__webpack_require__.d(__webpack_exports__, "parseLatLng", function() { return /* reexport */ parse_latlng; });

// NAMESPACE OBJECT: ./src/components/index.js
var components_namespaceObject = {};
__webpack_require__.r(components_namespaceObject);
__webpack_require__.d(components_namespaceObject, "VMap", function() { return v_map; });
__webpack_require__.d(components_namespaceObject, "VMapSimple", function() { return v_map_simple; });
__webpack_require__.d(components_namespaceObject, "VMapOsmTileLayer", function() { return v_map_osm_tile_layer; });
__webpack_require__.d(components_namespaceObject, "VMapOcmTileLayer", function() { return v_map_ocm_tile_layer; });
__webpack_require__.d(components_namespaceObject, "VMapMapboxTileLayer", function() { return v_map_mapbox_tile_layer; });
__webpack_require__.d(components_namespaceObject, "VMapArcGisAeroTileLayer", function() { return v_map_arc_gis_aero_tile_layer; });
__webpack_require__.d(components_namespaceObject, "VMapArcGisTileLayer", function() { return v_map_arc_gis_tile_layer; });
__webpack_require__.d(components_namespaceObject, "VMapYandexTileLayer", function() { return v_map_yandex_tile_layer; });
__webpack_require__.d(components_namespaceObject, "VMapGoogleTileLayer", function() { return v_map_google_tile_layer; });
__webpack_require__.d(components_namespaceObject, "VMapCadastreTileLayer", function() { return v_map_cadastre_tile_layer; });
__webpack_require__.d(components_namespaceObject, "VMapSputnikTileLayer", function() { return v_map_sputnik_tile_layer; });
__webpack_require__.d(components_namespaceObject, "VMapClientLayer", function() { return v_map_client_layer; });
__webpack_require__.d(components_namespaceObject, "VMapServerLayer", function() { return v_map_server_layer; });
__webpack_require__.d(components_namespaceObject, "VMapGroupLayer", function() { return v_map_group_layer; });
__webpack_require__.d(components_namespaceObject, "VMapEmptyLayer", function() { return v_map_empty_layer; });
__webpack_require__.d(components_namespaceObject, "VMapWmsLayer", function() { return v_map_wms_layer; });
__webpack_require__.d(components_namespaceObject, "VMapTrackLayer", function() { return v_map_track_layer; });
__webpack_require__.d(components_namespaceObject, "VMapPane", function() { return v_map_pane; });
__webpack_require__.d(components_namespaceObject, "VMapMarkerIcon", function() { return v_map_marker_icon; });
__webpack_require__.d(components_namespaceObject, "VMapTrackerIcon", function() { return v_map_tracker_icon; });
__webpack_require__.d(components_namespaceObject, "VMapPathStyle", function() { return v_map_path_style; });
__webpack_require__.d(components_namespaceObject, "VMapClusterIcon", function() { return v_map_cluster_icon; });
__webpack_require__.d(components_namespaceObject, "VMapLayerPanel", function() { return v_map_layer_panel; });
__webpack_require__.d(components_namespaceObject, "VMapSidebar", function() { return v_map_sidebar; });
__webpack_require__.d(components_namespaceObject, "VMapTree", function() { return v_map_tree; });
__webpack_require__.d(components_namespaceObject, "VMapTreeLayer", function() { return v_map_tree_layer; });
__webpack_require__.d(components_namespaceObject, "VMapPanel", function() { return v_map_panel; });
__webpack_require__.d(components_namespaceObject, "VMapList", function() { return v_map_list; });
__webpack_require__.d(components_namespaceObject, "VMapCard", function() { return v_map_card; });
__webpack_require__.d(components_namespaceObject, "VMapSearch", function() { return v_map_search; });
__webpack_require__.d(components_namespaceObject, "VMapPopup", function() { return v_map_popup; });
__webpack_require__.d(components_namespaceObject, "VMapPopupContent", function() { return v_map_popup_content; });
__webpack_require__.d(components_namespaceObject, "VMapPopupToolbar", function() { return v_map_popup_toolbar; });
__webpack_require__.d(components_namespaceObject, "VMapSingleSelection", function() { return v_map_single_selection; });
__webpack_require__.d(components_namespaceObject, "VMapZoomControl", function() { return v_map_zoom_control; });
__webpack_require__.d(components_namespaceObject, "VMapLayersControl", function() { return v_map_layers_control; });
__webpack_require__.d(components_namespaceObject, "VMapRulerControl", function() { return v_map_ruler_control; });
__webpack_require__.d(components_namespaceObject, "VMapHeatmapControl", function() { return v_map_heatmap_control; });
__webpack_require__.d(components_namespaceObject, "VMapFullscreenControl", function() { return v_map_fullscreen_control; });
__webpack_require__.d(components_namespaceObject, "VMapEditControl", function() { return v_map_edit_control; });
__webpack_require__.d(components_namespaceObject, "VMapLocationControl", function() { return v_map_location_control; });
__webpack_require__.d(components_namespaceObject, "VMapPrintControl", function() { return v_map_print_control; });
__webpack_require__.d(components_namespaceObject, "VMapRoutesControl", function() { return v_map_routes_control; });
__webpack_require__.d(components_namespaceObject, "VMapSearchControl", function() { return v_map_search_control; });
__webpack_require__.d(components_namespaceObject, "VMapScaleControl", function() { return v_map_scale_control; });
__webpack_require__.d(components_namespaceObject, "VMapTileLayer", function() { return v_map_tile_layer; });
__webpack_require__.d(components_namespaceObject, "VMapWmsTileLayer", function() { return v_map_wms_tile_layer; });
__webpack_require__.d(components_namespaceObject, "VMapEsriVectorTileLayer", function() { return v_map_esri_vector_tile_layer; });
__webpack_require__.d(components_namespaceObject, "VMapSvgOverlay", function() { return v_map_svg_overlay; });
__webpack_require__.d(components_namespaceObject, "VMapLoadMore", function() { return v_map_load_more; });
__webpack_require__.d(components_namespaceObject, "VMapLoading", function() { return v_map_loading; });
__webpack_require__.d(components_namespaceObject, "VMapHeatmapObserver", function() { return v_map_heatmap_observer; });
__webpack_require__.d(components_namespaceObject, "VMapSearchMarkerIcon", function() { return v_map_search_marker_icon; });
__webpack_require__.d(components_namespaceObject, "VMapSearchPopup", function() { return v_map_search_popup; });
__webpack_require__.d(components_namespaceObject, "VMapRouteHistory", function() { return v_map_route_history; });
__webpack_require__.d(components_namespaceObject, "VMapHeatmapHandler", function() { return v_map_heatmap_handler; });
__webpack_require__.d(components_namespaceObject, "VMapEditHandler", function() { return v_map_edit_handler; });
__webpack_require__.d(components_namespaceObject, "VMapEditObjectHandler", function() { return v_map_edit_object_handler; });
__webpack_require__.d(components_namespaceObject, "VMapDeleteObjectHandler", function() { return v_map_delete_object_handler; });
__webpack_require__.d(components_namespaceObject, "VMapFitHandler", function() { return v_map_fit_handler; });
__webpack_require__.d(components_namespaceObject, "VMapPicketHandler", function() { return v_map_picket_handler; });
__webpack_require__.d(components_namespaceObject, "VMapFollowHandler", function() { return v_map_follow_handler; });
__webpack_require__.d(components_namespaceObject, "VMapTooltipHandler", function() { return v_map_tooltip_handler; });
__webpack_require__.d(components_namespaceObject, "VMapLinePointHandler", function() { return v_map_line_point_handler; });

// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (true) {
    var getCurrentScript = __webpack_require__("8875")
    currentScript = getCurrentScript()

    // for backward compatibility, because previously we directly included the polyfill
    if (!('currentScript' in document)) {
      Object.defineProperty(document, 'currentScript', { get: getCurrentScript })
    }
  }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("b0c0");

// EXTERNAL MODULE: external "@rosgidromet/leaflet-extensions"
var leaflet_extensions_ = __webpack_require__("b50e");

// EXTERNAL MODULE: ./src/assets/scss/map/style.scss
var style = __webpack_require__("f266");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"443a82ff-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/v-map.vue?vue&type=template&id=12a06f6b&
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "v-map"
  }, [_vm.ready ? _vm._t("default") : _vm._e()], 2);
};
var staticRenderFns = [];

// CONCATENATED MODULE: ./src/components/map/v-map.vue?vue&type=template&id=12a06f6b&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("b64b");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("a4d3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("4de4");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("d3b7");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("e439");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.push.js
var es_array_push = __webpack_require__("14d9");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("159b");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("dbb4");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js









function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("a9e3");

// EXTERNAL MODULE: external "leaflet"
var external_leaflet_ = __webpack_require__("860c");
var external_leaflet_default = /*#__PURE__*/__webpack_require__.n(external_leaflet_);

// EXTERNAL MODULE: external "merge"
var external_merge_ = __webpack_require__("6c42");
var external_merge_default = /*#__PURE__*/__webpack_require__.n(external_merge_);

// CONCATENATED MODULE: ./src/utils/messages.ru.js
/* harmony default export */ var messages_ru = ({
  heatmapTitle: "Тепловая карта",
  fullscreenTitle: {
    false: "Полноэкранный режим",
    true: "Выйти из полноэкранного режима"
  },
  printTitle: "Печать карты",
  saveAsTitle: "Сохранить как изображение",
  searchTitle: "Поиск на карте",
  zoomInTitle: "Приблизить",
  zoomOutTitle: "Отдалить",
  searchHint: "Поиск мест",
  searchPlaceHint: "Поиск мест и адресов",
  searchPopupTitle: "Результат поиска",
  editButtonTitle: "Изменить",
  detailsButtonTitle: "Подробнее",
  cancelButtonTitle: "Отмена",
  deleteButtonTitle: "Удалить",
  confirmDeleteMessage: "Вы действительно хотите удалить объект?",
  rulerTitle: "Линейка",
  rulerLengthLabel: "Расстояние:",
  rulerLengthUnit: "км",
  rulerAngleLabel: "Угол:",
  rulerAreaLabel: "Площадь:",
  locationStrings: {
    title: "Показать мое местоположение",
    metersUnit: "м",
    feetUnit: "feet",
    popup: "Вы находитесь в пределах {distance} {unit} от этой точки",
    outsideMapBoundsMsg: "Вы, кажется, находитесь за пределами карты"
  },
  noPicketsMessage: "Пикеты не найдены",
  picketDistanceMessage: "Расстояние от начала {distance}",
  units: {
    "km²": "км²",
    ha: "га",
    "m²": "м²",
    km: "км",
    m: "м",
    hours: "ч",
    minutes: "мин."
  },
  toolbarSaveBtn: "Сохранить",
  toolbarCancelBtn: "Отмена",
  routesTitle: "Маршруты",
  routesNoData: "Маршрут не найден",
  routesTotalDistanceMessage: "Общая длина маршрута {distance}",
  routesTotalTimeMessage: "Общее время движения {time}"
});
// CONCATENATED MODULE: ./src/utils/messages.en.js
/* harmony default export */ var messages_en = ({
  heatmapTitle: "Heatmap",
  fullscreenTitle: {
    false: "View fullscreen",
    true: "Exit fullscreen"
  },
  printTitle: "Print map",
  saveAsTitle: "Save as image",
  searchTitle: "Search",
  zoomInTitle: "Zoom in",
  zoomOutTitle: "Zoom out",
  searchHint: "Search places",
  searchPlaceHint: "Search places and adresses",
  searchPopupTitle: "Search results",
  editButtonTitle: "Edit",
  detailsButtonTitle: "Details",
  cancelButtonTitle: "Cancel",
  deleteButtonTitle: "Delete",
  confirmDeleteMessage: "Are you sure you want to delete the object?",
  rulerTitle: "Ruler",
  rulerLengthLabel: "Distance:",
  rulerLengthUnit: "km",
  rulerAngleLabel: "Angle:",
  rulerAreaLabel: "Area:",
  locationStrings: {
    title: "Show my location",
    metersUnit: "m",
    feetUnit: "feet",
    popup: "You are within {distance} {unit} of this point",
    outsideMapBoundsMsg: "You seem to be outside the map"
  },
  noPicketsMessage: "Pickets not found",
  picketDistanceMessage: "Distance from origin {distance}",
  units: {
    "km²": "km²",
    ha: "ha",
    "m²": "m²",
    km: "km",
    m: "m",
    hours: "h",
    minutes: "min."
  },
  toolbarSaveBtn: "Save",
  toolbarCancelBtn: "Cancel",
  routesTitle: "Routes",
  routesNoData: "Route not found",
  routesTotalDistanceMessage: "Total route length {distance}",
  routesTotalTimeMessage: "Total travel time {time}"
});
// CONCATENATED MODULE: ./src/utils/locale.js




var defaultLang = "ru";
var locale = defaultLang;
var localeMessages = {
  ru: messages_ru,
  en: messages_en
};
function setLocale(lang) {
  var fallbackLang = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var messages = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  if (!localeMessages[lang]) {
    localeMessages[lang] = localeMessages[fallbackLang] || localeMessages[defaultLang];
  }
  locale = lang;
  external_merge_default.a.recursive(localeMessages[lang], messages);
  Object(external_leaflet_["setDrawLocale"])(lang, fallbackLang || defaultLang);
}
setLocale(defaultLang);
/* harmony default export */ var utils_locale = ({
  get default() {
    return localeMessages[locale];
  },
  setLocale: setLocale
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/v-map.vue?vue&type=script&lang=js&




var zeroCenter = [0, 0];
var zeroZoom = 0;
var viewportChanged = "viewport-changed";

/**
 * Base component, contains and wrap all the other components.
 */
/* harmony default export */ var v_mapvue_type_script_lang_js_ = ({
  name: "v-map",
  provide: function provide() {
    return {
      getMap: this.getMap,
      presentation: function presentation() {
        return false;
      },
      bindPopup: function bindPopup() {},
      unbindPopup: function unbindPopup() {},
      setGroupCount: function setGroupCount() {},
      setGroupVisible: function setGroupVisible() {},
      setMarkerIcon: function setMarkerIcon() {},
      setPathStyle: function setPathStyle() {},
      setClusterIconFactory: function setClusterIconFactory() {},
      getMarkerIcon: function getMarkerIcon() {
        return null;
      },
      getPathStyle: function getPathStyle() {
        return null;
      },
      isLayersControl: function isLayersControl() {
        return false;
      },
      addBaseLayer: function addBaseLayer() {},
      addOverlay: function addOverlay() {},
      removeLayerControl: function removeLayerControl() {},
      getScroll: function getScroll() {
        return null;
      },
      getData: function getData() {
        return null;
      },
      isVisible: function isVisible() {
        return false;
      },
      setUseVisibleHandler: function setUseVisibleHandler() {},
      removeFromMap: function removeFromMap() {},
      addToMap: function addToMap() {},
      listenEvent: function listenEvent() {},
      getId: function getId() {}
    };
  },
  props: {
    center: {
      type: [external_leaflet_["LatLng"], Array],
      default: function _default() {
        return [0, 0];
      }
    },
    zoom: {
      type: Number,
      default: 0
    },
    minZoom: {
      type: Number,
      default: undefined
    },
    maxZoom: {
      type: Number,
      default: undefined
    },
    bounds: {
      type: [external_leaflet_["LatLngBounds"], Array],
      default: null
    },
    maxBounds: {
      type: [external_leaflet_["LatLngBounds"], Array],
      default: undefined
    },
    useFlyTo: {
      type: Boolean,
      default: false
    },
    attributionControl: {
      type: Boolean,
      default: false
    },
    zoomControl: {
      type: Boolean,
      default: true
    },
    mapOptions: {
      type: Object,
      default: null
    }
  },
  data: function data() {
    return {
      ready: false
    };
  },
  computed: {
    viewport: function viewport() {
      return {
        center: this.center,
        zoom: this.zoom
      };
    }
  },
  watch: {
    viewport: function viewport(newValue, oldValue) {
      var newCenter = Object(external_leaflet_["latLng"])(newValue.center);
      var oldCenter = Object(external_leaflet_["latLng"])(oldValue.center);
      if (!newCenter.equals(oldCenter) && newValue.zoom !== oldValue.zoom) {
        this.setView(newCenter, newValue.zoom);
      } else if (!newCenter.equals(oldCenter)) {
        this.setCenter(newCenter);
      } else if (newValue.zoom !== oldValue.zoom) {
        this.setZoom(newValue.zoom);
      }
    },
    bounds: function bounds() {
      this.setBounds(this.bounds);
    }
  },
  mounted: function mounted() {
    var _this = this;
    var options = _objectSpread2({
      center: undefined,
      zoom: undefined,
      minZoom: this.minZoom,
      maxZoom: this.maxZoom,
      maxBounds: this.maxBounds,
      attributionControl: this.attributionControl,
      zoomControl: this.zoomControl
    }, this.mapOptions);
    if (this.zoomControl) {
      external_leaflet_["Control"].Zoom.mergeOptions({
        zoomInTitle: utils_locale.default.zoomInTitle,
        zoomOutTitle: utils_locale.default.zoomOutTitle
      });
    }
    this.mapObject = Object(external_leaflet_["map"])(this.$el, options);
    if (this.bounds) {
      if (this.useFlyTo) {
        this.mapObject.setView(zeroCenter, zeroZoom).flyToBounds(this.bounds);
      } else {
        this.mapObject.fitBounds(this.bounds);
      }
    } else {
      if (this.useFlyTo) {
        this.mapObject.setView(zeroCenter, zeroZoom).flyTo(this.center, this.zoom);
      } else {
        this.mapObject.setView(this.center, this.zoom);
      }
    }
    if (this.$listeners[viewportChanged]) {
      this.mapObject.on("moveend", this.handleMoveEnd);
    }
    external_leaflet_["DomEvent"].on(this.mapObject, this.$listeners);
    this.ready = true;
    this.$nextTick(function () {
      /**
       * @type {void}
       */
      _this.$emit("ready", _this.mapObject);
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (this.mapObject) {
      external_leaflet_["DomEvent"].off(this.mapObject, this.$listeners);
      this.mapObject.off("moveend", this.handleMoveEnd);
      this.mapObject.remove();
    }
  },
  methods: {
    getMap: function getMap() {
      return this.mapObject;
    },
    setBounds: function setBounds(bounds) {
      if (!bounds) return;
      bounds = Object(external_leaflet_["latLngBounds"])(bounds);
      if (!bounds.isValid()) return;
      if (this.useFlyTo) {
        this.mapObject.flyToBounds(bounds);
      } else {
        this.mapObject.fitBounds(bounds);
      }
    },
    setZoom: function setZoom(zoom) {
      if (this.useFlyTo) {
        this.mapObject.flyTo(this.mapObject.getCenter(), zoom);
      } else {
        this.mapObject.setZoom(zoom);
      }
    },
    setCenter: function setCenter(center) {
      if (this.useFlyTo) {
        this.mapObject.flyTo(center);
      } else {
        this.mapObject.panTo(center);
      }
    },
    setView: function setView(center, zoom) {
      if (this.useFlyTo) {
        this.mapObject.flyTo(center, zoom);
      } else {
        this.mapObject.setView(center, zoom);
      }
    },
    handleMoveEnd: function handleMoveEnd() {
      var viewport = {
        center: this.mapObject.getCenter(),
        zoom: this.mapObject.getZoom(),
        bounds: this.mapObject.getBounds()
      };
      /**
       * @type {object}
       */
      this.$emit(viewportChanged, viewport);
    }
  }
});
// CONCATENATED MODULE: ./src/components/map/v-map.vue?vue&type=script&lang=js&
 /* harmony default export */ var map_v_mapvue_type_script_lang_js_ = (v_mapvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent(
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */,
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options =
    typeof scriptExports === 'function' ? scriptExports.options : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) {
    // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
          injectStyles.call(
            this,
            (options.functional ? this.parent : this).$root.$options.shadowRoot
          )
        }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

// EXTERNAL MODULE: ./src/components/map/v-map.vue?vue&type=custom&index=0&blockType=docs
var v_mapvue_type_custom_index_0_blockType_docs = __webpack_require__("c962");
var v_mapvue_type_custom_index_0_blockType_docs_default = /*#__PURE__*/__webpack_require__.n(v_mapvue_type_custom_index_0_blockType_docs);

// EXTERNAL MODULE: ./src/components/map/v-map.vue?vue&type=custom&index=1&blockType=docs
var v_mapvue_type_custom_index_1_blockType_docs = __webpack_require__("a683");
var v_mapvue_type_custom_index_1_blockType_docs_default = /*#__PURE__*/__webpack_require__.n(v_mapvue_type_custom_index_1_blockType_docs);

// CONCATENATED MODULE: ./src/components/map/v-map.vue





/* normalize component */

var v_map_component = normalizeComponent(
  map_v_mapvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */

if (typeof v_mapvue_type_custom_index_0_blockType_docs_default.a === 'function') v_mapvue_type_custom_index_0_blockType_docs_default()(v_map_component)

if (typeof v_mapvue_type_custom_index_1_blockType_docs_default.a === 'function') v_mapvue_type_custom_index_1_blockType_docs_default()(v_map_component)

/* harmony default export */ var v_map = (v_map_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"443a82ff-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/v-map-simple.vue?vue&type=template&id=410ef069&
var v_map_simplevue_type_template_id_410ef069_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('v-map', _vm._g({
    ref: "map",
    attrs: {
      "center": _vm.center,
      "zoom": _vm.zoom,
      "bounds": _vm.bounds,
      "use-fly-to": _vm.useFlyTo,
      "attribution-control": _vm.attributionControl,
      "zoom-control": _vm.zoomControl,
      "map-options": _vm.getMapOptions()
    }
  }, _vm.$listeners), [_vm._t("default")], 2);
};
var v_map_simplevue_type_template_id_410ef069_staticRenderFns = [];

// CONCATENATED MODULE: ./src/components/map/v-map-simple.vue?vue&type=template&id=410ef069&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("d81d");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/v-map-simple.vue?vue&type=script&lang=js&





/* harmony default export */ var v_map_simplevue_type_script_lang_js_ = ({
  name: "v-map-simple",
  components: {
    VMap: v_map
  },
  props: {
    center: {
      type: [external_leaflet_["LatLng"], Array],
      default: function _default() {
        return [0, 0];
      }
    },
    zoom: {
      type: Number,
      default: 0
    },
    bounds: {
      type: [external_leaflet_["LatLngBounds"], Array],
      default: null
    },
    useFlyTo: {
      type: Boolean,
      default: false
    },
    attributionControl: {
      type: Boolean,
      default: false
    },
    zoomControl: {
      type: Boolean,
      default: true
    },
    crs: {
      type: Object,
      default: function _default() {
        return external_leaflet_["CRS"].Simple;
      }
    },
    minZoom: {
      type: Number,
      default: 0
    },
    maxZoom: {
      type: Number,
      default: 4
    },
    maxBoundsViscosity: {
      type: Number,
      default: 0.5
    },
    maxBounds: {
      type: [external_leaflet_["LatLngBounds"], Array],
      default: null
    },
    mapOptions: {
      type: Object,
      default: null
    }
  },
  methods: {
    getMapOptions: function getMapOptions() {
      return _objectSpread2({
        crs: this.crs,
        minZoom: this.minZoom,
        maxZoom: this.maxZoom,
        maxBoundsViscosity: this.maxBoundsViscosity,
        maxBounds: this.maxBounds
      }, this.mapOptions);
    },
    getMap: function getMap() {
      var _this$$refs$map;
      return (_this$$refs$map = this.$refs.map) === null || _this$$refs$map === void 0 ? void 0 : _this$$refs$map.getMap();
    }
  }
});
// CONCATENATED MODULE: ./src/components/map/v-map-simple.vue?vue&type=script&lang=js&
 /* harmony default export */ var map_v_map_simplevue_type_script_lang_js_ = (v_map_simplevue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/map/v-map-simple.vue





/* normalize component */

var v_map_simple_component = normalizeComponent(
  map_v_map_simplevue_type_script_lang_js_,
  v_map_simplevue_type_template_id_410ef069_render,
  v_map_simplevue_type_template_id_410ef069_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var v_map_simple = (v_map_simple_component.exports);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.freeze.js
var es_object_freeze = __webpack_require__("dca8");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.error.cause.js
var es_error_cause = __webpack_require__("d9e2");

// CONCATENATED MODULE: ./src/components/map/mixins/tile-layer-mixin.js



var layerType = Object.freeze({
  BASE: "base",
  OVERLAY: "overlay"
});
/* harmony default export */ var tile_layer_mixin = ({
  inject: ["getMap", "isLayersControl", "addBaseLayer", "addOverlay", "removeLayerControl"],
  props: {
    name: {
      type: String,
      default: null
    },
    layerType: {
      type: String,
      default: layerType.BASE
    }
  },
  mounted: function mounted() {
    var _this = this;
    this.mapObject = this.createMapObject();
    if (this.layerType && this.isLayersControl()) {
      this.$nextTick(function () {
        if (_this.layerType === layerType.BASE) {
          _this.addBaseLayer(_this.mapObject, _this.name);
        } else if (_this.layerType === layerType.OVERLAY) {
          _this.addOverlay(_this.mapObject, _this.name);
        }
      });
    } else {
      var map = this.getMap();
      this.mapObject.addTo(map);
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.mapObject) {
      if (this.layerType && this.isLayersControl()) {
        this.removeLayerControl(this.mapObject);
      }
      this.mapObject.remove();
      this.finalDestroyMapObject();
    }
  },
  methods: {
    createMapObject: function createMapObject() {
      throw new Error("Please override method createMapObject");
    },
    finalDestroyMapObject: function finalDestroyMapObject() {}
  }
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/tile-layers/v-map-osm-tile-layer.vue?vue&type=script&lang=js&


/* harmony default export */ var v_map_osm_tile_layervue_type_script_lang_js_ = ({
  name: "v-map-osm-tile-layer",
  mixins: [tile_layer_mixin],
  props: {
    url: {
      type: String,
      default: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
    },
    attribution: {
      type: String,
      default: null
    }
  },
  methods: {
    createMapObject: function createMapObject() {
      return Object(external_leaflet_["tileLayer"])(this.url, {
        attribution: this.attribution
      });
    }
  },
  render: function render() {
    return null;
  }
});
// CONCATENATED MODULE: ./src/components/map/tile-layers/v-map-osm-tile-layer.vue?vue&type=script&lang=js&
 /* harmony default export */ var tile_layers_v_map_osm_tile_layervue_type_script_lang_js_ = (v_map_osm_tile_layervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/map/tile-layers/v-map-osm-tile-layer.vue?vue&type=custom&index=0&blockType=docs
var v_map_osm_tile_layervue_type_custom_index_0_blockType_docs = __webpack_require__("c566");
var v_map_osm_tile_layervue_type_custom_index_0_blockType_docs_default = /*#__PURE__*/__webpack_require__.n(v_map_osm_tile_layervue_type_custom_index_0_blockType_docs);

// EXTERNAL MODULE: ./src/components/map/tile-layers/v-map-osm-tile-layer.vue?vue&type=custom&index=1&blockType=docs
var v_map_osm_tile_layervue_type_custom_index_1_blockType_docs = __webpack_require__("f940");
var v_map_osm_tile_layervue_type_custom_index_1_blockType_docs_default = /*#__PURE__*/__webpack_require__.n(v_map_osm_tile_layervue_type_custom_index_1_blockType_docs);

// CONCATENATED MODULE: ./src/components/map/tile-layers/v-map-osm-tile-layer.vue
var v_map_osm_tile_layer_render, v_map_osm_tile_layer_staticRenderFns




/* normalize component */

var v_map_osm_tile_layer_component = normalizeComponent(
  tile_layers_v_map_osm_tile_layervue_type_script_lang_js_,
  v_map_osm_tile_layer_render,
  v_map_osm_tile_layer_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */

if (typeof v_map_osm_tile_layervue_type_custom_index_0_blockType_docs_default.a === 'function') v_map_osm_tile_layervue_type_custom_index_0_blockType_docs_default()(v_map_osm_tile_layer_component)

if (typeof v_map_osm_tile_layervue_type_custom_index_1_blockType_docs_default.a === 'function') v_map_osm_tile_layervue_type_custom_index_1_blockType_docs_default()(v_map_osm_tile_layer_component)

/* harmony default export */ var v_map_osm_tile_layer = (v_map_osm_tile_layer_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/tile-layers/v-map-ocm-tile-layer.vue?vue&type=script&lang=js&


/* harmony default export */ var v_map_ocm_tile_layervue_type_script_lang_js_ = ({
  name: "v-map-ocm-tile-layer",
  mixins: [tile_layer_mixin],
  props: {
    url: {
      type: String,
      default: "https://{s}.tile.thunderforest.com/transport/{z}/{x}/{y}.png?apikey=af7fd7de0ed048059413e19e7fb7d90b"
    },
    attribution: {
      type: String,
      default: null
    }
  },
  methods: {
    createMapObject: function createMapObject() {
      return Object(external_leaflet_["tileLayer"])(this.url, {
        attribution: this.attribution
      });
    }
  },
  render: function render() {
    return null;
  }
});
// CONCATENATED MODULE: ./src/components/map/tile-layers/v-map-ocm-tile-layer.vue?vue&type=script&lang=js&
 /* harmony default export */ var tile_layers_v_map_ocm_tile_layervue_type_script_lang_js_ = (v_map_ocm_tile_layervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/map/tile-layers/v-map-ocm-tile-layer.vue?vue&type=custom&index=0&blockType=docs
var v_map_ocm_tile_layervue_type_custom_index_0_blockType_docs = __webpack_require__("8f14");
var v_map_ocm_tile_layervue_type_custom_index_0_blockType_docs_default = /*#__PURE__*/__webpack_require__.n(v_map_ocm_tile_layervue_type_custom_index_0_blockType_docs);

// EXTERNAL MODULE: ./src/components/map/tile-layers/v-map-ocm-tile-layer.vue?vue&type=custom&index=1&blockType=docs
var v_map_ocm_tile_layervue_type_custom_index_1_blockType_docs = __webpack_require__("5b2b");
var v_map_ocm_tile_layervue_type_custom_index_1_blockType_docs_default = /*#__PURE__*/__webpack_require__.n(v_map_ocm_tile_layervue_type_custom_index_1_blockType_docs);

// CONCATENATED MODULE: ./src/components/map/tile-layers/v-map-ocm-tile-layer.vue
var v_map_ocm_tile_layer_render, v_map_ocm_tile_layer_staticRenderFns




/* normalize component */

var v_map_ocm_tile_layer_component = normalizeComponent(
  tile_layers_v_map_ocm_tile_layervue_type_script_lang_js_,
  v_map_ocm_tile_layer_render,
  v_map_ocm_tile_layer_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */

if (typeof v_map_ocm_tile_layervue_type_custom_index_0_blockType_docs_default.a === 'function') v_map_ocm_tile_layervue_type_custom_index_0_blockType_docs_default()(v_map_ocm_tile_layer_component)

if (typeof v_map_ocm_tile_layervue_type_custom_index_1_blockType_docs_default.a === 'function') v_map_ocm_tile_layervue_type_custom_index_1_blockType_docs_default()(v_map_ocm_tile_layer_component)

/* harmony default export */ var v_map_ocm_tile_layer = (v_map_ocm_tile_layer_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/tile-layers/v-map-mapbox-tile-layer.vue?vue&type=script&lang=js&


/* harmony default export */ var v_map_mapbox_tile_layervue_type_script_lang_js_ = ({
  name: "v-map-mapbox-tile-layer",
  mixins: [tile_layer_mixin],
  props: {
    url: {
      type: String,
      default: "https://api.tiles.mapbox.com/v4/{id}/{z}/{x}/{y}.png?access_token={accessToken}"
    },
    id: {
      type: String,
      default: "mapbox.streets"
    },
    accessToken: {
      type: String,
      default: "pk.eyJ1IjoiYWx0YXJpY2thIiwiYSI6ImNpa3BidXNoaTExMWh1Mm02YTY1ZXlvZXkifQ.fRS4SvpNrcqc7ZFKQSUJxA"
    },
    attribution: {
      type: String,
      default: null
    }
  },
  methods: {
    createMapObject: function createMapObject() {
      return Object(external_leaflet_["tileLayer"])(this.url, {
        url: this.url,
        id: this.id,
        accessToken: this.accessToken,
        attribution: this.attribution
      });
    }
  },
  render: function render() {
    return null;
  }
});
// CONCATENATED MODULE: ./src/components/map/tile-layers/v-map-mapbox-tile-layer.vue?vue&type=script&lang=js&
 /* harmony default export */ var tile_layers_v_map_mapbox_tile_layervue_type_script_lang_js_ = (v_map_mapbox_tile_layervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/map/tile-layers/v-map-mapbox-tile-layer.vue?vue&type=custom&index=0&blockType=docs
var v_map_mapbox_tile_layervue_type_custom_index_0_blockType_docs = __webpack_require__("841b");
var v_map_mapbox_tile_layervue_type_custom_index_0_blockType_docs_default = /*#__PURE__*/__webpack_require__.n(v_map_mapbox_tile_layervue_type_custom_index_0_blockType_docs);

// EXTERNAL MODULE: ./src/components/map/tile-layers/v-map-mapbox-tile-layer.vue?vue&type=custom&index=1&blockType=docs
var v_map_mapbox_tile_layervue_type_custom_index_1_blockType_docs = __webpack_require__("aff7");
var v_map_mapbox_tile_layervue_type_custom_index_1_blockType_docs_default = /*#__PURE__*/__webpack_require__.n(v_map_mapbox_tile_layervue_type_custom_index_1_blockType_docs);

// CONCATENATED MODULE: ./src/components/map/tile-layers/v-map-mapbox-tile-layer.vue
var v_map_mapbox_tile_layer_render, v_map_mapbox_tile_layer_staticRenderFns




/* normalize component */

var v_map_mapbox_tile_layer_component = normalizeComponent(
  tile_layers_v_map_mapbox_tile_layervue_type_script_lang_js_,
  v_map_mapbox_tile_layer_render,
  v_map_mapbox_tile_layer_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */

if (typeof v_map_mapbox_tile_layervue_type_custom_index_0_blockType_docs_default.a === 'function') v_map_mapbox_tile_layervue_type_custom_index_0_blockType_docs_default()(v_map_mapbox_tile_layer_component)

if (typeof v_map_mapbox_tile_layervue_type_custom_index_1_blockType_docs_default.a === 'function') v_map_mapbox_tile_layervue_type_custom_index_1_blockType_docs_default()(v_map_mapbox_tile_layer_component)

/* harmony default export */ var v_map_mapbox_tile_layer = (v_map_mapbox_tile_layer_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/tile-layers/v-map-arc-gis-aero-tile-layer.vue?vue&type=script&lang=js&


/* harmony default export */ var v_map_arc_gis_aero_tile_layervue_type_script_lang_js_ = ({
  name: "v-map-arc-gis-aero-tile-layer",
  mixins: [tile_layer_mixin],
  props: {
    url: {
      type: String,
      default: "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
    },
    attribution: {
      type: String,
      default: null
    }
  },
  methods: {
    createMapObject: function createMapObject() {
      return Object(external_leaflet_["tileLayer"])(this.url, {
        attribution: this.attribution
      });
    }
  },
  render: function render() {
    return null;
  }
});
// CONCATENATED MODULE: ./src/components/map/tile-layers/v-map-arc-gis-aero-tile-layer.vue?vue&type=script&lang=js&
 /* harmony default export */ var tile_layers_v_map_arc_gis_aero_tile_layervue_type_script_lang_js_ = (v_map_arc_gis_aero_tile_layervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/map/tile-layers/v-map-arc-gis-aero-tile-layer.vue?vue&type=custom&index=0&blockType=docs
var v_map_arc_gis_aero_tile_layervue_type_custom_index_0_blockType_docs = __webpack_require__("9d47");
var v_map_arc_gis_aero_tile_layervue_type_custom_index_0_blockType_docs_default = /*#__PURE__*/__webpack_require__.n(v_map_arc_gis_aero_tile_layervue_type_custom_index_0_blockType_docs);

// EXTERNAL MODULE: ./src/components/map/tile-layers/v-map-arc-gis-aero-tile-layer.vue?vue&type=custom&index=1&blockType=docs
var v_map_arc_gis_aero_tile_layervue_type_custom_index_1_blockType_docs = __webpack_require__("a076");
var v_map_arc_gis_aero_tile_layervue_type_custom_index_1_blockType_docs_default = /*#__PURE__*/__webpack_require__.n(v_map_arc_gis_aero_tile_layervue_type_custom_index_1_blockType_docs);

// CONCATENATED MODULE: ./src/components/map/tile-layers/v-map-arc-gis-aero-tile-layer.vue
var v_map_arc_gis_aero_tile_layer_render, v_map_arc_gis_aero_tile_layer_staticRenderFns




/* normalize component */

var v_map_arc_gis_aero_tile_layer_component = normalizeComponent(
  tile_layers_v_map_arc_gis_aero_tile_layervue_type_script_lang_js_,
  v_map_arc_gis_aero_tile_layer_render,
  v_map_arc_gis_aero_tile_layer_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */

if (typeof v_map_arc_gis_aero_tile_layervue_type_custom_index_0_blockType_docs_default.a === 'function') v_map_arc_gis_aero_tile_layervue_type_custom_index_0_blockType_docs_default()(v_map_arc_gis_aero_tile_layer_component)

if (typeof v_map_arc_gis_aero_tile_layervue_type_custom_index_1_blockType_docs_default.a === 'function') v_map_arc_gis_aero_tile_layervue_type_custom_index_1_blockType_docs_default()(v_map_arc_gis_aero_tile_layer_component)

/* harmony default export */ var v_map_arc_gis_aero_tile_layer = (v_map_arc_gis_aero_tile_layer_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/tile-layers/v-map-arc-gis-tile-layer.vue?vue&type=script&lang=js&


/* harmony default export */ var v_map_arc_gis_tile_layervue_type_script_lang_js_ = ({
  name: "v-map-arc-gis-tile-layer",
  mixins: [tile_layer_mixin],
  props: {
    url: {
      type: String,
      default: "https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}"
    },
    attribution: {
      type: String,
      default: null
    }
  },
  methods: {
    createMapObject: function createMapObject() {
      return Object(external_leaflet_["tileLayer"])(this.url, {
        attribution: this.attribution
      });
    }
  },
  render: function render() {
    return null;
  }
});
// CONCATENATED MODULE: ./src/components/map/tile-layers/v-map-arc-gis-tile-layer.vue?vue&type=script&lang=js&
 /* harmony default export */ var tile_layers_v_map_arc_gis_tile_layervue_type_script_lang_js_ = (v_map_arc_gis_tile_layervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/map/tile-layers/v-map-arc-gis-tile-layer.vue?vue&type=custom&index=0&blockType=docs
var v_map_arc_gis_tile_layervue_type_custom_index_0_blockType_docs = __webpack_require__("fd92");
var v_map_arc_gis_tile_layervue_type_custom_index_0_blockType_docs_default = /*#__PURE__*/__webpack_require__.n(v_map_arc_gis_tile_layervue_type_custom_index_0_blockType_docs);

// EXTERNAL MODULE: ./src/components/map/tile-layers/v-map-arc-gis-tile-layer.vue?vue&type=custom&index=1&blockType=docs
var v_map_arc_gis_tile_layervue_type_custom_index_1_blockType_docs = __webpack_require__("9e19");
var v_map_arc_gis_tile_layervue_type_custom_index_1_blockType_docs_default = /*#__PURE__*/__webpack_require__.n(v_map_arc_gis_tile_layervue_type_custom_index_1_blockType_docs);

// CONCATENATED MODULE: ./src/components/map/tile-layers/v-map-arc-gis-tile-layer.vue
var v_map_arc_gis_tile_layer_render, v_map_arc_gis_tile_layer_staticRenderFns




/* normalize component */

var v_map_arc_gis_tile_layer_component = normalizeComponent(
  tile_layers_v_map_arc_gis_tile_layervue_type_script_lang_js_,
  v_map_arc_gis_tile_layer_render,
  v_map_arc_gis_tile_layer_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */

if (typeof v_map_arc_gis_tile_layervue_type_custom_index_0_blockType_docs_default.a === 'function') v_map_arc_gis_tile_layervue_type_custom_index_0_blockType_docs_default()(v_map_arc_gis_tile_layer_component)

if (typeof v_map_arc_gis_tile_layervue_type_custom_index_1_blockType_docs_default.a === 'function') v_map_arc_gis_tile_layervue_type_custom_index_1_blockType_docs_default()(v_map_arc_gis_tile_layer_component)

/* harmony default export */ var v_map_arc_gis_tile_layer = (v_map_arc_gis_tile_layer_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/tile-layers/v-map-yandex-tile-layer.vue?vue&type=script&lang=js&



var types = ["map", "satellite", "hybrid", "publicMap", "publicMapHybrid"];
/* harmony default export */ var v_map_yandex_tile_layervue_type_script_lang_js_ = ({
  name: "v-map-yandex-tile-layer",
  mixins: [tile_layer_mixin],
  props: {
    type: {
      type: String,
      default: "publicMap",
      validator: function validator(value) {
        return types.indexOf(value) !== -1;
      }
    },
    minZoom: {
      type: Number,
      default: 0
    },
    maxZoom: {
      type: Number,
      default: 19
    },
    opacity: {
      type: Number,
      default: 1
    },
    traffic: {
      type: Boolean,
      default: false
    },
    attribution: {
      type: String,
      default: null
    }
  },
  methods: {
    createMapObject: function createMapObject() {
      return new external_leaflet_["Yandex"](this.type, {
        minZoom: this.minZoom,
        maxZoom: this.maxZoom,
        opacity: this.opacity,
        traffic: this.traffic,
        attribution: this.attribution
      });
    },
    finalDestroyMapObject: function finalDestroyMapObject() {
      if (this.mapObject._yandex) {
        this.mapObject._yandex.destroy();
        this.mapObject._container = null;
        this.mapObject._yandex = null;
      }
    }
  },
  render: function render() {
    return null;
  }
});
// CONCATENATED MODULE: ./src/components/map/tile-layers/v-map-yandex-tile-layer.vue?vue&type=script&lang=js&
 /* harmony default export */ var tile_layers_v_map_yandex_tile_layervue_type_script_lang_js_ = (v_map_yandex_tile_layervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/map/tile-layers/v-map-yandex-tile-layer.vue?vue&type=custom&index=0&blockType=docs
var v_map_yandex_tile_layervue_type_custom_index_0_blockType_docs = __webpack_require__("12cc");
var v_map_yandex_tile_layervue_type_custom_index_0_blockType_docs_default = /*#__PURE__*/__webpack_require__.n(v_map_yandex_tile_layervue_type_custom_index_0_blockType_docs);

// EXTERNAL MODULE: ./src/components/map/tile-layers/v-map-yandex-tile-layer.vue?vue&type=custom&index=1&blockType=docs
var v_map_yandex_tile_layervue_type_custom_index_1_blockType_docs = __webpack_require__("1a7e");
var v_map_yandex_tile_layervue_type_custom_index_1_blockType_docs_default = /*#__PURE__*/__webpack_require__.n(v_map_yandex_tile_layervue_type_custom_index_1_blockType_docs);

// CONCATENATED MODULE: ./src/components/map/tile-layers/v-map-yandex-tile-layer.vue
var v_map_yandex_tile_layer_render, v_map_yandex_tile_layer_staticRenderFns




/* normalize component */

var v_map_yandex_tile_layer_component = normalizeComponent(
  tile_layers_v_map_yandex_tile_layervue_type_script_lang_js_,
  v_map_yandex_tile_layer_render,
  v_map_yandex_tile_layer_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */

if (typeof v_map_yandex_tile_layervue_type_custom_index_0_blockType_docs_default.a === 'function') v_map_yandex_tile_layervue_type_custom_index_0_blockType_docs_default()(v_map_yandex_tile_layer_component)

if (typeof v_map_yandex_tile_layervue_type_custom_index_1_blockType_docs_default.a === 'function') v_map_yandex_tile_layervue_type_custom_index_1_blockType_docs_default()(v_map_yandex_tile_layer_component)

/* harmony default export */ var v_map_yandex_tile_layer = (v_map_yandex_tile_layer_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/tile-layers/v-map-google-tile-layer.vue?vue&type=script&lang=js&



var v_map_google_tile_layervue_type_script_lang_js_types = ["SATELLITE", "ROADMAP", "HYBRID", "TERRAIN"];
/* harmony default export */ var v_map_google_tile_layervue_type_script_lang_js_ = ({
  name: "v-map-google-tile-layer",
  mixins: [tile_layer_mixin],
  props: {
    type: {
      type: String,
      default: "ROADMAP",
      validator: function validator(value) {
        return v_map_google_tile_layervue_type_script_lang_js_types.indexOf(value) !== -1;
      }
    },
    minZoom: {
      type: Number,
      default: 0
    },
    maxZoom: {
      type: Number,
      default: 19
    },
    opacity: {
      type: Number,
      default: 1
    },
    attribution: {
      type: String,
      default: null
    }
  },
  methods: {
    createMapObject: function createMapObject() {
      return new external_leaflet_["Google"](this.type, {
        minZoom: this.minZoom,
        maxZoom: this.maxZoom,
        opacity: this.opacity,
        attribution: this.attribution
      });
    },
    finalDestroyMapObject: function finalDestroyMapObject() {
      if (this.mapObject._google) {
        this.mapObject._container = null;
        this.mapObject._google = null;
      }
    }
  },
  render: function render() {
    return null;
  }
});
// CONCATENATED MODULE: ./src/components/map/tile-layers/v-map-google-tile-layer.vue?vue&type=script&lang=js&
 /* harmony default export */ var tile_layers_v_map_google_tile_layervue_type_script_lang_js_ = (v_map_google_tile_layervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/map/tile-layers/v-map-google-tile-layer.vue?vue&type=custom&index=0&blockType=docs
var v_map_google_tile_layervue_type_custom_index_0_blockType_docs = __webpack_require__("ea73");
var v_map_google_tile_layervue_type_custom_index_0_blockType_docs_default = /*#__PURE__*/__webpack_require__.n(v_map_google_tile_layervue_type_custom_index_0_blockType_docs);

// EXTERNAL MODULE: ./src/components/map/tile-layers/v-map-google-tile-layer.vue?vue&type=custom&index=1&blockType=docs
var v_map_google_tile_layervue_type_custom_index_1_blockType_docs = __webpack_require__("04fe");
var v_map_google_tile_layervue_type_custom_index_1_blockType_docs_default = /*#__PURE__*/__webpack_require__.n(v_map_google_tile_layervue_type_custom_index_1_blockType_docs);

// CONCATENATED MODULE: ./src/components/map/tile-layers/v-map-google-tile-layer.vue
var v_map_google_tile_layer_render, v_map_google_tile_layer_staticRenderFns




/* normalize component */

var v_map_google_tile_layer_component = normalizeComponent(
  tile_layers_v_map_google_tile_layervue_type_script_lang_js_,
  v_map_google_tile_layer_render,
  v_map_google_tile_layer_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */

if (typeof v_map_google_tile_layervue_type_custom_index_0_blockType_docs_default.a === 'function') v_map_google_tile_layervue_type_custom_index_0_blockType_docs_default()(v_map_google_tile_layer_component)

if (typeof v_map_google_tile_layervue_type_custom_index_1_blockType_docs_default.a === 'function') v_map_google_tile_layervue_type_custom_index_1_blockType_docs_default()(v_map_google_tile_layer_component)

/* harmony default export */ var v_map_google_tile_layer = (v_map_google_tile_layer_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"443a82ff-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/tile-layers/v-map-cadastre-tile-layer.vue?vue&type=template&id=58b593cc&

var v_map_cadastre_tile_layervue_type_template_id_58b593cc_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('v-map-wms-tile-layer', {
    ref: "wms",
    attrs: {
      "layer-type": _vm.layerType,
      "name": _vm.name,
      "url": _vm.url,
      "format": _vm.format,
      "layers": _vm.layers,
      "transparent": _vm.transparent,
      "tile-size": _vm.tileSize,
      "version": _vm.version,
      "params": {
        dpi: _vm.dpi,
        f: _vm.f,
        size: _vm.size,
        bboxSR: _vm.bboxSR,
        imageSR: _vm.imageSR
      }
    }
  }), _vm.vectorLayerEnabled && _vm.vectorLayerVisible ? _c('v-map-esri-vector-tile-layer', {
    attrs: {
      "url": _vm.vectorUrl,
      "layer-type": null
    }
  }) : _vm._e()], 1);
};
var v_map_cadastre_tile_layervue_type_template_id_58b593cc_staticRenderFns = [];

// CONCATENATED MODULE: ./src/components/map/tile-layers/v-map-cadastre-tile-layer.vue?vue&type=template&id=58b593cc&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__("3ca3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__("ddb0");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.url.js
var web_url = __webpack_require__("2b3d");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.url-search-params.js
var web_url_search_params = __webpack_require__("9861");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("25f0");

// CONCATENATED MODULE: ./src/components/map/mixins/grid-layer-props-mixin.js

/* harmony default export */ var grid_layer_props_mixin = ({
  props: {
    pane: {
      type: String,
      default: "tilePane"
    },
    opacity: {
      type: Number,
      default: 1.0
    },
    zIndex: {
      type: Number,
      default: 1
    },
    tileSize: {
      type: Number,
      default: 256
    },
    noWrap: {
      type: Boolean,
      default: false
    },
    className: {
      type: String,
      default: ""
    },
    attribution: {
      type: String,
      default: null
    }
  }
});
// CONCATENATED MODULE: ./src/components/map/mixins/tile-layer-props-mixin.js


/* harmony default export */ var tile_layer_props_mixin = ({
  mixins: [grid_layer_props_mixin],
  props: {
    minZoom: {
      type: Number,
      default: 0
    },
    maxZoom: {
      type: Number,
      default: 18
    },
    subdomains: {
      type: String,
      default: "abc"
    },
    errorTileUrl: {
      type: String,
      default: ""
    },
    zoomOffset: {
      type: Number,
      default: 0
    },
    tms: {
      type: Boolean,
      default: false
    },
    zoomReverse: {
      type: Boolean,
      default: false
    },
    detectRetina: {
      type: Boolean,
      default: false
    },
    crossOrigin: {
      type: Boolean,
      default: false
    }
  }
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/v-map-wms-tile-layer.vue?vue&type=script&lang=js&




/* harmony default export */ var v_map_wms_tile_layervue_type_script_lang_js_ = ({
  name: "v-map-wms-tile-layer",
  mixins: [tile_layer_props_mixin, tile_layer_mixin],
  props: {
    /**
     * required
     */
    url: {
      type: String,
      required: true
    },
    layers: {
      type: String,
      default: ""
    },
    styles: {
      type: String,
      default: ""
    },
    format: {
      type: String,
      default: "image/jpeg"
    },
    transparent: {
      type: Boolean,
      custom: false
    },
    version: {
      type: String,
      default: "1.1.1"
    },
    crs: {
      type: Object,
      default: null
    },
    uppercase: {
      type: Boolean,
      default: false
    },
    params: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  methods: {
    createMapObject: function createMapObject() {
      return external_leaflet_["tileLayer"].wms(this.url, _objectSpread2(_objectSpread2({}, this.params), {}, {
        layers: this.layers,
        styles: this.styles,
        format: this.format,
        transparent: this.transparent,
        version: this.version,
        crs: this.crs,
        uppercase: this.uppercase,
        minZoom: this.minZoom,
        maxZoom: this.maxZoom,
        subdomains: this.subdomains,
        errorTileUrl: this.errorTileUrl,
        zoomOffset: this.zoomOffset,
        tms: this.tms,
        zoomReverse: this.zoomReverse,
        detectRetina: this.detectRetina,
        crossOrigin: this.crossOrigin,
        pane: this.pane,
        opacity: this.opacity,
        zIndex: this.zIndex,
        tileSize: this.tileSize,
        noWrap: this.noWrap,
        className: this.className,
        attribution: this.attribution
      }));
    }
  },
  render: function render() {
    return null;
  }
});
// CONCATENATED MODULE: ./src/components/map/v-map-wms-tile-layer.vue?vue&type=script&lang=js&
 /* harmony default export */ var map_v_map_wms_tile_layervue_type_script_lang_js_ = (v_map_wms_tile_layervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/map/v-map-wms-tile-layer.vue?vue&type=custom&index=0&blockType=docs
var v_map_wms_tile_layervue_type_custom_index_0_blockType_docs = __webpack_require__("bae3");
var v_map_wms_tile_layervue_type_custom_index_0_blockType_docs_default = /*#__PURE__*/__webpack_require__.n(v_map_wms_tile_layervue_type_custom_index_0_blockType_docs);

// EXTERNAL MODULE: ./src/components/map/v-map-wms-tile-layer.vue?vue&type=custom&index=1&blockType=docs
var v_map_wms_tile_layervue_type_custom_index_1_blockType_docs = __webpack_require__("1322");
var v_map_wms_tile_layervue_type_custom_index_1_blockType_docs_default = /*#__PURE__*/__webpack_require__.n(v_map_wms_tile_layervue_type_custom_index_1_blockType_docs);

// CONCATENATED MODULE: ./src/components/map/v-map-wms-tile-layer.vue
var v_map_wms_tile_layer_render, v_map_wms_tile_layer_staticRenderFns




/* normalize component */

var v_map_wms_tile_layer_component = normalizeComponent(
  map_v_map_wms_tile_layervue_type_script_lang_js_,
  v_map_wms_tile_layer_render,
  v_map_wms_tile_layer_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */

if (typeof v_map_wms_tile_layervue_type_custom_index_0_blockType_docs_default.a === 'function') v_map_wms_tile_layervue_type_custom_index_0_blockType_docs_default()(v_map_wms_tile_layer_component)

if (typeof v_map_wms_tile_layervue_type_custom_index_1_blockType_docs_default.a === 'function') v_map_wms_tile_layervue_type_custom_index_1_blockType_docs_default()(v_map_wms_tile_layer_component)

/* harmony default export */ var v_map_wms_tile_layer = (v_map_wms_tile_layer_component.exports);
// CONCATENATED MODULE: ./src/utils/types.js
function isUndefined(obj) {
  return typeof obj === "undefined";
}
function isDefined(arg) {
  return !isUndefinedOrNull(arg);
}
function isUndefinedOrNull(obj) {
  return isUndefined(obj) || obj === null;
}
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/v-map-esri-vector-tile-layer.vue?vue&type=script&lang=js&




/* harmony default export */ var v_map_esri_vector_tile_layervue_type_script_lang_js_ = ({
  name: "v-map-esri-vector-tile-layer",
  mixins: [tile_layer_mixin],
  props: {
    /**
     * required
     */
    url: {
      type: String,
      required: true
    },
    apikey: {
      type: String,
      default: undefined
    },
    token: {
      type: String,
      default: undefined
    },
    portalUrl: {
      type: String,
      default: undefined
    },
    styles: {
      type: Function,
      default: undefined
    },
    esriOptions: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  methods: {
    createMapObject: function createMapObject() {
      var mapObject = external_leaflet_["esri"].Vector.vectorTileLayer(this.url, this.getEsriOptions());
      var superOnRemove = mapObject.onRemove;
      mapObject.onRemove = function (map) {
        if (mapObject._ready) {
          superOnRemove.call(mapObject, map);
        }
      };
      return mapObject;
    },
    getEsriOptions: function getEsriOptions() {
      var options = {};
      if (isDefined(this.apiKey)) {
        options.apikey = this.apikey;
      }
      if (isDefined(this.token)) {
        options.token = this.token;
      }
      if (isDefined(this.portalUrl)) {
        options.portalUrl = this.portalUrl;
      }
      if (isDefined(this.styles)) {
        options.styles = this.styles;
      }
      return _objectSpread2(_objectSpread2({}, options), this.esriOptions);
    }
  },
  render: function render() {
    return null;
  }
});
// CONCATENATED MODULE: ./src/components/map/v-map-esri-vector-tile-layer.vue?vue&type=script&lang=js&
 /* harmony default export */ var map_v_map_esri_vector_tile_layervue_type_script_lang_js_ = (v_map_esri_vector_tile_layervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/map/v-map-esri-vector-tile-layer.vue?vue&type=custom&index=0&blockType=docs
var v_map_esri_vector_tile_layervue_type_custom_index_0_blockType_docs = __webpack_require__("6642");
var v_map_esri_vector_tile_layervue_type_custom_index_0_blockType_docs_default = /*#__PURE__*/__webpack_require__.n(v_map_esri_vector_tile_layervue_type_custom_index_0_blockType_docs);

// CONCATENATED MODULE: ./src/components/map/v-map-esri-vector-tile-layer.vue
var v_map_esri_vector_tile_layer_render, v_map_esri_vector_tile_layer_staticRenderFns




/* normalize component */

var v_map_esri_vector_tile_layer_component = normalizeComponent(
  map_v_map_esri_vector_tile_layervue_type_script_lang_js_,
  v_map_esri_vector_tile_layer_render,
  v_map_esri_vector_tile_layer_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */

if (typeof v_map_esri_vector_tile_layervue_type_custom_index_0_blockType_docs_default.a === 'function') v_map_esri_vector_tile_layervue_type_custom_index_0_blockType_docs_default()(v_map_esri_vector_tile_layer_component)

/* harmony default export */ var v_map_esri_vector_tile_layer = (v_map_esri_vector_tile_layer_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/tile-layers/v-map-cadastre-tile-layer.vue?vue&type=script&lang=js&









/* harmony default export */ var v_map_cadastre_tile_layervue_type_script_lang_js_ = ({
  name: "v-map-cadastre-tile-layer",
  inject: ["getMap"],
  components: {
    VMapWmsTileLayer: v_map_wms_tile_layer,
    VMapEsriVectorTileLayer: v_map_esri_vector_tile_layer
  },
  props: {
    name: {
      type: String,
      default: null
    },
    url: {
      type: String,
      default: "https://pkk.rosreestr.ru/arcgis/rest/services/PKK6/CadastreObjects/MapServer/export"
    },
    vectorUrl: {
      type: String,
      default: "https://pkk.rosreestr.ru/arcgis/rest/services/Hosted/caddivsion/VectorTileServer"
    },
    minVectorZoom: {
      type: Number,
      default: 3
    },
    format: {
      type: String,
      default: "PNG32"
    },
    layers: {
      type: String,
      default: "show:30,27,24,23,22"
    },
    dpi: {
      type: Number,
      default: 96
    },
    f: {
      type: String,
      default: "image"
    },
    transparent: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: "1024,1024"
    },
    tileSize: {
      type: Number,
      default: 1024
    },
    bboxSR: {
      type: Number,
      default: 102100
    },
    imageSR: {
      type: Number,
      default: 102100
    },
    version: {
      type: String,
      default: undefined
    },
    layerType: {
      type: String,
      default: "overlay"
    }
  },
  data: function data() {
    return {
      vectorLayerVisible: false,
      vectorLayerEnabled: false
    };
  },
  mounted: function mounted() {
    var _this = this;
    var mapObject = this.$refs.wms.mapObject;
    var superGetTileUrl = mapObject.getTileUrl;
    mapObject.getTileUrl = function (coords) {
      return _this.prepareTileUrl(superGetTileUrl.call(mapObject, coords));
    };
    var map = this.getMap();
    map.on("zoom", this.onMapZoom);
    mapObject.on("add", this.onAddLayer).on("remove", this.onRemoveLayer);
    if (map.hasLayer(mapObject)) {
      this.onAddLayer();
    }
    this.updateVectorLayerEnabled();
  },
  beforeDestroy: function beforeDestroy() {
    var map = this.getMap();
    map.off("zoom", this.onMapZoom);
    var mapObject = this.$refs.wms.mapObject;
    mapObject.off("add", this.onAddLayer).off("remove", this.onRemoveLayer);
  },
  methods: {
    onAddLayer: function onAddLayer() {
      this.vectorLayerVisible = true;
    },
    onRemoveLayer: function onRemoveLayer() {
      this.vectorLayerVisible = false;
    },
    onMapZoom: function onMapZoom() {
      this.updateVectorLayerEnabled();
    },
    updateVectorLayerEnabled: function updateVectorLayerEnabled() {
      var map = this.getMap();
      this.vectorLayerEnabled = map.getZoom() >= this.minVectorZoom;
    },
    prepareTileUrl: function prepareTileUrl(tileUrl) {
      var url = new URL(tileUrl);
      var removeParams = ["version", "crs", "srs", "request", "service", "styles", "width", "height"];
      removeParams.forEach(function (param) {
        url.searchParams.delete(param);
      });
      return url.toString();
    }
  }
});
// CONCATENATED MODULE: ./src/components/map/tile-layers/v-map-cadastre-tile-layer.vue?vue&type=script&lang=js&
 /* harmony default export */ var tile_layers_v_map_cadastre_tile_layervue_type_script_lang_js_ = (v_map_cadastre_tile_layervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/map/tile-layers/v-map-cadastre-tile-layer.vue?vue&type=custom&index=0&blockType=docs
var v_map_cadastre_tile_layervue_type_custom_index_0_blockType_docs = __webpack_require__("8b1b");
var v_map_cadastre_tile_layervue_type_custom_index_0_blockType_docs_default = /*#__PURE__*/__webpack_require__.n(v_map_cadastre_tile_layervue_type_custom_index_0_blockType_docs);

// EXTERNAL MODULE: ./src/components/map/tile-layers/v-map-cadastre-tile-layer.vue?vue&type=custom&index=1&blockType=docs
var v_map_cadastre_tile_layervue_type_custom_index_1_blockType_docs = __webpack_require__("af6f");
var v_map_cadastre_tile_layervue_type_custom_index_1_blockType_docs_default = /*#__PURE__*/__webpack_require__.n(v_map_cadastre_tile_layervue_type_custom_index_1_blockType_docs);

// CONCATENATED MODULE: ./src/components/map/tile-layers/v-map-cadastre-tile-layer.vue





/* normalize component */

var v_map_cadastre_tile_layer_component = normalizeComponent(
  tile_layers_v_map_cadastre_tile_layervue_type_script_lang_js_,
  v_map_cadastre_tile_layervue_type_template_id_58b593cc_render,
  v_map_cadastre_tile_layervue_type_template_id_58b593cc_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */

if (typeof v_map_cadastre_tile_layervue_type_custom_index_0_blockType_docs_default.a === 'function') v_map_cadastre_tile_layervue_type_custom_index_0_blockType_docs_default()(v_map_cadastre_tile_layer_component)

if (typeof v_map_cadastre_tile_layervue_type_custom_index_1_blockType_docs_default.a === 'function') v_map_cadastre_tile_layervue_type_custom_index_1_blockType_docs_default()(v_map_cadastre_tile_layer_component)

/* harmony default export */ var v_map_cadastre_tile_layer = (v_map_cadastre_tile_layer_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/tile-layers/v-map-sputnik-tile-layer.vue?vue&type=script&lang=js&


/* harmony default export */ var v_map_sputnik_tile_layervue_type_script_lang_js_ = ({
  name: "v-map-sputnik-tile-layer",
  mixins: [tile_layer_mixin],
  props: {
    url: {
      type: String,
      default: "https://{s}.tilessputnik.ru/{z}/{x}/{y}.png"
    },
    attribution: {
      type: String,
      default: null
    }
  },
  methods: {
    createMapObject: function createMapObject() {
      return Object(external_leaflet_["tileLayer"])(this.url, {
        attribution: this.attribution
      });
    }
  },
  render: function render() {
    return null;
  }
});
// CONCATENATED MODULE: ./src/components/map/tile-layers/v-map-sputnik-tile-layer.vue?vue&type=script&lang=js&
 /* harmony default export */ var tile_layers_v_map_sputnik_tile_layervue_type_script_lang_js_ = (v_map_sputnik_tile_layervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/map/tile-layers/v-map-sputnik-tile-layer.vue?vue&type=custom&index=0&blockType=docs
var v_map_sputnik_tile_layervue_type_custom_index_0_blockType_docs = __webpack_require__("a845");
var v_map_sputnik_tile_layervue_type_custom_index_0_blockType_docs_default = /*#__PURE__*/__webpack_require__.n(v_map_sputnik_tile_layervue_type_custom_index_0_blockType_docs);

// EXTERNAL MODULE: ./src/components/map/tile-layers/v-map-sputnik-tile-layer.vue?vue&type=custom&index=1&blockType=docs
var v_map_sputnik_tile_layervue_type_custom_index_1_blockType_docs = __webpack_require__("b5b8");
var v_map_sputnik_tile_layervue_type_custom_index_1_blockType_docs_default = /*#__PURE__*/__webpack_require__.n(v_map_sputnik_tile_layervue_type_custom_index_1_blockType_docs);

// CONCATENATED MODULE: ./src/components/map/tile-layers/v-map-sputnik-tile-layer.vue
var v_map_sputnik_tile_layer_render, v_map_sputnik_tile_layer_staticRenderFns




/* normalize component */

var v_map_sputnik_tile_layer_component = normalizeComponent(
  tile_layers_v_map_sputnik_tile_layervue_type_script_lang_js_,
  v_map_sputnik_tile_layer_render,
  v_map_sputnik_tile_layer_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */

if (typeof v_map_sputnik_tile_layervue_type_custom_index_0_blockType_docs_default.a === 'function') v_map_sputnik_tile_layervue_type_custom_index_0_blockType_docs_default()(v_map_sputnik_tile_layer_component)

if (typeof v_map_sputnik_tile_layervue_type_custom_index_1_blockType_docs_default.a === 'function') v_map_sputnik_tile_layervue_type_custom_index_1_blockType_docs_default()(v_map_sputnik_tile_layer_component)

/* harmony default export */ var v_map_sputnik_tile_layer = (v_map_sputnik_tile_layer_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/controls/v-map-zoom-control.vue?vue&type=script&lang=js&


/* harmony default export */ var v_map_zoom_controlvue_type_script_lang_js_ = ({
  name: "v-map-zoom-control",
  inject: ["getMap"],
  props: {
    position: {
      type: String,
      default: "rightcenter"
    },
    zoomInTitle: {
      type: String,
      default: function _default() {
        return utils_locale.default.zoomInTitle;
      }
    },
    zoomOutTitle: {
      type: String,
      default: function _default() {
        return utils_locale.default.zoomOutTitle;
      }
    }
  },
  mounted: function mounted() {
    var map = this.getMap();
    this.mapObject = external_leaflet_["control"].zoom({
      position: this.position,
      zoomInTitle: this.zoomInTitle,
      zoomOutTitle: this.zoomOutTitle
    });
    this.mapObject.addTo(map);
  },
  beforeDestroy: function beforeDestroy() {
    if (this.mapObject) {
      this.mapObject.remove();
    }
  },
  render: function render() {
    return null;
  }
});
// CONCATENATED MODULE: ./src/components/map/controls/v-map-zoom-control.vue?vue&type=script&lang=js&
 /* harmony default export */ var controls_v_map_zoom_controlvue_type_script_lang_js_ = (v_map_zoom_controlvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/map/controls/v-map-zoom-control.vue
var v_map_zoom_control_render, v_map_zoom_control_staticRenderFns




/* normalize component */

var v_map_zoom_control_component = normalizeComponent(
  controls_v_map_zoom_controlvue_type_script_lang_js_,
  v_map_zoom_control_render,
  v_map_zoom_control_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var v_map_zoom_control = (v_map_zoom_control_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"443a82ff-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/controls/v-map-layers-control.vue?vue&type=template&id=68f1f562&
var v_map_layers_controlvue_type_template_id_68f1f562_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_vm._t("default")], 2);
};
var v_map_layers_controlvue_type_template_id_68f1f562_staticRenderFns = [];

// CONCATENATED MODULE: ./src/components/map/controls/v-map-layers-control.vue?vue&type=template&id=68f1f562&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/controls/v-map-layers-control.vue?vue&type=script&lang=js&





/* harmony default export */ var v_map_layers_controlvue_type_script_lang_js_ = ({
  name: "v-map-layers-control",
  inject: ["getMap"],
  provide: function provide() {
    return {
      isLayersControl: function isLayersControl() {
        return true;
      },
      addBaseLayer: this.addBaseLayer,
      addOverlay: this.addOverlay,
      removeLayerControl: this.removeLayerControl
    };
  },
  props: {
    /**
     * sync
     */
    current: {
      type: String,
      default: null
    },
    overlays: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    position: {
      type: String,
      default: "topright"
    },
    collapsed: {
      type: Boolean,
      default: true
    },
    autoZIndex: {
      type: Boolean,
      default: true
    },
    hideSingleBase: {
      type: Boolean,
      default: false
    },
    sortLayers: {
      type: Boolean,
      default: false
    },
    sortFunction: {
      type: Function,
      default: undefined
    }
  },
  watch: {
    current: function current(newValue, oldValue) {
      this.updateCurrent(newValue, oldValue);
    },
    overlays: function overlays(newValue, oldValue) {
      this.updateOverlays(newValue, oldValue);
    }
  },
  mounted: function mounted() {
    var _this = this;
    var map = this.getMap();
    map.on("baselayerchange", this.onBaseLayerChanged);
    this.mapObject = external_leaflet_["control"].layers(null, null, {
      position: this.position,
      collapsed: this.collapsed,
      autoZIndex: this.autoZIndex,
      hideSingleBase: this.hideSingleBase,
      sortLayers: this.sortLayers,
      sortFunction: this.sortFunction
    });
    this.mapObject.addTo(map);
    this.$nextTick(function () {
      _this.updateCurrent(_this.current);
      _this.updateOverlays(_this.overlays);
    });
  },
  beforeDestroy: function beforeDestroy() {
    var map = this.getMap();
    map.off("baselayerchange", this.onBaseLayerChanged);
    if (this.mapObject) {
      this.mapObject.remove();
    }
  },
  methods: {
    addBaseLayer: function addBaseLayer(mapObject, name) {
      this.mapObject.addBaseLayer(mapObject, name);
    },
    addOverlay: function addOverlay(mapObject, name) {
      this.mapObject.addOverlay(mapObject, name);
    },
    removeLayerControl: function removeLayerControl(mapObject) {
      this.mapObject.removeLayer(mapObject);
    },
    updateCurrent: function updateCurrent(newValue, oldValue) {
      var _this$mapObject = this.mapObject,
        map = _this$mapObject._map,
        layers = _this$mapObject._layers;
      if (!map) return;
      if (oldValue !== undefined) {
        layers.filter(function (_ref) {
          var name = _ref.name,
            overlay = _ref.overlay;
          return !overlay && name === oldValue;
        }).forEach(function (_ref2) {
          var layer = _ref2.layer;
          return map.removeLayer(layer);
        });
      }
      var firstObj = layers.filter(function (_ref3) {
        var name = _ref3.name,
          overlay = _ref3.overlay;
        return !overlay && name === newValue;
      })[0];
      if (firstObj) {
        map.addLayer(firstObj.layer);
      }
    },
    updateOverlays: function updateOverlays(newValue, oldValue) {
      var _this$mapObject2 = this.mapObject,
        map = _this$mapObject2._map,
        layers = _this$mapObject2._layers;
      if (!map) return;
      if (oldValue !== undefined) {
        layers.filter(function (_ref4) {
          var name = _ref4.name,
            overlay = _ref4.overlay;
          return overlay && oldValue.indexOf(name) !== -1;
        }).forEach(function (_ref5) {
          var layer = _ref5.layer;
          return map.removeLayer(layer);
        });
      }
      layers.filter(function (_ref6) {
        var name = _ref6.name,
          overlay = _ref6.overlay;
        return overlay && newValue.indexOf(name) !== -1;
      }).forEach(function (_ref7) {
        var layer = _ref7.layer;
        return map.addLayer(layer);
      });
    },
    onBaseLayerChanged: function onBaseLayerChanged(e) {
      /**
       * @type {string}
       */
      this.$emit("update:current", e.name);
    }
  }
});
// CONCATENATED MODULE: ./src/components/map/controls/v-map-layers-control.vue?vue&type=script&lang=js&
 /* harmony default export */ var controls_v_map_layers_controlvue_type_script_lang_js_ = (v_map_layers_controlvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/map/controls/v-map-layers-control.vue?vue&type=custom&index=0&blockType=docs
var v_map_layers_controlvue_type_custom_index_0_blockType_docs = __webpack_require__("2235");
var v_map_layers_controlvue_type_custom_index_0_blockType_docs_default = /*#__PURE__*/__webpack_require__.n(v_map_layers_controlvue_type_custom_index_0_blockType_docs);

// EXTERNAL MODULE: ./src/components/map/controls/v-map-layers-control.vue?vue&type=custom&index=1&blockType=docs
var v_map_layers_controlvue_type_custom_index_1_blockType_docs = __webpack_require__("3ae1");
var v_map_layers_controlvue_type_custom_index_1_blockType_docs_default = /*#__PURE__*/__webpack_require__.n(v_map_layers_controlvue_type_custom_index_1_blockType_docs);

// CONCATENATED MODULE: ./src/components/map/controls/v-map-layers-control.vue





/* normalize component */

var v_map_layers_control_component = normalizeComponent(
  controls_v_map_layers_controlvue_type_script_lang_js_,
  v_map_layers_controlvue_type_template_id_68f1f562_render,
  v_map_layers_controlvue_type_template_id_68f1f562_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */

if (typeof v_map_layers_controlvue_type_custom_index_0_blockType_docs_default.a === 'function') v_map_layers_controlvue_type_custom_index_0_blockType_docs_default()(v_map_layers_control_component)

if (typeof v_map_layers_controlvue_type_custom_index_1_blockType_docs_default.a === 'function') v_map_layers_controlvue_type_custom_index_1_blockType_docs_default()(v_map_layers_control_component)

/* harmony default export */ var v_map_layers_control = (v_map_layers_control_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"443a82ff-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/controls/v-map-ruler-control.vue?vue&type=template&id=348ba235&
var v_map_ruler_controlvue_type_template_id_348ba235_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.pane ? _c('v-map-pane', {
    attrs: {
      "name": _vm.pane
    }
  }) : _vm._e();
};
var v_map_ruler_controlvue_type_template_id_348ba235_staticRenderFns = [];

// CONCATENATED MODULE: ./src/components/map/controls/v-map-ruler-control.vue?vue&type=template&id=348ba235&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/v-map-pane.vue?vue&type=script&lang=js&



/* harmony default export */ var v_map_panevue_type_script_lang_js_ = ({
  name: "v-map-pane",
  inject: ["getMap"],
  props: {
    /**
     * required
     */
    name: {
      type: String,
      required: true
    },
    zIndex: {
      type: [String, Number],
      default: null
    }
  },
  watch: {
    name: function name() {
      this.createPane(this.name);
    }
  },
  mounted: function mounted() {
    this.createPane(this.name);
    var pane = this.getPane();
    if (pane && this.$el) {
      pane.appendChild(this.$el);
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
  },
  methods: {
    createPane: function createPane(name) {
      var map = this.getMap();
      if (!map.getPane(name)) {
        var pane = map.createPane(name);
        if (pane && isDefined(this.zIndex)) {
          pane.style.zIndex = "".concat(this.zIndex);
        }
      }
    },
    getPane: function getPane() {
      var map = this.getMap();
      return map.getPane(this.name);
    }
  },
  render: function render(h) {
    return this.$slots.default ? h("div", {
      class: "v-map-pane"
    }, this.$slots.default) : null;
  }
});
// CONCATENATED MODULE: ./src/components/map/v-map-pane.vue?vue&type=script&lang=js&
 /* harmony default export */ var map_v_map_panevue_type_script_lang_js_ = (v_map_panevue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/map/v-map-pane.vue?vue&type=custom&index=0&blockType=docs
var v_map_panevue_type_custom_index_0_blockType_docs = __webpack_require__("0868");
var v_map_panevue_type_custom_index_0_blockType_docs_default = /*#__PURE__*/__webpack_require__.n(v_map_panevue_type_custom_index_0_blockType_docs);

// EXTERNAL MODULE: ./src/components/map/v-map-pane.vue?vue&type=custom&index=1&blockType=docs
var v_map_panevue_type_custom_index_1_blockType_docs = __webpack_require__("c0eb");
var v_map_panevue_type_custom_index_1_blockType_docs_default = /*#__PURE__*/__webpack_require__.n(v_map_panevue_type_custom_index_1_blockType_docs);

// CONCATENATED MODULE: ./src/components/map/v-map-pane.vue
var v_map_pane_render, v_map_pane_staticRenderFns




/* normalize component */

var v_map_pane_component = normalizeComponent(
  map_v_map_panevue_type_script_lang_js_,
  v_map_pane_render,
  v_map_pane_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */

if (typeof v_map_panevue_type_custom_index_0_blockType_docs_default.a === 'function') v_map_panevue_type_custom_index_0_blockType_docs_default()(v_map_pane_component)

if (typeof v_map_panevue_type_custom_index_1_blockType_docs_default.a === 'function') v_map_panevue_type_custom_index_1_blockType_docs_default()(v_map_pane_component)

/* harmony default export */ var v_map_pane = (v_map_pane_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/controls/v-map-ruler-control.vue?vue&type=script&lang=js&




/* harmony default export */ var v_map_ruler_controlvue_type_script_lang_js_ = ({
  name: "v-map-ruler-control",
  inject: ["getMap"],
  components: {
    VMapPane: v_map_pane
  },
  props: {
    position: {
      type: String,
      default: "htophright"
    },
    title: {
      type: String,
      default: function _default() {
        return utils_locale.default.rulerTitle;
      }
    },
    pane: {
      type: String,
      default: "rulerOverlayPane"
    },
    moveInfo: {
      type: Boolean,
      default: true
    },
    lengthLabel: {
      type: String,
      default: function _default() {
        return utils_locale.default.rulerLengthLabel;
      }
    },
    angleLabel: {
      type: String,
      default: function _default() {
        return utils_locale.default.rulerAngleLabel;
      }
    },
    areaLabel: {
      type: String,
      default: function _default() {
        return utils_locale.default.rulerAreaLabel;
      }
    },
    localizedUnits: {
      type: Object,
      default: function _default() {
        return _objectSpread2({}, utils_locale.default.units);
      }
    }
  },
  mounted: function mounted() {
    var map = this.getMap();
    this.mapObject = external_leaflet_["control"].ruler({
      position: this.position,
      title: this.title,
      ruler: {
        pane: this.pane,
        moveInfo: this.moveInfo,
        lengthLabel: this.lengthLabel,
        angleLabel: this.angleLabel,
        areaLabel: this.areaLabel,
        localizeUnits: !!this.localizedUnits,
        unitLabels: this.localizedUnits
      }
    });
    this.mapObject.addTo(map);
  },
  beforeDestroy: function beforeDestroy() {
    if (this.mapObject) {
      this.mapObject.remove();
    }
  }
});
// CONCATENATED MODULE: ./src/components/map/controls/v-map-ruler-control.vue?vue&type=script&lang=js&
 /* harmony default export */ var controls_v_map_ruler_controlvue_type_script_lang_js_ = (v_map_ruler_controlvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/map/controls/v-map-ruler-control.vue





/* normalize component */

var v_map_ruler_control_component = normalizeComponent(
  controls_v_map_ruler_controlvue_type_script_lang_js_,
  v_map_ruler_controlvue_type_template_id_348ba235_render,
  v_map_ruler_controlvue_type_template_id_348ba235_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var v_map_ruler_control = (v_map_ruler_control_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"443a82ff-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/controls/v-map-heatmap-control.vue?vue&type=template&id=d1a49ce6&
var v_map_heatmap_controlvue_type_template_id_d1a49ce6_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.visible,
      expression: "visible"
    }],
    staticClass: "leaflet-control-heatmap leaflet-bar leaflet-control"
  }, [_c('a', {
    ref: "button",
    staticClass: "leaflet-control-heatmap-button",
    class: {
      'leaflet-control-heatmap-button--active': _vm.active
    },
    attrs: {
      "href": "#",
      "title": _vm.title
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.handleButtonPressed.apply(null, arguments);
      }
    }
  }, [_c('i', {
    staticClass: "leaflet-control-heatmap-icon"
  })])]);
};
var v_map_heatmap_controlvue_type_template_id_d1a49ce6_staticRenderFns = [];

// CONCATENATED MODULE: ./src/components/map/controls/v-map-heatmap-control.vue?vue&type=template&id=d1a49ce6&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/controls/v-map-heatmap-control.vue?vue&type=script&lang=js&


var eventPrefix = "vmap:control:heatmap";
var visibleEvent = "".concat(eventPrefix, ":visible");
var activeEvent = "".concat(eventPrefix, ":active");
/* harmony default export */ var v_map_heatmap_controlvue_type_script_lang_js_ = ({
  name: "v-map-heatmap-control",
  inject: ["getMap"],
  props: {
    position: {
      type: String,
      default: "htophright"
    },
    title: {
      type: String,
      default: function _default() {
        return utils_locale.default.heatmapTitle;
      }
    }
  },
  data: function data() {
    return {
      active: false,
      visible: false
    };
  },
  mounted: function mounted() {
    var map = this.getMap();
    this.mapObject = new external_leaflet_["LeafletControl"]({
      position: this.position,
      onAdd: this.handleControlAdd
    });
    this.mapObject.addTo(map);
    external_leaflet_["DomEvent"].disableClickPropagation(this.$refs.button);
    external_leaflet_["DomEvent"].disableScrollPropagation(this.$refs.button);
    map.on(visibleEvent, this.handleVisible).on(activeEvent, this.handleActive);
  },
  beforeDestroy: function beforeDestroy() {
    var map = this.getMap();
    map.off(visibleEvent, this.handleVisible).off(activeEvent, this.handleActive);
    if (this.mapObject) {
      this.mapObject.remove();
    }
  },
  methods: {
    handleButtonPressed: function handleButtonPressed(e) {
      this.active = !this.active;
      var map = this.getMap();
      map.fire(activeEvent, {
        value: this.active
      });
    },
    handleControlAdd: function handleControlAdd() {
      return this.$el;
    },
    handleVisible: function handleVisible(_ref) {
      var value = _ref.value;
      this.visible = !!value;
    },
    handleActive: function handleActive(_ref2) {
      var value = _ref2.value;
      this.active = !!value;
    }
  }
});
// CONCATENATED MODULE: ./src/components/map/controls/v-map-heatmap-control.vue?vue&type=script&lang=js&
 /* harmony default export */ var controls_v_map_heatmap_controlvue_type_script_lang_js_ = (v_map_heatmap_controlvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/map/controls/v-map-heatmap-control.vue





/* normalize component */

var v_map_heatmap_control_component = normalizeComponent(
  controls_v_map_heatmap_controlvue_type_script_lang_js_,
  v_map_heatmap_controlvue_type_template_id_d1a49ce6_render,
  v_map_heatmap_controlvue_type_template_id_d1a49ce6_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var v_map_heatmap_control = (v_map_heatmap_control_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/controls/v-map-fullscreen-control.vue?vue&type=script&lang=js&



/* harmony default export */ var v_map_fullscreen_controlvue_type_script_lang_js_ = ({
  name: "v-map-fullscreen-control",
  inject: ["getMap"],
  props: {
    position: {
      type: String,
      default: "htophright"
    },
    activeClassName: {
      type: String,
      default: null
    },
    containerId: {
      type: String,
      default: null
    },
    allPage: {
      type: Boolean,
      default: false
    },
    title: {
      type: Object,
      default: function _default() {
        return _objectSpread2({}, utils_locale.default.fullscreenTitle);
      }
    }
  },
  mounted: function mounted() {
    var map = this.getMap();
    this.mapObject = external_leaflet_["control"].fullscreen({
      position: this.position,
      title: this.title,
      activeCssClass: this.activeClassName,
      containerId: this.containerId,
      containerElement: this.allPage ? document.documentElement : null
    });
    this.mapObject.addTo(map);
  },
  beforeDestroy: function beforeDestroy() {
    if (this.mapObject) {
      this.mapObject.remove();
    }
  },
  render: function render() {
    return null;
  }
});
// CONCATENATED MODULE: ./src/components/map/controls/v-map-fullscreen-control.vue?vue&type=script&lang=js&
 /* harmony default export */ var controls_v_map_fullscreen_controlvue_type_script_lang_js_ = (v_map_fullscreen_controlvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/map/controls/v-map-fullscreen-control.vue
var v_map_fullscreen_control_render, v_map_fullscreen_control_staticRenderFns




/* normalize component */

var v_map_fullscreen_control_component = normalizeComponent(
  controls_v_map_fullscreen_controlvue_type_script_lang_js_,
  v_map_fullscreen_control_render,
  v_map_fullscreen_control_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var v_map_fullscreen_control = (v_map_fullscreen_control_component.exports);
// EXTERNAL MODULE: external "kind-of"
var external_kind_of_ = __webpack_require__("2c15");
var external_kind_of_default = /*#__PURE__*/__webpack_require__.n(external_kind_of_);

// EXTERNAL MODULE: external "is-plain-object"
var external_is_plain_object_ = __webpack_require__("821e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__("fb6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.map.js
var es_map = __webpack_require__("4ec9");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.set.js
var es_set = __webpack_require__("6062");

// CONCATENATED MODULE: ./src/utils/shallow-clone.js








function clone(val, deep) {
  switch (external_kind_of_default()(val)) {
    case 'array':
      return val.slice();
    case 'object':
      return Object.assign({}, val);
    case 'date':
      return new val.constructor(Number(val));
    case 'map':
      return new Map(val);
    case 'set':
      return new Set(val);
    case 'error':
      return Object.create(val);
    default:
      {
        return val;
      }
  }
}
/* harmony default export */ var shallow_clone = (clone);
// CONCATENATED MODULE: ./src/utils/clone-deep.js



function cloneDeep(val, instanceClone) {
  switch (external_kind_of_default()(val)) {
    case 'object':
      return cloneObjectDeep(val, instanceClone);
    case 'array':
      return cloneArrayDeep(val, instanceClone);
    default:
      {
        return shallow_clone(val);
      }
  }
}
function cloneObjectDeep(val, instanceClone) {
  if (typeof instanceClone === 'function') {
    return instanceClone(val);
  }
  if (instanceClone || Object(external_is_plain_object_["isPlainObject"])(val)) {
    var res = new val.constructor();
    for (var key in val) {
      res[key] = cloneDeep(val[key], instanceClone);
    }
    return res;
  }
  return val;
}
function cloneArrayDeep(val, instanceClone) {
  var res = new val.constructor(val.length);
  for (var i = 0; i < val.length; i++) {
    res[i] = cloneDeep(val[i], instanceClone);
  }
  return res;
}
/* harmony default export */ var clone_deep = (cloneDeep);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/controls/v-map-edit-control.vue?vue&type=script&lang=js&


/* harmony default export */ var v_map_edit_controlvue_type_script_lang_js_ = ({
  name: "v-map-edit-control",
  inject: ["getMap"],
  props: {
    position: {
      type: String,
      default: "leftcenter"
    },
    draw: {
      type: [Object, Boolean],
      default: function _default() {
        return {};
      }
    },
    edit: {
      type: [Object, Boolean],
      default: false
    },
    hideWhenDisabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    updateProps: function updateProps() {
      return {
        position: this.position,
        draw: this.draw,
        edit: this.edit
      };
    }
  },
  watch: {
    updateProps: function updateProps() {
      this.remove();
      this.create();
    },
    hideWhenDisabled: function hideWhenDisabled() {
      this.removeToolbarEvents();
      this.initToolbarEvents();
    }
  },
  mounted: function mounted() {
    this.create();
  },
  beforeDestroy: function beforeDestroy() {
    this.remove();
  },
  methods: {
    create: function create() {
      var map = this.getMap();
      this.mapObject = new external_leaflet_["Control"].Draw(this.getOptions());
      this.mapObject.addTo(map);
      this.initToolbarEvents();
    },
    getOptions: function getOptions() {
      return {
        position: this.position,
        draw: this.draw !== undefined ? clone_deep(this.draw) : null,
        edit: this.edit !== undefined ? clone_deep(this.edit) : null
      };
    },
    remove: function remove() {
      if (this.mapObject) {
        this.removeToolbarEvents();
        this.mapObject.remove();
      }
    },
    initToolbarEvents: function initToolbarEvents() {
      if (!this.hideWhenDisabled) return;
      var control = this.mapObject;
      var editToolbar = control._toolbars[external_leaflet_["EditToolbar"].TYPE];
      if (editToolbar) {
        editToolbar.on("disable", this.handleDisableToolbar);
        editToolbar.on("enable", this.handleDisableToolbar);
        this.handleDisableToolbar();
      }
    },
    removeToolbarEvents: function removeToolbarEvents() {
      var control = this.mapObject;
      var editToolbar = control._toolbars[external_leaflet_["EditToolbar"].TYPE];
      if (editToolbar) {
        editToolbar.off("disable", this.handleDisableToolbar);
        editToolbar.off("enable", this.handleDisableToolbar);
        external_leaflet_["DomUtil"].removeClass(control._container, "leaflet-draw-edit-disabled");
      }
    },
    handleDisableToolbar: function handleDisableToolbar() {
      var control = this.mapObject;
      var editToolbar = control ? control._toolbars[external_leaflet_["EditToolbar"].TYPE] : null;
      var editMode = editToolbar ? editToolbar._modes[external_leaflet_["EditToolbar"].Edit.TYPE] : null;
      if (control && control._container && editMode && editMode.button && editToolbar && editToolbar._toolbarContainer) {
        if (external_leaflet_["DomUtil"].hasClass(editMode.button, "leaflet-disabled")) {
          external_leaflet_["DomUtil"].addClass(control._container, "leaflet-draw-edit-disabled");
        } else {
          external_leaflet_["DomUtil"].removeClass(control._container, "leaflet-draw-edit-disabled");
        }
      }
    }
  },
  render: function render() {
    return null;
  }
});
// CONCATENATED MODULE: ./src/components/map/controls/v-map-edit-control.vue?vue&type=script&lang=js&
 /* harmony default export */ var controls_v_map_edit_controlvue_type_script_lang_js_ = (v_map_edit_controlvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/map/controls/v-map-edit-control.vue
var v_map_edit_control_render, v_map_edit_control_staticRenderFns




/* normalize component */

var v_map_edit_control_component = normalizeComponent(
  controls_v_map_edit_controlvue_type_script_lang_js_,
  v_map_edit_control_render,
  v_map_edit_control_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var v_map_edit_control = (v_map_edit_control_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/controls/v-map-location-control.vue?vue&type=script&lang=js&



/* harmony default export */ var v_map_location_controlvue_type_script_lang_js_ = ({
  name: "v-map-location-control",
  inject: ["getMap"],
  props: {
    position: {
      type: String,
      default: "rightcenter"
    },
    strings: {
      type: Object,
      default: function _default() {
        return _objectSpread2({}, utils_locale.default.locationStrings);
      }
    },
    icon: {
      type: String,
      default: "leaflet-control-locate-icon"
    },
    iconLoading: {
      type: String,
      default: "leaflet-control-locate-icon-loading"
    },
    popupClassName: {
      type: String,
      default: "v-map-simple-popup"
    },
    locateOptions: {
      type: Object,
      default: null
    }
  },
  mounted: function mounted() {
    var map = this.getMap();
    this.mapObject = external_leaflet_["control"].locate(_objectSpread2({
      position: this.position,
      icon: this.icon,
      iconLoading: this.iconLoading,
      strings: _objectSpread2(_objectSpread2({}, this.strings), {}, {
        popup: this.makePopupFn(this.strings.popup)
      })
    }, this.locateOptions));
    this.mapObject.addTo(map);
  },
  beforeDestroy: function beforeDestroy() {
    if (this.mapObject) {
      this.mapObject.remove();
    }
  },
  methods: {
    makePopupFn: function makePopupFn(template) {
      var _this = this;
      return function (_ref) {
        var distance = _ref.distance,
          unit = _ref.unit;
        return Object(external_leaflet_["popup"])({
          className: _this.popupClassName
        }).setContent(external_leaflet_["Util"].template(template, {
          distance: distance,
          unit: unit
        }));
      };
    }
  },
  render: function render() {
    return null;
  }
});
// CONCATENATED MODULE: ./src/components/map/controls/v-map-location-control.vue?vue&type=script&lang=js&
 /* harmony default export */ var controls_v_map_location_controlvue_type_script_lang_js_ = (v_map_location_controlvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/map/controls/v-map-location-control.vue
var v_map_location_control_render, v_map_location_control_staticRenderFns




/* normalize component */

var v_map_location_control_component = normalizeComponent(
  controls_v_map_location_controlvue_type_script_lang_js_,
  v_map_location_control_render,
  v_map_location_control_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var v_map_location_control = (v_map_location_control_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"443a82ff-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/controls/v-map-print-control.vue?vue&type=template&id=683ddb46&
var v_map_print_controlvue_type_template_id_683ddb46_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.visible,
      expression: "visible"
    }],
    staticClass: "leaflet-control-print leaflet-bar leaflet-control"
  }, [_c('a', {
    ref: "button",
    staticClass: "leaflet-control-print-button",
    attrs: {
      "href": "#",
      "title": _vm.buttonTitle
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.handleButtonPressed.apply(null, arguments);
      }
    }
  }, [_c('span', {
    class: {
      'leaflet-control-print-icon': !_vm.loading && !_vm.saveAs,
      'leaflet-control-image-icon': !_vm.loading && _vm.saveAs,
      'leaflet-control-print-icon-loading': _vm.loading
    }
  })])]);
};
var v_map_print_controlvue_type_template_id_683ddb46_staticRenderFns = [];

// CONCATENATED MODULE: ./src/components/map/controls/v-map-print-control.vue?vue&type=template&id=683ddb46&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__("e01a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.iterator.js
var es_symbol_iterator = __webpack_require__("d28b");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.async-iterator.js
var es_symbol_async_iterator = __webpack_require__("b636");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.to-string-tag.js
var es_symbol_to_string_tag = __webpack_require__("944a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.json.to-string-tag.js
var es_json_to_string_tag = __webpack_require__("0c47");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.math.to-string-tag.js
var es_math_to_string_tag = __webpack_require__("23dc");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-prototype-of.js
var es_object_get_prototype_of = __webpack_require__("3410");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.set-prototype-of.js
var es_object_set_prototype_of = __webpack_require__("131a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.proto.js
var es_object_proto = __webpack_require__("1f68");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js






function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js



















function _regeneratorRuntime() {
  "use strict";

  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  _regeneratorRuntime = function _regeneratorRuntime() {
    return exports;
  };
  var exports = {},
    Op = Object.prototype,
    hasOwn = Op.hasOwnProperty,
    defineProperty = Object.defineProperty || function (obj, key, desc) {
      obj[key] = desc.value;
    },
    $Symbol = "function" == typeof Symbol ? Symbol : {},
    iteratorSymbol = $Symbol.iterator || "@@iterator",
    asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
    toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }
  try {
    define({}, "");
  } catch (err) {
    define = function define(obj, key, value) {
      return obj[key] = value;
    };
  }
  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
      generator = Object.create(protoGenerator.prototype),
      context = new Context(tryLocsList || []);
    return defineProperty(generator, "_invoke", {
      value: makeInvokeMethod(innerFn, self, context)
    }), generator;
  }
  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }
  exports.wrap = wrap;
  var ContinueSentinel = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
    NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }
  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if ("throw" !== record.type) {
        var result = record.arg,
          value = result.value;
        return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }
      reject(record.arg);
    }
    var previousPromise;
    defineProperty(this, "_invoke", {
      value: function value(method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }
        return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(innerFn, self, context) {
    var state = "suspendedStart";
    return function (method, arg) {
      if ("executing" === state) throw new Error("Generator is already running");
      if ("completed" === state) {
        if ("throw" === method) throw arg;
        return doneResult();
      }
      for (context.method = method, context.arg = arg;;) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }
        if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
          if ("suspendedStart" === state) throw state = "completed", context.arg;
          context.dispatchException(context.arg);
        } else "return" === context.method && context.abrupt("return", context.arg);
        state = "executing";
        var record = tryCatch(innerFn, self, context);
        if ("normal" === record.type) {
          if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
          return {
            value: record.arg,
            done: context.done
          };
        }
        "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
      }
    };
  }
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (undefined === method) {
      if (context.delegate = null, "throw" === context.method) {
        if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
        context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
      }
      return ContinueSentinel;
    }
    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }
  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }
  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;
      if (!isNaN(iterable.length)) {
        var i = -1,
          next = function next() {
            for (; ++i < iterable.length;) {
              if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
            }
            return next.value = undefined, next.done = !0, next;
          };
        return next.next = next;
      }
    }
    return {
      next: doneResult
    };
  }
  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), defineProperty(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (val) {
    var object = Object(val),
      keys = [];
    for (var key in object) {
      keys.push(key);
    }
    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) {
        "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
      }
    },
    stop: function stop() {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(exception) {
      if (this.done) throw exception;
      var context = this;
      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
          record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
            hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function complete(record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function finish(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    "catch": function _catch(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
// EXTERNAL MODULE: external "dom-to-image"
var external_dom_to_image_ = __webpack_require__("790c");
var external_dom_to_image_default = /*#__PURE__*/__webpack_require__.n(external_dom_to_image_);

// CONCATENATED MODULE: ./src/utils/logger.js
/* harmony default export */ var logger = ({
  error: function error(messageOrError) {
    if (console.error) {
      console.error(messageOrError);
    } else if (console.log) {
      console.log(messageOrError);
    }
  }
});
// EXTERNAL MODULE: external "print-js"
var external_print_js_ = __webpack_require__("e351");
var external_print_js_default = /*#__PURE__*/__webpack_require__.n(external_print_js_);

// EXTERNAL MODULE: external "file-saver"
var external_file_saver_ = __webpack_require__("9588");
var external_file_saver_default = /*#__PURE__*/__webpack_require__.n(external_file_saver_);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/controls/v-map-print-control.vue?vue&type=script&lang=js&









/* harmony default export */ var v_map_print_controlvue_type_script_lang_js_ = ({
  name: "v-map-print-control",
  inject: ["getMap"],
  props: {
    position: {
      type: String,
      default: "htophright"
    },
    title: {
      type: String,
      default: function _default() {
        return utils_locale.default.printTitle;
      }
    },
    visible: {
      type: Boolean,
      default: true
    },
    saveAsTitle: {
      type: String,
      default: function _default() {
        return utils_locale.default.saveAsTitle;
      }
    },
    saveAs: {
      type: Boolean,
      default: false
    },
    saveFileName: {
      type: String,
      default: "print-map"
    },
    withSidebar: {
      type: Boolean,
      default: false
    },
    withControls: {
      type: Boolean,
      default: false
    },
    onlyScaleControl: {
      type: Boolean,
      default: false
    },
    controlWrapClassName: {
      type: String,
      default: "leaflet-control-container"
    },
    controlClassName: {
      type: String,
      default: "leaflet-control"
    },
    scaleControlClassName: {
      type: String,
      default: "leaflet-control-scale"
    },
    sidebarClassName: {
      type: String,
      default: "v-map-sidebar"
    },
    noPrintableClassName: {
      type: String,
      default: "v-map-no-printable"
    }
  },
  data: function data() {
    return {
      loading: false
    };
  },
  computed: {
    buttonTitle: function buttonTitle() {
      if (this.saveAs) {
        return this.saveAsTitle;
      }
      return this.title;
    }
  },
  mounted: function mounted() {
    var map = this.getMap();
    this.mapObject = new external_leaflet_["LeafletControl"]({
      position: this.position,
      onAdd: this.handleControlAdd
    });
    this.mapObject.addTo(map);
    external_leaflet_["DomEvent"].disableClickPropagation(this.$refs.button);
    external_leaflet_["DomEvent"].disableScrollPropagation(this.$refs.button);
  },
  beforeDestroy: function beforeDestroy() {
    if (this.mapObject) {
      this.mapObject.remove();
    }
  },
  methods: {
    convertMapToImage: function convertMapToImage() {
      var map = this.getMap();
      var container = map.getContainer();
      var _container$getBoundin = container.getBoundingClientRect(),
        width = _container$getBoundin.width,
        height = _container$getBoundin.height;
      var filter = this.isPrintNode;
      return external_dom_to_image_default.a.toPng(container, {
        width: width,
        height: height,
        filter: filter
      });
    },
    isPrintNode: function isPrintNode(node) {
      return !(node.nodeType === Node.ELEMENT_NODE && (!this.withControls && external_leaflet_["DomUtil"].hasClass(node, this.controlWrapClassName) || !this.withSidebar && external_leaflet_["DomUtil"].hasClass(node, this.sidebarClassName) || external_leaflet_["DomUtil"].hasClass(node, this.noPrintableClassName) || this.onlyScaleControl && external_leaflet_["DomUtil"].hasClass(node, this.controlClassName) && !external_leaflet_["DomUtil"].hasClass(node, this.scaleControlClassName)));
    },
    printMap: function printMap() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var dataUrl, blob;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _this.loading = true;
                _context.next = 4;
                return _this.convertMapToImage();
              case 4:
                dataUrl = _context.sent;
                if (!_this.saveAs) {
                  _context.next = 12;
                  break;
                }
                _context.next = 8;
                return _this.toBlob(dataUrl);
              case 8:
                blob = _context.sent;
                external_file_saver_default.a.saveAs(blob, "".concat(_this.saveFileName, ".png"));
                _context.next = 13;
                break;
              case 12:
                external_print_js_default()(dataUrl, "image");
              case 13:
                _context.next = 18;
                break;
              case 15:
                _context.prev = 15;
                _context.t0 = _context["catch"](0);
                logger.error(_context.t0);
              case 18:
                _context.prev = 18;
                _this.loading = false;
                return _context.finish(18);
              case 21:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 15, 18, 21]]);
      }))();
    },
    toBlob: function toBlob(dataUrl) {
      return fetch(dataUrl).then(function (res) {
        return res.blob();
      });
    },
    handleButtonPressed: function handleButtonPressed(e) {
      if (this.loading) return;
      this.printMap();
    },
    handleControlAdd: function handleControlAdd() {
      return this.$el;
    }
  }
});
// CONCATENATED MODULE: ./src/components/map/controls/v-map-print-control.vue?vue&type=script&lang=js&
 /* harmony default export */ var controls_v_map_print_controlvue_type_script_lang_js_ = (v_map_print_controlvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/map/controls/v-map-print-control.vue





/* normalize component */

var v_map_print_control_component = normalizeComponent(
  controls_v_map_print_controlvue_type_script_lang_js_,
  v_map_print_controlvue_type_template_id_683ddb46_render,
  v_map_print_controlvue_type_template_id_683ddb46_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var v_map_print_control = (v_map_print_control_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"443a82ff-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/controls/v-map-routes-control.vue?vue&type=template&id=199af172&
var v_map_routes_controlvue_type_template_id_199af172_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.visible,
      expression: "visible"
    }],
    staticClass: "leaflet-control-routes leaflet-bar leaflet-control"
  }, [_c('a', {
    ref: "button",
    staticClass: "leaflet-control-routes-button",
    class: {
      'leaflet-control-routes-button--active': _vm.active
    },
    attrs: {
      "href": "#",
      "title": _vm.title
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.handleButtonPressed.apply(null, arguments);
      }
    }
  }, [_c('span', {
    staticClass: "leaflet-control-routes-icon"
  })]), _vm.markerPane ? _c('v-map-pane', {
    attrs: {
      "name": _vm.markerPane
    }
  }) : _vm._e(), _vm.overlayPane ? _c('v-map-pane', {
    attrs: {
      "name": _vm.overlayPane
    }
  }) : _vm._e()], 1);
};
var v_map_routes_controlvue_type_template_id_199af172_staticRenderFns = [];

// CONCATENATED MODULE: ./src/components/map/controls/v-map-routes-control.vue?vue&type=template&id=199af172&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/controls/v-map-routes-control.vue?vue&type=script&lang=js&



/* harmony default export */ var v_map_routes_controlvue_type_script_lang_js_ = ({
  name: "v-map-routes-control",
  inject: ["getMap"],
  components: {
    VMapPane: v_map_pane
  },
  props: {
    position: {
      type: String,
      default: "htophright"
    },
    title: {
      type: String,
      default: function _default() {
        return utils_locale.default.routesTitle;
      }
    },
    visible: {
      type: Boolean,
      default: true
    },
    dataSource: {
      type: Function,
      default: null
    },
    singleRoute: {
      type: Boolean,
      default: true
    },
    markerPane: {
      type: String,
      default: "routesMarkerPane"
    },
    overlayPane: {
      type: String,
      default: "routesOverlayPane"
    }
  },
  data: function data() {
    return {
      active: false
    };
  },
  watch: {
    dataSource: function dataSource() {
      if (this.routesController) {
        this.routesController.setDataSource(this.dataSource);
      }
    },
    singleRoute: function singleRoute() {
      if (this.routesController) {
        this.routesController.mergeOptions({
          singleRoute: this.singleRoute
        });
      }
    }
  },
  mounted: function mounted() {
    var map = this.getMap();
    this.mapObject = new external_leaflet_["LeafletControl"]({
      position: this.position,
      onAdd: this.handleControlAdd
    });
    this.mapObject.addTo(map);
    external_leaflet_["DomEvent"].disableClickPropagation(this.$refs.button);
    external_leaflet_["DomEvent"].disableScrollPropagation(this.$refs.button);
    this.createController();
  },
  beforeDestroy: function beforeDestroy() {
    if (this.mapObject) {
      this.mapObject.remove();
    }
    this.destroyController();
  },
  methods: {
    createController: function createController() {
      var map = this.getMap();
      this.routesController = new external_leaflet_["RoutesController"](map, this.dataSource, {
        messages: {
          noData: utils_locale.default.routesNoData,
          totalDistance: utils_locale.default.routesTotalDistanceMessage,
          totalTime: utils_locale.default.routesTotalTimeMessage,
          units: utils_locale.default.units
        },
        markerPane: this.markerPane,
        overlayPane: this.overlayPane,
        singleRoute: this.singleRoute
      });
    },
    destroyController: function destroyController() {
      if (this.routesController) {
        this.routesController.disable();
        this.routesController.dispose();
        this.routesController = null;
      }
    },
    handleButtonPressed: function handleButtonPressed(e) {
      this.active = !this.active;
      if (this.active) {
        this.routesController.enable();
      } else {
        this.routesController.disable();
      }
    },
    handleControlAdd: function handleControlAdd() {
      return this.$el;
    }
  }
});
// CONCATENATED MODULE: ./src/components/map/controls/v-map-routes-control.vue?vue&type=script&lang=js&
 /* harmony default export */ var controls_v_map_routes_controlvue_type_script_lang_js_ = (v_map_routes_controlvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/map/controls/v-map-routes-control.vue?vue&type=custom&index=0&blockType=docs
var v_map_routes_controlvue_type_custom_index_0_blockType_docs = __webpack_require__("6f9e");
var v_map_routes_controlvue_type_custom_index_0_blockType_docs_default = /*#__PURE__*/__webpack_require__.n(v_map_routes_controlvue_type_custom_index_0_blockType_docs);

// EXTERNAL MODULE: ./src/components/map/controls/v-map-routes-control.vue?vue&type=custom&index=1&blockType=docs
var v_map_routes_controlvue_type_custom_index_1_blockType_docs = __webpack_require__("b230");
var v_map_routes_controlvue_type_custom_index_1_blockType_docs_default = /*#__PURE__*/__webpack_require__.n(v_map_routes_controlvue_type_custom_index_1_blockType_docs);

// CONCATENATED MODULE: ./src/components/map/controls/v-map-routes-control.vue





/* normalize component */

var v_map_routes_control_component = normalizeComponent(
  controls_v_map_routes_controlvue_type_script_lang_js_,
  v_map_routes_controlvue_type_template_id_199af172_render,
  v_map_routes_controlvue_type_template_id_199af172_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */

if (typeof v_map_routes_controlvue_type_custom_index_0_blockType_docs_default.a === 'function') v_map_routes_controlvue_type_custom_index_0_blockType_docs_default()(v_map_routes_control_component)

if (typeof v_map_routes_controlvue_type_custom_index_1_blockType_docs_default.a === 'function') v_map_routes_controlvue_type_custom_index_1_blockType_docs_default()(v_map_routes_control_component)

/* harmony default export */ var v_map_routes_control = (v_map_routes_control_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"443a82ff-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/controls/v-map-search-control.vue?vue&type=template&id=a99c1668&
var v_map_search_controlvue_type_template_id_a99c1668_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.visible,
      expression: "visible"
    }],
    staticClass: "leaflet-control-search leaflet-bar leaflet-control"
  }, [_c('div', {
    ref: "container",
    staticClass: "v-map-control-search",
    class: {
      'v-map-control-search--open': _vm.dataOpen
    }
  }, [_c('a', {
    staticClass: "leaflet-control-search-button",
    attrs: {
      "href": "#",
      "title": _vm.title
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.toggleSearchBar.apply(null, arguments);
      }
    }
  }, [_c('span', {
    staticClass: "leaflet-control-search-icon"
  })]), _c('div', {
    staticClass: "v-map-search-bar",
    class: {
      'v-map-search-bar--text': _vm.dataQuery
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.dataQuery,
      expression: "dataQuery"
    }],
    staticClass: "v-map-search-bar__input",
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm.dataQuery
    },
    on: {
      "focus": _vm.handleInputFocusIn,
      "blur": _vm.handleInputFocusOut,
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.dataQuery = $event.target.value;
      }
    }
  }), _c('span', {
    staticClass: "v-map-search-bar__back",
    on: {
      "click": _vm.toggleSearchBar
    }
  }), _vm.loading ? _c('span', {
    staticClass: "v-map-search-bar__loading"
  }) : _vm._e(), _vm.dataQuery ? _c('span', {
    staticClass: "v-map-search-bar__clear",
    on: {
      "click": _vm.resetSearch
    }
  }) : _vm._e(), _c('transition', {
    attrs: {
      "name": "v-map-fade"
    }
  }, [_c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.dropdownOpen,
      expression: "dropdownOpen"
    }],
    staticClass: "v-map-search-bar__list"
  }, _vm._l(_vm.resultItems, function (item, index) {
    return _c('li', {
      key: index,
      staticClass: "v-map-search-bar__list-item",
      on: {
        "click": function click($event) {
          return _vm.handleItemClick(item);
        }
      }
    }, [_c('span', {
      staticClass: "v-map-search-item__title"
    }, [_vm._v(" " + _vm._s(item.displayTitle) + " ")]), _c('span', {
      staticClass: "v-map-search-item__subtitle"
    }, [_vm._v(" " + _vm._s(item.displaySubtitle) + " ")])]);
  }), 0)])], 1)]), _c('v-map-client-layer', {
    ref: "clientLayer",
    attrs: {
      "data-source": _vm.layerDataSource,
      "styles": _vm.pathStyles
    },
    on: {
      "data:changed": _vm.handleLayerDataChanged
    },
    scopedSlots: _vm._u([{
      key: "marker-icon",
      fn: function fn() {
        return [_c('v-map-search-marker-icon')];
      },
      proxy: true
    }, {
      key: "popup",
      fn: function fn() {
        return [_c('v-map-search-popup', {
          attrs: {
            "close-on-click": _vm.closePopupOnClick
          }
        })];
      },
      proxy: true
    }])
  }), _c('v-map-fit-handler', {
    ref: "fit",
    attrs: {
      "point-around-meters": _vm.fitPointAround
    }
  })], 1);
};
var v_map_search_controlvue_type_template_id_a99c1668_staticRenderFns = [];

// CONCATENATED MODULE: ./src/components/map/controls/v-map-search-control.vue?vue&type=template&id=a99c1668&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("ac1f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.search.js
var es_string_search = __webpack_require__("841c");

// EXTERNAL MODULE: external "debounce"
var external_debounce_ = __webpack_require__("81f2");
var external_debounce_default = /*#__PURE__*/__webpack_require__.n(external_debounce_);

// CONCATENATED MODULE: ./src/utils/is-cancel.js
/* harmony default export */ var is_cancel = (function (value) {
  return !!(value && value.__CANCEL__);
});
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.trim.js
var es_string_trim = __webpack_require__("498a");

// CONCATENATED MODULE: ./src/utils/parse-latlng.js




/* harmony default export */ var parse_latlng = (function (text) {
  text = (text || "").trim();
  if (!text) {
    return null;
  }
  var parts = text.split(",").map(function (s) {
    return s.trim();
  }).map(parseFloat).filter(function (n) {
    return !isNaN(n) && isFinite(n);
  });
  if (parts.length !== 2) {
    return null;
  }
  return [parts[0], parts[1]];
});
// CONCATENATED MODULE: ./src/utils/delay.js

/* harmony default export */ var delay = (function (duration) {
  return new Promise(function (resolve) {
    setTimeout(resolve, duration);
  });
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"443a82ff-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/v-map-client-layer.vue?vue&type=template&id=20962bf8&
var v_map_client_layervue_type_template_id_20962bf8_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('v-map-tree-layer', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.presentation(),
      expression: "presentation()"
    }],
    attrs: {
      "title": _vm.title,
      "count": _vm.dataCount,
      "filtering": _vm.filtering,
      "filter-active": _vm.filterActive,
      "selection": _vm.selection,
      "disabled": _vm.disabled,
      "selected": _vm.dataSelected,
      "visible": _vm.dataVisible,
      "icon-color": _vm.styles[_vm.iconColorField]
    },
    on: {
      "update:selected": function updateSelected($event) {
        _vm.dataSelected = $event;
      },
      "update:visible": function updateVisible($event) {
        _vm.dataVisible = $event;
      },
      "filter": _vm.handleFilterPressed,
      "count": _vm.handleCountPressed
    },
    scopedSlots: _vm._u([{
      key: "icon",
      fn: function fn() {
        return [_vm._t("icon")];
      },
      proxy: true
    }, {
      key: "other",
      fn: function fn() {
        return [_vm._t("marker-icon", function () {
          return [_c('v-map-marker-icon', {
            attrs: {
              "color": _vm.styles[_vm.iconColorField]
            },
            scopedSlots: _vm._u([{
              key: "icon",
              fn: function fn() {
                return [_vm._t("icon")];
              },
              proxy: true
            }], null, true)
          })];
        }), _vm._t("path-style", function () {
          return [_c('v-map-path-style', {
            attrs: {
              "styles": _vm.styles
            }
          })];
        }), _vm._t("cluster-icon", function () {
          return [_c('v-map-cluster-icon', {
            attrs: {
              "color": _vm.styles[_vm.iconColorField]
            },
            scopedSlots: _vm._u([{
              key: "icon",
              fn: function fn() {
                return [_vm._t("icon")];
              },
              proxy: true
            }], null, true)
          })];
        }), _vm.popupEnabled ? _vm._t("popup", function () {
          return [_c('v-map-popup', {
            scopedSlots: _vm._u([{
              key: "default",
              fn: function fn(_ref) {
                var content = _ref.content;
                return [_c('v-map-popup-content', {
                  attrs: {
                    "title": content[_vm.titleField],
                    "description": content[_vm.descriptionField],
                    "icon-color": _vm.styles[_vm.iconColorField],
                    "show-edit": _vm.popupShowEdit,
                    "show-delete": _vm.popupShowDelete,
                    "show-details": _vm.popupShowDetails,
                    "with-confirm-delete": _vm.popupShowDelete
                  },
                  on: {
                    "edit": function edit($event) {
                      return _vm.handlePopupEditPressed(content);
                    },
                    "delete": function _delete($event) {
                      return _vm.handlePopupDeletePressed(content);
                    },
                    "details": function details($event) {
                      return _vm.handlePopupDetailsPressed(content);
                    }
                  },
                  scopedSlots: _vm._u([{
                    key: "icon",
                    fn: function fn() {
                      return [_vm._t("icon")];
                    },
                    proxy: true
                  }], null, true)
                })];
              }
            }], null, false, 402217516)
          })];
        }) : _vm._e(), _vm.selection && _vm.singleSelection && _vm.selectionKey ? _vm._t("single-selection", function () {
          return [_c('v-map-single-selection', {
            attrs: {
              "name": _vm.selectionKey,
              "selected": _vm.dataSelected
            },
            on: {
              "update:selected": function updateSelected($event) {
                _vm.dataSelected = $event;
              }
            }
          })];
        }) : _vm._e(), _vm.groupCountKey ? _vm._t("group-count", function () {
          return [_c('v-map-group-count', {
            attrs: {
              "name": _vm.groupCountKey,
              "count": _vm.dataCount
            }
          })];
        }) : _vm._e(), _vm.groupVisibleKey ? _vm._t("group-visible", function () {
          return [_c('v-map-group-visible', {
            attrs: {
              "name": _vm.groupVisibleKey,
              "visible": _vm.dataVisible
            },
            on: {
              "update:visible": function updateVisible($event) {
                _vm.dataVisible = $event;
              }
            }
          })];
        }) : _vm._e(), _vm._t("default")];
      },
      proxy: true
    }], null, true)
  });
};
var v_map_client_layervue_type_template_id_20962bf8_staticRenderFns = [];

// CONCATENATED MODULE: ./src/components/map/v-map-client-layer.vue?vue&type=template&id=20962bf8&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array-buffer.constructor.js
var es_array_buffer_constructor = __webpack_require__("c19f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array-buffer.slice.js
var es_array_buffer_slice = __webpack_require__("ace4");

// CONCATENATED MODULE: ./src/components/map/mixins/popup-mixin.js





/* harmony default export */ var popup_mixin = ({
  methods: {
    bindPopup: function bindPopup(popup) {
      this.mapObject.bindPopup(popup);
    },
    unbindPopup: function unbindPopup() {
      this.mapObject.unbindPopup();
    },
    openPopup: function openPopup(id) {
      if (!this.mapObject) return;
      var layers = this.mapObject.getLayers();
      var layer = this.findMapObject(layers, _defineProperty({}, this.idField, id));
      if (!layer) return;
      if (layer._centerMarker) {
        this.mapObject.openPopup(layer._centerMarker);
      } else if (typeof layer.getLatLng === "function") {
        this.mapObject.openPopup(layer);
      } else {
        try {
          var map = this.getMap();
          var center = external_leaflet_["leafletUtil"].getPathCenter(map, layer);
          if (center) {
            this.mapObject.openPopup(layer, center);
          }
        } catch (e) {
          logger.error(e);
        }
      }
    },
    closePopup: function closePopup() {
      if (this.mapObject) {
        this.mapObject.closePopup();
      }
    },
    updatePopup: function updatePopup(mapObjects) {
      var popup = this.mapObject.getPopup();
      if (!popup || !popup.isOpen() || !popup._source) return;
      var sourceData = popup._source.options.data;
      if (!sourceData) return;
      var mapObject = this.findMapObject(mapObjects, sourceData);
      if (!mapObject) {
        this.mapObject.closePopup();
      } else if (mapObject !== popup._source) {
        if (popup._source instanceof external_leaflet_["PathCenterMarker"]) {
          if (mapObject._centerMarker) {
            popup._source = mapObject._centerMarker;
            this.updatePopupPos(popup, mapObject._centerMarker);
          }
        } else {
          popup._source = mapObject;
          this.updatePopupPos(popup, mapObject);
        }
      }
    },
    updatePopupPos: function updatePopupPos(popup, mapObject) {
      if (typeof mapObject.getLatLng === "function") {
        var autoPan = popup.options.autoPan;
        popup.options.autoPan = false;
        popup.setLatLng(mapObject.getLatLng());
        popup.options.autoPan = autoPan;
      }
    },
    findMapObject: function findMapObject(mapObjects, itemData) {
      var _this = this;
      if (this.equalsFn) {
        return mapObjects.filter(function (_ref) {
          var data = _ref.options.data;
          return _this.equalsFn(data, itemData);
        })[0] || null;
      } else {
        return mapObjects.filter(function (_ref2) {
          var data = _ref2.options.data;
          return data[_this.idField] != null && itemData[_this.idField] != null && data[_this.idField] === itemData[_this.idField];
        })[0] || null;
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"443a82ff-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/v-map-marker-icon.vue?vue&type=template&id=48b02802&
var v_map_marker_iconvue_type_template_id_48b02802_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_vm._t("default", function () {
    return [_c('div', {
      staticClass: "v-map-marker__wrap v-map-marker__wrap--primary",
      style: {
        color: _vm.color
      }
    }, [_c('div', {
      staticClass: "v-map-marker__shadow"
    }), _c('v-pin-icon', {
      staticClass: "v-map-marker__pin"
    }), _c('div', {
      staticClass: "v-map-marker__icon"
    }, [_vm.$slots.icon ? _vm._t("icon") : _c('v-visary-icon')], 2)], 1)];
  })], 2);
};
var v_map_marker_iconvue_type_template_id_48b02802_staticRenderFns = [];

// CONCATENATED MODULE: ./src/components/map/v-map-marker-icon.vue?vue&type=template&id=48b02802&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.anchor.js
var es_string_anchor = __webpack_require__("18a5");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"443a82ff-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/icons/v-pin-icon.vue?vue&type=template&id=1abf2390&
var v_pin_iconvue_type_template_id_1abf2390_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('svg', {
    staticClass: "v-map-svg",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 32 46",
      "fill": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "d": "M16,0A15.91,15.91,0,0,0,4.69,4.72,16.12,16.12,0,0,0,0,16.1C0,28.18,16,46,16,46S32,28.17,32,16.1A16.12,16.12,0,0,0,27.31,4.72,15.91,15.91,0,0,0,16,0Zm0,21.85a5.72,5.72,0,0,1-4-1.68A5.79,5.79,0,0,1,12,12,5.7,5.7,0,0,1,20,12l0,0a5.76,5.76,0,0,1,0,8.15,5.83,5.83,0,0,1-1.84,1.23A5.71,5.71,0,0,1,16,21.85Z"
    }
  })]);
};
var v_pin_iconvue_type_template_id_1abf2390_staticRenderFns = [];

// CONCATENATED MODULE: ./src/components/map/icons/v-pin-icon.vue?vue&type=template&id=1abf2390&

// CONCATENATED MODULE: ./src/components/map/icons/v-pin-icon.vue

var script = {}


/* normalize component */

var v_pin_icon_component = normalizeComponent(
  script,
  v_pin_iconvue_type_template_id_1abf2390_render,
  v_pin_iconvue_type_template_id_1abf2390_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var v_pin_icon = (v_pin_icon_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"443a82ff-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/icons/v-visary-icon.vue?vue&type=template&id=f469a508&
var v_visary_iconvue_type_template_id_f469a508_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('svg', {
    staticClass: "v-map-svg",
    attrs: {
      "fill": "currentColor",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 10.8 12.47"
    }
  }, [_c('path', {
    attrs: {
      "d": "M10.8,3.12,5.4,0,0,3.12V9.35l5.4,3.12,5.4-3.12Z"
    }
  })]);
};
var v_visary_iconvue_type_template_id_f469a508_staticRenderFns = [];

// CONCATENATED MODULE: ./src/components/map/icons/v-visary-icon.vue?vue&type=template&id=f469a508&

// CONCATENATED MODULE: ./src/components/map/icons/v-visary-icon.vue

var v_visary_icon_script = {}


/* normalize component */

var v_visary_icon_component = normalizeComponent(
  v_visary_icon_script,
  v_visary_iconvue_type_template_id_f469a508_render,
  v_visary_iconvue_type_template_id_f469a508_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var v_visary_icon = (v_visary_icon_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/v-map-marker-icon.vue?vue&type=script&lang=js&





var defWidth = 32;
var defHeight = 46;
/* harmony default export */ var v_map_marker_iconvue_type_script_lang_js_ = ({
  name: "v-map-marker-icon",
  inject: ["setMarkerIcon"],
  components: {
    VPinIcon: v_pin_icon,
    VVisaryIcon: v_visary_icon
  },
  props: {
    size: {
      type: Array,
      default: function _default() {
        return [defWidth, defHeight];
      }
    },
    anchor: {
      type: Array,
      default: null
    },
    popupAnchor: {
      type: Array,
      default: null
    },
    popupOffsetY: {
      type: Number,
      default: 4
    },
    popupOffsetX: {
      type: Number,
      default: 0
    },
    className: {
      type: String,
      default: ""
    },
    color: {
      type: String,
      default: null
    },
    invalidate: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    iconProps: function iconProps() {
      return {
        size: this.size,
        anchor: this.anchor,
        popupAnchor: this.popupAnchor,
        className: this.className
      };
    }
  },
  watch: {
    iconProps: function iconProps() {
      this.updateOnNextTick();
    },
    color: function color() {
      this.updateOnNextTick();
    },
    invalidate: function invalidate() {
      if (this.invalidate) {
        this.updateOnNextTick();
        this.$emit("update:invalidate", false);
      }
    }
  },
  mounted: function mounted() {
    if (this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
    this.updateOnNextTick();
  },
  methods: {
    updateOnNextTick: function updateOnNextTick() {
      var _this = this;
      this.$nextTick(function () {
        _this.updateIcon();
      });
    },
    updateIcon: function updateIcon() {
      var _this$calcProps = this.calcProps(),
        size = _this$calcProps.size,
        anchor = _this$calcProps.anchor,
        popupAnchor = _this$calcProps.popupAnchor;
      var html = this.$el.innerHTML;
      this.setMarkerIcon(this.createDivIcon(html, size, anchor, popupAnchor));
    },
    calcProps: function calcProps() {
      var size = Object(external_leaflet_["point"])(this.size);
      var anchor = this.anchor ? Object(external_leaflet_["point"])(this.anchor) : Object(external_leaflet_["point"])(size.x / 2, size.y);
      var popupAnchor = this.popupAnchor ? Object(external_leaflet_["point"])(this.popupAnchor) : Object(external_leaflet_["point"])(this.popupOffsetX, -size.y - this.popupOffsetY);
      return {
        size: size,
        anchor: anchor,
        popupAnchor: popupAnchor
      };
    },
    createDivIcon: function createDivIcon(html, size, anchor, popupAnchor) {
      return Object(external_leaflet_["divIcon"])({
        className: this.className,
        html: html,
        iconSize: size,
        iconAnchor: anchor,
        popupAnchor: popupAnchor
      });
    }
  }
});
// CONCATENATED MODULE: ./src/components/map/v-map-marker-icon.vue?vue&type=script&lang=js&
 /* harmony default export */ var map_v_map_marker_iconvue_type_script_lang_js_ = (v_map_marker_iconvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/map/v-map-marker-icon.vue





/* normalize component */

var v_map_marker_icon_component = normalizeComponent(
  map_v_map_marker_iconvue_type_script_lang_js_,
  v_map_marker_iconvue_type_template_id_48b02802_render,
  v_map_marker_iconvue_type_template_id_48b02802_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var v_map_marker_icon = (v_map_marker_icon_component.exports);
// CONCATENATED MODULE: ./src/utils/background-style-enum.js

/* harmony default export */ var background_style_enum = (Object.freeze({
  SOLID: 0,
  STRIPE_PATTERN: 1,
  NONE: 2
}));
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/v-map-path-style.vue?vue&type=script&lang=js&



var isEmpty = function isEmpty(prop) {
  return prop === null || prop === undefined;
};
/* harmony default export */ var v_map_path_stylevue_type_script_lang_js_ = ({
  name: "v-map-path-style",
  inject: ["setPathStyle"],
  props: {
    styles: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    custom: {
      type: Function,
      default: null
    },
    extend: {
      type: Function,
      default: null
    }
  },
  watch: {
    styles: {
      deep: true,
      handler: "updatePathStyle"
    }
  },
  mounted: function mounted() {
    this.updatePathStyle();
  },
  methods: {
    updatePathStyle: function updatePathStyle() {
      var pathStyle = this.custom ? this.custom(this.styles) : this.getPathStyle(this.styles);
      if (this.extend) {
        this.setPathStyle(this.extend(pathStyle, this.styles));
      } else {
        this.setPathStyle(pathStyle);
      }
    },
    getPathStyle: function getPathStyle(styles) {
      var _styles = _objectSpread2({}, styles),
        color = _styles.color,
        backgroundColor = _styles.backgroundColor,
        backgroundStyle = _styles.backgroundStyle,
        backgroundOpacity = _styles.backgroundOpacity,
        borderColor = _styles.borderColor,
        borderWidth = _styles.borderWidth,
        borderOpacity = _styles.borderOpacity,
        borderNone = _styles.borderNone;
      var resultPathStyles = {};
      if (!isEmpty(color)) {
        resultPathStyles.color = color;
      }
      if (!isEmpty(backgroundColor)) {
        resultPathStyles.fillColor = backgroundColor;
      }
      if (!isEmpty(borderColor)) {
        resultPathStyles.color = borderColor;
      }
      if (backgroundStyle === background_style_enum.NONE) {
        resultPathStyles.fill = false;
      } else if (backgroundStyle === background_style_enum.STRIPE_PATTERN) {
        resultPathStyles.fillPattern = this.getStripePattern(styles);
      }
      if (!isEmpty(backgroundOpacity)) {
        resultPathStyles.fillOpacity = backgroundOpacity;
      }
      if (!isEmpty(borderWidth)) {
        resultPathStyles.weight = borderWidth;
      }
      if (!isEmpty(borderOpacity)) {
        resultPathStyles.opacity = borderOpacity;
      }
      if (borderNone === true) {
        resultPathStyles.stroke = false;
      }
      return _objectSpread2(_objectSpread2({}, this.getDefaultPathStyle()), resultPathStyles);
    },
    getStripePattern: function getStripePattern(styles) {
      if (!this.stripePattern) {
        this.stripePattern = new external_leaflet_["SvgPattern"].SvgStripePattern();
      }
      var _styles2 = _objectSpread2({}, styles),
        stripeColor = _styles2.stripeColor,
        stripeAngle = _styles2.stripeAngle,
        stripeDistance = _styles2.stripeDistance,
        stripeWidth = _styles2.stripeWidth;
      var stripePatternOptions = {};
      if (!isEmpty(stripeColor)) {
        stripePatternOptions.color = stripeColor;
      }
      if (!isEmpty(stripeAngle)) {
        stripePatternOptions.angle = stripeAngle;
      }
      if (!isEmpty(stripeDistance)) {
        stripePatternOptions.spaceWeight = stripeDistance;
      }
      if (!isEmpty(stripeWidth)) {
        stripePatternOptions.weight = stripeWidth;
      }
      if (!isEmpty(stripePatternOptions.weight) || !isEmpty(stripePatternOptions.spaceWeight)) {
        stripePatternOptions.height = (stripePatternOptions.weight || 0) + (stripePatternOptions.spaceWeight || 0);
      }
      Object(external_leaflet_["setOptions"])(this.stripePattern, stripePatternOptions);
      return this.stripePattern;
    },
    getDefaultPathStyle: function getDefaultPathStyle() {
      return {
        color: "#3863C2",
        weight: 2,
        fillOpacity: 0.1
      };
    }
  },
  render: function render() {
    return null;
  }
});
// CONCATENATED MODULE: ./src/components/map/v-map-path-style.vue?vue&type=script&lang=js&
 /* harmony default export */ var map_v_map_path_stylevue_type_script_lang_js_ = (v_map_path_stylevue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/map/v-map-path-style.vue
var v_map_path_style_render, v_map_path_style_staticRenderFns




/* normalize component */

var v_map_path_style_component = normalizeComponent(
  map_v_map_path_stylevue_type_script_lang_js_,
  v_map_path_style_render,
  v_map_path_style_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var v_map_path_style = (v_map_path_style_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"443a82ff-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/v-map-cluster-icon.vue?vue&type=template&id=04b64824&
var v_map_cluster_iconvue_type_template_id_04b64824_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_vm._t("default", function () {
    return [_c('div', {
      staticClass: "v-map-marker__wrap v-map-marker__wrap--primary",
      style: {
        color: _vm.color
      }
    }, [_c('div', {
      staticClass: "v-map-marker__shadow"
    }), _c('v-pin-icon', {
      staticClass: "v-map-marker__pin"
    }), _c('div', {
      staticClass: "v-map-marker__icon"
    }, [_vm.$slots.icon ? _vm._t("icon") : _c('v-visary-icon')], 2), _c('div', {
      staticClass: "v-map-marker__count",
      attrs: {
        "data-count": _vm.countMarker
      }
    }, [_vm._v(_vm._s(_vm.countMarker))])], 1)];
  }, {
    "countMarker": _vm.countMarker
  })], 2);
};
var v_map_cluster_iconvue_type_template_id_04b64824_staticRenderFns = [];

// CONCATENATED MODULE: ./src/components/map/v-map-cluster-icon.vue?vue&type=template&id=04b64824&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__("5319");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/v-map-cluster-icon.vue?vue&type=script&lang=js&







var v_map_cluster_iconvue_type_script_lang_js_defWidth = 32;
var v_map_cluster_iconvue_type_script_lang_js_defHeight = 46;
var countMarker = "#{count}";
var replaceRegex = /#\{count\}/g;
/* harmony default export */ var v_map_cluster_iconvue_type_script_lang_js_ = ({
  name: "v-map-cluster-icon",
  inject: ["setClusterIconFactory"],
  components: {
    VPinIcon: v_pin_icon,
    VVisaryIcon: v_visary_icon
  },
  props: {
    size: {
      type: Array,
      default: function _default() {
        return [v_map_cluster_iconvue_type_script_lang_js_defWidth, v_map_cluster_iconvue_type_script_lang_js_defHeight];
      }
    },
    anchor: {
      type: Array,
      default: null
    },
    popupAnchor: {
      type: Array,
      default: null
    },
    popupOffsetY: {
      type: Number,
      default: 4
    },
    popupOffsetX: {
      type: Number,
      default: 0
    },
    className: {
      type: String,
      default: ""
    },
    color: {
      type: String,
      default: null
    },
    invalidate: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      countMarker: countMarker
    };
  },
  computed: {
    iconProps: function iconProps() {
      return {
        size: this.size,
        anchor: this.anchor,
        popupAnchor: this.popupAnchor,
        className: this.className
      };
    }
  },
  watch: {
    iconProps: function iconProps() {
      this.updateOnNextTick();
    },
    color: function color() {
      this.updateOnNextTick();
    },
    invalidate: function invalidate() {
      if (this.invalidate) {
        this.updateOnNextTick();
        this.$emit("update:invalidate", false);
      }
    }
  },
  mounted: function mounted() {
    if (this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
    this.updateOnNextTick();
  },
  methods: {
    updateOnNextTick: function updateOnNextTick() {
      var _this = this;
      this.$nextTick(function () {
        _this.updateIcon();
      });
    },
    updateIcon: function updateIcon() {
      var _this$calcProps = this.calcProps(),
        size = _this$calcProps.size,
        anchor = _this$calcProps.anchor,
        popupAnchor = _this$calcProps.popupAnchor;
      var html = this.$el.innerHTML;
      var className = this.className;
      var factory = function factory(count) {
        return Object(external_leaflet_["divIcon"])({
          className: className,
          html: html.replace(replaceRegex, count),
          iconSize: size,
          iconAnchor: anchor,
          popupAnchor: popupAnchor
        });
      };
      this.setClusterIconFactory(factory);
    },
    calcProps: function calcProps() {
      var size = Object(external_leaflet_["point"])(this.size);
      var anchor = this.anchor ? Object(external_leaflet_["point"])(this.anchor) : Object(external_leaflet_["point"])(size.x / 2, size.y);
      var popupAnchor = this.popupAnchor ? Object(external_leaflet_["point"])(this.popupAnchor) : Object(external_leaflet_["point"])(this.popupOffsetX, -size.y - this.popupOffsetY);
      return {
        size: size,
        anchor: anchor,
        popupAnchor: popupAnchor
      };
    }
  }
});
// CONCATENATED MODULE: ./src/components/map/v-map-cluster-icon.vue?vue&type=script&lang=js&
 /* harmony default export */ var map_v_map_cluster_iconvue_type_script_lang_js_ = (v_map_cluster_iconvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/map/v-map-cluster-icon.vue





/* normalize component */

var v_map_cluster_icon_component = normalizeComponent(
  map_v_map_cluster_iconvue_type_script_lang_js_,
  v_map_cluster_iconvue_type_template_id_04b64824_render,
  v_map_cluster_iconvue_type_template_id_04b64824_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var v_map_cluster_icon = (v_map_cluster_icon_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"443a82ff-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/v-map-popup.vue?vue&type=template&id=37600833&
var v_map_popupvue_type_template_id_37600833_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "v-map-popup__wrap"
  }, [_vm._t("default", null, {
    "content": _vm.contentData
  })], 2);
};
var v_map_popupvue_type_template_id_37600833_staticRenderFns = [];

// CONCATENATED MODULE: ./src/components/map/v-map-popup.vue?vue&type=template&id=37600833&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/v-map-popup.vue?vue&type=script&lang=js&



/* harmony default export */ var v_map_popupvue_type_script_lang_js_ = ({
  name: "v-map-popup",
  inject: ["getMap", "bindPopup", "unbindPopup"],
  props: {
    autoPan: {
      type: Boolean,
      default: true
    },
    pane: {
      type: String,
      default: null
    },
    latLng: {
      type: [external_leaflet_["LatLng"], Array],
      default: null
    },
    /**
     * sync
     */
    open: {
      type: Boolean,
      default: false
    },
    className: {
      type: String,
      default: ""
    },
    minWidth: {
      type: Number,
      default: 50
    },
    maxWidth: {
      type: Number,
      default: 450
    },
    popupData: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    sourceDataFn: {
      type: Function,
      default: function _default(s) {
        return s.options.data;
      }
    },
    /**
     * sync
     */
    invalidate: {
      type: Boolean,
      default: false
    },
    closeOnClick: {
      type: Boolean,
      default: undefined
    },
    closeOnEscapeKey: {
      type: Boolean,
      default: undefined
    },
    popupOptions: {
      type: Object,
      default: null
    }
  },
  data: function data() {
    return {
      contentData: this.popupData
    };
  },
  watch: {
    popupData: {
      deep: true,
      handler: "popupDataChanged"
    },
    contentData: {
      deep: true,
      handler: function handler() {
        this.updatePopup();
      }
    },
    open: function open() {
      var _this = this;
      if (this.open) {
        this.$nextTick(function () {
          _this.mapObject.openOn(_this.getMap());
        });
      } else {
        this.mapObject.remove();
      }
    },
    invalidate: function invalidate() {
      if (this.invalidate) {
        this.updatePopup();
        /**
         * @type {boolean}
         */
        this.$emit("update:invalidate", false);
      }
    }
  },
  mounted: function mounted() {
    var _this2 = this;
    if (this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
    this.mapObject = Object(external_leaflet_["popup"])(this.getPopupOptions());
    this.mapObject.on("add", this.onOpen).on("remove", this.onClose).setContent(this.$el);
    if (this.latLng) {
      this.mapObject.setLatLng(this.latLng);
      if (this.open) {
        this.$nextTick(function () {
          _this2.mapObject.openOn(_this2.getMap());
        });
      }
    } else {
      this.$nextTick(function () {
        _this2.bindPopup(_this2.mapObject);
      });
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.unbindPopup();
    if (this.mapObject) {
      this.mapObject.off("add", this.onOpen).off("remove", this.onClose).remove()._source = null;
    }
  },
  methods: {
    getPopupOptions: function getPopupOptions() {
      var options = _objectSpread2({
        autoPan: this.autoPan,
        className: this.className,
        maxWidth: this.maxWidth,
        minWidth: this.minWidth,
        fixWidthPixel: true
      }, this.popupOptions);
      if (this.pane) {
        options.pane = this.pane;
      }
      if (typeof this.closeOnClick === "boolean") {
        options.closeOnClick = this.closeOnClick;
      }
      if (typeof this.closeOnEscapeKey === "boolean") {
        options.closeOnEscapeKey = this.closeOnEscapeKey;
      }
      return options;
    },
    updatePopup: function updatePopup() {
      var _this3 = this;
      this.$nextTick(function () {
        _this3.mapObject.update();
      });
    },
    popupDataChanged: function popupDataChanged() {
      this.contentData = this.popupData;
    },
    onOpen: function onOpen(e) {
      if (e.target && e.target._source) {
        this.contentData = this.sourceDataFn(e.target._source) || {};
      }
      /**
       * @type {boolean}
       */
      this.$emit("update:open", true);
      /**
       * @type {object}
       */
      this.$emit("open", e);
    },
    onClose: function onClose(e) {
      /**
       * @type {boolean}
       */
      this.$emit("update:open", false);
      /**
       * @type {object}
       */
      this.$emit("close", e);
    }
  }
});
// CONCATENATED MODULE: ./src/components/map/v-map-popup.vue?vue&type=script&lang=js&
 /* harmony default export */ var map_v_map_popupvue_type_script_lang_js_ = (v_map_popupvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/map/v-map-popup.vue?vue&type=custom&index=0&blockType=docs
var v_map_popupvue_type_custom_index_0_blockType_docs = __webpack_require__("64a6");
var v_map_popupvue_type_custom_index_0_blockType_docs_default = /*#__PURE__*/__webpack_require__.n(v_map_popupvue_type_custom_index_0_blockType_docs);

// EXTERNAL MODULE: ./src/components/map/v-map-popup.vue?vue&type=custom&index=1&blockType=docs
var v_map_popupvue_type_custom_index_1_blockType_docs = __webpack_require__("48ad");
var v_map_popupvue_type_custom_index_1_blockType_docs_default = /*#__PURE__*/__webpack_require__.n(v_map_popupvue_type_custom_index_1_blockType_docs);

// CONCATENATED MODULE: ./src/components/map/v-map-popup.vue





/* normalize component */

var v_map_popup_component = normalizeComponent(
  map_v_map_popupvue_type_script_lang_js_,
  v_map_popupvue_type_template_id_37600833_render,
  v_map_popupvue_type_template_id_37600833_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */

if (typeof v_map_popupvue_type_custom_index_0_blockType_docs_default.a === 'function') v_map_popupvue_type_custom_index_0_blockType_docs_default()(v_map_popup_component)

if (typeof v_map_popupvue_type_custom_index_1_blockType_docs_default.a === 'function') v_map_popupvue_type_custom_index_1_blockType_docs_default()(v_map_popup_component)

/* harmony default export */ var v_map_popup = (v_map_popup_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"443a82ff-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/v-map-popup-content.vue?vue&type=template&id=f429ce24&


var v_map_popup_contentvue_type_template_id_f429ce24_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_vm._t("header", function () {
    return [_c('div', {
      staticClass: "v-map-popup__header"
    }, [_vm.showIcon ? _c('span', {
      staticClass: "v-map-popup__header__icon",
      style: {
        color: _vm.iconColor
      }
    }, [_vm.$slots.icon ? _vm._t("icon") : _c('v-visary-icon')], 2) : _vm._e(), _c('span', {
      staticClass: "v-map-popup__header__title"
    }, [_vm.title ? _c('span', [_vm._v(_vm._s(_vm.title))]) : _vm._t("title")], 2)])];
  }), _vm._t("content", function () {
    return [!_vm.confirmDelete ? _c('div', {
      staticClass: "v-map-popup__content"
    }, [_vm._t("description", function () {
      return [_vm.description ? _c('div', {
        staticClass: "v-map-popup__description"
      }, [_vm._v(" " + _vm._s(_vm.description) + " ")]) : _vm._e()];
    }), _vm._t("other-content"), _vm.toolbarActions.length ? _vm._t("toolbar", function () {
      return [_c('v-map-popup-toolbar', {
        attrs: {
          "open": _vm.toolbarOpen,
          "actions": _vm.toolbarActions
        },
        on: {
          "update:open": function updateOpen($event) {
            _vm.toolbarOpen = $event;
          },
          "action": _vm.onAction
        },
        scopedSlots: _vm._u([_vm.$slots['toolbar-description'] ? {
          key: "description",
          fn: function fn() {
            return [_vm._t("toolbar-description")];
          },
          proxy: true
        } : null, {
          key: "icon",
          fn: function fn(_ref) {
            var action = _ref.action;
            return [_vm._t("action-icon", function () {
              return [_vm.hasDeleteIcon(action) ? _c('v-delete-icon', {
                staticClass: "v-map-delete-icon"
              }) : _vm._e()];
            }, {
              "action": action
            })];
          }
        }], null, true)
      })];
    }) : _vm._e(), _vm._t("primary-actions", function () {
      return [_vm.showEdit || _vm.showDetails ? _c('div', {
        staticClass: "v-map-popup__action"
      }, [_vm.showEdit ? _c('button', {
        staticClass: "v-map-popup__button v-map-popup__button--outline",
        on: {
          "click": function click($event) {
            $event.preventDefault();
            return _vm.onEdit.apply(null, arguments);
          }
        }
      }, [_c('span', {
        staticClass: "v-map-popup__button__icon"
      }, [_c('v-edit-icon')], 1), _c('span', [_vm._v(_vm._s(_vm.editTitle))])]) : _vm._e(), _vm.showDetails ? _c('button', {
        staticClass: "v-map-popup__button",
        on: {
          "click": function click($event) {
            $event.preventDefault();
            return _vm.onDetails.apply(null, arguments);
          }
        }
      }, [_c('span', {
        staticClass: "v-map-popup__button__icon"
      }, [_c('v-info-circle-icon')], 1), _c('span', [_vm._v(_vm._s(_vm.detailsTitle))])]) : _vm._e()]) : _vm._e()];
    })], 2) : _c('div', {
      staticClass: "v-map-popup__content"
    }, [_c('div', {
      staticClass: "v-map-popup__description"
    }, [_vm._v(_vm._s(_vm.confirmDeleteMessage))]), _c('div', {
      staticClass: "v-map-popup__action"
    }, [_c('button', {
      staticClass: "v-map-popup__button v-map-popup__button--outline",
      on: {
        "click": function click($event) {
          $event.preventDefault();
          return _vm.onConfirmDeleteCancel.apply(null, arguments);
        }
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.cancelButtonTitle))])]), _c('button', {
      staticClass: "v-map-popup__button",
      on: {
        "click": function click($event) {
          $event.preventDefault();
          return _vm.onConfirmDeleteOk.apply(null, arguments);
        }
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.deleteButtonTitle))])])])])];
  })], 2);
};
var v_map_popup_contentvue_type_template_id_f429ce24_staticRenderFns = [];

// CONCATENATED MODULE: ./src/components/map/v-map-popup-content.vue?vue&type=template&id=f429ce24&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("99af");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"443a82ff-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/icons/v-edit-icon.vue?vue&type=template&id=317203c2&
var v_edit_iconvue_type_template_id_317203c2_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('svg', {
    staticClass: "v-map-svg",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 576 512",
      "fill": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M402.3 344.9l32-32c5-5 13.7-1.5 13.7 5.7V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h273.5c7.1 0 10.7 8.6 5.7 13.7l-32 32c-1.5 1.5-3.5 2.3-5.7 2.3H48v352h352V350.5c0-2.1.8-4.1 2.3-5.6zm156.6-201.8L296.3 405.7l-90.4 10c-26.2 2.9-48.5-19.2-45.6-45.6l10-90.4L432.9 17.1c22.9-22.9 59.9-22.9 82.7 0l43.2 43.2c22.9 22.9 22.9 60 .1 82.8zM460.1 174L402 115.9 216.2 301.8l-7.3 65.3 65.3-7.3L460.1 174zm64.8-79.7l-43.2-43.2c-4.1-4.1-10.8-4.1-14.8 0L436 82l58.1 58.1 30.9-30.9c4-4.2 4-10.8-.1-14.9z"
    }
  })]);
};
var v_edit_iconvue_type_template_id_317203c2_staticRenderFns = [];

// CONCATENATED MODULE: ./src/components/map/icons/v-edit-icon.vue?vue&type=template&id=317203c2&

// CONCATENATED MODULE: ./src/components/map/icons/v-edit-icon.vue

var v_edit_icon_script = {}


/* normalize component */

var v_edit_icon_component = normalizeComponent(
  v_edit_icon_script,
  v_edit_iconvue_type_template_id_317203c2_render,
  v_edit_iconvue_type_template_id_317203c2_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var v_edit_icon = (v_edit_icon_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"443a82ff-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/icons/v-info-circle-icon.vue?vue&type=template&id=3edabbe7&
var v_info_circle_iconvue_type_template_id_3edabbe7_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('svg', {
    staticClass: "v-map-svg",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512",
      "fill": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "d": "M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 448c-110.532 0-200-89.431-200-200 0-110.495 89.472-200 200-200 110.491 0 200 89.471 200 200 0 110.53-89.431 200-200 200zm0-338c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z"
    }
  })]);
};
var v_info_circle_iconvue_type_template_id_3edabbe7_staticRenderFns = [];

// CONCATENATED MODULE: ./src/components/map/icons/v-info-circle-icon.vue?vue&type=template&id=3edabbe7&

// CONCATENATED MODULE: ./src/components/map/icons/v-info-circle-icon.vue

var v_info_circle_icon_script = {}


/* normalize component */

var v_info_circle_icon_component = normalizeComponent(
  v_info_circle_icon_script,
  v_info_circle_iconvue_type_template_id_3edabbe7_render,
  v_info_circle_iconvue_type_template_id_3edabbe7_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var v_info_circle_icon = (v_info_circle_icon_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"443a82ff-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/icons/v-delete-icon.vue?vue&type=template&id=46d28e09&
var v_delete_iconvue_type_template_id_46d28e09_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('svg', {
    staticClass: "v-map-svg",
    attrs: {
      "fill": "currentColor",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 8.757 10.008"
    }
  }, [_c('path', {
    attrs: {
      "d": "M5.786,8.444H6.1a.156.156,0,0,0,.156-.156V2.971A.156.156,0,0,0,6.1,2.815H5.786a.156.156,0,0,0-.156.156V8.288A.156.156,0,0,0,5.786,8.444Zm-3.127,0h.313a.156.156,0,0,0,.156-.156V2.971a.156.156,0,0,0-.156-.156H2.658a.156.156,0,0,0-.156.156V8.288A.156.156,0,0,0,2.658,8.444ZM8.6,1.251H6.568L5.911.375A.938.938,0,0,0,5.16,0H3.6a.938.938,0,0,0-.751.375l-.657.876H.156A.156.156,0,0,0,0,1.407V1.72a.156.156,0,0,0,.156.156H.625V9.07a.938.938,0,0,0,.938.938H7.193a.938.938,0,0,0,.938-.938V1.876H8.6a.156.156,0,0,0,.156-.156V1.407A.156.156,0,0,0,8.6,1.251ZM3.346.751A.315.315,0,0,1,3.6.625H5.16a.315.315,0,0,1,.25.125l.375.5H2.971ZM7.506,9.07a.313.313,0,0,1-.313.313H1.564a.313.313,0,0,1-.313-.313V1.876H7.506ZM4.222,8.444h.313a.156.156,0,0,0,.156-.156V2.971a.156.156,0,0,0-.156-.156H4.222a.156.156,0,0,0-.156.156V8.288A.156.156,0,0,0,4.222,8.444Z"
    }
  })]);
};
var v_delete_iconvue_type_template_id_46d28e09_staticRenderFns = [];

// CONCATENATED MODULE: ./src/components/map/icons/v-delete-icon.vue?vue&type=template&id=46d28e09&

// CONCATENATED MODULE: ./src/components/map/icons/v-delete-icon.vue

var v_delete_icon_script = {}


/* normalize component */

var v_delete_icon_component = normalizeComponent(
  v_delete_icon_script,
  v_delete_iconvue_type_template_id_46d28e09_render,
  v_delete_iconvue_type_template_id_46d28e09_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var v_delete_icon = (v_delete_icon_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"443a82ff-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/v-map-popup-toolbar.vue?vue&type=template&id=5bca3818&


var v_map_popup_toolbarvue_type_template_id_5bca3818_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "v-map-popup__toolbar",
    class: {
      'v-map-popup__toolbar--opened': _vm.dataOpen
    }
  }, [_c('div', {
    staticClass: "v-map-popup__toolbar__expand-button",
    on: {
      "click": _vm.toggle
    }
  }), _c('transition', {
    attrs: {
      "name": "v-map-transition-expand"
    },
    on: {
      "enter": _vm.expandEnter,
      "afterEnter": _vm.expandAfterEnter,
      "beforeLeave": _vm.expandBeforeLeave
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.dataOpen,
      expression: "dataOpen"
    }],
    staticClass: "v-map-popup__toolbar__content"
  }, [_vm.$slots['description'] ? _c('div', {
    staticClass: "v-map-popup__toolbar__description"
  }, [_vm._t("description")], 2) : _vm._e(), _c('div', {
    staticClass: "v-map-popup__toolbar__actions"
  }, _vm._l(_vm.actions, function (action) {
    return _c('div', {
      key: action.id,
      staticClass: "v-map-popup__toolbar__action",
      class: "v-map-popup__toolbar__action-".concat(action.id),
      on: {
        "click": function click($event) {
          return _vm.onAction(action);
        }
      }
    }, [action.icon ? _c('span', {
      staticClass: "v-map-popup__toolbar__action__icon"
    }, [_vm._t("icon", null, {
      "action": action
    })], 2) : _vm._e(), _c('span', {
      staticClass: "v-map-popup__toolbar__action__title"
    }, [_vm._v(_vm._s(action.title))])]);
  }), 0)])])], 1);
};
var v_map_popup_toolbarvue_type_template_id_5bca3818_staticRenderFns = [];

// CONCATENATED MODULE: ./src/components/map/v-map-popup-toolbar.vue?vue&type=template&id=5bca3818&

// CONCATENATED MODULE: ./src/mixins/expand-animation.js
/* harmony default export */ var expand_animation = ({
  methods: {
    expandEnter: function expandEnter(el) {
      el.style.height = el.scrollHeight + 'px';
    },
    expandAfterEnter: function expandAfterEnter(el) {
      el.style.height = 'auto';
    },
    expandBeforeLeave: function expandBeforeLeave(el) {
      el.style.height = el.scrollHeight + 'px';
    }
  }
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/v-map-popup-toolbar.vue?vue&type=script&lang=js&

/* harmony default export */ var v_map_popup_toolbarvue_type_script_lang_js_ = ({
  name: "v-map-popup-toolbar",
  mixins: [expand_animation],
  props: {
    actions: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    /**
     * sync
     */
    open: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      dataOpen: this.open
    };
  },
  watch: {
    open: function open() {
      this.dataOpen = this.open;
    },
    dataOpen: function dataOpen() {
      /**
       * @type {boolean}
       */
      this.$emit("update:open", this.dataOpen);
    }
  },
  methods: {
    toggle: function toggle() {
      this.dataOpen = !this.dataOpen;
    },
    onAction: function onAction(action) {
      /**
       * @type {object}
       */
      this.$emit("action", action);
    }
  }
});
// CONCATENATED MODULE: ./src/components/map/v-map-popup-toolbar.vue?vue&type=script&lang=js&
 /* harmony default export */ var map_v_map_popup_toolbarvue_type_script_lang_js_ = (v_map_popup_toolbarvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/map/v-map-popup-toolbar.vue?vue&type=custom&index=0&blockType=docs
var v_map_popup_toolbarvue_type_custom_index_0_blockType_docs = __webpack_require__("23a6");
var v_map_popup_toolbarvue_type_custom_index_0_blockType_docs_default = /*#__PURE__*/__webpack_require__.n(v_map_popup_toolbarvue_type_custom_index_0_blockType_docs);

// EXTERNAL MODULE: ./src/components/map/v-map-popup-toolbar.vue?vue&type=custom&index=1&blockType=docs
var v_map_popup_toolbarvue_type_custom_index_1_blockType_docs = __webpack_require__("7609");
var v_map_popup_toolbarvue_type_custom_index_1_blockType_docs_default = /*#__PURE__*/__webpack_require__.n(v_map_popup_toolbarvue_type_custom_index_1_blockType_docs);

// CONCATENATED MODULE: ./src/components/map/v-map-popup-toolbar.vue





/* normalize component */

var v_map_popup_toolbar_component = normalizeComponent(
  map_v_map_popup_toolbarvue_type_script_lang_js_,
  v_map_popup_toolbarvue_type_template_id_5bca3818_render,
  v_map_popup_toolbarvue_type_template_id_5bca3818_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */

if (typeof v_map_popup_toolbarvue_type_custom_index_0_blockType_docs_default.a === 'function') v_map_popup_toolbarvue_type_custom_index_0_blockType_docs_default()(v_map_popup_toolbar_component)

if (typeof v_map_popup_toolbarvue_type_custom_index_1_blockType_docs_default.a === 'function') v_map_popup_toolbarvue_type_custom_index_1_blockType_docs_default()(v_map_popup_toolbar_component)

/* harmony default export */ var v_map_popup_toolbar = (v_map_popup_toolbar_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/v-map-popup-content.vue?vue&type=script&lang=js&







/* harmony default export */ var v_map_popup_contentvue_type_script_lang_js_ = ({
  name: "v-map-popup-content",
  components: {
    VEditIcon: v_edit_icon,
    VInfoCircleIcon: v_info_circle_icon,
    VVisaryIcon: v_visary_icon,
    VDeleteIcon: v_delete_icon,
    VMapPopupToolbar: v_map_popup_toolbar
  },
  props: {
    title: {
      type: String,
      default: null
    },
    description: {
      type: String,
      default: null
    },
    actions: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    /**
     * sync
     */
    actionsOpen: {
      type: Boolean,
      default: false
    },
    editTitle: {
      type: String,
      default: function _default() {
        return utils_locale.default.editButtonTitle;
      }
    },
    detailsTitle: {
      type: String,
      default: function _default() {
        return utils_locale.default.detailsButtonTitle;
      }
    },
    showEdit: {
      type: Boolean,
      default: false
    },
    showDetails: {
      type: Boolean,
      default: false
    },
    showDelete: {
      type: Boolean,
      default: false
    },
    showIcon: {
      type: Boolean,
      default: true
    },
    iconColor: {
      type: String,
      default: null
    },
    /**
     * sync
     */
    showConfirmDelete: {
      type: Boolean,
      default: false
    },
    withConfirmDelete: {
      type: Boolean,
      default: false
    },
    confirmDeleteMessage: {
      type: String,
      default: function _default() {
        return utils_locale.default.confirmDeleteMessage;
      }
    },
    cancelButtonTitle: {
      type: String,
      default: function _default() {
        return utils_locale.default.cancelButtonTitle;
      }
    },
    deleteButtonTitle: {
      type: String,
      default: function _default() {
        return utils_locale.default.deleteButtonTitle;
      }
    }
  },
  data: function data() {
    return {
      confirmDelete: this.showConfirmDelete
    };
  },
  computed: {
    toolbarOpen: {
      get: function get() {
        return this.actionsOpen;
      },
      set: function set(value) {
        /**
         * @type {boolean}
         */
        this.$emit("update:actionsOpen", value);
      }
    },
    toolbarActions: function toolbarActions() {
      if (this.showDelete) {
        return this.actions.concat([{
          id: "delete",
          title: this.deleteButtonTitle,
          icon: "delete"
        }]);
      } else {
        return this.actions;
      }
    }
  },
  watch: {
    showConfirmDelete: function showConfirmDelete() {
      this.confirmDelete = this.showConfirmDelete;
    },
    confirmDelete: function confirmDelete() {
      /**
       * @type {boolean}
       */
      this.$emit("update:showConfirmDelete", this.confirmDelete);
    }
  },
  methods: {
    onDetails: function onDetails() {
      /**
       * @type {void}
       */
      this.$emit("details");
    },
    onEdit: function onEdit() {
      /**
       * @type {void}
       */
      this.$emit("edit");
    },
    onDelete: function onDelete() {
      if (this.withConfirmDelete) {
        this.confirmDelete = true;
      } else {
        /**
         * @type {void}
         */
        this.$emit("delete");
      }
    },
    onConfirmDeleteCancel: function onConfirmDeleteCancel() {
      this.confirmDelete = false;
    },
    onConfirmDeleteOk: function onConfirmDeleteOk() {
      this.confirmDelete = false;
      /**
       * @type {void}
       */
      this.$emit("delete");
    },
    hasDeleteIcon: function hasDeleteIcon(_ref) {
      var icon = _ref.icon;
      return icon === "delete";
    },
    hasDeleteAction: function hasDeleteAction(_ref2) {
      var id = _ref2.id;
      return id === "delete";
    },
    onAction: function onAction(action) {
      if (this.hasDeleteAction(action)) {
        this.onDelete();
      } else {
        /**
         * @type {object}
         */
        this.$emit("action", action);
      }
    }
  }
});
// CONCATENATED MODULE: ./src/components/map/v-map-popup-content.vue?vue&type=script&lang=js&
 /* harmony default export */ var map_v_map_popup_contentvue_type_script_lang_js_ = (v_map_popup_contentvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/map/v-map-popup-content.vue?vue&type=custom&index=0&blockType=docs
var v_map_popup_contentvue_type_custom_index_0_blockType_docs = __webpack_require__("c723");
var v_map_popup_contentvue_type_custom_index_0_blockType_docs_default = /*#__PURE__*/__webpack_require__.n(v_map_popup_contentvue_type_custom_index_0_blockType_docs);

// EXTERNAL MODULE: ./src/components/map/v-map-popup-content.vue?vue&type=custom&index=1&blockType=docs
var v_map_popup_contentvue_type_custom_index_1_blockType_docs = __webpack_require__("8208");
var v_map_popup_contentvue_type_custom_index_1_blockType_docs_default = /*#__PURE__*/__webpack_require__.n(v_map_popup_contentvue_type_custom_index_1_blockType_docs);

// CONCATENATED MODULE: ./src/components/map/v-map-popup-content.vue





/* normalize component */

var v_map_popup_content_component = normalizeComponent(
  map_v_map_popup_contentvue_type_script_lang_js_,
  v_map_popup_contentvue_type_template_id_f429ce24_render,
  v_map_popup_contentvue_type_template_id_f429ce24_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */

if (typeof v_map_popup_contentvue_type_custom_index_0_blockType_docs_default.a === 'function') v_map_popup_contentvue_type_custom_index_0_blockType_docs_default()(v_map_popup_content_component)

if (typeof v_map_popup_contentvue_type_custom_index_1_blockType_docs_default.a === 'function') v_map_popup_contentvue_type_custom_index_1_blockType_docs_default()(v_map_popup_content_component)

/* harmony default export */ var v_map_popup_content = (v_map_popup_content_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"443a82ff-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/v-map-tree-layer.vue?vue&type=template&id=18465301&
var v_map_tree_layervue_type_template_id_18465301_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('li', {
    staticClass: "v-map-item",
    on: {
      "click": function click($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.onToggleSelect.apply(null, arguments);
      }
    }
  }, [_c('p', {
    staticClass: "v-map-item__inside",
    class: {
      'v-map-item--selected': _vm.selected,
      'v-map-item--disabled': _vm.disabled
    }
  }, [_c('span', {
    staticClass: "v-map-item__arrow",
    class: {
      'v-map-item__arrow--expanded': _vm.expanded,
      'v-map-item__arrow--hidden': !_vm.hasChildren
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.onToggleExpand.apply(null, arguments);
      }
    }
  }, [_c('v-arrow-icon')], 1), _c('span', {
    staticClass: "v-map-item__icon v-map-item__icon--primary",
    style: _vm.iconStyle
  }, [_vm.$slots.icon ? _vm._t("icon") : _c('v-visary-icon')], 2), _c('span', {
    staticClass: "v-map-item__title"
  }, [_vm._v(_vm._s(_vm.title))]), _c('span', {
    staticClass: "v-map-item__action"
  }, [_vm.filtering ? _c('span', {
    staticClass: "v-map-item__filter",
    class: {
      'v-map-item__filter--active': _vm.filterActive
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.onFilter.apply(null, arguments);
      }
    }
  }, [_c('v-filter-icon')], 1) : _vm._e(), _vm.showCount ? _c('span', {
    staticClass: "v-map-item__count",
    on: {
      "click": function click($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.onCountPressed.apply(null, arguments);
      }
    }
  }, [_vm._v(_vm._s(_vm.count))]) : _vm._e(), _c('span', {
    staticClass: "v-map-item__show",
    class: {
      'v-map-item__show--active': _vm.visible,
      'v-map-item__show--deactive': !_vm.visible
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.onToggleVisible.apply(null, arguments);
      }
    }
  }, [_vm.visible ? _c('v-eye-icon') : _c('v-eye-solid-icon')], 1)])]), _vm.hasChildren ? _c('transition', {
    attrs: {
      "name": "v-map-transition-expand"
    },
    on: {
      "enter": _vm.expandEnter,
      "afterEnter": _vm.onExpandEnd,
      "beforeLeave": _vm.expandBeforeLeave,
      "afterLeave": _vm.onCollapseEnd
    }
  }, [_c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.expanded,
      expression: "expanded"
    }],
    staticClass: "v-map-tree__sub"
  }, [_vm._t("default")], 2)]) : _vm._e(), _vm._t("other")], 2);
};
var v_map_tree_layervue_type_template_id_18465301_staticRenderFns = [];

// CONCATENATED MODULE: ./src/components/map/v-map-tree-layer.vue?vue&type=template&id=18465301&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"443a82ff-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/icons/v-filter-icon.vue?vue&type=template&id=3a45f1a9&
var v_filter_iconvue_type_template_id_3a45f1a9_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('svg', {
    staticClass: "v-map-svg",
    attrs: {
      "viewBox": "0 0 11 11",
      "fill": "currentColor",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('line', {
    attrs: {
      "x1": "0.5",
      "y1": "1.5",
      "x2": "10.5",
      "y2": "1.5",
      "stroke": "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('line', {
    attrs: {
      "x1": "0.5",
      "y1": "5.5",
      "x2": "10.5",
      "y2": "5.5",
      "stroke": "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('line', {
    attrs: {
      "x1": "0.5",
      "y1": "9.5",
      "x2": "10.5",
      "y2": "9.5",
      "stroke": "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('circle', {
    attrs: {
      "cx": "3.5",
      "cy": "1.5",
      "r": "1",
      "fill": "white",
      "stroke": "currentColor"
    }
  }), _c('path', {
    attrs: {
      "d": "M8.5 5.5C8.5 6.05228 8.05228 6.5 7.5 6.5C6.94772 6.5 6.5 6.05228 6.5 5.5C6.5 4.94772 6.94772 4.5 7.5 4.5C8.05228 4.5 8.5 4.94772 8.5 5.5Z",
      "fill": "white",
      "stroke": "currentColor"
    }
  }), _c('circle', {
    attrs: {
      "cx": "3.5",
      "cy": "9.5",
      "r": "1",
      "fill": "white",
      "stroke": "currentColor"
    }
  })]);
};
var v_filter_iconvue_type_template_id_3a45f1a9_staticRenderFns = [];

// CONCATENATED MODULE: ./src/components/map/icons/v-filter-icon.vue?vue&type=template&id=3a45f1a9&

// CONCATENATED MODULE: ./src/components/map/icons/v-filter-icon.vue

var v_filter_icon_script = {}


/* normalize component */

var v_filter_icon_component = normalizeComponent(
  v_filter_icon_script,
  v_filter_iconvue_type_template_id_3a45f1a9_render,
  v_filter_iconvue_type_template_id_3a45f1a9_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var v_filter_icon = (v_filter_icon_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"443a82ff-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/icons/v-eye-icon.vue?vue&type=template&id=7e37129b&
var v_eye_iconvue_type_template_id_7e37129b_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('svg', {
    staticClass: "v-map-svg",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "fill": "currentColor",
      "viewBox": "0 0 576 512"
    }
  }, [_c('path', {
    attrs: {
      "d": "M572.52 241.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0 0-29.19zM288 400a144 144 0 1 1 144-144 143.93 143.93 0 0 1-144 144zm0-240a95.31 95.31 0 0 0-25.31 3.79 47.85 47.85 0 0 1-66.9 66.9A95.78 95.78 0 1 0 288 160z"
    }
  })]);
};
var v_eye_iconvue_type_template_id_7e37129b_staticRenderFns = [];

// CONCATENATED MODULE: ./src/components/map/icons/v-eye-icon.vue?vue&type=template&id=7e37129b&

// CONCATENATED MODULE: ./src/components/map/icons/v-eye-icon.vue

var v_eye_icon_script = {}


/* normalize component */

var v_eye_icon_component = normalizeComponent(
  v_eye_icon_script,
  v_eye_iconvue_type_template_id_7e37129b_render,
  v_eye_iconvue_type_template_id_7e37129b_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var v_eye_icon = (v_eye_icon_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"443a82ff-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/icons/v-eye-solid-icon.vue?vue&type=template&id=2362dff2&
var v_eye_solid_iconvue_type_template_id_2362dff2_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('svg', {
    staticClass: "v-map-svg",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 640 512",
      "fill": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "d": "M320 400c-75.85 0-137.25-58.71-142.9-133.11L72.2 185.82c-13.79 17.3-26.48 35.59-36.72 55.59a32.35 32.35 0 0 0 0 29.19C89.71 376.41 197.07 448 320 448c26.91 0 52.87-4 77.89-10.46L346 397.39a144.13 144.13 0 0 1-26 2.61zm313.82 58.1l-110.55-85.44a331.25 331.25 0 0 0 81.25-102.07 32.35 32.35 0 0 0 0-29.19C550.29 135.59 442.93 64 320 64a308.15 308.15 0 0 0-147.32 37.7L45.46 3.37A16 16 0 0 0 23 6.18L3.37 31.45A16 16 0 0 0 6.18 53.9l588.36 454.73a16 16 0 0 0 22.46-2.81l19.64-25.27a16 16 0 0 0-2.82-22.45zm-183.72-142l-39.3-30.38A94.75 94.75 0 0 0 416 256a94.76 94.76 0 0 0-121.31-92.21A47.65 47.65 0 0 1 304 192a46.64 46.64 0 0 1-1.54 10l-73.61-56.89A142.31 142.31 0 0 1 320 112a143.92 143.92 0 0 1 144 144c0 21.63-5.29 41.79-13.9 60.11z"
    }
  })]);
};
var v_eye_solid_iconvue_type_template_id_2362dff2_staticRenderFns = [];

// CONCATENATED MODULE: ./src/components/map/icons/v-eye-solid-icon.vue?vue&type=template&id=2362dff2&

// CONCATENATED MODULE: ./src/components/map/icons/v-eye-solid-icon.vue

var v_eye_solid_icon_script = {}


/* normalize component */

var v_eye_solid_icon_component = normalizeComponent(
  v_eye_solid_icon_script,
  v_eye_solid_iconvue_type_template_id_2362dff2_render,
  v_eye_solid_iconvue_type_template_id_2362dff2_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var v_eye_solid_icon = (v_eye_solid_icon_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"443a82ff-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/icons/v-arrow-icon.vue?vue&type=template&id=dabcc044&
var v_arrow_iconvue_type_template_id_dabcc044_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('svg', {
    staticClass: "v-map-svg",
    attrs: {
      "viewBox": "0 0 5 8",
      "fill": "currentColor",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M3.40673 4.35317L3.75951 3.99961L3.40634 3.64645L0.705313 0.945419L0.940705 0.708358L4.23235 4L0.939453 7.29289L0.706174 7.05961L3.40673 4.35317Z",
      "stroke": "currentColor"
    }
  })]);
};
var v_arrow_iconvue_type_template_id_dabcc044_staticRenderFns = [];

// CONCATENATED MODULE: ./src/components/map/icons/v-arrow-icon.vue?vue&type=template&id=dabcc044&

// CONCATENATED MODULE: ./src/components/map/icons/v-arrow-icon.vue

var v_arrow_icon_script = {}


/* normalize component */

var v_arrow_icon_component = normalizeComponent(
  v_arrow_icon_script,
  v_arrow_iconvue_type_template_id_dabcc044_render,
  v_arrow_iconvue_type_template_id_dabcc044_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var v_arrow_icon = (v_arrow_icon_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/v-map-tree-layer.vue?vue&type=script&lang=js&








/* harmony default export */ var v_map_tree_layervue_type_script_lang_js_ = ({
  name: "v-map-tree-layer",
  mixins: [expand_animation],
  components: {
    VVisaryIcon: v_visary_icon,
    VFilterIcon: v_filter_icon,
    VEyeIcon: v_eye_icon,
    VEyeSolidIcon: v_eye_solid_icon,
    VArrowIcon: v_arrow_icon
  },
  props: {
    title: {
      type: String,
      default: null
    },
    selected: {
      type: Boolean,
      default: false
    },
    expanded: {
      type: Boolean,
      default: false
    },
    visible: {
      type: Boolean,
      default: false
    },
    filtering: {
      type: Boolean,
      default: false
    },
    filterActive: {
      type: Boolean,
      default: false
    },
    count: {
      type: Number,
      default: 0
    },
    showCount: {
      type: Boolean,
      default: true
    },
    iconColor: {
      type: String,
      default: null
    },
    selection: {
      type: Boolean,
      default: true
    },
    expandOnSelect: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    hasChildren: function hasChildren() {
      return !!this.$slots.default;
    },
    iconStyle: function iconStyle() {
      return _defineProperty({}, this.selected ? "color" : "backgroundColor", this.iconColor);
    }
  },
  methods: {
    onToggleVisible: function onToggleVisible() {
      if (this.disabled) return;
      this.$emit("update:visible", !this.visible);
    },
    onToggleSelect: function onToggleSelect() {
      if (this.disabled) return;
      if (this.expandOnSelect) this.onToggleExpand();
      if (!this.selection) return;
      this.$emit("update:selected", !this.selected);
    },
    onToggleExpand: function onToggleExpand() {
      if (this.disabled) return;
      this.$emit("update:expanded", !this.expanded);
    },
    onFilter: function onFilter() {
      if (this.disabled) return;
      this.$emit("filter");
    },
    onCountPressed: function onCountPressed() {
      if (this.disabled) return;
      this.$emit("count", {
        count: this.count
      });
    },
    onExpandEnd: function onExpandEnd(el) {
      this.expandAfterEnter(el);
      this.$emit("expand-end");
    },
    onCollapseEnd: function onCollapseEnd() {
      this.$emit("collapse-end");
    }
  }
});
// CONCATENATED MODULE: ./src/components/map/v-map-tree-layer.vue?vue&type=script&lang=js&
 /* harmony default export */ var map_v_map_tree_layervue_type_script_lang_js_ = (v_map_tree_layervue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/map/v-map-tree-layer.vue





/* normalize component */

var v_map_tree_layer_component = normalizeComponent(
  map_v_map_tree_layervue_type_script_lang_js_,
  v_map_tree_layervue_type_template_id_18465301_render,
  v_map_tree_layervue_type_template_id_18465301_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var v_map_tree_layer = (v_map_tree_layer_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/v-map-single-selection.vue?vue&type=script&lang=js&

var v_map_single_selectionvue_type_script_lang_js_eventPrefix = "vmap:layer:selection:single:";
/* harmony default export */ var v_map_single_selectionvue_type_script_lang_js_ = ({
  name: "v-map-single-selection",
  inject: ["getMap"],
  props: {
    name: {
      type: String,
      required: true
    },
    selected: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    eventName: function eventName() {
      return "".concat(v_map_single_selectionvue_type_script_lang_js_eventPrefix).concat(this.name);
    }
  },
  watch: {
    name: function name(newValue, oldValue) {
      var map = this.getMap();
      map.off("".concat(v_map_single_selectionvue_type_script_lang_js_eventPrefix).concat(oldValue), this.handleSelection).on("".concat(v_map_single_selectionvue_type_script_lang_js_eventPrefix).concat(newValue), this.handleSelection);
    },
    selected: function selected() {
      var map = this.getMap();
      map.fire(this.eventName, {
        value: this.selected,
        uid: this._uid
      });
    }
  },
  mounted: function mounted() {
    var map = this.getMap();
    map.on(this.eventName, this.handleSelection);
  },
  beforeDestroy: function beforeDestroy() {
    var map = this.getMap();
    map.off(this.eventName, this.handleSelection);
  },
  methods: {
    handleSelection: function handleSelection(_ref) {
      var value = _ref.value,
        uid = _ref.uid;
      if (this._uid === uid) return;
      if (value) {
        this.$emit("update:selected", false);
      }
    }
  },
  render: function render() {
    return null;
  }
});
// CONCATENATED MODULE: ./src/components/map/v-map-single-selection.vue?vue&type=script&lang=js&
 /* harmony default export */ var map_v_map_single_selectionvue_type_script_lang_js_ = (v_map_single_selectionvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/map/v-map-single-selection.vue
var v_map_single_selection_render, v_map_single_selection_staticRenderFns




/* normalize component */

var v_map_single_selection_component = normalizeComponent(
  map_v_map_single_selectionvue_type_script_lang_js_,
  v_map_single_selection_render,
  v_map_single_selection_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var v_map_single_selection = (v_map_single_selection_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/v-map-group-count.vue?vue&type=script&lang=js&


/* harmony default export */ var v_map_group_countvue_type_script_lang_js_ = ({
  name: "v-map-group-count",
  inject: ["setGroupCount"],
  props: {
    name: {
      type: String,
      required: true
    },
    count: {
      type: Number,
      default: 0
    }
  },
  watch: {
    count: function count() {
      this.setGroupCount(this.name, this._uid, this.count);
    },
    name: function name(newValue, oldValue) {
      this.setGroupCount(oldValue, this._uid, 0);
      this.setGroupCount(newValue, this._uid, this.count);
    }
  },
  mounted: function mounted() {
    this.setGroupCount(this.name, this._uid, this.count);
  },
  beforeDestroy: function beforeDestroy() {
    this.setGroupCount(this.name, this._uid, 0);
  },
  render: function render() {
    return null;
  }
});
// CONCATENATED MODULE: ./src/components/map/v-map-group-count.vue?vue&type=script&lang=js&
 /* harmony default export */ var map_v_map_group_countvue_type_script_lang_js_ = (v_map_group_countvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/map/v-map-group-count.vue
var v_map_group_count_render, v_map_group_count_staticRenderFns




/* normalize component */

var v_map_group_count_component = normalizeComponent(
  map_v_map_group_countvue_type_script_lang_js_,
  v_map_group_count_render,
  v_map_group_count_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var v_map_group_count = (v_map_group_count_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/v-map-group-visible.vue?vue&type=script&lang=js&



var eventName = function eventName(groupName) {
  return "vmap:layer:visible:".concat(groupName);
};
/* harmony default export */ var v_map_group_visiblevue_type_script_lang_js_ = ({
  name: "v-map-group-visible",
  inject: ["setGroupVisible", "getMap"],
  props: {
    name: {
      type: String,
      required: true
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    visible: function visible() {
      this.setGroupVisible(this.name, this._uid, this.visible);
    },
    name: function name(newValue, oldValue) {
      var map = this.getMap();
      map.off(eventName(oldValue), this.handleVisible).on(eventName(newValue), this.handleVisible);
      this.setGroupVisible(oldValue, this._uid, null);
      this.setGroupVisible(newValue, this._uid, this.visible);
    }
  },
  mounted: function mounted() {
    var map = this.getMap();
    map.on(eventName(this.name), this.handleVisible);
    this.setGroupVisible(this.name, this._uid, this.visible);
  },
  beforeDestroy: function beforeDestroy() {
    var map = this.getMap();
    map.off(eventName(this.name), this.handleVisible);
    this.setGroupVisible(this.name, this._uid, null);
  },
  methods: {
    handleVisible: function handleVisible(_ref) {
      var values = _ref.values;
      if (values[this._uid] == null) return;
      this.$emit("update:visible", !!values[this._uid]);
    }
  },
  render: function render() {
    return null;
  }
});
// CONCATENATED MODULE: ./src/components/map/v-map-group-visible.vue?vue&type=script&lang=js&
 /* harmony default export */ var map_v_map_group_visiblevue_type_script_lang_js_ = (v_map_group_visiblevue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/map/v-map-group-visible.vue
var v_map_group_visible_render, v_map_group_visible_staticRenderFns




/* normalize component */

var v_map_group_visible_component = normalizeComponent(
  map_v_map_group_visiblevue_type_script_lang_js_,
  v_map_group_visible_render,
  v_map_group_visible_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var v_map_group_visible = (v_map_group_visible_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/v-map-client-layer.vue?vue&type=script&lang=js&






















/* harmony default export */ var v_map_client_layervue_type_script_lang_js_ = ({
  name: "v-map-client-layer",
  mixins: [popup_mixin],
  inject: ["getMap", "presentation"],
  provide: function provide() {
    return {
      setMarkerIcon: this.setMarkerIcon,
      setPathStyle: this.setPathStyle,
      setClusterIconFactory: this.setClusterIconFactory,
      getMarkerIcon: this.getMarkerIcon,
      getPathStyle: this.getPathStyle,
      bindPopup: this.bindPopup,
      unbindPopup: this.unbindPopup,
      getData: this.getData,
      isVisible: this.isVisible,
      setUseVisibleHandler: this.setUseVisibleHandler,
      removeFromMap: this.removeFromMap,
      addToMap: this.addToMap,
      getMapObject: this.getMapObject,
      listenEvent: this.listenEvent,
      getId: this.getId
    };
  },
  components: {
    VMapMarkerIcon: v_map_marker_icon,
    VMapClusterIcon: v_map_cluster_icon,
    VMapPathStyle: v_map_path_style,
    VMapPopup: v_map_popup,
    VMapPopupContent: v_map_popup_content,
    VMapTreeLayer: v_map_tree_layer,
    VMapSingleSelection: v_map_single_selection,
    VMapGroupCount: v_map_group_count,
    VMapGroupVisible: v_map_group_visible
  },
  props: {
    id: {
      type: [String, Number],
      default: null
    },
    title: {
      type: String,
      default: null
    },
    /**
     * sync
     */
    visible: {
      type: Boolean,
      default: true
    },
    /**
     * sync
     */
    selected: {
      type: Boolean,
      default: false
    },
    /**
     * sync
     */
    invalidate: {
      type: Boolean,
      default: true
    },
    /**
     * sync
     */
    fetching: {
      type: Boolean,
      default: false
    },
    filtering: {
      type: Boolean,
      default: false
    },
    filterActive: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    clustering: {
      type: Boolean,
      default: false
    },
    clusterOptions: {
      type: Object,
      default: null
    },
    clusterAnimation: {
      type: Boolean,
      default: true
    },
    useSuperCluster: {
      type: Boolean,
      default: false
    },
    superClusterOptions: {
      type: Object,
      default: null
    },
    /**
     * sync
     */
    count: {
      type: Number,
      default: 0
    },
    dataSource: {
      type: Function,
      default: null
    },
    markerPane: {
      type: String,
      default: null
    },
    styles: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    centerMarker: {
      type: Boolean,
      default: true
    },
    geometryField: {
      type: String,
      default: "geometry"
    },
    iconColorField: {
      type: String,
      default: "iconColor"
    },
    idField: {
      type: String,
      default: "id"
    },
    titleField: {
      type: String,
      default: "title"
    },
    descriptionField: {
      type: String,
      default: "description"
    },
    pathStyleField: {
      type: String,
      default: "pathStyle"
    },
    pathClassField: {
      type: String,
      default: "pathClass"
    },
    equalsFn: {
      type: Function,
      default: null
    },
    popupEnabled: {
      type: Boolean,
      default: true
    },
    popupShowEdit: {
      type: Boolean,
      default: false
    },
    popupShowDelete: {
      type: Boolean,
      default: false
    },
    popupShowDetails: {
      type: Boolean,
      default: true
    },
    selection: {
      type: Boolean,
      default: true
    },
    singleSelection: {
      type: Boolean,
      default: true
    },
    selectionKey: {
      type: String,
      default: "maplayer"
    },
    groupCountKey: {
      type: String,
      default: "maplayer"
    },
    groupVisibleKey: {
      type: String,
      default: "maplayer"
    },
    clusterCountAttr: {
      type: String,
      default: "data-count"
    }
  },
  data: function data() {
    return {
      didInvalidate: this.invalidate,
      dataFetching: this.fetching,
      lastFetchError: null,
      dataCount: this.count,
      dataSelected: this.selected,
      dataVisible: this.visible,
      useVisibleHandler: false
    };
  },
  watch: {
    invalidate: function invalidate() {
      this.didInvalidate = this.invalidate;
      this.fetchDataIfNeeded();
    },
    fetching: function fetching() {
      this.dataFetching = this.fetching;
    },
    dataSource: function dataSource() {
      this.invalidateAndFetch();
    },
    count: function count() {
      this.dataCount = this.count;
    },
    selected: function selected() {
      this.dataSelected = this.selected;
    },
    dataSelected: function dataSelected() {
      /**
       * @type {boolean}
       */
      this.$emit("update:selected", this.dataSelected);
    },
    visible: function visible() {
      this.dataVisible = this.visible;
    },
    dataVisible: function dataVisible() {
      this.setVisible(this.dataVisible);
      this.fetchDataIfNeeded();
      /**
       * @type {boolean}
       */
      this.$emit("update:visible", this.dataVisible);
    },
    styles: {
      deep: true,
      handler: "stylesChanged"
    }
  },
  mounted: function mounted() {
    var _this = this;
    this.mapObject = this.createGroup();
    this.setVisible(this.dataVisible);
    this.$nextTick(function () {
      _this.fetchDataIfNeeded();
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (this.mapObject) {
      this.mapObject.off("click", this.handleGroupClick).off("clusterclick", this.handleClusterClick).off("error", this.handleError).off("dataLoaded", this.handleDataLoaded).clearLayers().remove();
      if (typeof this.mapObject.destroy === "function") {
        this.mapObject.destroy();
      }
    }
  },
  methods: {
    createGroup: function createGroup() {
      if (this.clustering) {
        return this.createClusterGroup();
      } else {
        return this.createFeatureGroup();
      }
    },
    createClusterGroup: function createClusterGroup() {
      if (this.useSuperCluster) {
        return this.createSuperClusterGroup();
      } else {
        return this.createMarkerClusterGroup();
      }
    },
    createMarkerClusterGroup: function createMarkerClusterGroup() {
      var options = _objectSpread2({
        showCoverageOnHover: false,
        chunkedLoading: true,
        animate: this.clusterAnimation,
        iconCreateFunction: this.makeClusterIcon
      }, this.clusterOptions);
      var layerGroup = Object(external_leaflet_["markerClusterGroup"])(options).on("clusterclick", this.handleClusterClick).on("click", this.handleGroupClick);
      return layerGroup;
    },
    createSuperClusterGroup: function createSuperClusterGroup() {
      var options = _objectSpread2({
        iconClusterCreateFunction: this.makeSuperClusterIcon,
        layerCreateFunction: this.createMapObject,
        updatePopupFunction: this.updatePopup
      }, this.superClusterOptions);
      var layerGroup = Object(external_leaflet_["superClusterGroup"])(options).on("clusterclick", this.handleClusterClick).on("click", this.handleGroupClick).on("error", this.handleError).on("dataLoaded", this.handleDataLoaded);
      return layerGroup;
    },
    createFeatureGroup: function createFeatureGroup() {
      var layerGroup = Object(external_leaflet_["featureGroup"])();
      layerGroup.on("click", this.handleGroupClick);
      return layerGroup;
    },
    invalidateAndFetch: function invalidateAndFetch() {
      this.didInvalidate = true;
      this.fetchDataIfNeeded();
    },
    fetchDataIfNeeded: function fetchDataIfNeeded() {
      if (this.shouldFetchData()) {
        this.fetchData();
      }
    },
    shouldFetchData: function shouldFetchData() {
      return this.didInvalidate && this.dataVisible;
    },
    canFetchData: function canFetchData() {
      return typeof this.dataSource === "function";
    },
    fetchData: function fetchData() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var responseData;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                if (_this2.canFetchData()) {
                  _context.next = 3;
                  break;
                }
                return _context.abrupt("return");
              case 3:
                _this2.didInvalidate = false;
                _this2.dataFetching = true;
                _this2.lastFetchError = null;

                /**
                 * @type {boolean}
                 */
                _this2.$emit("update:invalidate", false);
                /**
                 * @type {boolean}
                 */
                _this2.$emit("update:fetching", true);
                _context.next = 10;
                return _this2.dataSource(_this2.id);
              case 10:
                responseData = _context.sent;
                if (!_this2._isDestroyed) {
                  _context.next = 13;
                  break;
                }
                return _context.abrupt("return");
              case 13:
                if (_this2.clustering && _this2.useSuperCluster) {
                  _this2._loadSuperClusterData(responseData);
                } else {
                  _this2._loadResponseData(responseData);
                }
                if (!Array.isArray(responseData)) {
                  responseData = [];
                }
                _this2.dataFetching = false;
                _this2.dataCount = responseData.length;

                /**
                 * @type {boolean}
                 */
                _this2.$emit("update:fetching", false);
                /**
                 * @type {number}
                 */
                _this2.$emit("update:count", _this2.dataCount);
                /**
                 * @type {object}
                 */
                _this2.$emit("data:changed", {
                  data: responseData
                });
                _context.next = 30;
                break;
              case 22:
                _context.prev = 22;
                _context.t0 = _context["catch"](0);
                if (!is_cancel(_context.t0)) {
                  _context.next = 26;
                  break;
                }
                return _context.abrupt("return");
              case 26:
                logger.error(_context.t0);
                _this2.dataFetching = false;
                _this2.lastFetchError = _context.t0;
                /**
                 * @type {boolean}
                 */
                _this2.$emit("update:fetching", false);
              case 30:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 22]]);
      }))();
    },
    _loadSuperClusterData: function _loadSuperClusterData(responseData) {
      if (!Array.isArray(responseData) && !(responseData instanceof ArrayBuffer)) {
        return;
      }
      this.closePopup();
      this.clearMapObjects();
      this.mapObject.loadData(responseData);
    },
    _loadResponseData: function _loadResponseData(responseData) {
      if (!Array.isArray(responseData)) {
        return;
      }
      var mapObjects = this.createMapObjects(responseData);
      if (this.centerMarker) {
        this.attachCenterMarkers(mapObjects);
      }
      this.clearMapObjects();
      this.placeMapObjects(mapObjects);
      this.updatePopup(mapObjects);
    },
    setVisible: function setVisible(visible) {
      if (this.useVisibleHandler) {
        this.$emit("handle-visible", visible);
        return;
      }
      var map = this.getMap();
      if (visible) {
        map.addLayer(this.mapObject);
      } else {
        map.removeLayer(this.mapObject);
      }
    },
    setUseVisibleHandler: function setUseVisibleHandler(value) {
      this.useVisibleHandler = value;
    },
    makeClusterIcon: function makeClusterIcon(cluster) {
      return this.clusterIconFactory ? this.clusterIconFactory(cluster.getChildCount()) : null;
    },
    makeSuperClusterIcon: function makeSuperClusterIcon(cluster) {
      return this.clusterIconFactory ? this.clusterIconFactory(cluster.count) : null;
    },
    createMapObjects: function createMapObjects(items) {
      var result = [];
      for (var i = 0, size = items.length; i < size; i++) {
        var mapObject = this.createMapObject(items[i]);
        if (mapObject) {
          result.push(mapObject);
        }
      }
      return result;
    },
    createMapObject: function createMapObject(itemData) {
      try {
        var geometry = itemData[this.geometryField];
        var itemPathStyle = itemData[this.pathStyleField];
        var pathClassName = itemData[this.pathClassField];
        var options = pathClassName ? {
          className: pathClassName
        } : undefined;
        var mapObject = external_leaflet_["GeoJSON"].geometryToLayer(geometry, options);
        mapObject.options.data = itemData;
        if (this.markerPane && typeof mapObject.getLatLng === "function") {
          mapObject.options.pane = this.markerPane;
        }
        if (this.markerIcon && typeof mapObject.setIcon === "function") {
          mapObject.setIcon(this.markerIcon);
        } else if (this.pathStyle && typeof mapObject.setStyle === "function") {
          mapObject.setStyle(itemPathStyle ? _objectSpread2(_objectSpread2({}, this.pathStyle), itemPathStyle) : this.pathStyle);
        }
        return mapObject;
      } catch (e) {
        logger.error(e);
        return null;
      }
    },
    placeMapObjects: function placeMapObjects(mapObjects) {
      if (this.clustering && typeof this.mapObject.addLayers === "function") {
        this.mapObject.addLayers(mapObjects);
      } else {
        for (var i = 0, size = mapObjects.length; i < size; i++) {
          this.mapObject.addLayer(mapObjects[i]);
        }
      }
    },
    clearMapObjects: function clearMapObjects() {
      if (this.clustering) {
        var map = this.getMap();
        if (map.hasLayer(this.mapObject)) {
          this.mapObject.clearLayers();
        } else {
          this.mapObject._map = map;
          this.mapObject.clearLayers();
          this.mapObject._map = null;
        }
      } else {
        this.mapObject.clearLayers();
      }
    },
    attachCenterMarkers: function attachCenterMarkers(mapObjects) {
      for (var i = 0, size = mapObjects.length; i < size; i++) {
        var mapObject = mapObjects[i];
        if (external_leaflet_["leafletUtil"].isPath(mapObject)) {
          var centerMarker = this.createCenterMarker(mapObject.options.data);
          centerMarker.attachTo(mapObject);
        }
      }
    },
    createCenterMarker: function createCenterMarker(itemData) {
      var mapObject = Object(external_leaflet_["pathCenterMarker"])();
      mapObject.options.data = itemData;
      if (this.markerPane) {
        mapObject.options.pane = this.markerPane;
      }
      if (this.markerIcon) {
        mapObject.setIcon(this.markerIcon);
      }
      return mapObject;
    },
    setMarkerIcon: function setMarkerIcon(value) {
      this.markerIcon = value;
    },
    getMarkerIcon: function getMarkerIcon() {
      return this.markerIcon;
    },
    setClusterIconFactory: function setClusterIconFactory(value) {
      this.clusterIconFactory = value;
    },
    setPathStyle: function setPathStyle(value) {
      this.pathStyle = value;
    },
    getPathStyle: function getPathStyle() {
      return this.pathStyle;
    },
    isVisible: function isVisible() {
      return this.dataVisible;
    },
    getData: function getData() {
      return this.mapObject ? this.mapObject.getLayers().map(function (l) {
        return l.options.data;
      }) : [];
    },
    getMapObject: function getMapObject() {
      return this.mapObject;
    },
    listenEvent: function listenEvent(event, listener) {
      var unsubscribe = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      if (unsubscribe) {
        this.$off(event, listener);
      } else {
        this.$on(event, listener);
      }
    },
    removeFromMap: function removeFromMap() {
      if (this._isDestroyed || !this.mapObject) return;
      var map = this.getMap();
      map.removeLayer(this.mapObject);
    },
    addToMap: function addToMap() {
      if (this._isDestroyed || !this.mapObject) return;
      var map = this.getMap();
      map.addLayer(this.mapObject);
    },
    getId: function getId() {
      return this.id;
    },
    stylesChanged: function stylesChanged() {
      var _this3 = this;
      this.$nextTick(function () {
        _this3.invalidateAndFetch();
      });
    },
    handleGroupClick: function handleGroupClick(e) {
      /**
       * @type {object}
       */
      this.$emit("object:click", _objectSpread2(_objectSpread2({}, e), {}, {
        layerId: this.id
      }));
    },
    handleClusterClick: function handleClusterClick(e) {
      var target = e.originalEvent.target,
        layer = e.layer;
      var cluster = {};
      this.wrapCluster(cluster, layer);
      var countAttrValue = null;
      if (this.clusterCountAttr) {
        countAttrValue = target.getAttribute(this.clusterCountAttr);
      }
      if (countAttrValue) {
        var count = parseInt(countAttrValue);
        if (isNaN(count)) {
          count = null;
        }
        /**
         * @type {object}
         */
        this.$emit("cluster:count", _objectSpread2(_objectSpread2({}, e), {}, {
          count: count,
          cluster: cluster,
          layerId: this.id,
          preventClick: function preventClick() {
            e._prevented = true;
          }
        }));
      } else {
        /**
         * @type {object}
         */
        this.$emit("cluster:click", _objectSpread2(_objectSpread2({}, e), {}, {
          cluster: cluster,
          layerId: this.id,
          preventClick: function preventClick() {
            e._prevented = true;
          }
        }));
      }
    },
    wrapCluster: function wrapCluster(cluster, layer) {
      if (typeof layer.getAllChildMarkers === "function") {
        cluster.getMarkers = function () {
          return layer.getAllChildMarkers();
        };
      }
      if (typeof layer.getMarkersDataAsync === "function") {
        cluster.getMarkersDataAsync = function () {
          return layer.getMarkersDataAsync();
        };
      }
    },
    handlePopupEditPressed: function handlePopupEditPressed(itemData) {
      /**
       * @type {object}
       */
      this.$emit("popup:edit", {
        layerId: this.id,
        popup: this.mapObject.getPopup(),
        data: _objectSpread2({}, itemData)
      });
    },
    handlePopupDeletePressed: function handlePopupDeletePressed(itemData) {
      /**
       * @type {object}
       */
      this.$emit("popup:delete", {
        layerId: this.id,
        popup: this.mapObject.getPopup(),
        data: _objectSpread2({}, itemData)
      });
    },
    handlePopupDetailsPressed: function handlePopupDetailsPressed(itemData) {
      /**
       * @type {object}
       */
      this.$emit("popup:details", {
        layerId: this.id,
        popup: this.mapObject.getPopup(),
        data: _objectSpread2({}, itemData)
      });
    },
    handleFilterPressed: function handleFilterPressed() {
      /**
       * @type {object}
       */
      this.$emit("filter", {
        layerId: this.id
      });
    },
    handleCountPressed: function handleCountPressed(e) {
      /**
       * @type {object}
       */
      this.$emit("count:click", _objectSpread2(_objectSpread2({}, e), {}, {
        layerId: this.id
      }));
    },
    handleError: function handleError(e) {
      logger.error(e.error);
    },
    handleDataLoaded: function handleDataLoaded(e) {
      this.dataCount = e.count || 0;
      /**
       * @type {number}
       */
      this.$emit("update:count", this.dataCount);
    }
  }
});
// CONCATENATED MODULE: ./src/components/map/v-map-client-layer.vue?vue&type=script&lang=js&
 /* harmony default export */ var map_v_map_client_layervue_type_script_lang_js_ = (v_map_client_layervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/map/v-map-client-layer.vue?vue&type=custom&index=0&blockType=docs
var v_map_client_layervue_type_custom_index_0_blockType_docs = __webpack_require__("feb3");
var v_map_client_layervue_type_custom_index_0_blockType_docs_default = /*#__PURE__*/__webpack_require__.n(v_map_client_layervue_type_custom_index_0_blockType_docs);

// EXTERNAL MODULE: ./src/components/map/v-map-client-layer.vue?vue&type=custom&index=1&blockType=docs
var v_map_client_layervue_type_custom_index_1_blockType_docs = __webpack_require__("4198");
var v_map_client_layervue_type_custom_index_1_blockType_docs_default = /*#__PURE__*/__webpack_require__.n(v_map_client_layervue_type_custom_index_1_blockType_docs);

// CONCATENATED MODULE: ./src/components/map/v-map-client-layer.vue





/* normalize component */

var v_map_client_layer_component = normalizeComponent(
  map_v_map_client_layervue_type_script_lang_js_,
  v_map_client_layervue_type_template_id_20962bf8_render,
  v_map_client_layervue_type_template_id_20962bf8_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */

if (typeof v_map_client_layervue_type_custom_index_0_blockType_docs_default.a === 'function') v_map_client_layervue_type_custom_index_0_blockType_docs_default()(v_map_client_layer_component)

if (typeof v_map_client_layervue_type_custom_index_1_blockType_docs_default.a === 'function') v_map_client_layervue_type_custom_index_1_blockType_docs_default()(v_map_client_layer_component)

/* harmony default export */ var v_map_client_layer = (v_map_client_layer_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/v-map-fit-handler.vue?vue&type=script&lang=js&



var v_map_fit_handlervue_type_script_lang_js_eventName = "vmap:fit:geometry";
/* harmony default export */ var v_map_fit_handlervue_type_script_lang_js_ = ({
  name: "v-map-fit-handler",
  inject: ["getMap"],
  props: {
    coverPanelClassName: {
      type: String,
      default: "v-map-sidebar"
    },
    coverPanelOpenClassName: {
      type: String,
      default: "v-map-sidebar--open"
    },
    coverRight: {
      type: Boolean,
      default: false
    },
    customPaddingFn: {
      type: Function,
      default: null
    },
    pointAroundMeters: {
      type: Number,
      default: 500
    }
  },
  mounted: function mounted() {
    var map = this.getMap();
    map.on(v_map_fit_handlervue_type_script_lang_js_eventName, this.handleFitBounds);
  },
  beforeDestroy: function beforeDestroy() {
    var map = this.getMap();
    map.off(v_map_fit_handlervue_type_script_lang_js_eventName, this.handleFitBounds);
  },
  methods: {
    handleFitBounds: function handleFitBounds(_ref) {
      var value = _ref.value;
      if (!value) return;
      this.fitBounds(value);
    },
    fitGeometry: function fitGeometry(geometry) {
      var pointAroundMeters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      try {
        var map = this.getMap();
        external_leaflet_["leafletUtil"].fitGeometry(map, geometry, pointAroundMeters !== null && pointAroundMeters !== void 0 ? pointAroundMeters : this.pointAroundMeters, this.getPadding());
      } catch (e) {
        logger.error(e);
      }
    },
    fitBounds: function fitBounds(bounds) {
      var map = this.getMap();
      external_leaflet_["leafletUtil"].fitBounds(map, bounds, this.getPadding());
    },
    fitPoint: function fitPoint(latLng) {
      var pointAroundMeters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var map = this.getMap();
      external_leaflet_["leafletUtil"].fitPoint(map, latLng, pointAroundMeters !== null && pointAroundMeters !== void 0 ? pointAroundMeters : this.pointAroundMeters, this.getPadding());
    },
    getPadding: function getPadding() {
      if (this.customPaddingFn) return this.customPaddingFn();
      if (this.coverPanelClassName) {
        var map = this.getMap();
        if (!map.getContainer()) return null;
        var container = map.getContainer();
        var coverElement = container.querySelector(".".concat(this.coverPanelClassName));
        if (coverElement && external_leaflet_["DomUtil"].hasClass(container, this.coverPanelOpenClassName)) {
          var _coverElement$getBoun = coverElement.getBoundingClientRect(),
            width = _coverElement$getBoun.width;
          return this.coverRight ? {
            right: width
          } : {
            left: width
          };
        }
      }
      return null;
    }
  },
  render: function render() {
    return null;
  }
});
// CONCATENATED MODULE: ./src/components/map/v-map-fit-handler.vue?vue&type=script&lang=js&
 /* harmony default export */ var map_v_map_fit_handlervue_type_script_lang_js_ = (v_map_fit_handlervue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/map/v-map-fit-handler.vue
var v_map_fit_handler_render, v_map_fit_handler_staticRenderFns




/* normalize component */

var v_map_fit_handler_component = normalizeComponent(
  map_v_map_fit_handlervue_type_script_lang_js_,
  v_map_fit_handler_render,
  v_map_fit_handler_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var v_map_fit_handler = (v_map_fit_handler_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"443a82ff-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/v-map-search-marker-icon.vue?vue&type=template&id=bc63b6ea&
var v_map_search_marker_iconvue_type_template_id_bc63b6ea_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('v-map-marker-icon', [_c('div', {
    staticClass: "v-map-marker__wrap v-map-marker__wrap--primary"
  }, [_c('v-search-pin-icon', {
    staticClass: "v-map-marker__pin"
  })], 1)]);
};
var v_map_search_marker_iconvue_type_template_id_bc63b6ea_staticRenderFns = [];

// CONCATENATED MODULE: ./src/components/map/v-map-search-marker-icon.vue?vue&type=template&id=bc63b6ea&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"443a82ff-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/icons/v-search-pin-icon.vue?vue&type=template&id=6d32c1b5&
var v_search_pin_iconvue_type_template_id_6d32c1b5_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('svg', {
    staticClass: "v-map-svg",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 32 46"
    }
  }, [_c('g', {
    attrs: {
      "transform": "translate(-960 -322)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M1454,395a15.948,15.948,0,0,0-11.314,4.716A16.152,16.152,0,0,0,1438,411.1c0,12.075,16,29.9,16,29.9s16-17.825,16-29.9a16.152,16.152,0,0,0-4.686-11.384A15.949,15.949,0,0,0,1454,395Zm0,21.85a5.7,5.7,0,0,1-4.041-1.684,5.777,5.777,0,0,1,0-8.132,5.691,5.691,0,0,1,8.082,0,5.759,5.759,0,0,1-1.854,9.378A5.688,5.688,0,0,1,1454,416.85Z",
      "transform": "translate(-478 -73)",
      "fill": "currentColor"
    }
  }), _c('path', {
    attrs: {
      "d": "M11,0A11.258,11.258,0,0,1,22,11.5,11.258,11.258,0,0,1,11,23,11.258,11.258,0,0,1,0,11.5,11.258,11.258,0,0,1,11,0Z",
      "transform": "translate(965 327)",
      "fill": "#fff"
    }
  })])]);
};
var v_search_pin_iconvue_type_template_id_6d32c1b5_staticRenderFns = [];

// CONCATENATED MODULE: ./src/components/map/icons/v-search-pin-icon.vue?vue&type=template&id=6d32c1b5&

// CONCATENATED MODULE: ./src/components/map/icons/v-search-pin-icon.vue

var v_search_pin_icon_script = {}


/* normalize component */

var v_search_pin_icon_component = normalizeComponent(
  v_search_pin_icon_script,
  v_search_pin_iconvue_type_template_id_6d32c1b5_render,
  v_search_pin_iconvue_type_template_id_6d32c1b5_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var v_search_pin_icon = (v_search_pin_icon_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/v-map-search-marker-icon.vue?vue&type=script&lang=js&


/* harmony default export */ var v_map_search_marker_iconvue_type_script_lang_js_ = ({
  name: "v-map-search-marker-icon",
  components: {
    VSearchPinIcon: v_search_pin_icon,
    VMapMarkerIcon: v_map_marker_icon
  }
});
// CONCATENATED MODULE: ./src/components/map/v-map-search-marker-icon.vue?vue&type=script&lang=js&
 /* harmony default export */ var map_v_map_search_marker_iconvue_type_script_lang_js_ = (v_map_search_marker_iconvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/map/v-map-search-marker-icon.vue





/* normalize component */

var v_map_search_marker_icon_component = normalizeComponent(
  map_v_map_search_marker_iconvue_type_script_lang_js_,
  v_map_search_marker_iconvue_type_template_id_bc63b6ea_render,
  v_map_search_marker_iconvue_type_template_id_bc63b6ea_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var v_map_search_marker_icon = (v_map_search_marker_icon_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"443a82ff-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/v-map-search-popup.vue?vue&type=template&id=81e12b90&


var v_map_search_popupvue_type_template_id_81e12b90_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('v-map-popup', {
    attrs: {
      "close-on-click": _vm.closeOnClick
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var content = _ref.content;
        return [_c('v-map-popup-content', {
          attrs: {
            "title": content.title
          },
          scopedSlots: _vm._u([{
            key: "icon",
            fn: function fn() {
              return [_c('v-search-pin-icon')];
            },
            proxy: true
          }, {
            key: "other-content",
            fn: function fn() {
              return [_c('div', {
                staticClass: "v-map-popup__description"
              }, [content.subtitle ? _c('div', {
                staticClass: "v-map-search-popup__subtitle"
              }, [_vm._v(" " + _vm._s(content.subtitle) + " ")]) : _vm._e(), content.description ? _c('div', {
                staticClass: "v-map-search-popup__description"
              }, [_vm._v(" " + _vm._s(content.description) + " ")]) : _vm._e(), content.coords ? _c('div', {
                staticClass: "v-map-search-popup__coords"
              }, [_vm._v(" " + _vm._s(content.coords) + " ")]) : _vm._e()])];
            },
            proxy: true
          }], null, true)
        })];
      }
    }])
  });
};
var v_map_search_popupvue_type_template_id_81e12b90_staticRenderFns = [];

// CONCATENATED MODULE: ./src/components/map/v-map-search-popup.vue?vue&type=template&id=81e12b90&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/v-map-search-popup.vue?vue&type=script&lang=js&



/* harmony default export */ var v_map_search_popupvue_type_script_lang_js_ = ({
  name: "v-map-search-popup",
  components: {
    VMapPopup: v_map_popup,
    VMapPopupContent: v_map_popup_content,
    VSearchPinIcon: v_search_pin_icon
  },
  props: {
    closeOnClick: {
      type: Boolean,
      default: undefined
    }
  }
});
// CONCATENATED MODULE: ./src/components/map/v-map-search-popup.vue?vue&type=script&lang=js&
 /* harmony default export */ var map_v_map_search_popupvue_type_script_lang_js_ = (v_map_search_popupvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/map/v-map-search-popup.vue





/* normalize component */

var v_map_search_popup_component = normalizeComponent(
  map_v_map_search_popupvue_type_script_lang_js_,
  v_map_search_popupvue_type_template_id_81e12b90_render,
  v_map_search_popupvue_type_template_id_81e12b90_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var v_map_search_popup = (v_map_search_popup_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/controls/v-map-search-control.vue?vue&type=script&lang=js&





















var defaultPathStyles = {
  backgroundColor: "#dc8c5d",
  borderColor: "#dc8c5d",
  borderOpacity: 0.8
};
var emptyDataSource = function emptyDataSource() {
  return Promise.resolve([]);
};
/* harmony default export */ var v_map_search_controlvue_type_script_lang_js_ = ({
  name: "v-map-search-control",
  inject: ["getMap"],
  components: {
    VMapClientLayer: v_map_client_layer,
    VMapFitHandler: v_map_fit_handler,
    VMapSearchMarkerIcon: v_map_search_marker_icon,
    VMapSearchPopup: v_map_search_popup
  },
  props: {
    position: {
      type: String,
      default: "topleft"
    },
    title: {
      type: String,
      default: function _default() {
        return utils_locale.default.searchTitle;
      }
    },
    placeholder: {
      type: String,
      default: function _default() {
        return utils_locale.default.searchPlaceHint;
      }
    },
    popupTitle: {
      type: String,
      default: function _default() {
        return utils_locale.default.searchPopupTitle;
      }
    },
    visible: {
      type: Boolean,
      default: true
    },
    /**
     * sync
     */
    open: {
      type: Boolean,
      default: false
    },
    /**
     * sync
     */
    query: {
      type: String,
      default: ""
    },
    dataSource: {
      type: Function,
      default: null
    },
    fetchDelay: {
      type: Number,
      default: 500
    },
    openPopupDelay: {
      type: Number,
      default: 500
    },
    fitPointAround: {
      type: Number,
      default: 500
    },
    pathStyles: {
      type: Object,
      default: function _default() {
        return _objectSpread2({}, defaultPathStyles);
      }
    },
    closePopupOnClick: {
      type: Boolean,
      default: undefined
    }
  },
  data: function data() {
    return {
      dataOpen: this.open,
      dataQuery: this.query,
      dropdownOpen: false,
      loading: false,
      error: false,
      resultItems: [],
      inputInFocus: false,
      layerDataSource: emptyDataSource
    };
  },
  computed: {
    search: function search() {
      return external_debounce_default()(this.reloadData, this.fetchDelay);
    }
  },
  watch: {
    open: function open() {
      this.dataOpen = this.open;
    },
    query: function query() {
      this.dataQuery = this.query;
    },
    dataOpen: function dataOpen() {
      /**
       * @type {boolean}
       */
      this.$emit("update:open", this.dataOpen);
    },
    dataQuery: function dataQuery() {
      /**
       * @type {string}
       */
      this.$emit("update:query", this.dataQuery);
      this.search();
    },
    dataSource: function dataSource() {
      this.reloadData();
    }
  },
  created: function created() {
    if (this.dataOpen) {
      this.reloadData();
    }
  },
  mounted: function mounted() {
    var map = this.getMap();
    this.mapObject = new external_leaflet_["LeafletControl"]({
      position: this.position,
      onAdd: this.handleControlAdd
    });
    this.mapObject.addTo(map);
    external_leaflet_["DomEvent"].disableClickPropagation(this.$refs.container);
    external_leaflet_["DomEvent"].disableScrollPropagation(this.$refs.container);
  },
  beforeDestroy: function beforeDestroy() {
    if (this.mapObject) {
      this.mapObject.remove();
    }
  },
  methods: {
    reloadData: function reloadData() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.fetchData();
              case 2:
                result = _context.sent;
                _this.resultItems = _this.dataOpen ? result : [];
                _this.dropdownOpen = _this.isOpenDropdown();
              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    fetchData: function fetchData() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var response;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                if (_this2.canFetchData()) {
                  _context2.next = 3;
                  break;
                }
                return _context2.abrupt("return", []);
              case 3:
                _this2.loading = true;
                _this2.error = false;
                _context2.next = 7;
                return _this2.dataSource(_this2.dataQuery, parse_latlng(_this2.dataQuery), _this2.getMapZoom());
              case 7:
                response = _context2.sent;
                if (!_this2._isDestroyed) {
                  _context2.next = 10;
                  break;
                }
                return _context2.abrupt("return", []);
              case 10:
                _this2.loading = false;
                return _context2.abrupt("return", (response || []).map(_this2.toResultItem));
              case 14:
                _context2.prev = 14;
                _context2.t0 = _context2["catch"](0);
                if (!is_cancel(_context2.t0)) {
                  _context2.next = 18;
                  break;
                }
                return _context2.abrupt("return");
              case 18:
                logger.error(_context2.t0);
                _this2.loading = false;
                _this2.error = true;
                return _context2.abrupt("return", []);
              case 22:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 14]]);
      }))();
    },
    toResultItem: function toResultItem(_ref) {
      var title = _ref.title,
        description = _ref.description,
        displayTitle = _ref.displayTitle,
        displaySubtitle = _ref.displaySubtitle,
        coords = _ref.coords,
        geometry = _ref.geometry,
        pointAround = _ref.pointAround;
      return {
        title: title,
        description: description,
        displayTitle: displayTitle !== null && displayTitle !== void 0 ? displayTitle : title,
        displaySubtitle: displaySubtitle !== null && displaySubtitle !== void 0 ? displaySubtitle : description,
        coords: coords,
        geometry: geometry,
        pointAround: pointAround
      };
    },
    canFetchData: function canFetchData() {
      return typeof this.dataSource === "function";
    },
    isOpenDropdown: function isOpenDropdown() {
      return this.resultItems.length > 0 && this.dataOpen && this.inputInFocus;
    },
    toggleSearchBar: function toggleSearchBar(e) {
      this.dataOpen = !this.dataOpen;
      if (!this.dataOpen) {
        this.resetSearch();
      }
    },
    resetSearch: function resetSearch() {
      this.resultItems = [];
      this.dropdownOpen = false;
      this.setResultItem(null);
    },
    getMapZoom: function getMapZoom() {
      var _map$getZoom;
      var map = this.getMap();
      return (_map$getZoom = map === null || map === void 0 ? void 0 : map.getZoom()) !== null && _map$getZoom !== void 0 ? _map$getZoom : undefined;
    },
    handleControlAdd: function handleControlAdd() {
      return this.$el;
    },
    handleInputFocusIn: function handleInputFocusIn() {
      this.inputInFocus = true;
      this.dropdownOpen = this.isOpenDropdown();
    },
    handleInputFocusOut: function handleInputFocusOut() {
      this.inputInFocus = false;
      this.dropdownOpen = false;
    },
    handleItemClick: function handleItemClick(item) {
      this.setResultItem(item);
    },
    handleLayerDataChanged: function handleLayerDataChanged(_ref2) {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var data, _this3$$refs, fit, clientLayer, _data$, geometry, id, pointAround;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                data = _ref2.data;
                if (!(data.length && data[0])) {
                  _context3.next = 8;
                  break;
                }
                _this3$$refs = _this3.$refs, fit = _this3$$refs.fit, clientLayer = _this3$$refs.clientLayer;
                _data$ = data[0], geometry = _data$.geometry, id = _data$.id, pointAround = _data$.pointAround;
                fit.fitGeometry(geometry, pointAround);
                _context3.next = 7;
                return delay(_this3.openPopupDelay);
              case 7:
                clientLayer.openPopup(id);
              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    setResultItem: function setResultItem(resultItem) {
      var _this4 = this;
      this.closePopup();
      if (resultItem) {
        var title = resultItem.title,
          description = resultItem.description,
          coords = resultItem.coords,
          geometry = resultItem.geometry,
          pointAround = resultItem.pointAround;
        this.layerDataSource = function () {
          return Promise.resolve([{
            id: 1,
            title: _this4.popupTitle,
            subtitle: title,
            description: description,
            coords: coords,
            geometry: geometry,
            pointAround: pointAround
          }]);
        };
        this.dataQuery = title;
      } else {
        this.dataQuery = "";
        this.layerDataSource = emptyDataSource;
      }
    },
    closePopup: function closePopup() {
      this.$refs.clientLayer.closePopup();
    }
  }
});
// CONCATENATED MODULE: ./src/components/map/controls/v-map-search-control.vue?vue&type=script&lang=js&
 /* harmony default export */ var controls_v_map_search_controlvue_type_script_lang_js_ = (v_map_search_controlvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/map/controls/v-map-search-control.vue?vue&type=custom&index=0&blockType=docs
var v_map_search_controlvue_type_custom_index_0_blockType_docs = __webpack_require__("e31d");
var v_map_search_controlvue_type_custom_index_0_blockType_docs_default = /*#__PURE__*/__webpack_require__.n(v_map_search_controlvue_type_custom_index_0_blockType_docs);

// EXTERNAL MODULE: ./src/components/map/controls/v-map-search-control.vue?vue&type=custom&index=1&blockType=docs
var v_map_search_controlvue_type_custom_index_1_blockType_docs = __webpack_require__("133c");
var v_map_search_controlvue_type_custom_index_1_blockType_docs_default = /*#__PURE__*/__webpack_require__.n(v_map_search_controlvue_type_custom_index_1_blockType_docs);

// CONCATENATED MODULE: ./src/components/map/controls/v-map-search-control.vue





/* normalize component */

var v_map_search_control_component = normalizeComponent(
  controls_v_map_search_controlvue_type_script_lang_js_,
  v_map_search_controlvue_type_template_id_a99c1668_render,
  v_map_search_controlvue_type_template_id_a99c1668_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */

if (typeof v_map_search_controlvue_type_custom_index_0_blockType_docs_default.a === 'function') v_map_search_controlvue_type_custom_index_0_blockType_docs_default()(v_map_search_control_component)

if (typeof v_map_search_controlvue_type_custom_index_1_blockType_docs_default.a === 'function') v_map_search_controlvue_type_custom_index_1_blockType_docs_default()(v_map_search_control_component)

/* harmony default export */ var v_map_search_control = (v_map_search_control_component.exports);
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
// CONCATENATED MODULE: ./src/utils/make-cancel.js



var make_cancel_Cancel = /*#__PURE__*/function () {
  function Cancel(message) {
    _classCallCheck(this, Cancel);
    _defineProperty(this, "__CANCEL__", true);
    this.message = message;
  }
  _createClass(Cancel, [{
    key: "toString",
    value: function toString() {
      return 'Cancel' + (this.message ? ': ' + this.message : '');
    }
  }]);
  return Cancel;
}();
/* harmony default export */ var make_cancel = (function (message) {
  return new make_cancel_Cancel(message);
});
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.to-fixed.js
var es_number_to_fixed = __webpack_require__("b680");

// CONCATENATED MODULE: ./src/utils/format-latlng.js


/* harmony default export */ var format_latlng = (function (latlng) {
  return "".concat(parseFloat(latlng[0].toFixed(6)), ", ").concat(parseFloat(latlng[1].toFixed(6)));
});
// CONCATENATED MODULE: ./src/utils/index.js







var leafletUtil = external_leaflet_default.a.leafletUtil;

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/controls/v-map-scale-control.vue?vue&type=script&lang=js&



/* harmony default export */ var v_map_scale_controlvue_type_script_lang_js_ = ({
  name: "v-map-scale-control",
  inject: ["getMap"],
  props: {
    position: {
      type: String,
      default: "bottomright"
    },
    maxWidth: {
      type: Number,
      default: 100
    },
    metric: {
      type: Boolean,
      default: false
    },
    imperial: {
      type: Boolean,
      default: false
    },
    custom: {
      type: Boolean,
      default: true
    },
    updateWhenIdle: {
      type: Boolean,
      default: true
    },
    messageUnits: {
      type: Object,
      default: function _default() {
        return utils_locale.default.units;
      }
    }
  },
  mounted: function mounted() {
    var map = this.getMap();
    this.mapObject = external_leaflet_["control"].customScale({
      position: this.position,
      maxWidth: this.maxWidth,
      metric: this.metric,
      imperial: this.imperial,
      custom: this.custom,
      updateWhenIdle: this.updateWhenIdle,
      messages: {
        units: this.messageUnits
      }
    });
    this.mapObject.addTo(map);
  },
  beforeDestroy: function beforeDestroy() {
    if (this.mapObject) {
      this.mapObject.remove();
    }
  },
  render: function render() {
    return null;
  }
});
// CONCATENATED MODULE: ./src/components/map/controls/v-map-scale-control.vue?vue&type=script&lang=js&
 /* harmony default export */ var controls_v_map_scale_controlvue_type_script_lang_js_ = (v_map_scale_controlvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/map/controls/v-map-scale-control.vue
var v_map_scale_control_render, v_map_scale_control_staticRenderFns




/* normalize component */

var v_map_scale_control_component = normalizeComponent(
  controls_v_map_scale_controlvue_type_script_lang_js_,
  v_map_scale_control_render,
  v_map_scale_control_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var v_map_scale_control = (v_map_scale_control_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"443a82ff-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/v-map-server-layer.vue?vue&type=template&id=249d811c&
var v_map_server_layervue_type_template_id_249d811c_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('v-map-tree-layer', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.presentation(),
      expression: "presentation()"
    }],
    attrs: {
      "title": _vm.title,
      "count": _vm.dataCount,
      "filtering": _vm.filtering,
      "filter-active": _vm.filterActive,
      "disabled": _vm.disabled,
      "selection": _vm.selection,
      "selected": _vm.dataSelected,
      "visible": _vm.dataVisible,
      "icon-color": _vm.styles[_vm.iconColorField]
    },
    on: {
      "update:selected": function updateSelected($event) {
        _vm.dataSelected = $event;
      },
      "update:visible": function updateVisible($event) {
        _vm.dataVisible = $event;
      },
      "filter": _vm.handleFilterPressed,
      "count": _vm.handleCountPressed
    },
    scopedSlots: _vm._u([{
      key: "icon",
      fn: function fn() {
        return [_vm._t("icon")];
      },
      proxy: true
    }, {
      key: "other",
      fn: function fn() {
        return [_vm._t("marker-icon", function () {
          return [_c('v-map-marker-icon', {
            attrs: {
              "color": _vm.styles[_vm.iconColorField]
            },
            scopedSlots: _vm._u([{
              key: "icon",
              fn: function fn() {
                return [_vm._t("icon")];
              },
              proxy: true
            }], null, true)
          })];
        }), _vm._t("path-style", function () {
          return [_c('v-map-path-style', {
            attrs: {
              "styles": _vm.styles
            }
          })];
        }), _vm._t("cluster-icon", function () {
          return [_c('v-map-cluster-icon', {
            attrs: {
              "color": _vm.styles[_vm.iconColorField]
            },
            scopedSlots: _vm._u([{
              key: "icon",
              fn: function fn() {
                return [_vm._t("icon")];
              },
              proxy: true
            }], null, true)
          })];
        }), _vm._t("popup", function () {
          return [_c('v-map-popup', {
            scopedSlots: _vm._u([{
              key: "default",
              fn: function fn(_ref) {
                var content = _ref.content;
                return [_c('v-map-popup-content', {
                  attrs: {
                    "title": content[_vm.titleField],
                    "description": content[_vm.descriptionField],
                    "icon-color": _vm.styles[_vm.iconColorField],
                    "show-edit": _vm.popupShowEdit,
                    "show-delete": _vm.popupShowDelete,
                    "show-details": _vm.popupShowDetails,
                    "with-confirm-delete": _vm.popupShowDelete
                  },
                  on: {
                    "edit": function edit($event) {
                      return _vm.handlePopupEditPressed(content);
                    },
                    "delete": function _delete($event) {
                      return _vm.handlePopupDeletePressed(content);
                    },
                    "details": function details($event) {
                      return _vm.handlePopupDetailsPressed(content);
                    }
                  },
                  scopedSlots: _vm._u([{
                    key: "icon",
                    fn: function fn() {
                      return [_vm._t("icon")];
                    },
                    proxy: true
                  }], null, true)
                })];
              }
            }])
          })];
        }), _vm.selection && _vm.singleSelection && _vm.selectionKey ? _vm._t("single-selection", function () {
          return [_c('v-map-single-selection', {
            attrs: {
              "name": _vm.selectionKey,
              "selected": _vm.dataSelected
            },
            on: {
              "update:selected": function updateSelected($event) {
                _vm.dataSelected = $event;
              }
            }
          })];
        }) : _vm._e(), _vm.groupCountKey ? _vm._t("group-count", function () {
          return [_c('v-map-group-count', {
            attrs: {
              "name": _vm.groupCountKey,
              "count": _vm.dataCount
            }
          })];
        }) : _vm._e(), _vm.groupVisibleKey ? _vm._t("group-visible", function () {
          return [_c('v-map-group-visible', {
            attrs: {
              "name": _vm.groupVisibleKey,
              "visible": _vm.dataVisible
            },
            on: {
              "update:visible": function updateVisible($event) {
                _vm.dataVisible = $event;
              }
            }
          })];
        }) : _vm._e(), _vm._t("default")];
      },
      proxy: true
    }], null, true)
  });
};
var v_map_server_layervue_type_template_id_249d811c_staticRenderFns = [];

// CONCATENATED MODULE: ./src/components/map/v-map-server-layer.vue?vue&type=template&id=249d811c&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/v-map-server-layer.vue?vue&type=script&lang=js&






















/* harmony default export */ var v_map_server_layervue_type_script_lang_js_ = ({
  name: "v-map-server-layer",
  mixins: [popup_mixin],
  inject: ["getMap", "presentation"],
  provide: function provide() {
    return {
      setMarkerIcon: this.setMarkerIcon,
      setPathStyle: this.setPathStyle,
      setClusterIconFactory: this.setClusterIconFactory,
      getMarkerIcon: this.getMarkerIcon,
      getPathStyle: this.getPathStyle,
      bindPopup: this.bindPopup,
      unbindPopup: this.unbindPopup,
      getData: this.getData,
      isVisible: this.isVisible,
      setUseVisibleHandler: this.setUseVisibleHandler,
      removeFromMap: this.removeFromMap,
      addToMap: this.addToMap,
      getMapObject: this.getMapObject,
      listenEvent: this.listenEvent,
      getId: this.getId
    };
  },
  components: {
    VMapMarkerIcon: v_map_marker_icon,
    VMapClusterIcon: v_map_cluster_icon,
    VMapPathStyle: v_map_path_style,
    VMapPopup: v_map_popup,
    VMapPopupContent: v_map_popup_content,
    VMapTreeLayer: v_map_tree_layer,
    VMapSingleSelection: v_map_single_selection,
    VMapGroupCount: v_map_group_count,
    VMapGroupVisible: v_map_group_visible
  },
  props: {
    id: {
      type: [String, Number],
      default: null
    },
    title: {
      type: String,
      default: null
    },
    /**
     * sync
     */
    visible: {
      type: Boolean,
      default: true
    },
    /**
     * sync
     */
    selected: {
      type: Boolean,
      default: false
    },
    /**
     * sync
     */
    invalidate: {
      type: Boolean,
      default: true
    },
    /**
     * sync
     */
    countInvalidate: {
      type: Boolean,
      default: true
    },
    /**
     * sync
     */
    fetching: {
      type: Boolean,
      default: false
    },
    filtering: {
      type: Boolean,
      default: false
    },
    filterActive: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    clientClustering: {
      type: Boolean,
      default: false
    },
    clientClusterOptions: {
      type: Object,
      default: null
    },
    minFetchZoom: {
      type: Number,
      default: null
    },
    maxFetchZoom: {
      type: Number,
      default: null
    },
    /**
     * sync
     */
    count: {
      type: Number,
      default: 0
    },
    dataSource: {
      type: Object,
      default: null
    },
    styles: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    markerPane: {
      type: String,
      default: null
    },
    centerMarker: {
      type: Boolean,
      default: true
    },
    geometryField: {
      type: String,
      default: "geometry"
    },
    clusterField: {
      type: String,
      default: "isCluster"
    },
    countField: {
      type: String,
      default: "count"
    },
    iconColorField: {
      type: String,
      default: "iconColor"
    },
    idField: {
      type: String,
      default: "id"
    },
    titleField: {
      type: String,
      default: "title"
    },
    descriptionField: {
      type: String,
      default: "description"
    },
    equalsFn: {
      type: Function,
      default: null
    },
    popupShowEdit: {
      type: Boolean,
      default: false
    },
    popupShowDelete: {
      type: Boolean,
      default: false
    },
    popupShowDetails: {
      type: Boolean,
      default: true
    },
    selection: {
      type: Boolean,
      default: true
    },
    singleSelection: {
      type: Boolean,
      default: true
    },
    selectionKey: {
      type: String,
      default: "maplayer"
    },
    groupCountKey: {
      type: String,
      default: "maplayer"
    },
    groupVisibleKey: {
      type: String,
      default: "maplayer"
    },
    clusterCountAttr: {
      type: String,
      default: "data-count"
    },
    moveEndDelay: {
      type: Number,
      default: null
    }
  },
  data: function data() {
    return {
      didInvalidate: this.invalidate,
      countDidInvalidate: this.countInvalidate,
      dataFetching: this.fetching,
      lastFetchError: null,
      dataCount: this.count,
      dataSelected: this.selected,
      dataVisible: this.visible,
      useVisibleHandler: false
    };
  },
  computed: {
    moveEndReload: function moveEndReload() {
      return external_debounce_default()(this.invalidateAndFetchData, this.moveEndDelay);
    }
  },
  watch: {
    invalidate: function invalidate() {
      this.didInvalidate = this.invalidate;
      this.fetchDataIfNeeded();
    },
    countInvalidate: function countInvalidate() {
      this.countDidInvalidate = this.countInvalidate;
      this.fetchCountIfNeeded();
    },
    fetching: function fetching() {
      this.dataFetching = this.fetching;
    },
    dataSource: function dataSource() {
      this.invalidateAndFetchData();
      this.invalidateAndFetchCount();
    },
    count: function count() {
      this.dataCount = this.count;
    },
    selected: function selected() {
      this.dataSelected = this.selected;
    },
    dataSelected: function dataSelected() {
      /**
       * @type {boolean}
       */
      this.$emit("update:selected", this.dataSelected);
    },
    visible: function visible() {
      this.dataVisible = this.visible;
    },
    dataVisible: function dataVisible() {
      this.setVisible(this.dataVisible);
      this.fetchDataIfNeeded();
      this.fetchCountIfNeeded();
      /**
       * @type {boolean}
       */
      this.$emit("update:visible", this.dataVisible);
    },
    styles: {
      deep: true,
      handler: "stylesChanged"
    }
  },
  mounted: function mounted() {
    var _this = this;
    var map = this.getMap();
    map.on("moveend", this.handleMoveEnd);
    this.mapObject = this.createGroup();
    this.serverClusterGroup = this.createServerClusterGroup();
    this.setVisible(this.dataVisible);
    this.$nextTick(function () {
      _this.fetchDataIfNeeded();
      _this.fetchCountIfNeeded();
    });
  },
  beforeDestroy: function beforeDestroy() {
    var map = this.getMap();
    map.off("moveend", this.handleMoveEnd);
    if (this.mapObject) {
      this.mapObject.off("click", this.handleDataGroupClick);
      this.mapObject.off("clusterclick", this.handleClientClusterClick);
      this.mapObject.clearLayers().remove();
    }
    if (this.serverClusterGroup) {
      this.serverClusterGroup.off("click", this.handleServerClusterGroupClick);
      this.serverClusterGroup.clearLayers().remove();
    }
  },
  methods: {
    createGroup: function createGroup() {
      if (this.clientClustering) {
        return this.createClientClusterGroup();
      } else {
        return this.createDataFeatureGroup();
      }
    },
    createClientClusterGroup: function createClientClusterGroup() {
      var options = _objectSpread2({
        showCoverageOnHover: false,
        chunkedLoading: true,
        iconCreateFunction: this.makeClusterIcon
      }, this.clientClusterOptions);
      var layerGroup = Object(external_leaflet_["markerClusterGroup"])(options);
      layerGroup.on("clusterclick", this.handleClientClusterClick).on("click", this.handleDataGroupClick);
      return layerGroup;
    },
    createDataFeatureGroup: function createDataFeatureGroup() {
      var layerGroup = Object(external_leaflet_["featureGroup"])();
      layerGroup.on("click", this.handleDataGroupClick);
      return layerGroup;
    },
    createServerClusterGroup: function createServerClusterGroup() {
      var layerGroup = Object(external_leaflet_["featureGroup"])();
      layerGroup.on("click", this.handleServerClusterGroupClick);
      return layerGroup;
    },
    setVisible: function setVisible(visible) {
      if (this.useVisibleHandler) {
        this.$emit("handle-visible", visible);
        return;
      }
      var map = this.getMap();
      if (visible) {
        map.addLayer(this.mapObject).addLayer(this.serverClusterGroup);
      } else {
        map.removeLayer(this.mapObject).removeLayer(this.serverClusterGroup);
      }
    },
    setUseVisibleHandler: function setUseVisibleHandler(value) {
      this.useVisibleHandler = value;
    },
    invalidateAndFetchData: function invalidateAndFetchData() {
      this.didInvalidate = true;
      this.fetchDataIfNeeded();
    },
    invalidateAndFetchCount: function invalidateAndFetchCount() {
      this.countDidInvalidate = true;
      this.fetchCountIfNeeded();
    },
    fetchDataIfNeeded: function fetchDataIfNeeded() {
      if (this.shouldFetchData()) {
        this.fetchData();
      }
    },
    fetchCountIfNeeded: function fetchCountIfNeeded() {
      if (this.shouldFetchCount()) {
        this.fetchCount();
      }
    },
    shouldFetchData: function shouldFetchData() {
      return this.didInvalidate && this.dataVisible;
    },
    shouldFetchCount: function shouldFetchCount() {
      return this.countDidInvalidate && this.dataVisible;
    },
    canFetchData: function canFetchData() {
      return this.dataSource && typeof this.dataSource.fetchData === "function";
    },
    canFetchCount: function canFetchCount() {
      return this.dataSource && typeof this.dataSource.fetchCount === "function";
    },
    canFetchAtZoom: function canFetchAtZoom(zoom) {
      if (this.minFetchZoom != null && this.maxFetchZoom != null) {
        return zoom >= this.minFetchZoom && zoom <= this.maxFetchZoom;
      } else if (this.minFetchZoom != null) {
        return zoom >= this.minFetchZoom;
      } else if (this.maxFetchZoom != null) {
        return zoom <= this.maxFetchZoom;
      } else {
        return true;
      }
    },
    fetchData: function fetchData() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var map, bbox, zoom, responseData, _this2$splitAndCreate, serverClusters, mapObjects;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                if (_this2.canFetchData()) {
                  _context.next = 3;
                  break;
                }
                return _context.abrupt("return");
              case 3:
                _this2.didInvalidate = false;
                _this2.dataFetching = true;
                _this2.lastFetchError = null;

                /**
                 * @type {boolean}
                 */
                _this2.$emit("update:invalidate", false);
                /**
                 * @type {boolean}
                 */
                _this2.$emit("update:fetching", true);
                map = _this2.getMap();
                bbox = external_leaflet_["leafletUtil"].boundsToArray(map.getBounds());
                zoom = map.getZoom();
                if (_this2.canFetchAtZoom(zoom)) {
                  _context.next = 15;
                  break;
                }
                _this2.clearServerClusters();
                _this2.clearMapObjects();
                return _context.abrupt("return");
              case 15:
                _context.next = 17;
                return _this2.dataSource.fetchData(_this2.id, bbox, zoom);
              case 17:
                responseData = _context.sent;
                if (!_this2._isDestroyed) {
                  _context.next = 20;
                  break;
                }
                return _context.abrupt("return");
              case 20:
                _this2$splitAndCreate = _this2.splitAndCreateMapObjects(responseData), serverClusters = _this2$splitAndCreate.serverClusters, mapObjects = _this2$splitAndCreate.mapObjects;
                if (_this2.centerMarker) {
                  _this2.attachCenterMarkers(mapObjects);
                }
                _this2.clearServerClusters();
                _this2.clearMapObjects();
                _this2.placeServerClusters(serverClusters);
                _this2.placeMapObjects(mapObjects);
                _this2.updatePopup(mapObjects);
                _this2.dataFetching = false;
                /**
                 * @type {boolean}
                 */
                _this2.$emit("update:fetching", false);
                /**
                 * @type {object}
                 */
                _this2.$emit("data:changed", {
                  data: responseData
                });
                _context.next = 40;
                break;
              case 32:
                _context.prev = 32;
                _context.t0 = _context["catch"](0);
                if (!is_cancel(_context.t0)) {
                  _context.next = 36;
                  break;
                }
                return _context.abrupt("return");
              case 36:
                logger.error(_context.t0);
                _this2.dataFetching = false;
                _this2.lastFetchError = _context.t0;
                /**
                 * @type {boolean}
                 */
                _this2.$emit("update:fetching", false);
              case 40:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 32]]);
      }))();
    },
    fetchCount: function fetchCount() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var count;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                if (_this3.canFetchCount()) {
                  _context2.next = 3;
                  break;
                }
                return _context2.abrupt("return");
              case 3:
                _this3.countDidInvalidate = false;
                /**
                 * @type {boolean}
                 */
                _this3.$emit("update:countInvalidate", false);
                _context2.next = 7;
                return _this3.dataSource.fetchCount(_this3.id);
              case 7:
                count = _context2.sent;
                if (!_this3._isDestroyed) {
                  _context2.next = 10;
                  break;
                }
                return _context2.abrupt("return");
              case 10:
                _this3.dataCount = count;
                /**
                 * @type {number}
                 */
                _this3.$emit("update:count", _this3.dataCount);
                _context2.next = 19;
                break;
              case 14:
                _context2.prev = 14;
                _context2.t0 = _context2["catch"](0);
                if (!is_cancel(_context2.t0)) {
                  _context2.next = 18;
                  break;
                }
                return _context2.abrupt("return");
              case 18:
                logger.error(_context2.t0);
              case 19:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 14]]);
      }))();
    },
    makeClusterIcon: function makeClusterIcon(cluster) {
      return this.clusterIconFactory ? this.clusterIconFactory(cluster.getChildCount()) : null;
    },
    clearServerClusters: function clearServerClusters() {
      this.serverClusterGroup.clearLayers();
    },
    clearMapObjects: function clearMapObjects() {
      if (this.clientClustering) {
        var map = this.getMap();
        if (map.hasLayer(this.mapObject)) {
          this.mapObject.clearLayers();
        } else {
          this.mapObject._map = map;
          this.mapObject.clearLayers();
          this.mapObject._map = null;
        }
      } else {
        this.mapObject.clearLayers();
      }
    },
    splitAndCreateMapObjects: function splitAndCreateMapObjects(items) {
      var mapObjects = [];
      var serverClusters = [];
      for (var i = 0, size = items.length; i < size; i++) {
        var item = items[i];
        if (item[this.clusterField]) {
          var clusterObject = this.createClusterObject(item);
          if (clusterObject) {
            serverClusters.push(clusterObject);
          }
        } else {
          var mapObject = this.createMapObject(item);
          if (mapObject) {
            mapObjects.push(mapObject);
          }
        }
      }
      return {
        mapObjects: mapObjects,
        serverClusters: serverClusters
      };
    },
    createMapObject: function createMapObject(itemData) {
      try {
        var mapObject = external_leaflet_["GeoJSON"].geometryToLayer(itemData[this.geometryField]);
        mapObject.options.data = itemData;
        if (this.markerPane && typeof mapObject.getLatLng === "function") {
          mapObject.options.pane = this.markerPane;
        }
        if (this.markerIcon && typeof mapObject.setIcon === "function") {
          mapObject.setIcon(this.markerIcon);
        } else if (this.pathStyle && typeof mapObject.setStyle === "function") {
          mapObject.setStyle(this.pathStyle);
        }
        return mapObject;
      } catch (e) {
        logger.error(e);
        return null;
      }
    },
    createClusterObject: function createClusterObject(itemData) {
      try {
        var mapObject = external_leaflet_["GeoJSON"].geometryToLayer(itemData.geometry);
        mapObject.options.data = itemData;
        if (this.markerPane && typeof mapObject.getLatLng === "function") {
          mapObject.options.pane = this.markerPane;
        }
        if (this.clusterIconFactory && typeof mapObject.setIcon === "function") {
          mapObject.setIcon(this.clusterIconFactory(itemData[this.countField] || 0));
        }
        return mapObject;
      } catch (e) {
        logger.error(e);
        return null;
      }
    },
    placeMapObjects: function placeMapObjects(mapObjects) {
      if (this.clientClustering) {
        this.mapObject.addLayers(mapObjects);
      } else {
        for (var i = 0, size = mapObjects.length; i < size; i++) {
          this.mapObject.addLayer(mapObjects[i]);
        }
      }
    },
    placeServerClusters: function placeServerClusters(mapObjects) {
      for (var i = 0, size = mapObjects.length; i < size; i++) {
        this.serverClusterGroup.addLayer(mapObjects[i]);
      }
    },
    attachCenterMarkers: function attachCenterMarkers(mapObjects) {
      for (var i = 0, size = mapObjects.length; i < size; i++) {
        var mapObject = mapObjects[i];
        if (external_leaflet_["leafletUtil"].isPath(mapObject)) {
          var centerMarker = this.createCenterMarker(mapObject.options.data);
          centerMarker.attachTo(mapObject);
        }
      }
    },
    createCenterMarker: function createCenterMarker(itemData) {
      var mapObject = Object(external_leaflet_["pathCenterMarker"])();
      mapObject.options.data = itemData;
      if (this.markerPane) {
        mapObject.options.pane = this.markerPane;
      }
      if (this.markerIcon) {
        mapObject.setIcon(this.markerIcon);
      }
      return mapObject;
    },
    setMarkerIcon: function setMarkerIcon(value) {
      this.markerIcon = value;
    },
    getMarkerIcon: function getMarkerIcon() {
      return this.markerIcon;
    },
    setClusterIconFactory: function setClusterIconFactory(value) {
      this.clusterIconFactory = value;
    },
    setPathStyle: function setPathStyle(value) {
      this.pathStyle = value;
    },
    getPathStyle: function getPathStyle() {
      return this.pathStyle;
    },
    isVisible: function isVisible() {
      return this.dataVisible;
    },
    getData: function getData() {
      if (this.mapObject && this.serverClusterGroup) {
        return this.mapObject.getLayers().map(function (l) {
          return l.options.data;
        }).concat(this.serverClusterGroup.getLayers().map(function (l) {
          return l.options.data;
        }));
      }
      return [];
    },
    getMapObject: function getMapObject() {
      return this.mapObject;
    },
    listenEvent: function listenEvent(event, listener) {
      var unsubscribe = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      if (unsubscribe) {
        this.$off(event, listener);
      } else {
        this.$on(event, listener);
      }
    },
    removeFromMap: function removeFromMap() {
      if (!this._isDestroyed && this.mapObject && this.serverClusterGroup) {
        var map = this.getMap();
        map.removeLayer(this.mapObject).removeLayer(this.serverClusterGroup);
      }
    },
    addToMap: function addToMap() {
      if (!this._isDestroyed && this.mapObject && this.serverClusterGroup) {
        var map = this.getMap();
        map.addLayer(this.mapObject).addLayer(this.serverClusterGroup);
      }
    },
    getId: function getId() {
      return this.id;
    },
    stylesChanged: function stylesChanged() {
      var _this4 = this;
      this.$nextTick(function () {
        _this4.invalidateAndFetchData();
      });
    },
    handleDataGroupClick: function handleDataGroupClick(e) {
      /**
       * @type {object}
       */
      this.$emit("object:click", _objectSpread2(_objectSpread2({}, e), {}, {
        layerId: this.id
      }));
    },
    handleClientClusterClick: function handleClientClusterClick(e) {
      /**
       * @type {object}
       */
      this.$emit("clientcluster:click", _objectSpread2(_objectSpread2({}, e), {}, {
        layerId: this.id
      }));
    },
    handleServerClusterGroupClick: function handleServerClusterGroupClick(e) {
      var layer = e.propagatedFrom,
        target = e.originalEvent.target;
      var countAttrValue = this.clusterCountAttr ? target.getAttribute(this.clusterCountAttr) : null;
      var event = _objectSpread2(_objectSpread2({}, e), {}, {
        layerId: this.id,
        preventClick: function preventClick() {
          this._prevented = true;
        }
      });
      if (countAttrValue) {
        var count = parseInt(countAttrValue);
        event.count = isNaN(count) ? null : count;
        /**
         * @type {object}
         */
        this.$emit("cluster:count", event);
      } else {
        /**
         * @type {object}
         */
        this.$emit("cluster:click", event);
      }
      if (!event._prevented && typeof layer.getLatLng === "function") {
        var map = this.getMap();
        map.setView(layer.getLatLng(), map.getZoom() + 1);
      }
    },
    handlePopupEditPressed: function handlePopupEditPressed(itemData) {
      /**
       * @type {object}
       */
      this.$emit("popup:edit", {
        layerId: this.id,
        popup: this.mapObject.getPopup(),
        data: _objectSpread2({}, itemData)
      });
    },
    handlePopupDeletePressed: function handlePopupDeletePressed(itemData) {
      /**
       * @type {object}
       */
      this.$emit("popup:delete", {
        layerId: this.id,
        popup: this.mapObject.getPopup(),
        data: _objectSpread2({}, itemData)
      });
    },
    handlePopupDetailsPressed: function handlePopupDetailsPressed(itemData) {
      /**
       * @type {object}
       */
      this.$emit("popup:details", {
        layerId: this.id,
        popup: this.mapObject.getPopup(),
        data: _objectSpread2({}, itemData)
      });
    },
    handleFilterPressed: function handleFilterPressed() {
      /**
       * @type {object}
       */
      this.$emit("filter", {
        layerId: this.id
      });
    },
    handleCountPressed: function handleCountPressed(e) {
      /**
       * @type {object}
       */
      this.$emit("count:click", _objectSpread2(_objectSpread2({}, e), {}, {
        layerId: this.id
      }));
    },
    handleMoveEnd: function handleMoveEnd(e) {
      if (isDefined(this.moveEndDelay)) {
        this.moveEndReload();
      } else {
        this.invalidateAndFetchData();
      }
    }
  }
});
// CONCATENATED MODULE: ./src/components/map/v-map-server-layer.vue?vue&type=script&lang=js&
 /* harmony default export */ var map_v_map_server_layervue_type_script_lang_js_ = (v_map_server_layervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/map/v-map-server-layer.vue?vue&type=custom&index=0&blockType=docs
var v_map_server_layervue_type_custom_index_0_blockType_docs = __webpack_require__("5d64");
var v_map_server_layervue_type_custom_index_0_blockType_docs_default = /*#__PURE__*/__webpack_require__.n(v_map_server_layervue_type_custom_index_0_blockType_docs);

// EXTERNAL MODULE: ./src/components/map/v-map-server-layer.vue?vue&type=custom&index=1&blockType=docs
var v_map_server_layervue_type_custom_index_1_blockType_docs = __webpack_require__("dd13");
var v_map_server_layervue_type_custom_index_1_blockType_docs_default = /*#__PURE__*/__webpack_require__.n(v_map_server_layervue_type_custom_index_1_blockType_docs);

// CONCATENATED MODULE: ./src/components/map/v-map-server-layer.vue





/* normalize component */

var v_map_server_layer_component = normalizeComponent(
  map_v_map_server_layervue_type_script_lang_js_,
  v_map_server_layervue_type_template_id_249d811c_render,
  v_map_server_layervue_type_template_id_249d811c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */

if (typeof v_map_server_layervue_type_custom_index_0_blockType_docs_default.a === 'function') v_map_server_layervue_type_custom_index_0_blockType_docs_default()(v_map_server_layer_component)

if (typeof v_map_server_layervue_type_custom_index_1_blockType_docs_default.a === 'function') v_map_server_layervue_type_custom_index_1_blockType_docs_default()(v_map_server_layer_component)

/* harmony default export */ var v_map_server_layer = (v_map_server_layer_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"443a82ff-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/v-map-group-layer.vue?vue&type=template&id=7e9e94fc&
var v_map_group_layervue_type_template_id_7e9e94fc_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('v-map-tree-layer', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.presentation(),
      expression: "presentation()"
    }],
    attrs: {
      "title": _vm.title,
      "count": _vm.dataCount,
      "filtering": _vm.filtering,
      "disabled": _vm.disabled,
      "selection": _vm.selection,
      "selected": _vm.dataSelected,
      "visible": _vm.dataVisible,
      "expanded": _vm.dataExpanded,
      "icon-color": _vm.styles[_vm.iconColorField],
      "expand-on-select": _vm.expandOnSelect
    },
    on: {
      "update:selected": function updateSelected($event) {
        _vm.dataSelected = $event;
      },
      "update:expanded": function updateExpanded($event) {
        _vm.dataExpanded = $event;
      },
      "filter": _vm.handleFilterPressed,
      "update:visible": _vm.handleVisiblePressed,
      "expand-end": _vm.handleScrollUpdate,
      "collapse-end": _vm.handleScrollUpdate
    },
    scopedSlots: _vm._u([{
      key: "icon",
      fn: function fn() {
        return [_vm._t("icon")];
      },
      proxy: true
    }, {
      key: "other",
      fn: function fn() {
        return [_vm.selection && _vm.singleSelection && _vm.selectionKey ? _vm._t("single-selection", function () {
          return [_c('v-map-single-selection', {
            attrs: {
              "name": _vm.selectionKey,
              "selected": _vm.dataSelected
            },
            on: {
              "update:selected": function updateSelected($event) {
                _vm.dataSelected = $event;
              }
            }
          })];
        }) : _vm._e(), _vm._t("scroll-update", function () {
          return [_c('v-map-scroll-update', {
            ref: "scrollUpdate"
          })];
        })];
      },
      proxy: true
    }], null, true)
  }, [_vm._t("default")], 2);
};
var v_map_group_layervue_type_template_id_7e9e94fc_staticRenderFns = [];

// CONCATENATED MODULE: ./src/components/map/v-map-group-layer.vue?vue&type=template&id=7e9e94fc&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__("13d5");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/v-map-scroll-update.vue?vue&type=script&lang=js&
/* harmony default export */ var v_map_scroll_updatevue_type_script_lang_js_ = ({
  name: "v-map-scroll-update",
  inject: ["getMap"],
  props: {
    trigger: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    trigger: function trigger() {
      var _this = this;
      this.$nextTick(function () {
        _this.updateScroll();
      });
    }
  },
  methods: {
    updateScroll: function updateScroll() {
      var map = this.getMap();
      map.fire("vmap:scroll:update");
    }
  },
  render: function render() {
    return null;
  }
});
// CONCATENATED MODULE: ./src/components/map/v-map-scroll-update.vue?vue&type=script&lang=js&
 /* harmony default export */ var map_v_map_scroll_updatevue_type_script_lang_js_ = (v_map_scroll_updatevue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/map/v-map-scroll-update.vue
var v_map_scroll_update_render, v_map_scroll_update_staticRenderFns




/* normalize component */

var v_map_scroll_update_component = normalizeComponent(
  map_v_map_scroll_updatevue_type_script_lang_js_,
  v_map_scroll_update_render,
  v_map_scroll_update_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var v_map_scroll_update = (v_map_scroll_update_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/v-map-group-layer.vue?vue&type=script&lang=js&










var visibleChangeEvent = function visibleChangeEvent(groupName) {
  return "vmap:layer:visible:".concat(groupName);
};
/* harmony default export */ var v_map_group_layervue_type_script_lang_js_ = ({
  name: "v-map-group-layer",
  inject: ["presentation", "setGroupCount", "setGroupVisible", "getMap"],
  provide: function provide() {
    return {
      setGroupCount: this._setGroupCount,
      setGroupVisible: this._setGroupVisible
    };
  },
  components: {
    VMapTreeLayer: v_map_tree_layer,
    VMapSingleSelection: v_map_single_selection,
    VMapScrollUpdate: v_map_scroll_update
  },
  props: {
    id: {
      type: [String, Number],
      default: null
    },
    title: {
      type: String,
      default: null
    },
    /**
     * sync
     */
    visible: {
      type: Boolean,
      default: false
    },
    /**
     * sync
     */
    expanded: {
      type: Boolean,
      default: false
    },
    /**
     * sync
     */
    selected: {
      type: Boolean,
      default: false
    },
    filtering: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    /**
     * sync
     */
    count: {
      type: Number,
      default: 0
    },
    selection: {
      type: Boolean,
      default: false
    },
    singleSelection: {
      type: Boolean,
      default: true
    },
    expandOnSelect: {
      type: Boolean,
      default: true
    },
    oneWayVisible: {
      type: Boolean,
      default: false
    },
    selectionKey: {
      type: String,
      default: "maplayer"
    },
    groupCountKey: {
      type: String,
      default: "maplayer"
    },
    groupVisibleKey: {
      type: String,
      default: "maplayer"
    },
    styles: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    iconColorField: {
      type: String,
      default: "iconColor"
    }
  },
  data: function data() {
    return {
      dataCount: this.count,
      dataSelected: this.selected,
      dataVisible: this.visible,
      dataExpanded: this.expanded,
      groupCountData: {},
      groupVisibleData: {}
    };
  },
  watch: {
    count: function count() {
      this.dataCount = this.count;
    },
    dataCount: function dataCount() {
      /**
       * @type {number}
       */
      this.$emit("update:count", this.dataCount);
    },
    selected: function selected() {
      this.dataSelected = this.selected;
    },
    dataSelected: function dataSelected() {
      /**
       * @type {boolean}
       */
      this.$emit("update:selected", this.dataSelected);
    },
    visible: function visible() {
      this.dataVisible = this.visible;
    },
    dataVisible: function dataVisible() {
      if (this.oneWayVisible) {
        this.notifyVisibleChanged(this.dataVisible);
      }
      /**
       * @type {boolean}
       */
      this.$emit("update:visible", this.dataVisible);
    },
    expanded: function expanded() {
      this.dataExpanded = this.expanded;
    },
    dataExpanded: function dataExpanded() {
      /**
       * @type {boolean}
       */
      this.$emit("update:expanded", this.dataExpanded);
    },
    groupCountData: {
      deep: true,
      handler: "groupCountDataChanged"
    },
    groupVisibleData: {
      deep: true,
      handler: "groupVisibleDataChanged"
    }
  },
  methods: {
    _setGroupCount: function _setGroupCount(name, uid, count) {
      this.setGroupCount(name, uid, count);
      if (!this.groupCountKey) return;
      if (!this.groupCountData[name]) {
        this.$set(this.groupCountData, name, {});
      }
      this.$set(this.groupCountData[name], uid, count);
    },
    groupCountDataChanged: function groupCountDataChanged() {
      if (!this.groupCountKey) return;
      var groupCountData = this.groupCountData[this.groupCountKey];
      if (!groupCountData) return;
      this.dataCount = Object.keys(groupCountData).reduce(function (res, curr) {
        return res + groupCountData[curr];
      }, 0);
    },
    _setGroupVisible: function _setGroupVisible(name, uid, visible) {
      this.setGroupVisible(name, uid, visible);
      if (!this.groupVisibleKey) return;
      if (!this.groupVisibleData[name]) {
        this.$set(this.groupVisibleData, name, {});
      }
      if (visible == null) {
        this.$delete(this.groupVisibleData[name], uid);
      } else {
        this.$set(this.groupVisibleData[name], uid, visible);
      }
    },
    groupVisibleDataChanged: function groupVisibleDataChanged() {
      if (!this.groupVisibleKey || this.oneWayVisible) return;
      var groupVisibleData = this.groupVisibleData[this.groupVisibleKey];
      if (!groupVisibleData) return;
      this.dataVisible = Object.keys(groupVisibleData).map(function (k) {
        return groupVisibleData[k];
      }).some(function (v) {
        return v === true;
      });
    },
    notifyVisibleChanged: function notifyVisibleChanged(value) {
      if (!this.groupVisibleKey) return;
      var groupVisibleData = this.groupVisibleData[this.groupVisibleKey];
      if (!groupVisibleData) return;
      var map = this.getMap();
      Object.keys(groupVisibleData).forEach(function (k) {
        return groupVisibleData[k] = value;
      });
      map.fire(visibleChangeEvent(this.groupVisibleKey), {
        values: _objectSpread2({}, groupVisibleData)
      });
    },
    handleVisiblePressed: function handleVisiblePressed(value) {
      this.dataVisible = value;
      if (!this.oneWayVisible) {
        this.notifyVisibleChanged(value);
      }
    },
    handleFilterPressed: function handleFilterPressed() {
      /**
       * @type {object}
       */
      this.$emit("filter", {
        layerId: this.id
      });
    },
    handleScrollUpdate: function handleScrollUpdate() {
      this.$refs.scrollUpdate.updateScroll();
    }
  }
});
// CONCATENATED MODULE: ./src/components/map/v-map-group-layer.vue?vue&type=script&lang=js&
 /* harmony default export */ var map_v_map_group_layervue_type_script_lang_js_ = (v_map_group_layervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/map/v-map-group-layer.vue?vue&type=custom&index=0&blockType=docs
var v_map_group_layervue_type_custom_index_0_blockType_docs = __webpack_require__("a1b0");
var v_map_group_layervue_type_custom_index_0_blockType_docs_default = /*#__PURE__*/__webpack_require__.n(v_map_group_layervue_type_custom_index_0_blockType_docs);

// EXTERNAL MODULE: ./src/components/map/v-map-group-layer.vue?vue&type=custom&index=1&blockType=docs
var v_map_group_layervue_type_custom_index_1_blockType_docs = __webpack_require__("6011");
var v_map_group_layervue_type_custom_index_1_blockType_docs_default = /*#__PURE__*/__webpack_require__.n(v_map_group_layervue_type_custom_index_1_blockType_docs);

// CONCATENATED MODULE: ./src/components/map/v-map-group-layer.vue





/* normalize component */

var v_map_group_layer_component = normalizeComponent(
  map_v_map_group_layervue_type_script_lang_js_,
  v_map_group_layervue_type_template_id_7e9e94fc_render,
  v_map_group_layervue_type_template_id_7e9e94fc_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */

if (typeof v_map_group_layervue_type_custom_index_0_blockType_docs_default.a === 'function') v_map_group_layervue_type_custom_index_0_blockType_docs_default()(v_map_group_layer_component)

if (typeof v_map_group_layervue_type_custom_index_1_blockType_docs_default.a === 'function') v_map_group_layervue_type_custom_index_1_blockType_docs_default()(v_map_group_layer_component)

/* harmony default export */ var v_map_group_layer = (v_map_group_layer_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"443a82ff-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/v-map-empty-layer.vue?vue&type=template&id=16d1caf6&
var v_map_empty_layervue_type_template_id_16d1caf6_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('v-map-tree-layer', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.presentation(),
      expression: "presentation()"
    }],
    attrs: {
      "title": _vm.title,
      "count": _vm.count,
      "filtering": _vm.filtering,
      "selection": _vm.selection,
      "disabled": _vm.disabled,
      "selected": _vm.dataSelected,
      "visible": _vm.dataVisible,
      "icon-color": _vm.styles[_vm.iconColorField]
    },
    on: {
      "update:selected": function updateSelected($event) {
        _vm.dataSelected = $event;
      },
      "update:visible": function updateVisible($event) {
        _vm.dataVisible = $event;
      },
      "filter": _vm.handleFilterPressed
    },
    scopedSlots: _vm._u([{
      key: "icon",
      fn: function fn() {
        return [_vm._t("icon")];
      },
      proxy: true
    }, {
      key: "other",
      fn: function fn() {
        return [_vm.selection && _vm.singleSelection && _vm.selectionKey ? _vm._t("single-selection", function () {
          return [_c('v-map-single-selection', {
            attrs: {
              "name": _vm.selectionKey,
              "selected": _vm.dataSelected
            },
            on: {
              "update:selected": function updateSelected($event) {
                _vm.dataSelected = $event;
              }
            }
          })];
        }) : _vm._e(), _vm.groupCountKey ? _vm._t("group-count", function () {
          return [_c('v-map-group-count', {
            attrs: {
              "name": _vm.groupCountKey,
              "count": _vm.count
            }
          })];
        }) : _vm._e(), _vm.groupVisibleKey ? _vm._t("group-visible", function () {
          return [_c('v-map-group-visible', {
            attrs: {
              "name": _vm.groupVisibleKey,
              "visible": _vm.dataVisible
            },
            on: {
              "update:visible": function updateVisible($event) {
                _vm.dataVisible = $event;
              }
            }
          })];
        }) : _vm._e(), _vm._t("default")];
      },
      proxy: true
    }], null, true)
  });
};
var v_map_empty_layervue_type_template_id_16d1caf6_staticRenderFns = [];

// CONCATENATED MODULE: ./src/components/map/v-map-empty-layer.vue?vue&type=template&id=16d1caf6&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/v-map-empty-layer.vue?vue&type=script&lang=js&





/* harmony default export */ var v_map_empty_layervue_type_script_lang_js_ = ({
  name: "v-map-empty-layer",
  inject: ["presentation"],
  components: {
    VMapTreeLayer: v_map_tree_layer,
    VMapSingleSelection: v_map_single_selection,
    VMapGroupCount: v_map_group_count,
    VMapGroupVisible: v_map_group_visible
  },
  props: {
    id: {
      type: [String, Number],
      default: null
    },
    title: {
      type: String,
      default: null
    },
    /**
     * sync
     */
    visible: {
      type: Boolean,
      default: true
    },
    /**
     * sync
     */
    selected: {
      type: Boolean,
      default: false
    },
    filtering: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    count: {
      type: Number,
      default: 0
    },
    styles: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    iconColorField: {
      type: String,
      default: "iconColor"
    },
    selection: {
      type: Boolean,
      default: true
    },
    singleSelection: {
      type: Boolean,
      default: true
    },
    selectionKey: {
      type: String,
      default: "maplayer"
    },
    groupCountKey: {
      type: String,
      default: "maplayer"
    },
    groupVisibleKey: {
      type: String,
      default: "maplayer"
    }
  },
  data: function data() {
    return {
      dataSelected: this.selected,
      dataVisible: this.visible
    };
  },
  watch: {
    selected: function selected() {
      this.dataSelected = this.selected;
    },
    dataSelected: function dataSelected() {
      /**
       * @type {boolean}
       */
      this.$emit("update:selected", this.dataSelected);
    },
    visible: function visible() {
      this.dataVisible = this.visible;
    },
    dataVisible: function dataVisible() {
      /**
       * @type {boolean}
       */
      this.$emit("update:visible", this.dataVisible);
    }
  },
  methods: {
    handleFilterPressed: function handleFilterPressed() {
      /**
       * @type {object}
       */
      this.$emit("filter", {
        layerId: this.id
      });
    }
  }
});
// CONCATENATED MODULE: ./src/components/map/v-map-empty-layer.vue?vue&type=script&lang=js&
 /* harmony default export */ var map_v_map_empty_layervue_type_script_lang_js_ = (v_map_empty_layervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/map/v-map-empty-layer.vue?vue&type=custom&index=0&blockType=docs
var v_map_empty_layervue_type_custom_index_0_blockType_docs = __webpack_require__("8bcc");
var v_map_empty_layervue_type_custom_index_0_blockType_docs_default = /*#__PURE__*/__webpack_require__.n(v_map_empty_layervue_type_custom_index_0_blockType_docs);

// EXTERNAL MODULE: ./src/components/map/v-map-empty-layer.vue?vue&type=custom&index=1&blockType=docs
var v_map_empty_layervue_type_custom_index_1_blockType_docs = __webpack_require__("64a0");
var v_map_empty_layervue_type_custom_index_1_blockType_docs_default = /*#__PURE__*/__webpack_require__.n(v_map_empty_layervue_type_custom_index_1_blockType_docs);

// CONCATENATED MODULE: ./src/components/map/v-map-empty-layer.vue





/* normalize component */

var v_map_empty_layer_component = normalizeComponent(
  map_v_map_empty_layervue_type_script_lang_js_,
  v_map_empty_layervue_type_template_id_16d1caf6_render,
  v_map_empty_layervue_type_template_id_16d1caf6_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */

if (typeof v_map_empty_layervue_type_custom_index_0_blockType_docs_default.a === 'function') v_map_empty_layervue_type_custom_index_0_blockType_docs_default()(v_map_empty_layer_component)

if (typeof v_map_empty_layervue_type_custom_index_1_blockType_docs_default.a === 'function') v_map_empty_layervue_type_custom_index_1_blockType_docs_default()(v_map_empty_layer_component)

/* harmony default export */ var v_map_empty_layer = (v_map_empty_layer_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"443a82ff-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/v-map-wms-layer.vue?vue&type=template&id=1168247e&
var v_map_wms_layervue_type_template_id_1168247e_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('v-map-tree-layer', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.presentation(),
      expression: "presentation()"
    }],
    attrs: {
      "title": _vm.title,
      "count": _vm.count,
      "show-count": _vm.showCount,
      "filtering": _vm.filtering,
      "selection": _vm.selection,
      "disabled": _vm.disabled,
      "selected": _vm.dataSelected,
      "visible": _vm.dataVisible,
      "icon-color": _vm.styles[_vm.iconColorField]
    },
    on: {
      "update:selected": function updateSelected($event) {
        _vm.dataSelected = $event;
      },
      "update:visible": function updateVisible($event) {
        _vm.dataVisible = $event;
      },
      "filter": _vm.handleFilterPressed
    },
    scopedSlots: _vm._u([{
      key: "icon",
      fn: function fn() {
        return [_vm._t("icon")];
      },
      proxy: true
    }, {
      key: "other",
      fn: function fn() {
        return [_vm.wmsVisible ? _c('v-map-wms-tile-layer', {
          attrs: {
            "layer-type": _vm.wmsLayerType,
            "name": _vm.title,
            "tile-size": _vm.wmsTileSize,
            "url": _vm.wmsUrl,
            "layers": _vm.wmsLayers,
            "styles": _vm.wmsStyles,
            "format": _vm.wmsFormat,
            "transparent": _vm.wmsTransparent,
            "version": _vm.wmsVersion,
            "crs": _vm.wmsCrs,
            "uppercase": _vm.wmsUppercase,
            "params": _vm.wmsParams
          }
        }) : _vm._e(), _vm.selection && _vm.singleSelection && _vm.selectionKey ? _vm._t("single-selection", function () {
          return [_c('v-map-single-selection', {
            attrs: {
              "name": _vm.selectionKey,
              "selected": _vm.dataSelected
            },
            on: {
              "update:selected": function updateSelected($event) {
                _vm.dataSelected = $event;
              }
            }
          })];
        }) : _vm._e(), _vm.groupCountKey ? _vm._t("group-count", function () {
          return [_c('v-map-group-count', {
            attrs: {
              "name": _vm.groupCountKey,
              "count": _vm.count
            }
          })];
        }) : _vm._e(), _vm.groupVisibleKey ? _vm._t("group-visible", function () {
          return [_c('v-map-group-visible', {
            attrs: {
              "name": _vm.groupVisibleKey,
              "visible": _vm.dataVisible
            },
            on: {
              "update:visible": function updateVisible($event) {
                _vm.dataVisible = $event;
              }
            }
          })];
        }) : _vm._e(), _vm._t("default")];
      },
      proxy: true
    }], null, true)
  });
};
var v_map_wms_layervue_type_template_id_1168247e_staticRenderFns = [];

// CONCATENATED MODULE: ./src/components/map/v-map-wms-layer.vue?vue&type=template&id=1168247e&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/v-map-wms-layer.vue?vue&type=script&lang=js&






/* harmony default export */ var v_map_wms_layervue_type_script_lang_js_ = ({
  name: "v-map-wms-layer",
  inject: ["presentation"],
  components: {
    VMapTreeLayer: v_map_tree_layer,
    VMapSingleSelection: v_map_single_selection,
    VMapGroupCount: v_map_group_count,
    VMapGroupVisible: v_map_group_visible,
    VMapWmsTileLayer: v_map_wms_tile_layer
  },
  props: {
    id: {
      type: [String, Number],
      default: null
    },
    title: {
      type: String,
      default: null
    },
    /**
     * sync
     */
    visible: {
      type: Boolean,
      default: true
    },
    /**
     * sync
     */
    selected: {
      type: Boolean,
      default: false
    },
    filtering: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    count: {
      type: Number,
      default: 0
    },
    showCount: {
      type: Boolean,
      default: false
    },
    styles: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    iconColorField: {
      type: String,
      default: "iconColor"
    },
    selection: {
      type: Boolean,
      default: true
    },
    singleSelection: {
      type: Boolean,
      default: true
    },
    selectionKey: {
      type: String,
      default: "maplayer"
    },
    groupCountKey: {
      type: String,
      default: "maplayer"
    },
    groupVisibleKey: {
      type: String,
      default: "maplayer"
    },
    wmsUrl: {
      type: String,
      default: null
    },
    wmsLayers: {
      type: String,
      default: ""
    },
    wmsStyles: {
      type: String,
      default: ""
    },
    wmsFormat: {
      type: String,
      default: "image/jpeg"
    },
    wmsTransparent: {
      type: Boolean,
      custom: false
    },
    wmsVersion: {
      type: String,
      default: "1.1.1"
    },
    wmsCrs: {
      default: null
    },
    wmsUppercase: {
      type: Boolean,
      default: false
    },
    wmsParams: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    wmsLayerType: {
      type: String,
      default: "overlay"
    },
    wmsTileSize: {
      type: Number,
      default: undefined
    }
  },
  data: function data() {
    return {
      dataSelected: this.selected,
      dataVisible: this.visible
    };
  },
  computed: {
    wmsVisible: function wmsVisible() {
      return this.wmsUrl && this.dataVisible;
    }
  },
  watch: {
    selected: function selected() {
      this.dataSelected = this.selected;
    },
    dataSelected: function dataSelected() {
      /**
       * @type {boolean}
       */
      this.$emit("update:selected", this.dataSelected);
    },
    visible: function visible() {
      this.dataVisible = this.visible;
    },
    dataVisible: function dataVisible() {
      /**
       * @type {boolean}
       */
      this.$emit("update:visible", this.dataVisible);
    }
  },
  methods: {
    handleFilterPressed: function handleFilterPressed() {
      /**
       * @type {object}
       */
      this.$emit("filter", {
        layerId: this.id
      });
    }
  }
});
// CONCATENATED MODULE: ./src/components/map/v-map-wms-layer.vue?vue&type=script&lang=js&
 /* harmony default export */ var map_v_map_wms_layervue_type_script_lang_js_ = (v_map_wms_layervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/map/v-map-wms-layer.vue?vue&type=custom&index=0&blockType=docs
var v_map_wms_layervue_type_custom_index_0_blockType_docs = __webpack_require__("729a");
var v_map_wms_layervue_type_custom_index_0_blockType_docs_default = /*#__PURE__*/__webpack_require__.n(v_map_wms_layervue_type_custom_index_0_blockType_docs);

// EXTERNAL MODULE: ./src/components/map/v-map-wms-layer.vue?vue&type=custom&index=1&blockType=docs
var v_map_wms_layervue_type_custom_index_1_blockType_docs = __webpack_require__("8a5d");
var v_map_wms_layervue_type_custom_index_1_blockType_docs_default = /*#__PURE__*/__webpack_require__.n(v_map_wms_layervue_type_custom_index_1_blockType_docs);

// CONCATENATED MODULE: ./src/components/map/v-map-wms-layer.vue





/* normalize component */

var v_map_wms_layer_component = normalizeComponent(
  map_v_map_wms_layervue_type_script_lang_js_,
  v_map_wms_layervue_type_template_id_1168247e_render,
  v_map_wms_layervue_type_template_id_1168247e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */

if (typeof v_map_wms_layervue_type_custom_index_0_blockType_docs_default.a === 'function') v_map_wms_layervue_type_custom_index_0_blockType_docs_default()(v_map_wms_layer_component)

if (typeof v_map_wms_layervue_type_custom_index_1_blockType_docs_default.a === 'function') v_map_wms_layervue_type_custom_index_1_blockType_docs_default()(v_map_wms_layer_component)

/* harmony default export */ var v_map_wms_layer = (v_map_wms_layer_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"443a82ff-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/v-map-track-layer.vue?vue&type=template&id=4f6a9f23&
var v_map_track_layervue_type_template_id_4f6a9f23_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('v-map-tree-layer', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.presentation(),
      expression: "presentation()"
    }],
    attrs: {
      "title": _vm.title,
      "count": _vm.dataCount,
      "filtering": _vm.filtering,
      "filter-active": _vm.filterActive,
      "selection": _vm.selection,
      "disabled": _vm.disabled,
      "selected": _vm.dataSelected,
      "visible": _vm.dataVisible,
      "icon-color": _vm.styles[_vm.iconColorField]
    },
    on: {
      "update:selected": function updateSelected($event) {
        _vm.dataSelected = $event;
      },
      "update:visible": function updateVisible($event) {
        _vm.dataVisible = $event;
      },
      "filter": _vm.handleFilterPressed,
      "count": _vm.handleCountPressed
    },
    scopedSlots: _vm._u([{
      key: "icon",
      fn: function fn() {
        return [_vm._t("icon")];
      },
      proxy: true
    }, {
      key: "other",
      fn: function fn() {
        return [_vm._t("marker-icon", function () {
          return [_c('v-map-tracker-icon', {
            attrs: {
              "color": _vm.styles[_vm.iconColorField]
            },
            scopedSlots: _vm._u([{
              key: "icon",
              fn: function fn() {
                return [_vm._t("icon")];
              },
              proxy: true
            }], null, true)
          })];
        }), _vm._t("popup", function () {
          return [_c('v-map-popup', {
            attrs: {
              "auto-pan": _vm.popupAutoPan
            },
            scopedSlots: _vm._u([{
              key: "default",
              fn: function fn(_ref) {
                var content = _ref.content;
                return [_c('v-map-popup-content', {
                  attrs: {
                    "title": content[_vm.titleField],
                    "description": content[_vm.descriptionField],
                    "icon-color": _vm.styles[_vm.iconColorField],
                    "show-edit": _vm.popupShowEdit,
                    "show-delete": _vm.popupShowDelete,
                    "show-details": _vm.popupShowDetails,
                    "with-confirm-delete": _vm.popupShowDelete
                  },
                  on: {
                    "edit": function edit($event) {
                      return _vm.handlePopupEditPressed(content);
                    },
                    "delete": function _delete($event) {
                      return _vm.handlePopupDeletePressed(content);
                    },
                    "details": function details($event) {
                      return _vm.handlePopupDetailsPressed(content);
                    }
                  },
                  scopedSlots: _vm._u([{
                    key: "icon",
                    fn: function fn() {
                      return [_vm._t("icon")];
                    },
                    proxy: true
                  }], null, true)
                })];
              }
            }])
          })];
        }), _vm.selection && _vm.singleSelection && _vm.selectionKey ? _vm._t("single-selection", function () {
          return [_c('v-map-single-selection', {
            attrs: {
              "name": _vm.selectionKey,
              "selected": _vm.dataSelected
            },
            on: {
              "update:selected": function updateSelected($event) {
                _vm.dataSelected = $event;
              }
            }
          })];
        }) : _vm._e(), _vm.groupCountKey ? _vm._t("group-count", function () {
          return [_c('v-map-group-count', {
            attrs: {
              "name": _vm.groupCountKey,
              "count": _vm.dataCount
            }
          })];
        }) : _vm._e(), _vm.groupVisibleKey ? _vm._t("group-visible", function () {
          return [_c('v-map-group-visible', {
            attrs: {
              "name": _vm.groupVisibleKey,
              "visible": _vm.dataVisible
            },
            on: {
              "update:visible": function updateVisible($event) {
                _vm.dataVisible = $event;
              }
            }
          })];
        }) : _vm._e(), _vm._t("default")];
      },
      proxy: true
    }], null, true)
  });
};
var v_map_track_layervue_type_template_id_4f6a9f23_staticRenderFns = [];

// CONCATENATED MODULE: ./src/components/map/v-map-track-layer.vue?vue&type=template&id=4f6a9f23&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"443a82ff-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/v-map-tracker-icon.vue?vue&type=template&id=190d35a8&
var v_map_tracker_iconvue_type_template_id_190d35a8_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_vm._t("default", function () {
    return [_c('div', {
      staticClass: "v-map-tracker__wrap v-map-tracker__wrap--primary"
    }, [_c('div', {
      staticClass: "v-map-tracker__icon",
      style: {
        borderColor: _vm.color,
        color: _vm.color
      }
    }, [_vm.$slots.icon ? _vm._t("icon") : _c('v-visary-icon')], 2), _c('div', {
      staticClass: "v-map-tracker__direction",
      style: {
        backgroundColor: _vm.color
      }
    })])];
  })], 2);
};
var v_map_tracker_iconvue_type_template_id_190d35a8_staticRenderFns = [];

// CONCATENATED MODULE: ./src/components/map/v-map-tracker-icon.vue?vue&type=template&id=190d35a8&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/v-map-tracker-icon.vue?vue&type=script&lang=js&




var v_map_tracker_iconvue_type_script_lang_js_defWidth = 28;
var v_map_tracker_iconvue_type_script_lang_js_defHeight = 28;
/* harmony default export */ var v_map_tracker_iconvue_type_script_lang_js_ = ({
  name: "v-map-tracker-icon",
  inject: ["setMarkerIcon"],
  components: {
    VVisaryIcon: v_visary_icon
  },
  props: {
    size: {
      type: Array,
      default: function _default() {
        return [v_map_tracker_iconvue_type_script_lang_js_defWidth, v_map_tracker_iconvue_type_script_lang_js_defHeight];
      }
    },
    anchor: {
      type: Array,
      default: null
    },
    popupAnchor: {
      type: Array,
      default: null
    },
    popupOffsetY: {
      type: Number,
      default: -10
    },
    popupOffsetX: {
      type: Number,
      default: 0
    },
    className: {
      type: String,
      default: ""
    },
    color: {
      type: String,
      default: null
    },
    invalidate: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    iconProps: function iconProps() {
      return {
        size: this.size,
        anchor: this.anchor,
        popupAnchor: this.popupAnchor,
        className: this.className
      };
    }
  },
  watch: {
    iconProps: function iconProps() {
      this.updateOnNextTick();
    },
    color: function color() {
      this.updateOnNextTick();
    },
    invalidate: function invalidate() {
      if (this.invalidate) {
        this.updateOnNextTick();
        this.$emit("update:invalidate", false);
      }
    }
  },
  mounted: function mounted() {
    if (this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
    this.updateOnNextTick();
  },
  methods: {
    updateOnNextTick: function updateOnNextTick() {
      var _this = this;
      this.$nextTick(function () {
        _this.updateIcon();
      });
    },
    updateIcon: function updateIcon() {
      var _this$calcProps = this.calcProps(),
        size = _this$calcProps.size,
        anchor = _this$calcProps.anchor,
        popupAnchor = _this$calcProps.popupAnchor;
      var html = this.$el.innerHTML;
      this.setMarkerIcon(this.createDivIcon(html, size, anchor, popupAnchor));
    },
    calcProps: function calcProps() {
      var size = Object(external_leaflet_["point"])(this.size);
      var anchor = this.anchor ? Object(external_leaflet_["point"])(this.anchor) : Object(external_leaflet_["point"])(size.x / 2, size.y / 2);
      var popupAnchor = this.popupAnchor ? Object(external_leaflet_["point"])(this.popupAnchor) : Object(external_leaflet_["point"])(this.popupOffsetX, -size.y - this.popupOffsetY);
      return {
        size: size,
        anchor: anchor,
        popupAnchor: popupAnchor
      };
    },
    createDivIcon: function createDivIcon(html, size, anchor, popupAnchor) {
      return Object(external_leaflet_["divIcon"])({
        className: this.className,
        html: html,
        iconSize: size,
        iconAnchor: anchor,
        popupAnchor: popupAnchor,
        rotateClass: "v-map-tracker__wrap",
        rotateIconClass: "v-map-tracker__icon"
      });
    }
  }
});
// CONCATENATED MODULE: ./src/components/map/v-map-tracker-icon.vue?vue&type=script&lang=js&
 /* harmony default export */ var map_v_map_tracker_iconvue_type_script_lang_js_ = (v_map_tracker_iconvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/map/v-map-tracker-icon.vue





/* normalize component */

var v_map_tracker_icon_component = normalizeComponent(
  map_v_map_tracker_iconvue_type_script_lang_js_,
  v_map_tracker_iconvue_type_template_id_190d35a8_render,
  v_map_tracker_iconvue_type_template_id_190d35a8_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var v_map_tracker_icon = (v_map_tracker_icon_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/v-map-track-layer.vue?vue&type=script&lang=js&


















/* harmony default export */ var v_map_track_layervue_type_script_lang_js_ = ({
  name: "v-map-track-layer",
  mixins: [popup_mixin],
  inject: ["getMap", "presentation"],
  provide: function provide() {
    return {
      setMarkerIcon: this.setMarkerIcon,
      getMarkerIcon: this.getMarkerIcon,
      bindPopup: this.bindPopup,
      unbindPopup: this.unbindPopup,
      getData: this.getData,
      removeFromMap: this.removeFromMap,
      addToMap: this.addToMap,
      getMapObject: this.getMapObject,
      getId: this.getId,
      listenEvent: this.listenEvent
    };
  },
  components: {
    VMapTrackerIcon: v_map_tracker_icon,
    VMapPopup: v_map_popup,
    VMapPopupContent: v_map_popup_content,
    VMapTreeLayer: v_map_tree_layer,
    VMapSingleSelection: v_map_single_selection,
    VMapGroupCount: v_map_group_count,
    VMapGroupVisible: v_map_group_visible
  },
  props: {
    id: {
      type: [String, Number],
      default: null
    },
    title: {
      type: String,
      default: null
    },
    /**
     * sync
     */
    visible: {
      type: Boolean,
      default: true
    },
    /**
     * sync
     */
    selected: {
      type: Boolean,
      default: false
    },
    /**
     * sync
     */
    invalidate: {
      type: Boolean,
      default: true
    },
    /**
     * sync
     */
    fetching: {
      type: Boolean,
      default: false
    },
    filtering: {
      type: Boolean,
      default: false
    },
    filterActive: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    /**
     * sync
     */
    count: {
      type: Number,
      default: 0
    },
    dataSource: {
      type: Object,
      default: null
    },
    markerPane: {
      type: String,
      default: null
    },
    styles: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    geometryField: {
      type: String,
      default: "geometry"
    },
    iconColorField: {
      type: String,
      default: "iconColor"
    },
    idField: {
      type: String,
      default: "id"
    },
    titleField: {
      type: String,
      default: "title"
    },
    descriptionField: {
      type: String,
      default: "description"
    },
    equalsFn: {
      type: Function,
      default: null
    },
    popupShowEdit: {
      type: Boolean,
      default: false
    },
    popupShowDelete: {
      type: Boolean,
      default: false
    },
    popupShowDetails: {
      type: Boolean,
      default: true
    },
    popupAutoPan: {
      type: Boolean,
      default: false
    },
    selection: {
      type: Boolean,
      default: true
    },
    singleSelection: {
      type: Boolean,
      default: true
    },
    selectionKey: {
      type: String,
      default: "maplayer"
    },
    groupCountKey: {
      type: String,
      default: "maplayer"
    },
    groupVisibleKey: {
      type: String,
      default: "maplayer"
    },
    trackerStateCssPrefix: {
      type: String,
      default: "v-map-tracker-state-"
    },
    trackerOptions: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      didInvalidate: this.invalidate,
      dataFetching: this.fetching,
      lastFetchError: null,
      dataCount: this.count,
      dataSelected: this.selected,
      dataVisible: this.visible
    };
  },
  watch: {
    invalidate: function invalidate() {
      this.didInvalidate = this.invalidate;
      this.fetchDataIfNeeded();
    },
    fetching: function fetching() {
      this.dataFetching = this.fetching;
    },
    dataSource: function dataSource(newDataSource, oldDataSource) {
      this.destroyDataSource(oldDataSource);
      this.initDataSource(newDataSource);
      this.invalidateAndFetch();
    },
    count: function count() {
      this.dataCount = this.count;
    },
    selected: function selected() {
      this.dataSelected = this.selected;
    },
    dataSelected: function dataSelected() {
      /**
       * @type {boolean}
       */
      this.$emit("update:selected", this.dataSelected);
    },
    visible: function visible() {
      this.dataVisible = this.visible;
    },
    dataVisible: function dataVisible() {
      this.setVisible(this.dataVisible);
      this.fetchDataIfNeeded();
      /**
       * @type {boolean}
       */
      this.$emit("update:visible", this.dataVisible);
    },
    styles: {
      deep: true,
      handler: "stylesChanged"
    }
  },
  mounted: function mounted() {
    var _this = this;
    this.mapObject = this.createGroup();
    this.tracker = this.createTracker();
    this.setVisible(this.dataVisible);
    this.$nextTick(function () {
      _this.initDataSource();
      _this.fetchDataIfNeeded();
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (this.tracker) {
      var _this$tracker$getLaye;
      (_this$tracker$getLaye = this.tracker.getLayerGroupCache()) === null || _this$tracker$getLaye === void 0 ? void 0 : _this$tracker$getLaye.destroy();
      this.tracker.destroy();
    }
    if (this.mapObject) {
      this.mapObject.off("click", this.handleGroupClick);
      this.mapObject.clearLayers().remove();
    }
    this.destroyDataSource();
  },
  methods: {
    createGroup: function createGroup() {
      var layerGroup = Object(external_leaflet_["featureGroup"])();
      layerGroup.on("click", this.handleGroupClick);
      layerGroup.on("layeradd", this.handleLayerAddToGroup);
      layerGroup.on("layerremove", this.handleLayerRemoveFromGroup);
      return layerGroup;
    },
    createTracker: function createTracker() {
      var _this2 = this;
      var layerGroupCache = new external_leaflet_["LayerGroupCache"](this.mapObject, function (id, layer) {
        return layer.options.data[_this2.idField] === id;
      });
      return new external_leaflet_["Tracker"](layerGroupCache, _objectSpread2({
        connStateCssPrefix: this.trackerStateCssPrefix
      }, this.trackerOptions));
    },
    invalidateAndFetch: function invalidateAndFetch() {
      this.didInvalidate = true;
      this.fetchDataIfNeeded();
    },
    clearAndInvalidate: function clearAndInvalidate() {
      this.clear();
      this.didInvalidate = true;
      this.$emit("update:invalidate", this.didInvalidate);
    },
    fetchDataIfNeeded: function fetchDataIfNeeded() {
      if (this.shouldFetchData()) {
        this.fetchData();
      }
    },
    shouldFetchData: function shouldFetchData() {
      return this.didInvalidate && this.dataVisible;
    },
    canFetchData: function canFetchData() {
      return this.dataSource && typeof this.dataSource.fetchData === "function";
    },
    canDataFetched: function canDataFetched() {
      return this.dataSource && typeof this.dataSource.dataFetched === "function";
    },
    canBeforeFetch: function canBeforeFetch() {
      return this.dataSource && typeof this.dataSource.beforeFetch === "function";
    },
    canInitDataSource: function canInitDataSource() {
      var dataSource = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.dataSource;
      return dataSource && typeof dataSource.init === "function";
    },
    canDestroyDataSource: function canDestroyDataSource() {
      var dataSource = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.dataSource;
      return dataSource && typeof dataSource.destroy === "function";
    },
    initDataSource: function initDataSource() {
      var dataSource = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.dataSource;
      if (this.canInitDataSource(dataSource)) {
        dataSource.init(this);
      }
    },
    destroyDataSource: function destroyDataSource() {
      var dataSource = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.dataSource;
      if (this.canDestroyDataSource(dataSource)) {
        dataSource.destroy();
      }
    },
    fetchData: function fetchData() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var responseData, mapObjects;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                if (_this3.canFetchData()) {
                  _context.next = 3;
                  break;
                }
                return _context.abrupt("return");
              case 3:
                if (_this3.canBeforeFetch()) {
                  _this3.dataSource.beforeFetch();
                }
                _this3.didInvalidate = false;
                _this3.dataFetching = true;
                _this3.lastFetchError = null;

                /**
                 * @type {boolean}
                 */
                _this3.$emit("update:invalidate", false);
                /**
                 * @type {boolean}
                 */
                _this3.$emit("update:fetching", true);
                _context.next = 11;
                return _this3.dataSource.fetchData(_this3.id);
              case 11:
                responseData = _context.sent;
                if (!_this3._isDestroyed) {
                  _context.next = 14;
                  break;
                }
                return _context.abrupt("return");
              case 14:
                mapObjects = _this3.createMapObjects(responseData);
                _this3.clearMapObjects();
                _this3.placeMapObjects(mapObjects);
                _this3.updatePopup(mapObjects);
                _this3.dataFetching = false;
                _this3.dataCount = mapObjects.length;

                /**
                 * @type {boolean}
                 */
                _this3.$emit("update:fetching", false);
                /**
                 * @type {number}
                 */
                _this3.$emit("update:count", _this3.dataCount);

                /**
                 * @type {object}
                 */
                _this3.$emit("data:changed", {
                  data: responseData
                });
                if (_this3.canDataFetched()) {
                  _this3.dataSource.dataFetched(responseData);
                }
                _context.next = 34;
                break;
              case 26:
                _context.prev = 26;
                _context.t0 = _context["catch"](0);
                if (!is_cancel(_context.t0)) {
                  _context.next = 30;
                  break;
                }
                return _context.abrupt("return");
              case 30:
                logger.error(_context.t0);
                _this3.dataFetching = false;
                _this3.lastFetchError = _context.t0;
                /**
                 * @type {boolean}
                 */
                _this3.$emit("update:fetching", false);
              case 34:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 26]]);
      }))();
    },
    setVisible: function setVisible(visible) {
      var map = this.getMap();
      if (visible) {
        map.addLayer(this.mapObject);
      } else {
        map.removeLayer(this.mapObject);
      }
    },
    createMapObjects: function createMapObjects(items) {
      var _this4 = this;
      return items.map(function (item) {
        return _this4.createMapObject(item);
      }).filter(function (item) {
        return !!item;
      });
    },
    createMapObject: function createMapObject(itemData) {
      try {
        var geometry = itemData[this.geometryField];
        if (!geometry || !external_leaflet_["leafletUtil"].geometryIsPoint(geometry)) return null;
        var mapObject = external_leaflet_["GeoJSON"].geometryToLayer(geometry, {
          pointToLayer: function pointToLayer(geojson, latlng) {
            return new external_leaflet_["Marker"].MovingMarker([latlng]);
          }
        });
        mapObject.options.data = itemData;
        if (this.markerPane) {
          mapObject.options.pane = this.markerPane;
        }
        if (this.markerIcon) {
          mapObject.setIcon(this.markerIcon);
        }
        return mapObject;
      } catch (e) {
        logger.error(e);
        return null;
      }
    },
    placeMapObjects: function placeMapObjects(mapObjects) {
      for (var i = 0, size = mapObjects.length; i < size; i++) {
        this.mapObject.addLayer(mapObjects[i]);
      }
    },
    clearMapObjects: function clearMapObjects() {
      var _this$tracker$getLaye2;
      (_this$tracker$getLaye2 = this.tracker.getLayerGroupCache()) === null || _this$tracker$getLaye2 === void 0 ? void 0 : _this$tracker$getLaye2.clear();
      this.mapObject.clearLayers();
    },
    clear: function clear() {
      this.clearMapObjects();
      this.dataCount = 0;
      this.$emit("update:count", this.dataCount);
      this.$emit("clear");
    },
    addObject: function addObject(data) {
      var mapObjects = this.createMapObjects([data]);
      this.placeMapObjects(mapObjects);
      this.dataCount += mapObjects.length;
      this.$emit("update:count", this.dataCount);
    },
    setMarkerIcon: function setMarkerIcon(value) {
      this.markerIcon = value;
    },
    getMarkerIcon: function getMarkerIcon() {
      return this.markerIcon;
    },
    getData: function getData() {
      var _this$mapObject$getLa, _this$mapObject;
      return (_this$mapObject$getLa = (_this$mapObject = this.mapObject) === null || _this$mapObject === void 0 ? void 0 : _this$mapObject.getLayers().map(function (l) {
        return l.options.data;
      })) !== null && _this$mapObject$getLa !== void 0 ? _this$mapObject$getLa : [];
    },
    getMapObject: function getMapObject() {
      return this.mapObject;
    },
    getId: function getId() {
      return this.id;
    },
    getTracker: function getTracker() {
      return this.tracker;
    },
    removeFromMap: function removeFromMap() {
      if (this._isDestroyed || !this.mapObject) return;
      var map = this.getMap();
      map.removeLayer(this.mapObject);
    },
    addToMap: function addToMap() {
      if (this._isDestroyed || !this.mapObject) return;
      var map = this.getMap();
      map.addLayer(this.mapObject);
    },
    stylesChanged: function stylesChanged() {
      var _this5 = this;
      this.$nextTick(function () {
        _this5.invalidateAndFetch();
      });
    },
    listenEvent: function listenEvent(event, listener) {
      var unsubscribe = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      if (unsubscribe) {
        this.$off(event, listener);
      } else {
        this.$on(event, listener);
      }
    },
    handleGroupClick: function handleGroupClick(e) {
      /**
       * @type {object}
       */
      this.$emit("object:click", _objectSpread2(_objectSpread2({}, e), {}, {
        layerId: this.id
      }));
    },
    handleLayerAddToGroup: function handleLayerAddToGroup(e) {
      e.layer.on("move", this.propagateMoveEvent);
    },
    handleLayerRemoveFromGroup: function handleLayerRemoveFromGroup(e) {
      e.layer.off("move", this.propagateMoveEvent);
    },
    propagateMoveEvent: function propagateMoveEvent(e) {
      e.sourceTarget._propagateEvent(e);
    },
    handlePopupEditPressed: function handlePopupEditPressed(itemData) {
      /**
       * @type {object}
       */
      this.$emit("popup:edit", {
        layerId: this.id,
        popup: this.mapObject.getPopup(),
        data: _objectSpread2({}, itemData)
      });
    },
    handlePopupDeletePressed: function handlePopupDeletePressed(itemData) {
      /**
       * @type {object}
       */
      this.$emit("popup:delete", {
        layerId: this.id,
        popup: this.mapObject.getPopup(),
        data: _objectSpread2({}, itemData)
      });
    },
    handlePopupDetailsPressed: function handlePopupDetailsPressed(itemData) {
      /**
       * @type {object}
       */
      this.$emit("popup:details", {
        layerId: this.id,
        popup: this.mapObject.getPopup(),
        data: _objectSpread2({}, itemData)
      });
    },
    handleFilterPressed: function handleFilterPressed() {
      /**
       * @type {object}
       */
      this.$emit("filter", {
        layerId: this.id
      });
    },
    handleCountPressed: function handleCountPressed(e) {
      /**
       * @type {object}
       */
      this.$emit("count:click", _objectSpread2(_objectSpread2({}, e), {}, {
        layerId: this.id
      }));
    }
  }
});
// CONCATENATED MODULE: ./src/components/map/v-map-track-layer.vue?vue&type=script&lang=js&
 /* harmony default export */ var map_v_map_track_layervue_type_script_lang_js_ = (v_map_track_layervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/map/v-map-track-layer.vue?vue&type=custom&index=0&blockType=docs
var v_map_track_layervue_type_custom_index_0_blockType_docs = __webpack_require__("f759");
var v_map_track_layervue_type_custom_index_0_blockType_docs_default = /*#__PURE__*/__webpack_require__.n(v_map_track_layervue_type_custom_index_0_blockType_docs);

// EXTERNAL MODULE: ./src/components/map/v-map-track-layer.vue?vue&type=custom&index=1&blockType=docs
var v_map_track_layervue_type_custom_index_1_blockType_docs = __webpack_require__("a646");
var v_map_track_layervue_type_custom_index_1_blockType_docs_default = /*#__PURE__*/__webpack_require__.n(v_map_track_layervue_type_custom_index_1_blockType_docs);

// CONCATENATED MODULE: ./src/components/map/v-map-track-layer.vue





/* normalize component */

var v_map_track_layer_component = normalizeComponent(
  map_v_map_track_layervue_type_script_lang_js_,
  v_map_track_layervue_type_template_id_4f6a9f23_render,
  v_map_track_layervue_type_template_id_4f6a9f23_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */

if (typeof v_map_track_layervue_type_custom_index_0_blockType_docs_default.a === 'function') v_map_track_layervue_type_custom_index_0_blockType_docs_default()(v_map_track_layer_component)

if (typeof v_map_track_layervue_type_custom_index_1_blockType_docs_default.a === 'function') v_map_track_layervue_type_custom_index_1_blockType_docs_default()(v_map_track_layer_component)

/* harmony default export */ var v_map_track_layer = (v_map_track_layer_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"443a82ff-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/v-map-layer-panel.vue?vue&type=template&id=f84e16b4&
var v_map_layer_panelvue_type_template_id_f84e16b4_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('v-map-panel', {
    attrs: {
      "open": "",
      "vertical-separator": false
    }
  }, [_c('v-map-tree', [_vm._t("default")], 2)], 1);
};
var v_map_layer_panelvue_type_template_id_f84e16b4_staticRenderFns = [];

// CONCATENATED MODULE: ./src/components/map/v-map-layer-panel.vue?vue&type=template&id=f84e16b4&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"443a82ff-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/v-map-panel.vue?vue&type=template&id=6dd49db2&
var v_map_panelvue_type_template_id_6dd49db2_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "v-map-panel",
    class: {
      'v-map-panel--open': _vm.open,
      'v-map-panel--minimized': _vm.minimized,
      'v-map-panel--vertical-separator': _vm.verticalSeparator
    }
  }, [_c('div', {
    staticClass: "v-map-panel__minimized",
    on: {
      "click": _vm.onMaximize
    }
  }, [_vm.hasIcon || _vm.defaultIcon ? _c('span', {
    staticClass: "v-map-panel__header__icon"
  }, [_vm.hasIcon ? _vm._t("icon") : _vm.defaultIcon ? _c('v-visary-icon') : _vm._e()], 2) : _vm._e(), _c('span', {
    staticClass: "v-map-panel__header__action"
  })]), _c('div', {
    staticClass: "v-map-panel__wrapper"
  }, [_vm.title != null || _vm.count != null ? _c('div', {
    staticClass: "v-map-panel__header"
  }, [_c('p', {
    staticClass: "v-map-panel__header__content"
  }, [_vm.hasIcon || _vm.defaultIcon ? _c('span', {
    staticClass: "v-map-panel__header__icon"
  }, [_vm.hasIcon ? _vm._t("icon") : _vm.defaultIcon ? _c('v-visary-icon') : _vm._e()], 2) : _vm._e(), _vm.title != null ? _c('span', {
    staticClass: "v-map-panel__header__title"
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm.count != null ? _c('span', {
    staticClass: "v-map-panel__header__count"
  }, [_vm._v(_vm._s(_vm.count))]) : _vm._e()]), _c('span', {
    staticClass: "v-map-panel__header__action",
    on: {
      "click": _vm.onClose
    }
  })]) : _vm._e(), _vm._t("search"), _c('div', {
    staticClass: "v-map-panel__content"
  }, [_vm.scrolling ? _c('v-map-scroll', [_vm._t("default")], 2) : _vm._t("default")], 2)], 2)]);
};
var v_map_panelvue_type_template_id_6dd49db2_staticRenderFns = [];

// CONCATENATED MODULE: ./src/components/map/v-map-panel.vue?vue&type=template&id=6dd49db2&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"443a82ff-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/v-map-scroll.vue?vue&type=template&id=0d37efc0&
var v_map_scrollvue_type_template_id_0d37efc0_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('perfect-scrollbar', {
    ref: "ps"
  }, [_vm._t("default")], 2);
};
var v_map_scrollvue_type_template_id_0d37efc0_staticRenderFns = [];

// CONCATENATED MODULE: ./src/components/map/v-map-scroll.vue?vue&type=template&id=0d37efc0&

// EXTERNAL MODULE: external "vue2-perfect-scrollbar"
var external_vue2_perfect_scrollbar_ = __webpack_require__("d7c9");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/v-map-scroll.vue?vue&type=script&lang=js&

/* harmony default export */ var v_map_scrollvue_type_script_lang_js_ = ({
  name: "v-map-scroll",
  inject: ["getMap"],
  provide: function provide() {
    return {
      getScroll: this.getScroll
    };
  },
  components: {
    PerfectScrollbar: external_vue2_perfect_scrollbar_["PerfectScrollbar"]
  },
  mounted: function mounted() {
    var _this = this;
    var map = this.getMap();
    map.on("vmap:scroll:update", this.updateScroll);
    this.$nextTick(function () {
      _this.updateScroll();
    });
  },
  beforeDestroy: function beforeDestroy() {
    var map = this.getMap();
    map.off("vmap:scroll:update", this.updateScroll);
  },
  methods: {
    updateScroll: function updateScroll() {
      this.$refs.ps.update();
    },
    getScroll: function getScroll() {
      return this.$refs.ps;
    }
  }
});
// CONCATENATED MODULE: ./src/components/map/v-map-scroll.vue?vue&type=script&lang=js&
 /* harmony default export */ var map_v_map_scrollvue_type_script_lang_js_ = (v_map_scrollvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/map/v-map-scroll.vue





/* normalize component */

var v_map_scroll_component = normalizeComponent(
  map_v_map_scrollvue_type_script_lang_js_,
  v_map_scrollvue_type_template_id_0d37efc0_render,
  v_map_scrollvue_type_template_id_0d37efc0_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var v_map_scroll = (v_map_scroll_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/v-map-panel.vue?vue&type=script&lang=js&



/* harmony default export */ var v_map_panelvue_type_script_lang_js_ = ({
  name: "v-map-panel",
  components: {
    VMapScroll: v_map_scroll,
    VVisaryIcon: v_visary_icon
  },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    minimized: {
      type: Boolean,
      default: false
    },
    scrolling: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: null
    },
    count: {
      type: Number,
      default: null
    },
    defaultIcon: {
      type: Boolean,
      default: true
    },
    verticalSeparator: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    hasIcon: function hasIcon() {
      return !!this.$slots.icon;
    }
  },
  methods: {
    onMaximize: function onMaximize() {
      this.$emit("maximize");
    },
    onClose: function onClose() {
      this.$emit("close");
    }
  }
});
// CONCATENATED MODULE: ./src/components/map/v-map-panel.vue?vue&type=script&lang=js&
 /* harmony default export */ var map_v_map_panelvue_type_script_lang_js_ = (v_map_panelvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/map/v-map-panel.vue





/* normalize component */

var v_map_panel_component = normalizeComponent(
  map_v_map_panelvue_type_script_lang_js_,
  v_map_panelvue_type_template_id_6dd49db2_render,
  v_map_panelvue_type_template_id_6dd49db2_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var v_map_panel = (v_map_panel_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"443a82ff-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/v-map-tree.vue?vue&type=template&id=79c6269d&
var v_map_treevue_type_template_id_79c6269d_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ul', {
    staticClass: "v-map-tree"
  }, [_vm._t("default")], 2);
};
var v_map_treevue_type_template_id_79c6269d_staticRenderFns = [];

// CONCATENATED MODULE: ./src/components/map/v-map-tree.vue?vue&type=template&id=79c6269d&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/v-map-tree.vue?vue&type=script&lang=js&
/* harmony default export */ var v_map_treevue_type_script_lang_js_ = ({
  name: "v-map-tree"
});
// CONCATENATED MODULE: ./src/components/map/v-map-tree.vue?vue&type=script&lang=js&
 /* harmony default export */ var map_v_map_treevue_type_script_lang_js_ = (v_map_treevue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/map/v-map-tree.vue





/* normalize component */

var v_map_tree_component = normalizeComponent(
  map_v_map_treevue_type_script_lang_js_,
  v_map_treevue_type_template_id_79c6269d_render,
  v_map_treevue_type_template_id_79c6269d_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var v_map_tree = (v_map_tree_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/v-map-layer-panel.vue?vue&type=script&lang=js&


/* harmony default export */ var v_map_layer_panelvue_type_script_lang_js_ = ({
  name: "v-map-layer-panel",
  provide: function provide() {
    return {
      presentation: function presentation() {
        return true;
      }
    };
  },
  components: {
    VMapPanel: v_map_panel,
    VMapTree: v_map_tree
  }
});
// CONCATENATED MODULE: ./src/components/map/v-map-layer-panel.vue?vue&type=script&lang=js&
 /* harmony default export */ var map_v_map_layer_panelvue_type_script_lang_js_ = (v_map_layer_panelvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/map/v-map-layer-panel.vue





/* normalize component */

var v_map_layer_panel_component = normalizeComponent(
  map_v_map_layer_panelvue_type_script_lang_js_,
  v_map_layer_panelvue_type_template_id_f84e16b4_render,
  v_map_layer_panelvue_type_template_id_f84e16b4_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var v_map_layer_panel = (v_map_layer_panel_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/v-map-tile-layer.vue?vue&type=script&lang=js&




/* harmony default export */ var v_map_tile_layervue_type_script_lang_js_ = ({
  name: "v-map-tile-layer",
  mixins: [tile_layer_props_mixin, tile_layer_mixin],
  props: {
    /**
     * required
     */
    url: {
      type: String,
      required: true
    },
    params: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  methods: {
    createMapObject: function createMapObject() {
      return Object(external_leaflet_["tileLayer"])(this.url, _objectSpread2(_objectSpread2({}, this.params), {}, {
        minZoom: this.minZoom,
        maxZoom: this.maxZoom,
        subdomains: this.subdomains,
        errorTileUrl: this.errorTileUrl,
        zoomOffset: this.zoomOffset,
        tms: this.tms,
        zoomReverse: this.zoomReverse,
        detectRetina: this.detectRetina,
        crossOrigin: this.crossOrigin,
        pane: this.pane,
        opacity: this.opacity,
        zIndex: this.zIndex,
        tileSize: this.tileSize,
        noWrap: this.noWrap,
        className: this.className,
        attribution: this.attribution
      }));
    }
  },
  render: function render() {
    return null;
  }
});
// CONCATENATED MODULE: ./src/components/map/v-map-tile-layer.vue?vue&type=script&lang=js&
 /* harmony default export */ var map_v_map_tile_layervue_type_script_lang_js_ = (v_map_tile_layervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/map/v-map-tile-layer.vue?vue&type=custom&index=0&blockType=docs
var v_map_tile_layervue_type_custom_index_0_blockType_docs = __webpack_require__("ef86");
var v_map_tile_layervue_type_custom_index_0_blockType_docs_default = /*#__PURE__*/__webpack_require__.n(v_map_tile_layervue_type_custom_index_0_blockType_docs);

// EXTERNAL MODULE: ./src/components/map/v-map-tile-layer.vue?vue&type=custom&index=1&blockType=docs
var v_map_tile_layervue_type_custom_index_1_blockType_docs = __webpack_require__("89fa");
var v_map_tile_layervue_type_custom_index_1_blockType_docs_default = /*#__PURE__*/__webpack_require__.n(v_map_tile_layervue_type_custom_index_1_blockType_docs);

// CONCATENATED MODULE: ./src/components/map/v-map-tile-layer.vue
var v_map_tile_layer_render, v_map_tile_layer_staticRenderFns




/* normalize component */

var v_map_tile_layer_component = normalizeComponent(
  map_v_map_tile_layervue_type_script_lang_js_,
  v_map_tile_layer_render,
  v_map_tile_layer_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */

if (typeof v_map_tile_layervue_type_custom_index_0_blockType_docs_default.a === 'function') v_map_tile_layervue_type_custom_index_0_blockType_docs_default()(v_map_tile_layer_component)

if (typeof v_map_tile_layervue_type_custom_index_1_blockType_docs_default.a === 'function') v_map_tile_layervue_type_custom_index_1_blockType_docs_default()(v_map_tile_layer_component)

/* harmony default export */ var v_map_tile_layer = (v_map_tile_layer_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"443a82ff-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/v-map-svg-overlay.vue?vue&type=template&id=263372f8&
var v_map_svg_overlayvue_type_template_id_263372f8_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('svg', _vm._g(_vm._b({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, 'svg', _vm.attributes, false), _vm.$listeners), [_vm._t("default")], 2);
};
var v_map_svg_overlayvue_type_template_id_263372f8_staticRenderFns = [];

// CONCATENATED MODULE: ./src/components/map/v-map-svg-overlay.vue?vue&type=template&id=263372f8&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/v-map-svg-overlay.vue?vue&type=script&lang=js&


/* harmony default export */ var v_map_svg_overlayvue_type_script_lang_js_ = ({
  name: "v-map-svg-overlay",
  inject: ["getMap"],
  props: {
    attributes: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    bounds: {
      type: [external_leaflet_["LatLngBounds"], Array],
      default: function _default() {
        return [[0, 0], [0, 0]];
      }
    },
    interactive: {
      type: Boolean,
      default: false
    },
    className: {
      type: String,
      default: ""
    },
    overlayOptions: {
      type: Object,
      default: null
    }
  },
  mounted: function mounted() {
    if (this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
    this.mapObject = Object(external_leaflet_["svgOverlay"])(this.$el, this.bounds, _objectSpread2({
      interactive: this.interactive,
      className: this.className
    }, this.overlayOptions));
    var map = this.getMap();
    this.mapObject.addTo(map);
  },
  beforeDestroy: function beforeDestroy() {
    if (this.mapObject) {
      this.mapObject.remove();
    }
  }
});
// CONCATENATED MODULE: ./src/components/map/v-map-svg-overlay.vue?vue&type=script&lang=js&
 /* harmony default export */ var map_v_map_svg_overlayvue_type_script_lang_js_ = (v_map_svg_overlayvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/map/v-map-svg-overlay.vue





/* normalize component */

var v_map_svg_overlay_component = normalizeComponent(
  map_v_map_svg_overlayvue_type_script_lang_js_,
  v_map_svg_overlayvue_type_template_id_263372f8_render,
  v_map_svg_overlayvue_type_template_id_263372f8_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var v_map_svg_overlay = (v_map_svg_overlay_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"443a82ff-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/v-map-sidebar.vue?vue&type=template&id=cc88d280&
var v_map_sidebarvue_type_template_id_cc88d280_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "v-map-sidebar"
  }, [_c('div', {
    staticClass: "v-map-sidebar__toggle-button v-map-no-printable",
    on: {
      "click": _vm.toggle
    }
  }, [_c('v-arrow-icon', {
    staticClass: "v-map-sidebar__toggle-button__icon"
  })], 1), _vm._t("default")], 2);
};
var v_map_sidebarvue_type_template_id_cc88d280_staticRenderFns = [];

// CONCATENATED MODULE: ./src/components/map/v-map-sidebar.vue?vue&type=template&id=cc88d280&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/v-map-sidebar.vue?vue&type=script&lang=js&


var sidebarOpenCss = "v-map-sidebar--open";
/* harmony default export */ var v_map_sidebarvue_type_script_lang_js_ = ({
  name: "v-map-sidebar",
  inject: ["getMap"],
  components: {
    VArrowIcon: v_arrow_icon
  },
  props: {
    open: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      isOpened: this.open
    };
  },
  watch: {
    open: function open() {
      this.isOpened = this.open;
    },
    isOpened: function isOpened() {
      this.updateCss();
    }
  },
  mounted: function mounted() {
    this.updateCss();
    external_leaflet_["DomEvent"].disableClickPropagation(this.$el);
    external_leaflet_["DomEvent"].disableScrollPropagation(this.$el);
  },
  beforeDestroy: function beforeDestroy() {
    var map = this.getMap();
    if (!map.getContainer()) return;
    external_leaflet_["DomUtil"].removeClass(map.getContainer(), sidebarOpenCss);
  },
  methods: {
    toggle: function toggle() {
      this.isOpened = !this.isOpened;
      this.$emit("update:open", this.isOpened);
    },
    updateCss: function updateCss() {
      var map = this.getMap();
      var mapContainer = map.getContainer();
      if (!mapContainer) return;
      if (this.isOpened) {
        external_leaflet_["DomUtil"].addClass(mapContainer, sidebarOpenCss);
      } else {
        external_leaflet_["DomUtil"].removeClass(mapContainer, sidebarOpenCss);
      }
    }
  }
});
// CONCATENATED MODULE: ./src/components/map/v-map-sidebar.vue?vue&type=script&lang=js&
 /* harmony default export */ var map_v_map_sidebarvue_type_script_lang_js_ = (v_map_sidebarvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/map/v-map-sidebar.vue





/* normalize component */

var v_map_sidebar_component = normalizeComponent(
  map_v_map_sidebarvue_type_script_lang_js_,
  v_map_sidebarvue_type_template_id_cc88d280_render,
  v_map_sidebarvue_type_template_id_cc88d280_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var v_map_sidebar = (v_map_sidebar_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"443a82ff-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/v-map-list.vue?vue&type=template&id=308224aa&
var v_map_listvue_type_template_id_308224aa_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(_vm.tag, {
    tag: "component"
  }, _vm._l(_vm.items, function (item, index) {
    return _c(_vm.itemTag, {
      key: item.id || index,
      tag: "component",
      staticClass: "v-map-item",
      on: {
        "click": function click($event) {
          return _vm.onClick(item);
        }
      }
    }, [_c('p', {
      staticClass: "v-map-item__inside"
    }, [_vm._t("default", function () {
      return [_c('span', {
        staticClass: "v-map-item__title"
      }, [_vm._v(_vm._s(item.title))])];
    }, {
      "item": item
    })], 2)]);
  }), 1);
};
var v_map_listvue_type_template_id_308224aa_staticRenderFns = [];

// CONCATENATED MODULE: ./src/components/map/v-map-list.vue?vue&type=template&id=308224aa&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/v-map-list.vue?vue&type=script&lang=js&
/* harmony default export */ var v_map_listvue_type_script_lang_js_ = ({
  name: "v-map-list",
  props: {
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    tag: {
      type: String,
      default: "ul"
    },
    itemTag: {
      type: String,
      default: "li"
    }
  },
  methods: {
    onClick: function onClick(item) {
      this.$emit("item-click", item);
    }
  }
});
// CONCATENATED MODULE: ./src/components/map/v-map-list.vue?vue&type=script&lang=js&
 /* harmony default export */ var map_v_map_listvue_type_script_lang_js_ = (v_map_listvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/map/v-map-list.vue





/* normalize component */

var v_map_list_component = normalizeComponent(
  map_v_map_listvue_type_script_lang_js_,
  v_map_listvue_type_template_id_308224aa_render,
  v_map_listvue_type_template_id_308224aa_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var v_map_list = (v_map_list_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"443a82ff-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/v-map-card.vue?vue&type=template&id=57cc1827&
var v_map_cardvue_type_template_id_57cc1827_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "v-map-card"
  }, [_c('h1', {
    staticClass: "v-map-card__title"
  }, [_vm._v("Комплекс мониторинга окружающей среды Малгобек")]), _c('p', {
    staticClass: "v-map-card__description"
  }, [_vm._v("Повседневная практика показывает, что консультация с широким активом обеспечивает широкому кругу (специалистов) участие в формировании существенных финансовых и административных условий.")]), _c('h2', {
    staticClass: "v-map-card__subtitle"
  }, [_vm._v("Информация")]), _c('ul', {
    staticClass: "v-map-card__section__info"
  }, [_c('li', {
    staticClass: "v-map-card__section__item"
  }, [_c('v-address-pin-icon', {
    staticClass: "v-map-card__section__info__icon"
  }), _c('p', [_vm._v("Велозаводская ул., 6, Москва, 115280")])], 1), _c('li', {
    staticClass: "v-map-card__section__item"
  }, [_c('v-phone-icon', {
    staticClass: "v-map-card__section__info__icon"
  }), _c('p', [_vm._v("8 (499) 764-15-32")])], 1)]), _c('h2', {
    staticClass: "v-map-card__subtitle"
  }, [_vm._v("Фото")]), _vm._m(0)]);
};
var v_map_cardvue_type_template_id_57cc1827_staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ul', {
    staticClass: "v-map-card__section__carousel"
  }, [_c('li', {
    staticClass: "v-map-card__section__carousel__item"
  }, [_c('img', {
    staticClass: "v-map-card__img",
    attrs: {
      "src": "https://avatars.mds.yandex.net/get-pdb/1636338/e23257f8-bbe2-456b-a3d6-de66968c65d1/s1200"
    }
  })]), _c('li', {
    staticClass: "v-map-card__section__carousel__item"
  }, [_c('img', {
    staticClass: "v-map-card__img",
    attrs: {
      "src": "https://avatars.mds.yandex.net/get-pdb/228049/0a78e7bc-71f2-40bc-adac-d38b9c2f8e30/s1200"
    }
  })]), _c('li', {
    staticClass: "v-map-card__section__carousel__item"
  }, [_c('img', {
    staticClass: "v-map-card__img",
    attrs: {
      "src": "https://avatars.mds.yandex.net/get-pdb/34158/e910f963-cad3-4983-8e4e-cea2abcf2be2/s1200"
    }
  })])]);
}];

// CONCATENATED MODULE: ./src/components/map/v-map-card.vue?vue&type=template&id=57cc1827&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"443a82ff-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/icons/v-phone-icon.vue?vue&type=template&id=08e1c679&
var v_phone_iconvue_type_template_id_08e1c679_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('svg', {
    staticClass: "v-map-svg",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512",
      "fill": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "d": "M476.5 22.9L382.3 1.2c-21.6-5-43.6 6.2-52.3 26.6l-43.5 101.5c-8 18.6-2.6 40.6 13.1 53.4l40 32.7C311 267.8 267.8 311 215.4 339.5l-32.7-40c-12.8-15.7-34.8-21.1-53.4-13.1L27.7 329.9c-20.4 8.7-31.5 30.7-26.6 52.3l21.7 94.2c4.8 20.9 23.2 35.5 44.6 35.5C312.3 512 512 313.7 512 67.5c0-21.4-14.6-39.8-35.5-44.6zM69.3 464l-20.9-90.7 98.2-42.1 55.7 68.1c98.8-46.4 150.6-98 197-197l-68.1-55.7 42.1-98.2L464 69.3C463 286.9 286.9 463 69.3 464z"
    }
  })]);
};
var v_phone_iconvue_type_template_id_08e1c679_staticRenderFns = [];

// CONCATENATED MODULE: ./src/components/map/icons/v-phone-icon.vue?vue&type=template&id=08e1c679&

// CONCATENATED MODULE: ./src/components/map/icons/v-phone-icon.vue

var v_phone_icon_script = {}


/* normalize component */

var v_phone_icon_component = normalizeComponent(
  v_phone_icon_script,
  v_phone_iconvue_type_template_id_08e1c679_render,
  v_phone_iconvue_type_template_id_08e1c679_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var v_phone_icon = (v_phone_icon_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"443a82ff-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/icons/v-address-pin-icon.vue?vue&type=template&id=b620403c&
var v_address_pin_iconvue_type_template_id_b620403c_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('svg', {
    staticClass: "v-map-svg",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 384 512",
      "fill": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "d": "M192 0C85.903 0 0 86.014 0 192c0 71.117 23.991 93.341 151.271 297.424 18.785 30.119 62.694 30.083 81.457 0C360.075 285.234 384 263.103 384 192 384 85.903 297.986 0 192 0zm0 464C64.576 259.686 48 246.788 48 192c0-79.529 64.471-144 144-144s144 64.471 144 144c0 54.553-15.166 65.425-144 272zm-80-272c0-44.183 35.817-80 80-80s80 35.817 80 80-35.817 80-80 80-80-35.817-80-80z"
    }
  })]);
};
var v_address_pin_iconvue_type_template_id_b620403c_staticRenderFns = [];

// CONCATENATED MODULE: ./src/components/map/icons/v-address-pin-icon.vue?vue&type=template&id=b620403c&

// CONCATENATED MODULE: ./src/components/map/icons/v-address-pin-icon.vue

var v_address_pin_icon_script = {}


/* normalize component */

var v_address_pin_icon_component = normalizeComponent(
  v_address_pin_icon_script,
  v_address_pin_iconvue_type_template_id_b620403c_render,
  v_address_pin_iconvue_type_template_id_b620403c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var v_address_pin_icon = (v_address_pin_icon_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/v-map-card.vue?vue&type=script&lang=js&


/* harmony default export */ var v_map_cardvue_type_script_lang_js_ = ({
  name: "v-map-card",
  components: {
    VPhoneIcon: v_phone_icon,
    VAddressPinIcon: v_address_pin_icon
  }
});
// CONCATENATED MODULE: ./src/components/map/v-map-card.vue?vue&type=script&lang=js&
 /* harmony default export */ var map_v_map_cardvue_type_script_lang_js_ = (v_map_cardvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/map/v-map-card.vue





/* normalize component */

var v_map_card_component = normalizeComponent(
  map_v_map_cardvue_type_script_lang_js_,
  v_map_cardvue_type_template_id_57cc1827_render,
  v_map_cardvue_type_template_id_57cc1827_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var v_map_card = (v_map_card_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"443a82ff-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/v-map-search.vue?vue&type=template&id=1347c218&
var v_map_searchvue_type_template_id_1347c218_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "v-map-search"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.model,
      expression: "model"
    }],
    staticClass: "v-map-search__input",
    attrs: {
      "type": "search",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm.model
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.model = $event.target.value;
      }
    }
  }), _c('v-search-icon', {
    staticClass: "v-map-search__icon",
    on: {
      "click": _vm.onSearch
    }
  })], 1);
};
var v_map_searchvue_type_template_id_1347c218_staticRenderFns = [];

// CONCATENATED MODULE: ./src/components/map/v-map-search.vue?vue&type=template&id=1347c218&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"443a82ff-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/icons/v-search-icon.vue?vue&type=template&id=1dd7d078&
var v_search_iconvue_type_template_id_1dd7d078_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('svg', _vm._g({
    staticClass: "v-map-svg",
    attrs: {
      "viewBox": "0 0 14 15",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, _vm.$listeners), [_c('path', {
    attrs: {
      "d": "M5.00191 0.714844C6.26777 0.714844 7.48177 1.25152 8.37687 2.20681C9.27196 3.16209 9.77482 4.45774 9.77482 5.80872C9.77482 7.07044 9.34159 8.23027 8.62932 9.12366L8.82758 9.33525H9.40767L13.0791 13.2536L11.9777 14.4291L8.30623 10.5108V9.89166L8.10797 9.68007C7.27088 10.4402 6.18412 10.9026 5.00191 10.9026C3.73606 10.9026 2.52205 10.3659 1.62696 9.41064C0.731862 8.45535 0.229004 7.1597 0.229004 5.80872C0.229004 4.45774 0.731862 3.16209 1.62696 2.20681C2.52205 1.25152 3.73606 0.714844 5.00191 0.714844ZM5.00191 2.28219C3.16618 2.28219 1.69759 3.84954 1.69759 5.80872C1.69759 7.7679 3.16618 9.33525 5.00191 9.33525C6.83765 9.33525 8.30623 7.7679 8.30623 5.80872C8.30623 3.84954 6.83765 2.28219 5.00191 2.28219Z",
      "fill": "#272933"
    }
  })]);
};
var v_search_iconvue_type_template_id_1dd7d078_staticRenderFns = [];

// CONCATENATED MODULE: ./src/components/map/icons/v-search-icon.vue?vue&type=template&id=1dd7d078&

// CONCATENATED MODULE: ./src/components/map/icons/v-search-icon.vue

var v_search_icon_script = {}


/* normalize component */

var v_search_icon_component = normalizeComponent(
  v_search_icon_script,
  v_search_iconvue_type_template_id_1dd7d078_render,
  v_search_iconvue_type_template_id_1dd7d078_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var v_search_icon = (v_search_icon_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/v-map-search.vue?vue&type=script&lang=js&



/* harmony default export */ var v_map_searchvue_type_script_lang_js_ = ({
  name: "v-map-search",
  components: {
    VSearchIcon: v_search_icon
  },
  props: {
    value: {
      type: [String, Number]
    },
    placeholder: {
      type: String,
      default: function _default() {
        return utils_locale.default.searchHint;
      }
    }
  },
  computed: {
    model: {
      get: function get() {
        return this.value;
      },
      set: function set(newValue) {
        this.$emit("input", newValue);
      }
    }
  },
  methods: {
    onSearch: function onSearch() {
      this.$emit("search");
    }
  }
});
// CONCATENATED MODULE: ./src/components/map/v-map-search.vue?vue&type=script&lang=js&
 /* harmony default export */ var map_v_map_searchvue_type_script_lang_js_ = (v_map_searchvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/map/v-map-search.vue





/* normalize component */

var v_map_search_component = normalizeComponent(
  map_v_map_searchvue_type_script_lang_js_,
  v_map_searchvue_type_template_id_1347c218_render,
  v_map_searchvue_type_template_id_1347c218_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var v_map_search = (v_map_search_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"443a82ff-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/v-map-load-more.vue?vue&type=template&id=4b9b527f&
var v_map_load_morevue_type_template_id_4b9b527f_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_vm._t("default", null, {
    "page": _vm.pageNum,
    "pageEnd": _vm.pageEnd,
    "loading": _vm.loading,
    "error": _vm.error
  })], 2);
};
var v_map_load_morevue_type_template_id_4b9b527f_staticRenderFns = [];

// CONCATENATED MODULE: ./src/components/map/v-map-load-more.vue?vue&type=template&id=4b9b527f&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/v-map-load-more.vue?vue&type=script&lang=js&





/* harmony default export */ var v_map_load_morevue_type_script_lang_js_ = ({
  name: "v-map-load-more",
  inject: ["getScroll"],
  props: {
    page: {
      type: Number,
      default: 1
    },
    end: {
      type: Boolean,
      default: false
    },
    dataSource: {
      type: Function,
      default: null
    },
    autoStart: {
      type: Boolean,
      default: false
    },
    scrollDownOffset: {
      type: Number,
      default: 20
    }
  },
  watch: {
    page: function page() {
      this.pageNum = this.page;
    },
    end: function end() {
      this.pageEnd = this.end;
    },
    pageNum: function pageNum() {
      this.$emit("update:page", this.pageNum);
      this.fetchData();
    },
    pageEnd: function pageEnd() {
      this.$emit("update:end", this.pageEnd);
    }
  },
  data: function data() {
    return {
      loading: false,
      error: false,
      pageNum: this.page,
      pageEnd: this.end
    };
  },
  created: function created() {
    if (this.autoStart) {
      this.fetchData();
    }
  },
  mounted: function mounted() {
    var _this = this;
    this.$nextTick(function () {
      var scroll = _this.getScroll();
      if (scroll && scroll.$el) {
        scroll.$el.addEventListener("ps-scroll-down", _this.handleScrollDown);
      }
    });
  },
  beforeDestroy: function beforeDestroy() {
    var scroll = this.getScroll();
    if (scroll && scroll.$el) {
      scroll.$el.removeEventListener("ps-scroll-down", this.handleScrollDown);
    }
  },
  methods: {
    nextPage: function nextPage() {
      if (this.pageEnd) return;
      this.pageNum++;
    },
    canFetchData: function canFetchData() {
      return typeof this.dataSource === "function";
    },
    fetchData: function fetchData() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var count;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                if (_this2.canFetchData()) {
                  _context.next = 3;
                  break;
                }
                return _context.abrupt("return");
              case 3:
                _this2.loading = true;
                _this2.error = false;
                _context.next = 7;
                return _this2.dataSource(_this2.pageNum);
              case 7:
                count = _context.sent;
                if (!_this2._isDestroyed) {
                  _context.next = 10;
                  break;
                }
                return _context.abrupt("return");
              case 10:
                _this2.loading = false;
                if (typeof count === "number") {
                  _this2.pageEnd = count === 0;
                }
                _this2.$nextTick(function () {
                  _this2.updateScroll();
                });
                _context.next = 22;
                break;
              case 15:
                _context.prev = 15;
                _context.t0 = _context["catch"](0);
                if (!is_cancel(_context.t0)) {
                  _context.next = 19;
                  break;
                }
                return _context.abrupt("return");
              case 19:
                logger.error(_context.t0);
                _this2.loading = false;
                _this2.error = _context.t0;
              case 22:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 15]]);
      }))();
    },
    updateScroll: function updateScroll() {
      var scroll = this.getScroll();
      if (scroll) {
        scroll.update();
      }
    },
    handleScrollDown: function handleScrollDown() {
      var scroll = this.getScroll();
      if (!scroll || !scroll.ps) return;
      var _scroll$ps = scroll.ps,
        contentHeight = _scroll$ps.contentHeight,
        containerHeight = _scroll$ps.containerHeight,
        scrollTop = _scroll$ps.element.scrollTop;
      if (scrollTop > contentHeight - containerHeight - 1 - this.scrollDownOffset) {
        if (!this.loading) {
          this.nextPage();
        }
      }
    }
  }
});
// CONCATENATED MODULE: ./src/components/map/v-map-load-more.vue?vue&type=script&lang=js&
 /* harmony default export */ var map_v_map_load_morevue_type_script_lang_js_ = (v_map_load_morevue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/map/v-map-load-more.vue





/* normalize component */

var v_map_load_more_component = normalizeComponent(
  map_v_map_load_morevue_type_script_lang_js_,
  v_map_load_morevue_type_template_id_4b9b527f_render,
  v_map_load_morevue_type_template_id_4b9b527f_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var v_map_load_more = (v_map_load_more_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"443a82ff-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/v-map-loading.vue?vue&type=template&id=5bfd5444&
var v_map_loadingvue_type_template_id_5bfd5444_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "v-map-loading",
    class: {
      'v-map-loading--padding': !_vm.noPadding
    }
  }, [_c('div', {
    staticClass: "v-map-loading__spinner",
    class: _vm.sizeClass
  }, [_c('svg', {
    staticClass: "v-map-loading__spinner__circle",
    attrs: {
      "viewBox": "25 25 50 50"
    }
  }, [_c('circle', {
    staticClass: "v-map-loading__spinner__path",
    class: _vm.color,
    attrs: {
      "cx": "50",
      "cy": "50",
      "r": "20",
      "fill": "none",
      "stroke-width": "2",
      "stroke-miterlimit": "10"
    }
  })])]), _vm.$slots.default ? _c('span', {
    staticClass: "v-map-loading__message"
  }, [_vm._t("default")], 2) : _vm._e()]);
};
var v_map_loadingvue_type_template_id_5bfd5444_staticRenderFns = [];

// CONCATENATED MODULE: ./src/components/map/v-map-loading.vue?vue&type=template&id=5bfd5444&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/v-map-loading.vue?vue&type=script&lang=js&
var sizes = ["xs", "sm", "md", "lg", "auto"];
/* harmony default export */ var v_map_loadingvue_type_script_lang_js_ = ({
  name: "v-map-loading",
  props: {
    size: {
      type: String,
      default: "md",
      validator: function validator(value) {
        return sizes.indexOf(value) !== -1;
      }
    },
    noPadding: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: null
    }
  },
  computed: {
    sizeClass: function sizeClass() {
      switch (this.size) {
        case "lg":
          return "v-map-loading__spinner--lg";
        case "sm":
          return "v-map-loading__spinner--sm";
        case "xs":
          return "v-map-loading__spinner--xs";
        case "auto":
          return "v-map-loading__spinner--auto";
        default:
          return "v-map-loading__spinner--md";
      }
    }
  }
});
// CONCATENATED MODULE: ./src/components/map/v-map-loading.vue?vue&type=script&lang=js&
 /* harmony default export */ var map_v_map_loadingvue_type_script_lang_js_ = (v_map_loadingvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/map/v-map-loading.vue





/* normalize component */

var v_map_loading_component = normalizeComponent(
  map_v_map_loadingvue_type_script_lang_js_,
  v_map_loadingvue_type_template_id_5bfd5444_render,
  v_map_loadingvue_type_template_id_5bfd5444_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var v_map_loading = (v_map_loading_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"443a82ff-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/v-map-route-history.vue?vue&type=template&id=a93571b8&
var v_map_route_historyvue_type_template_id_a93571b8_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('v-map-fit-handler', {
    ref: "fit"
  }), _c('v-map-path-style', {
    attrs: {
      "styles": _vm.styles
    }
  }), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    ref: "tooltip"
  }, [_vm._t("tooltip", null, {
    "id": _vm.id,
    "content": _vm.tooltipContent
  })], 2)])], 1);
};
var v_map_route_historyvue_type_template_id_a93571b8_staticRenderFns = [];

// CONCATENATED MODULE: ./src/components/map/v-map-route-history.vue?vue&type=template&id=a93571b8&

// CONCATENATED MODULE: ./src/utils/circle-cursor.js





var CLOSEST_DISTANCE_TOLERANCE = 0.001;
var circle_cursor_CircleCursor = /*#__PURE__*/function () {
  function CircleCursor(startLatLng, map, targetLayer, pointLayers, tooltipElement) {
    var _options$snapToleranc, _options$circleStyle, _options$tooltipOptio;
    var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
    _classCallCheck(this, CircleCursor);
    this.map = map;
    this.targetLayer = targetLayer;
    this.pointLayers = pointLayers;
    this.tooltipElement = tooltipElement;
    this.isDestroyed = false;
    this.snapTolerance = (_options$snapToleranc = options.snapTolerance) !== null && _options$snapToleranc !== void 0 ? _options$snapToleranc : 0;
    this.circleStyle = (_options$circleStyle = options.circleStyle) !== null && _options$circleStyle !== void 0 ? _options$circleStyle : {};
    this.tooltipOptions = (_options$tooltipOptio = options.tooltipOptions) !== null && _options$tooltipOptio !== void 0 ? _options$tooltipOptio : {};
    this.updateTooltipCallback = options.updateTooltipCallback;
    this.map.on("mousemove", this.handleMouseMove, this);
    this.circleMarker = Object(external_leaflet_["circleMarker"])([0, 0], _objectSpread2({}, this.circleStyle)).bindTooltip(this.tooltipElement, _objectSpread2({}, this.tooltipOptions));
    this.updateOrDestroy(startLatLng);
    if (this.isDestroyed) return;
    this.circleMarker.addTo(this.map).openTooltip();
  }
  _createClass(CircleCursor, [{
    key: "updateOrDestroy",
    value: function updateOrDestroy(latlng) {
      var closestLatLng = external_leaflet_["GeometryUtil"].closestLayerSnap(this.map, [this.targetLayer], latlng, this.snapTolerance, true);
      if (closestLatLng) {
        if (!this.circleMarker.getLatLng().equals(closestLatLng.latlng)) {
          this.circleMarker.setLatLng(closestLatLng.latlng);
          this.updateTooltip();
        }
      } else {
        this.destroy();
      }
    }
  }, {
    key: "updateTooltip",
    value: function updateTooltip() {
      var pointLayer = this.findClosestPoint(this.circleMarker.getLatLng(), CLOSEST_DISTANCE_TOLERANCE);
      if (pointLayer && this.updateTooltipCallback) {
        this.updateTooltipCallback(pointLayer);
      }
    }
  }, {
    key: "findClosestPoint",
    value: function findClosestPoint(latlng, mindist) {
      for (var i = 0; i < this.pointLayers.length; i++) {
        var pointLayer = this.pointLayers[i];
        var distance = latlng.distanceTo(pointLayer.getLatLng());
        if (distance <= mindist) {
          return pointLayer;
        }
      }
      return null;
    }
  }, {
    key: "handleMouseMove",
    value: function handleMouseMove(e) {
      if (this.isDestroyed) return;
      this.updateOrDestroy(e.latlng);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      if (!this.isDestroyed) {
        this.isDestroyed = true;
        this.circleMarker.unbindTooltip().remove();
        this.map.off("mousemove", this.handleMouseMove, this);
        this.map = this.circleMarker = this.targetLayer = null;
        this.pointLayers = this.tooltipElement = null;
        this.updateTooltipCallback = null;
      }
    }
  }]);
  return CircleCursor;
}();
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/v-map-route-history.vue?vue&type=script&lang=js&













/* harmony default export */ var v_map_route_historyvue_type_script_lang_js_ = ({
  name: "v-map-route-history",
  inject: ["getMap"],
  provide: function provide() {
    return {
      setPathStyle: this.setPathStyle
    };
  },
  components: {
    VMapFitHandler: v_map_fit_handler,
    VMapPathStyle: v_map_path_style
  },
  props: {
    id: {
      type: [String, Number],
      default: null
    },
    visible: {
      type: Boolean,
      default: true
    },
    invalidate: {
      type: Boolean,
      default: true
    },
    fetching: {
      type: Boolean,
      default: false
    },
    autoFocus: {
      type: Boolean,
      default: false
    },
    dataSource: {
      type: Function,
      default: null
    },
    styles: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    snapTolerance: {
      type: Number,
      default: 300
    },
    pointStyle: {
      type: Object,
      default: function _default() {
        return {
          color: "#EB5757",
          fill: true,
          fillOpacity: 1,
          radius: 2
        };
      }
    },
    circleStyle: {
      type: Object,
      default: function _default() {
        return {
          color: "#45D0B0",
          fill: true,
          fillOpacity: 0.3,
          radius: 8,
          weight: 4
        };
      }
    },
    tooltipOptions: {
      type: Object,
      default: function _default() {
        return {
          permanent: true,
          sticky: true,
          direction: "top",
          offset: Object(external_leaflet_["point"])(0, -15),
          className: "v-map-route-history-tooltip"
        };
      }
    }
  },
  data: function data() {
    return {
      didInvalidate: this.invalidate,
      dataFetching: this.fetching,
      lastFetchError: null,
      dataVisible: this.visible,
      tooltipContent: {}
    };
  },
  watch: {
    invalidate: function invalidate() {
      this.didInvalidate = this.invalidate;
      this.fetchDataIfNeeded();
    },
    fetching: function fetching() {
      this.dataFetching = this.fetching;
    },
    dataSource: function dataSource() {
      this.invalidateAndFetch();
    },
    visible: function visible() {
      this.dataVisible = this.visible;
    },
    dataVisible: function dataVisible() {
      this.setVisible(this.dataVisible);
      this.fetchDataIfNeeded();
      /**
       * @type {boolean}
       */
      this.$emit("update:visible", this.dataVisible);
    },
    styles: {
      deep: true,
      handler: "handleStylesChanged"
    }
  },
  mounted: function mounted() {
    this.mapObject = this.createLayerGroup();
    this.setVisible(this.dataVisible);
    this.fetchDataIfNeeded();
  },
  beforeDestroy: function beforeDestroy() {
    var _this$circleCursor, _this$mapObject;
    (_this$circleCursor = this.circleCursor) === null || _this$circleCursor === void 0 ? void 0 : _this$circleCursor.destroy();
    this.circleCursor = null;
    (_this$mapObject = this.mapObject) === null || _this$mapObject === void 0 ? void 0 : _this$mapObject.off("mouseover", this.handleMouseOver).clearLayers().remove();
  },
  methods: {
    createLayerGroup: function createLayerGroup() {
      var layerGroup = Object(external_leaflet_["featureGroup"])();
      layerGroup.on("mouseover", this.handleMouseOver);
      return layerGroup;
    },
    setVisible: function setVisible(visible) {
      var map = this.getMap();
      if (visible) {
        map.addLayer(this.mapObject);
      } else {
        map.removeLayer(this.mapObject);
      }
    },
    invalidateAndFetch: function invalidateAndFetch() {
      this.didInvalidate = true;
      this.fetchDataIfNeeded();
    },
    fetchDataIfNeeded: function fetchDataIfNeeded() {
      if (this.shouldFetchData()) {
        this.fetchData();
      }
    },
    shouldFetchData: function shouldFetchData() {
      return this.didInvalidate && this.dataVisible;
    },
    canFetchData: function canFetchData() {
      return typeof this.dataSource === "function";
    },
    fetchData: function fetchData() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var responseData;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                if (_this.canFetchData()) {
                  _context.next = 3;
                  break;
                }
                return _context.abrupt("return");
              case 3:
                _this.didInvalidate = false;
                _this.dataFetching = true;
                _this.lastFetchError = null;

                /**
                 * @type {boolean}
                 */
                _this.$emit("update:invalidate", false);
                /**
                 * @type {boolean}
                 */
                _this.$emit("update:fetching", true);
                _context.next = 10;
                return _this.dataSource(_this.id);
              case 10:
                responseData = _context.sent;
                if (!_this._isDestroyed) {
                  _context.next = 13;
                  break;
                }
                return _context.abrupt("return");
              case 13:
                if (!Array.isArray(responseData)) {
                  responseData = [];
                }
                _this.loadResponseData(responseData);
                _this.dataFetching = false;
                /**
                 * @type {boolean}
                 */
                _this.$emit("update:fetching", false);
                /**
                 * @type {object}
                 */
                _this.$emit("data:changed", {
                  data: responseData
                });
                _context.next = 28;
                break;
              case 20:
                _context.prev = 20;
                _context.t0 = _context["catch"](0);
                if (!is_cancel(_context.t0)) {
                  _context.next = 24;
                  break;
                }
                return _context.abrupt("return");
              case 24:
                logger.error(_context.t0);
                _this.dataFetching = false;
                _this.lastFetchError = _context.t0;
                /**
                 * @type {boolean}
                 */
                _this.$emit("update:fetching", false);
              case 28:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 20]]);
      }))();
    },
    loadResponseData: function loadResponseData(responseData) {
      this.clearState();
      this.createLine(responseData);
      this.createInfoPoints(responseData);
      if (this.autoFocus) {
        this.fitBounds();
      }
    },
    clearState: function clearState() {
      var _this$circleCursor2;
      (_this$circleCursor2 = this.circleCursor) === null || _this$circleCursor2 === void 0 ? void 0 : _this$circleCursor2.destroy();
      this.circleCursor = null;
      this.mapObject.clearLayers();
    },
    fitBounds: function fitBounds() {
      var bounds = this.mapObject.getBounds();
      if (bounds.isValid()) {
        var _this$$refs$fit;
        (_this$$refs$fit = this.$refs.fit) === null || _this$$refs$fit === void 0 ? void 0 : _this$$refs$fit.fitBounds(bounds);
      }
    },
    createLine: function createLine(points) {
      var latlngs = points.map(function (p) {
        return p.latlng;
      }).filter(Array.isArray);
      var layer = Object(external_leaflet_["polyline"])(latlngs, {
        data: {
          isLine: true
        }
      });
      if (this.pathStyle) {
        layer.setStyle(this.pathStyle);
      }
      this.mapObject.addLayer(layer);
    },
    createInfoPoints: function createInfoPoints(points) {
      for (var i = 0; i < points.length; i++) {
        var _point = points[i];
        if (Array.isArray(_point.latlng)) {
          var options = _objectSpread2(_objectSpread2({}, this.pointStyle), {}, {
            data: _objectSpread2(_objectSpread2({}, _point), {}, {
              isPoint: true
            })
          });
          var layer = Object(external_leaflet_["circleMarker"])(_point.latlng, options);
          this.mapObject.addLayer(layer);
        }
      }
    },
    setPathStyle: function setPathStyle(value) {
      this.pathStyle = value;
    },
    getPathStyle: function getPathStyle() {
      return this.pathStyle;
    },
    isVisible: function isVisible() {
      return this.dataVisible;
    },
    findLineLayer: function findLineLayer() {
      var res = null;
      var layers = this.mapObject.getLayers();
      for (var i = 0; i < layers.length; i++) {
        var _layer$options$data;
        var layer = layers[i];
        if ((_layer$options$data = layer.options.data) !== null && _layer$options$data !== void 0 && _layer$options$data.isLine) {
          res = layer;
          break;
        }
      }
      return res;
    },
    findPointLayers: function findPointLayers() {
      return this.mapObject.getLayers().filter(function (l) {
        var _l$options$data;
        return (_l$options$data = l.options.data) === null || _l$options$data === void 0 ? void 0 : _l$options$data.isPoint;
      });
    },
    handleMouseOver: function handleMouseOver(_ref) {
      var _this$circleCursor3,
        _this2 = this;
      var startLatLng = _ref.latlng;
      if ((_this$circleCursor3 = this.circleCursor) !== null && _this$circleCursor3 !== void 0 && _this$circleCursor3.isDestroyed) {
        this.circleCursor = null;
      }
      if (this.circleCursor) {
        return;
      }
      var targetLayer = this.findLineLayer();
      var pointLayers = this.findPointLayers();
      if (!targetLayer || pointLayers.length === 0) {
        return;
      }
      this.circleCursor = new circle_cursor_CircleCursor(startLatLng, this.getMap(), targetLayer, pointLayers, this.$refs.tooltip, {
        snapTolerance: this.snapTolerance,
        circleStyle: this.circleStyle,
        tooltipOptions: this.tooltipOptions,
        updateTooltipCallback: function updateTooltipCallback(pointLayer) {
          _this2.tooltipContent = _objectSpread2({}, pointLayer.options.data);
        }
      });
    },
    handleStylesChanged: function handleStylesChanged() {
      var _this3 = this;
      this.$nextTick(function () {
        _this3.invalidateAndFetch();
      });
    }
  }
});
// CONCATENATED MODULE: ./src/components/map/v-map-route-history.vue?vue&type=script&lang=js&
 /* harmony default export */ var map_v_map_route_historyvue_type_script_lang_js_ = (v_map_route_historyvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/map/v-map-route-history.vue





/* normalize component */

var v_map_route_history_component = normalizeComponent(
  map_v_map_route_historyvue_type_script_lang_js_,
  v_map_route_historyvue_type_template_id_a93571b8_render,
  v_map_route_historyvue_type_template_id_a93571b8_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var v_map_route_history = (v_map_route_history_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/v-map-heatmap-handler.vue?vue&type=script&lang=js&



/* harmony default export */ var v_map_heatmap_handlervue_type_script_lang_js_ = ({
  name: "v-map-heatmap-handler",
  inject: ["getMap", "getData", "removeFromMap", "addToMap", "listenEvent", "isVisible", "setUseVisibleHandler"],
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    maxZoom: {
      type: Number,
      default: undefined
    },
    minOpacity: {
      type: Number,
      default: 0.05
    },
    radius: {
      type: Number,
      default: 25
    },
    blur: {
      type: Number,
      default: 15
    },
    maxIntensity: {
      type: Number,
      default: 1.0
    },
    gradient: {
      type: Object,
      default: undefined
    },
    geometryField: {
      type: String,
      default: "geometry"
    },
    countField: {
      type: String,
      default: "count"
    }
  },
  watch: {
    visible: function visible() {
      this.updateVisibleAndData();
    }
  },
  mounted: function mounted() {
    this.mapObject = Object(external_leaflet_["heatLayerGroup"])(null, {
      maxZoom: this.maxZoom,
      minOpacity: this.minOpacity,
      radius: this.radius,
      blur: this.blur,
      max: this.maxIntensity,
      gradient: this.gradient
    });
    this.setUseVisibleHandler(true);
    this.listenEvent("data:changed", this.handleDataChange);
    this.listenEvent("handle-visible", this.handleVisibleChange);
    this.updateVisibleAndData();
  },
  beforeDestroy: function beforeDestroy() {
    this.setUseVisibleHandler(false);
    this.listenEvent("data:changed", this.handleDataChange, true);
    this.listenEvent("handle-visible", this.handleVisibleChange, true);
    if (this.mapObject) {
      this.mapObject.clearLayers().remove();
    }
    if (this.isVisible()) {
      this.addToMap();
    }
  },
  methods: {
    handleVisibleChange: function handleVisibleChange() {
      this.updateVisibleAndData();
    },
    handleDataChange: function handleDataChange(e) {
      if (this.isVisible() && this.visible) {
        this.updateData(e.data);
      }
    },
    updateData: function updateData(data) {
      if (!Array.isArray(data)) {
        return;
      }
      var heatPoints = [];
      for (var i = 0, s = data.length; i < s; i++) {
        var dataItem = data[i];
        var geometry = dataItem[this.geometryField];
        var count = dataItem[this.countField] || 1;
        if (geometry && external_leaflet_["leafletUtil"].geometryIsPoint(geometry)) {
          var latLng = external_leaflet_["GeoJSON"].coordsToLatLng(geometry.coordinates);
          heatPoints.push(Object(external_leaflet_["heatPoint"])(latLng, {
            intensity: count
          }));
        }
      }
      this.mapObject.clearLayers().addLayers(heatPoints);
    },
    updateVisibleAndData: function updateVisibleAndData() {
      var _this = this;
      if (!this.visible) {
        var map = this.getMap();
        map.removeLayer(this.mapObject);
        if (this.isVisible()) {
          this.addToMap();
        } else {
          this.removeFromMap();
        }
      } else {
        this.removeFromMap();
        var _map = this.getMap();
        if (this.isVisible()) {
          _map.addLayer(this.mapObject);
          this.$nextTick(function () {
            _this.updateData(_this.getData());
          });
        } else {
          _map.removeLayer(this.mapObject);
        }
      }
    }
  },
  render: function render() {
    return null;
  }
});
// CONCATENATED MODULE: ./src/components/map/v-map-heatmap-handler.vue?vue&type=script&lang=js&
 /* harmony default export */ var map_v_map_heatmap_handlervue_type_script_lang_js_ = (v_map_heatmap_handlervue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/map/v-map-heatmap-handler.vue
var v_map_heatmap_handler_render, v_map_heatmap_handler_staticRenderFns




/* normalize component */

var v_map_heatmap_handler_component = normalizeComponent(
  map_v_map_heatmap_handlervue_type_script_lang_js_,
  v_map_heatmap_handler_render,
  v_map_heatmap_handler_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var v_map_heatmap_handler = (v_map_heatmap_handler_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"443a82ff-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/v-map-heatmap-observer.vue?vue&type=template&id=7f546bfe&
var v_map_heatmap_observervue_type_template_id_7f546bfe_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_vm._t("default", null, {
    "active": _vm.dataControlActive
  })], 2);
};
var v_map_heatmap_observervue_type_template_id_7f546bfe_staticRenderFns = [];

// CONCATENATED MODULE: ./src/components/map/v-map-heatmap-observer.vue?vue&type=template&id=7f546bfe&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/v-map-heatmap-observer.vue?vue&type=script&lang=js&
var v_map_heatmap_observervue_type_script_lang_js_eventPrefix = "vmap:control:heatmap";
var v_map_heatmap_observervue_type_script_lang_js_visibleEvent = "".concat(v_map_heatmap_observervue_type_script_lang_js_eventPrefix, ":visible");
var v_map_heatmap_observervue_type_script_lang_js_activeEvent = "".concat(v_map_heatmap_observervue_type_script_lang_js_eventPrefix, ":active");
var observerCounter = 0;
/* harmony default export */ var v_map_heatmap_observervue_type_script_lang_js_ = ({
  name: "v-map-heatmap-observer",
  inject: ["getMap"],
  props: {
    enabled: {
      type: Boolean,
      default: true
    },
    controlVisible: {
      type: Boolean,
      default: false
    },
    controlActive: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      dataControlActive: this.controlActive
    };
  },
  watch: {
    enabled: function enabled() {
      this.handleEnabled(this.enabled);
    },
    controlVisible: function controlVisible() {
      if (!this.enabled) return;
      var map = this.getMap();
      map.fire(v_map_heatmap_observervue_type_script_lang_js_visibleEvent, {
        value: this.controlVisible
      });
    },
    controlActive: function controlActive() {
      this.dataControlActive = this.controlActive;
    },
    dataControlActive: function dataControlActive() {
      this.$emit("update:controlActive", this.dataControlActive);
      if (this.enabled) {
        var map = this.getMap();
        map.fire(v_map_heatmap_observervue_type_script_lang_js_activeEvent, {
          value: this.dataControlActive
        });
      }
    }
  },
  mounted: function mounted() {
    if (this.enabled) {
      this.handleEnabled(true);
    }
  },
  beforeDestroy: function beforeDestroy() {
    var map = this.getMap();
    map.off(v_map_heatmap_observervue_type_script_lang_js_activeEvent, this.handleActive);
    this.decrementCounter();
  },
  methods: {
    handleActive: function handleActive(_ref) {
      var value = _ref.value;
      this.dataControlActive = !!value;
    },
    handleEnabled: function handleEnabled(value) {
      var map = this.getMap();
      if (value) {
        this.incrementCounter();
        map.on(v_map_heatmap_observervue_type_script_lang_js_activeEvent, this.handleActive);
        this.updateControlState();
      } else {
        var _map = this.getMap();
        _map.off(v_map_heatmap_observervue_type_script_lang_js_activeEvent, this.handleActive);
        this.decrementCounter();
      }
    },
    updateControlState: function updateControlState() {
      var _this = this;
      this.$nextTick(function () {
        var map = _this.getMap();
        map.fire(v_map_heatmap_observervue_type_script_lang_js_visibleEvent, {
          value: _this.controlVisible
        });
        map.fire(v_map_heatmap_observervue_type_script_lang_js_activeEvent, {
          value: _this.dataControlActive
        });
      });
    },
    resetControlState: function resetControlState() {
      var map = this.getMap();
      map.fire(v_map_heatmap_observervue_type_script_lang_js_visibleEvent, {
        value: false
      });
      map.fire(v_map_heatmap_observervue_type_script_lang_js_activeEvent, {
        value: false
      });
    },
    incrementCounter: function incrementCounter() {
      observerCounter++;
    },
    decrementCounter: function decrementCounter() {
      observerCounter--;
      if (observerCounter < 0) observerCounter = 0;
      if (observerCounter === 0) {
        this.resetControlState();
      }
    }
  }
});
// CONCATENATED MODULE: ./src/components/map/v-map-heatmap-observer.vue?vue&type=script&lang=js&
 /* harmony default export */ var map_v_map_heatmap_observervue_type_script_lang_js_ = (v_map_heatmap_observervue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/map/v-map-heatmap-observer.vue





/* normalize component */

var v_map_heatmap_observer_component = normalizeComponent(
  map_v_map_heatmap_observervue_type_script_lang_js_,
  v_map_heatmap_observervue_type_template_id_7f546bfe_render,
  v_map_heatmap_observervue_type_template_id_7f546bfe_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var v_map_heatmap_observer = (v_map_heatmap_observer_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"443a82ff-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/v-map-edit-handler.vue?vue&type=template&id=5d37d6da&
var v_map_edit_handlervue_type_template_id_5d37d6da_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_vm.ready ? _c('v-map-edit-control', {
    attrs: {
      "draw": _vm.drawOptions,
      "edit": _vm.editOptions
    }
  }) : _vm._e(), _vm.markerEditPane ? _c('v-map-pane', {
    attrs: {
      "name": _vm.markerEditPane
    }
  }) : _vm._e(), _vm.overlayEditPane ? _c('v-map-pane', {
    attrs: {
      "name": _vm.overlayEditPane
    }
  }) : _vm._e(), _vm._t("popup", function () {
    return [_c('v-map-popup', {
      scopedSlots: _vm._u([{
        key: "default",
        fn: function fn(_ref) {
          var content = _ref.content;
          return [_c('v-map-popup-content', {
            attrs: {
              "title": content[_vm.titleField],
              "description": content[_vm.descriptionField],
              "icon-color": _vm.popupIconColor
            },
            scopedSlots: _vm._u([{
              key: "icon",
              fn: function fn() {
                return [_vm._t("icon")];
              },
              proxy: true
            }], null, true)
          })];
        }
      }])
    })];
  }), _vm._t("default")], 2);
};
var v_map_edit_handlervue_type_template_id_5d37d6da_staticRenderFns = [];

// CONCATENATED MODULE: ./src/components/map/v-map-edit-handler.vue?vue&type=template&id=5d37d6da&

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js


function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/v-map-edit-handler.vue?vue&type=script&lang=js&




var _excluded = ["layers"],
  _excluded2 = ["layers"];














var shapeTypes = Object.freeze({
  SHAPE_POLYLINE: "polyline",
  SHAPE_POLYGON: "polygon",
  SHAPE_RECTANGLE: "rectangle",
  SHAPE_CIRCLE: "circle",
  SHAPE_MARKER: "marker",
  SHAPE_CIRCLE_MARKER: "circlemarker",
  SHAPE_MULTI_POLYGON: "multipolygon",
  SHAPE_MULTI_POLYLINE: "multipolyline"
});
var DEFAULT_CREATION_SHAPES = [shapeTypes.SHAPE_POLYLINE, shapeTypes.SHAPE_POLYGON, shapeTypes.SHAPE_RECTANGLE, shapeTypes.SHAPE_MARKER, shapeTypes.SHAPE_MULTI_POLYGON, shapeTypes.SHAPE_MULTI_POLYLINE];
var layerToGeometry = function layerToGeometry(layer) {
  return typeof layer.toGeoJSON === "function" ? layer.toGeoJSON().geometry : null;
};
/* harmony default export */ var v_map_edit_handlervue_type_script_lang_js_ = ({
  name: "v-map-edit-handler",
  inject: ["getMap", "getMarkerIcon", "getPathStyle"],
  provide: function provide() {
    return {
      setMarkerIcon: this.setMarkerIcon,
      setPathStyle: this.setPathStyle,
      bindPopup: this.bindPopup,
      unbindPopup: this.unbindPopup
    };
  },
  components: {
    VMapEditControl: v_map_edit_control,
    VMapPane: v_map_pane,
    VMapPopup: v_map_popup,
    VMapPopupContent: v_map_popup_content
  },
  props: {
    creationShapes: {
      type: Array,
      default: function _default() {
        return [].concat(DEFAULT_CREATION_SHAPES);
      }
    },
    removeControlEnabled: {
      type: Boolean,
      default: true
    },
    editAllowIntersection: {
      type: Boolean,
      default: true
    },
    dataSource: {
      type: Function,
      default: null
    },
    multiple: {
      type: Boolean,
      default: false
    },
    canCreate: {
      type: Boolean,
      default: true
    },
    canEdit: {
      type: Boolean,
      default: true
    },
    markerEditPane: {
      type: String,
      default: "markerEditorPane"
    },
    overlayEditPane: {
      type: String,
      default: "overlayEditorPane"
    },
    geometryField: {
      type: String,
      default: "geometry"
    },
    titleField: {
      type: String,
      default: "title"
    },
    descriptionField: {
      type: String,
      default: "description"
    },
    popupIconColor: {
      type: String,
      default: null
    }
  },
  data: function data() {
    return {
      ready: false
    };
  },
  computed: {
    drawOptions: function drawOptions() {
      return this.canCreate ? this.getDrawOptions() : false;
    },
    editOptions: function editOptions() {
      return this.canEdit ? this.getEditOptions() : false;
    }
  },
  mounted: function mounted() {
    var _this = this;
    this.$nextTick(function () {
      _this.create();
      _this.fetchData();
      _this.ready = true;
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.remove();
  },
  methods: {
    create: function create() {
      this.editLayerGroup = Object(external_leaflet_["featureGroup"])().on("click", this.handleItemClick);
      if (!this.markerIcon) {
        this.markerIcon = this.getMarkerIcon();
      }
      if (!this.pathStyle) {
        this.pathStyle = this.getPathStyle();
      }
      if (this.popupObject) {
        this.editLayerGroup.bindPopup(this.popupObject);
      }
      var map = this.getMap();
      map.addLayer(this.editLayerGroup).on(external_leaflet_["Draw"].Event.CREATED, this.handleCreated).on(external_leaflet_["Draw"].Event.DRAWSTART, this.handleCreateStart).on(external_leaflet_["Draw"].Event.DRAWSTOP, this.handleCreateEnd).on(external_leaflet_["Draw"].Event.EDITSTART, this.handleEditStart).on(external_leaflet_["Draw"].Event.EDITSTOP, this.handleEditEnd).on(external_leaflet_["Draw"].Event.EDITED, this.handleEdited).on(external_leaflet_["Draw"].Event.DELETESTART, this.handleDeleteStart).on(external_leaflet_["Draw"].Event.DELETESTOP, this.handleDeleteEnd).on(external_leaflet_["Draw"].Event.DELETED, this.handleDeleted);
    },
    remove: function remove() {
      var map = this.getMap();
      map.off(external_leaflet_["Draw"].Event.CREATED, this.handleCreated).off(external_leaflet_["Draw"].Event.DRAWSTART, this.handleCreateStart).off(external_leaflet_["Draw"].Event.DRAWSTOP, this.handleCreateEnd).off(external_leaflet_["Draw"].Event.EDITSTART, this.handleEditStart).off(external_leaflet_["Draw"].Event.EDITSTOP, this.handleEditEnd).off(external_leaflet_["Draw"].Event.EDITED, this.handleEdited).off(external_leaflet_["Draw"].Event.DELETESTART, this.handleDeleteStart).off(external_leaflet_["Draw"].Event.DELETESTOP, this.handleDeleteEnd).off(external_leaflet_["Draw"].Event.DELETED, this.handleDeleted);
      if (this.editLayerGroup) {
        this.editLayerGroup.off("click", this.handleItemClick).clearLayers().remove();
      }
    },
    clear: function clear() {
      if (this.editLayerGroup) {
        this.editLayerGroup.clearLayers();
      }
    },
    getDrawOptions: function getDrawOptions() {
      return {
        polyline: this.getPolylineOptions(),
        polygon: this.getPolygonOptions(),
        rectangle: this.getRectangleOptions(),
        circle: this.getCircleOptions(),
        marker: this.getMarkerOptions(),
        circlemarker: this.getCircleMarkerOptions(),
        multipolygon: this.getMultiPolygonOptions(),
        multipolyline: this.getMultiPolylineOptions()
      };
    },
    getEditOptions: function getEditOptions() {
      return {
        featureGroup: this.editLayerGroup,
        remove: this.removeControlEnabled,
        poly: {
          allowIntersection: this.editAllowIntersection
        }
      };
    },
    getPolylineOptions: function getPolylineOptions() {
      if (!this.canCreateShape(shapeTypes.SHAPE_POLYLINE)) return false;
      return {
        showLength: true,
        shapeOptions: _objectSpread2({}, this.pathStyle)
      };
    },
    getPolygonOptions: function getPolygonOptions() {
      if (!this.canCreateShape(shapeTypes.SHAPE_POLYGON)) return false;
      return {
        allowIntersection: false,
        showArea: true,
        showLength: true,
        shapeOptions: _objectSpread2({}, this.pathStyle)
      };
    },
    getRectangleOptions: function getRectangleOptions() {
      if (!this.canCreateShape(shapeTypes.SHAPE_RECTANGLE)) return false;
      return {
        shapeOptions: _objectSpread2({}, this.pathStyle)
      };
    },
    getMarkerOptions: function getMarkerOptions() {
      if (!this.canCreateShape(shapeTypes.SHAPE_MARKER)) return false;
      var opt = {
        pane: this.markerEditPane
      };
      if (this.markerIcon) {
        opt.icon = this.markerIcon;
      }
      return opt;
    },
    getCircleOptions: function getCircleOptions() {
      if (!this.canCreateShape(shapeTypes.SHAPE_CIRCLE)) return false;
      return {
        shapeOptions: _objectSpread2({}, this.pathStyle)
      };
    },
    getCircleMarkerOptions: function getCircleMarkerOptions() {
      if (!this.canCreateShape(shapeTypes.SHAPE_CIRCLE_MARKER)) return false;
      return {
        shapeOptions: _objectSpread2({}, this.pathStyle)
      };
    },
    getMultiPolylineOptions: function getMultiPolylineOptions() {
      if (!this.canCreateShape(shapeTypes.SHAPE_MULTI_POLYLINE)) return false;
      return {
        showLength: true,
        shapeOptions: _objectSpread2({}, this.pathStyle)
      };
    },
    getMultiPolygonOptions: function getMultiPolygonOptions() {
      if (!this.canCreateShape(shapeTypes.SHAPE_MULTI_POLYGON)) return false;
      return {
        allowIntersection: false,
        showArea: true,
        showLength: true,
        shapeOptions: _objectSpread2({}, this.pathStyle)
      };
    },
    canCreateShape: function canCreateShape(shape) {
      return this.creationShapes.indexOf(shape) !== -1;
    },
    canFetchData: function canFetchData() {
      return typeof this.dataSource === "function";
    },
    fetchData: function fetchData() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var responseData, mapObjects;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                if (_this2.canFetchData()) {
                  _context.next = 3;
                  break;
                }
                return _context.abrupt("return");
              case 3:
                _context.next = 5;
                return _this2.dataSource();
              case 5:
                responseData = _context.sent;
                if (!_this2._isDestroyed) {
                  _context.next = 8;
                  break;
                }
                return _context.abrupt("return");
              case 8:
                if (!_this2.multiple) {
                  responseData = responseData.slice(0, 1);
                }
                mapObjects = _this2.createMapObjects(responseData);
                _this2.placeMapObjects(mapObjects);
                _this2.$emit("data", {
                  data: responseData,
                  mapObjects: mapObjects
                });
                _context.next = 19;
                break;
              case 14:
                _context.prev = 14;
                _context.t0 = _context["catch"](0);
                if (!is_cancel(_context.t0)) {
                  _context.next = 18;
                  break;
                }
                return _context.abrupt("return");
              case 18:
                logger.error(_context.t0);
              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 14]]);
      }))();
    },
    createMapObjects: function createMapObjects(items) {
      var result = [];
      for (var i = 0, size = items.length; i < size; i++) {
        var mapObject = this.createMapObject(items[i]);
        if (mapObject) {
          result.push(mapObject);
        }
      }
      return result;
    },
    createMapObject: function createMapObject(itemData) {
      try {
        var mapObject = external_leaflet_["GeoJSON"].geometryToLayer(itemData[this.geometryField]);
        mapObject.options.data = itemData;
        if (this.markerEditPane && mapObject instanceof external_leaflet_["Marker"]) {
          mapObject.options.pane = this.markerEditPane;
        } else if (this.overlayEditPane && mapObject instanceof external_leaflet_["Path"]) {
          mapObject.options.pane = this.overlayEditPane;
        }
        if (this.markerIcon && typeof mapObject.setIcon === "function") {
          mapObject.setIcon(this.markerIcon);
        } else if (this.pathStyle && typeof mapObject.setStyle === "function") {
          mapObject.setStyle(this.pathStyle);
        }
        return mapObject;
      } catch (e) {
        logger.error(e);
        return null;
      }
    },
    placeMapObjects: function placeMapObjects(mapObjects) {
      for (var i = 0, size = mapObjects.length; i < size; i++) {
        this.editLayerGroup.addLayer(mapObjects[i]);
      }
    },
    setMarkerIcon: function setMarkerIcon(value) {
      this.markerIcon = value;
    },
    setPathStyle: function setPathStyle(value) {
      this.pathStyle = value;
    },
    bindPopup: function bindPopup(popup) {
      this.popupObject = popup;
      if (this.editLayerGroup) {
        this.editLayerGroup.bindPopup(popup);
      }
    },
    unbindPopup: function unbindPopup() {
      this.editLayerGroup.unbindPopup();
    },
    itemClickOff: function itemClickOff() {
      this.editLayerGroup.off("click", this.handleItemClick);
    },
    itemClickOn: function itemClickOn() {
      this.editLayerGroup.on("click", this.handleItemClick);
    },
    popupOn: function popupOn() {
      if (this.popupObject) {
        this.editLayerGroup.bindPopup(this.popupObject);
      }
    },
    popupOff: function popupOff() {
      this.editLayerGroup.unbindPopup();
    },
    closePopup: function closePopup() {
      this.editLayerGroup.closePopup();
    },
    beforeEdit: function beforeEdit() {
      this.closePopup();
      this.itemClickOff();
      this.popupOff();
    },
    afterEdit: function afterEdit() {
      this.itemClickOn();
      this.popupOn();
    },
    handleCreateStart: function handleCreateStart(e) {
      this.beforeEdit();
      this.$emit("create-start", _objectSpread2({}, e));
    },
    handleCreateEnd: function handleCreateEnd(e) {
      this.afterEdit();
      this.$emit("create-end", _objectSpread2({}, e));
    },
    handleEditStart: function handleEditStart(e) {
      this.beforeEdit();
      this.$emit("edit-start", _objectSpread2({}, e));
    },
    handleEditEnd: function handleEditEnd(e) {
      this.afterEdit();
      this.$emit("edit-end", _objectSpread2({}, e));
    },
    handleDeleteStart: function handleDeleteStart(e) {
      this.beforeEdit();
      this.$emit("delete-start", _objectSpread2({}, e));
    },
    handleDeleteEnd: function handleDeleteEnd(e) {
      this.afterEdit();
      this.$emit("delete-end", _objectSpread2({}, e));
    },
    handleCreated: function handleCreated(e) {
      var _this3 = this;
      var layer = e.layer;
      if (layer instanceof external_leaflet_["Marker"]) {
        layer.options.pane = this.markerEditPane;
      } else if (layer instanceof external_leaflet_["Path"]) {
        layer.options.pane = this.overlayEditPane;
      }
      var done = function done() {
        if (!_this3._isDestroyed) {
          _this3.closePopup();
          _this3.editLayerGroup.removeLayer(layer);
        }
      };
      if (!this.multiple) {
        this.editLayerGroup.clearLayers();
      }
      this.editLayerGroup.addLayer(layer);
      this.$emit("create", _objectSpread2(_objectSpread2({}, e), {}, {
        geometry: layerToGeometry(layer),
        done: done
      }));
    },
    handleEdited: function handleEdited(e) {
      var _this4 = this;
      var layerGroup = e.layers,
        ev = _objectWithoutProperties(e, _excluded);
      var mapObjects = layerGroup.getLayers();
      if (!mapObjects.length) return;
      var removeLayer = function removeLayer(layer) {
        if (!_this4._isDestroyed) {
          _this4.$nextTick(function () {
            if (!_this4._isDestroyed) {
              _this4.closePopup();
              _this4.editLayerGroup.removeLayer(layer);
            }
          });
        }
      };
      var layers = mapObjects.map(function (layer) {
        return {
          layer: layer,
          geometry: layerToGeometry(layer),
          done: function done() {
            return removeLayer(layer);
          }
        };
      });
      var batchDone = function batchDone() {
        if (!_this4._isDestroyed) {
          layers.forEach(function (_ref) {
            var layer = _ref.layer;
            return removeLayer(layer);
          });
        }
      };
      this.$emit("edit", _objectSpread2(_objectSpread2({}, ev), {}, {
        layers: layers,
        batchDone: batchDone
      }));
    },
    handleDeleted: function handleDeleted(e) {
      var layerGroup = e.layers,
        ev = _objectWithoutProperties(e, _excluded2);
      var mapObjects = layerGroup.getLayers();
      if (!mapObjects.length) return;
      var layers = mapObjects.map(function (layer) {
        return {
          layer: layer,
          geometry: layerToGeometry(layer)
        };
      });
      this.$emit("delete", _objectSpread2(_objectSpread2({}, ev), {}, {
        layers: layers
      }));
    },
    handleItemClick: function handleItemClick(e) {
      this.$emit("click", _objectSpread2({}, e));
    }
  }
});
// CONCATENATED MODULE: ./src/components/map/v-map-edit-handler.vue?vue&type=script&lang=js&
 /* harmony default export */ var map_v_map_edit_handlervue_type_script_lang_js_ = (v_map_edit_handlervue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/map/v-map-edit-handler.vue





/* normalize component */

var v_map_edit_handler_component = normalizeComponent(
  map_v_map_edit_handlervue_type_script_lang_js_,
  v_map_edit_handlervue_type_template_id_5d37d6da_render,
  v_map_edit_handlervue_type_template_id_5d37d6da_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var v_map_edit_handler = (v_map_edit_handler_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"443a82ff-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/v-map-edit-object-handler.vue?vue&type=template&id=195891ea&
var v_map_edit_object_handlervue_type_template_id_195891ea_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_vm.markerEditPane ? _c('v-map-pane', {
    attrs: {
      "name": _vm.markerEditPane
    }
  }) : _vm._e(), _vm.overlayEditPane ? _c('v-map-pane', {
    attrs: {
      "name": _vm.overlayEditPane
    }
  }) : _vm._e()], 1);
};
var v_map_edit_object_handlervue_type_template_id_195891ea_staticRenderFns = [];

// CONCATENATED MODULE: ./src/components/map/v-map-edit-object-handler.vue?vue&type=template&id=195891ea&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/v-map-edit-object-handler.vue?vue&type=script&lang=js&












var editObjectEvent = "vmap:edit:object";
var v_map_edit_object_handlervue_type_script_lang_js_isMultiPoly = function isMultiPoly(layer) {
  return external_leaflet_["leafletUtil"].isMultiPolyline(layer) || external_leaflet_["leafletUtil"].isMultiPolygon(layer);
};
var v_map_edit_object_handlervue_type_script_lang_js_MultiPolyParts = /*#__PURE__*/function () {
  function MultiPolyParts(source) {
    _classCallCheck(this, MultiPolyParts);
    this.source = source;
    this.parts = [];
    this.polyConstructor = null;
    if (external_leaflet_["leafletUtil"].isMultiPolygon(source)) {
      this.polyConstructor = external_leaflet_["Polygon"];
    } else if (external_leaflet_["leafletUtil"].isMultiPolyline(source)) {
      this.polyConstructor = external_leaflet_["Polyline"];
    }
    this.createParts();
  }
  _createClass(MultiPolyParts, [{
    key: "createParts",
    value: function createParts() {
      var latlngs = this.source.getLatLngs();
      var options = _objectSpread2(_objectSpread2({}, this.source.options), {}, {
        _multiPolyParts: this
      });
      var PolyConstructor = this.polyConstructor;
      for (var i = 0; i < latlngs.length; i++) {
        var part = new PolyConstructor(external_leaflet_["LatLngUtil"].cloneLatLngs(latlngs[i]), options);
        this.parts.push(part);
      }
    }
  }, {
    key: "updateLatLngs",
    value: function updateLatLngs() {
      var latlngs = this.parts.map(function (p) {
        return p.getLatLngs();
      });
      this.source.setLatLngs(external_leaflet_["LatLngUtil"].cloneLatLngs(latlngs));
    }
  }, {
    key: "isEdited",
    value: function isEdited() {
      return this.parts.some(function (p) {
        return p.edited;
      });
    }
  }, {
    key: "getParts",
    value: function getParts() {
      return this.parts;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.parts.forEach(function (p) {
        delete p.options._multiPolyParts;
      });
      this.parts = [];
      this.source = null;
      this.polyConstructor = null;
    }
  }]);
  return MultiPolyParts;
}();
/* harmony default export */ var v_map_edit_object_handlervue_type_script_lang_js_ = ({
  name: "v-map-edit-object-handler",
  inject: ["getMap", "getMapObject", "getId"],
  components: {
    VMapPane: v_map_pane
  },
  props: {
    editAllowIntersection: {
      type: Boolean,
      default: true
    },
    tooltipOffsetX: {
      type: Number,
      default: 30
    },
    tooltipOffsetY: {
      type: Number,
      default: -25
    },
    markerEditPane: {
      type: String,
      default: "markerEditorPane"
    },
    overlayEditPane: {
      type: String,
      default: "overlayEditorPane"
    },
    idField: {
      type: String,
      default: "id"
    },
    geometryField: {
      type: String,
      default: "geometry"
    }
  },
  mounted: function mounted() {
    var map = this.getMap();
    map.on(editObjectEvent, this.handleEditObject);
    this.editLayerGroup = Object(external_leaflet_["featureGroup"])();
    map.addLayer(this.editLayerGroup);
  },
  beforeDestroy: function beforeDestroy() {
    var map = this.getMap();
    map.off(editObjectEvent, this.handleEditObject);
    if (this.editLayerGroup) {
      this.editLayerGroup.clearLayers().remove();
    }
  },
  methods: {
    handleEditObject: function handleEditObject(e) {
      var layerId = e.layerId,
        objectId = e.objectId;
      if (layerId !== this.getId()) return;
      this.editObject(objectId);
    },
    editObject: function editObject(id) {
      var _this = this;
      if (!this.editLayerGroup) return;
      var targetLayerGroup = this.getMapObject();
      if (!(targetLayerGroup instanceof external_leaflet_["LayerGroup"])) return;
      var editLayer = this.findLayer(targetLayerGroup, id);
      if (!editLayer) return;
      targetLayerGroup.removeLayer(editLayer);
      this.configureLayerPane(editLayer);
      if (v_map_edit_object_handlervue_type_script_lang_js_isMultiPoly(editLayer)) {
        var multiPoly = new v_map_edit_object_handlervue_type_script_lang_js_MultiPolyParts(editLayer);
        var firstToolbar = true;
        multiPoly.getParts().forEach(function (part) {
          _this.editLayerGroup.addLayer(part);
          _this.enableLayerEdit(part, firstToolbar);
          firstToolbar = false;
        });
      } else {
        this.editLayerGroup.addLayer(editLayer);
        if (editLayer._centerMarker) {
          editLayer._centerMarker.remove();
        }
        this.enableLayerEdit(editLayer);
      }
      this.emitEditStart(editLayer);
    },
    findLayer: function findLayer(layerGroup, id) {
      var _layerGroup$getLayers;
      if (id == null) return null;
      var idField = this.idField;
      return (_layerGroup$getLayers = layerGroup.getLayers().filter(function (_ref) {
        var data = _ref.options.data;
        return data && data[idField] != null && data[idField] === id;
      })[0]) !== null && _layerGroup$getLayers !== void 0 ? _layerGroup$getLayers : null;
    },
    enableLayerEdit: function enableLayerEdit(layer) {
      var isToolbar = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      this.backupLayer(layer);
      layer.options.poly = {
        allowIntersection: this.editAllowIntersection
      };
      if (layer.editing) {
        layer.editing.enable();
      }
      if (isToolbar) {
        this.createLayerToolbar(layer);
      }
    },
    disableLayerEdit: function disableLayerEdit(layer) {
      layer.edited = false;
      if (layer.editing) {
        layer.editing.disable();
      }
      delete layer.options.editing;
      delete layer.options.original;
      delete layer.options.backup;
      delete layer.options.poly;
      this.removeLayerToolbar(layer);
    },
    backupLayer: function backupLayer(layer) {
      var backup = {};
      if (typeof layer.getLatLng === "function") {
        backup.latlng = external_leaflet_["LatLngUtil"].cloneLatLng(layer.getLatLng());
      } else if (typeof layer.getLatLngs === "function") {
        backup.latlngs = external_leaflet_["LatLngUtil"].cloneLatLngs(layer.getLatLngs());
      }
      layer.options.backup = backup;
    },
    revertLayer: function revertLayer(layer) {
      var backup = layer.options.backup;
      layer.edited = false;
      if (backup) {
        if (typeof layer.setLatLng === "function" && backup.latlng) {
          layer.setLatLng(backup.latlng);
        } else if (typeof layer.setLatLngs === "function" && backup.latlngs) {
          layer.setLatLngs(backup.latlngs);
        }
        layer.fire("revert-edited", {
          layer: layer
        });
      }
    },
    createLayerToolbar: function createLayerToolbar(layer) {
      var _this2 = this;
      var toolbar = document.createElement("div");
      toolbar.className = "v-map-edit-tooltip__toolbar";
      var dragHandle = document.createElement("span");
      dragHandle.className = "v-map-edit-tooltip__toolbar__drag-handle";
      var saveBtn = document.createElement("a");
      saveBtn.className = "v-map-edit-tooltip__toolbar__action";
      saveBtn.href = "#";
      saveBtn.innerText = utils_locale.default.toolbarSaveBtn;
      saveBtn.addEventListener("click", function (e) {
        e.preventDefault();
        _this2.handleSaveEdit(layer);
      });
      var cancelBtn = document.createElement("a");
      cancelBtn.className = "v-map-edit-tooltip__toolbar__action";
      cancelBtn.href = "#";
      cancelBtn.innerText = utils_locale.default.toolbarCancelBtn;
      cancelBtn.addEventListener("click", function (e) {
        e.preventDefault();
        _this2.handleCancelEdit(layer);
      });
      toolbar.appendChild(dragHandle);
      toolbar.appendChild(saveBtn);
      toolbar.appendChild(cancelBtn);
      layer.bindTooltip(toolbar, {
        opacity: 1,
        permanent: true,
        sticky: false,
        interactive: true,
        direction: "right",
        offset: Object(external_leaflet_["point"])(this.tooltipOffsetX, this.tooltipOffsetY),
        className: "v-map-edit-tooltip"
      });
      var tooltip = layer.getTooltip();
      if (tooltip && tooltip._container) {
        tooltip.dragging = new external_leaflet_["Draggable"](tooltip._container, dragHandle);
        tooltip.dragging.enable();
      }
    },
    removeLayerToolbar: function removeLayerToolbar(layer) {
      var tooltip = layer.getTooltip();
      if (tooltip && tooltip.dragging) {
        tooltip.dragging.disable();
        delete tooltip.dragging;
      }
      layer.unbindTooltip();
    },
    configureLayerPane: function configureLayerPane(layer) {
      layer.options.previousPane = layer.options.pane;
      if (layer instanceof external_leaflet_["Marker"]) {
        layer.options.pane = this.markerEditPane;
      } else if (layer instanceof external_leaflet_["Path"]) {
        layer.options.pane = this.overlayEditPane;
      }
    },
    restoreLayerPane: function restoreLayerPane(layer) {
      var previousPane = layer.options.previousPane;
      if (previousPane) {
        layer.options.pane = previousPane;
        delete layer.options.previousPane;
      }
    },
    handleSaveEdit: function handleSaveEdit(layer) {
      var _this3 = this;
      if (layer.options._multiPolyParts) {
        var multiPoly = layer.options._multiPolyParts;
        var disableEditParts = function disableEditParts() {
          multiPoly.getParts().forEach(function (p) {
            _this3.disableLayerEdit(p);
            _this3.editLayerGroup.removeLayer(p);
          });
        };
        if (!multiPoly.isEdited()) {
          disableEditParts();
          var _multiPolyLayer = multiPoly.source;
          multiPoly.dispose();
          this.backToTargerLayerGroup(_multiPolyLayer);
          this.emitEditEnd(_multiPolyLayer);
          return;
        }
        disableEditParts();
        var multiPolyLayer = multiPoly.source;
        this.backupLayer(multiPolyLayer);
        multiPoly.updateLatLngs();
        multiPoly.dispose();
        this.updateGeometryData(multiPolyLayer);
        this.editLayerGroup.addLayer(multiPolyLayer);
        if (multiPolyLayer._centerMarker) {
          multiPolyLayer._centerMarker.remove();
        }
        var done = function done() {
          delete multiPolyLayer.options.backup;
          _this3.backToTargerLayerGroup(multiPolyLayer);
          _this3.emitEditEnd(multiPolyLayer);
        };
        var cancel = function cancel() {
          _this3.revertLayer(multiPolyLayer);
          _this3.updateGeometryData(multiPolyLayer);
          delete multiPolyLayer.options.backup;
          _this3.backToTargerLayerGroup(multiPolyLayer);
          _this3.emitEditEnd(multiPolyLayer);
        };
        this.$emit("edited", {
          layer: multiPolyLayer,
          layerId: this.getId(),
          data: multiPolyLayer.options.data,
          done: done,
          cancel: cancel
        });
      } else {
        if (!layer.edited) {
          this.disableLayerEdit(layer);
          this.backToTargerLayerGroup(layer);
          this.emitEditEnd(layer);
          return;
        }
        var backup = layer.options.backup;
        this.disableLayerEdit(layer);
        this.updateGeometryData(layer);
        layer.options.backup = backup;
        var _done = function _done() {
          delete layer.options.backup;
          _this3.backToTargerLayerGroup(layer);
          _this3.emitEditEnd(layer);
        };
        var _cancel = function _cancel() {
          _this3.revertLayer(layer);
          _this3.updateGeometryData(layer);
          delete layer.options.backup;
          _this3.backToTargerLayerGroup(layer);
          _this3.emitEditEnd(layer);
        };
        this.$emit("edited", {
          layer: layer,
          layerId: this.getId(),
          data: layer.options.data,
          done: _done,
          cancel: _cancel
        });
      }
    },
    handleCancelEdit: function handleCancelEdit(layer) {
      var _this4 = this;
      if (layer.options._multiPolyParts) {
        var multiPoly = layer.options._multiPolyParts;
        multiPoly.getParts().forEach(function (p) {
          _this4.disableLayerEdit(p);
          _this4.editLayerGroup.removeLayer(p);
        });
        var multiPolyLayer = multiPoly.source;
        multiPoly.dispose();
        this.backToTargerLayerGroup(multiPolyLayer);
        this.emitEditEnd(multiPolyLayer);
      } else {
        this.removeLayerToolbar(layer);
        this.revertLayer(layer);
        this.disableLayerEdit(layer);
        this.backToTargerLayerGroup(layer);
        this.emitEditEnd(layer);
      }
    },
    backToTargerLayerGroup: function backToTargerLayerGroup(layer) {
      this.editLayerGroup.removeLayer(layer);
      this.restoreLayerPane(layer);
      var targetLayerGroup = this.getMapObject();
      if (targetLayerGroup instanceof external_leaflet_["LayerGroup"]) {
        targetLayerGroup.addLayer(layer);
      }
    },
    updateGeometryData: function updateGeometryData(layer) {
      var data = layer.options.data;
      if (data && typeof layer.toGeoJSON === "function") {
        data[this.geometryField] = layer.toGeoJSON().geometry;
      }
    },
    emitEditStart: function emitEditStart(layer) {
      this.$emit("edit-start", {
        layer: layer,
        layerId: this.getId(),
        data: layer.options.data
      });
    },
    emitEditEnd: function emitEditEnd(layer) {
      this.$emit("edit-end", {
        layer: layer,
        layerId: this.getId(),
        data: layer.options.data
      });
    }
  }
});
// CONCATENATED MODULE: ./src/components/map/v-map-edit-object-handler.vue?vue&type=script&lang=js&
 /* harmony default export */ var map_v_map_edit_object_handlervue_type_script_lang_js_ = (v_map_edit_object_handlervue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/map/v-map-edit-object-handler.vue





/* normalize component */

var v_map_edit_object_handler_component = normalizeComponent(
  map_v_map_edit_object_handlervue_type_script_lang_js_,
  v_map_edit_object_handlervue_type_template_id_195891ea_render,
  v_map_edit_object_handlervue_type_template_id_195891ea_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var v_map_edit_object_handler = (v_map_edit_object_handler_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/v-map-delete-object-handler.vue?vue&type=script&lang=js&




var deleteObjectEvent = "vmap:delete:object";
/* harmony default export */ var v_map_delete_object_handlervue_type_script_lang_js_ = ({
  name: "v-map-delete-object-handler",
  inject: ["getMap", "getMapObject", "getId"],
  props: {
    idField: {
      type: String,
      default: "id"
    }
  },
  mounted: function mounted() {
    var map = this.getMap();
    map.on(deleteObjectEvent, this.handleDeleteObject);
  },
  beforeDestroy: function beforeDestroy() {
    var map = this.getMap();
    map.off(deleteObjectEvent, this.handleDeleteObject);
  },
  methods: {
    handleDeleteObject: function handleDeleteObject(e) {
      var layerId = e.layerId,
        objectId = e.objectId;
      if (layerId !== this.getId()) return;
      this.deleteObject(objectId);
    },
    deleteObject: function deleteObject(id) {
      var _this = this;
      var layerGroup = this.getMapObject();
      if (!(layerGroup instanceof external_leaflet_["LayerGroup"])) return;
      var deleteLayer = this.findLayer(layerGroup, id);
      if (!deleteLayer) return;
      var data = _objectSpread2({}, deleteLayer.options.data);
      var layerId = this.getId();
      var remove = function remove() {
        layerGroup.removeLayer(deleteLayer);
      };
      var done = function done() {
        var layer = _this.findLayer(layerGroup, id);
        if (layer) {
          layerGroup.removeLayer(layer);
        }
      };
      var cancel = function cancel() {
        var layer = _this.findLayer(layerGroup, id);
        if (!layer) {
          layerGroup.addLayer(deleteLayer);
        }
      };
      this.$emit("delete", {
        layer: deleteLayer,
        layerId: layerId,
        data: data,
        done: done,
        cancel: cancel,
        remove: remove
      });
    },
    findLayer: function findLayer(layerGroup, id) {
      var _layerGroup$getLayers;
      if (id == null) return null;
      var idField = this.idField;
      return (_layerGroup$getLayers = layerGroup.getLayers().filter(function (_ref) {
        var data = _ref.options.data;
        return data && data[idField] != null && data[idField] === id;
      })[0]) !== null && _layerGroup$getLayers !== void 0 ? _layerGroup$getLayers : null;
    }
  },
  render: function render() {
    return null;
  }
});
// CONCATENATED MODULE: ./src/components/map/v-map-delete-object-handler.vue?vue&type=script&lang=js&
 /* harmony default export */ var map_v_map_delete_object_handlervue_type_script_lang_js_ = (v_map_delete_object_handlervue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/map/v-map-delete-object-handler.vue
var v_map_delete_object_handler_render, v_map_delete_object_handler_staticRenderFns




/* normalize component */

var v_map_delete_object_handler_component = normalizeComponent(
  map_v_map_delete_object_handlervue_type_script_lang_js_,
  v_map_delete_object_handler_render,
  v_map_delete_object_handler_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var v_map_delete_object_handler = (v_map_delete_object_handler_component.exports);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.json.stringify.js
var es_json_stringify = __webpack_require__("e9c4");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/v-map-picket-handler.vue?vue&type=script&lang=js&





/* harmony default export */ var v_map_picket_handlervue_type_script_lang_js_ = ({
  name: "v-map-picket-handler",
  inject: ["getMap", "getMapObject", "listenEvent"],
  props: {
    dataSource: {
      type: Function,
      default: null
    },
    circleOptions: {
      type: Object,
      default: null
    },
    tooltipOptions: {
      type: Object,
      default: null
    },
    snapTolerance: {
      type: Number,
      default: 300
    },
    watchDataChanged: {
      type: Boolean,
      default: true
    },
    showClosestPickets: {
      type: Boolean,
      default: false
    },
    showTargetTitle: {
      type: Boolean,
      default: false
    },
    idField: {
      type: String,
      default: "id"
    },
    geometryField: {
      type: String,
      default: "geometry"
    },
    titleField: {
      type: String,
      default: "title"
    },
    picketTitleField: {
      type: String,
      default: "title"
    },
    picketGeometryField: {
      type: String,
      default: "geometry"
    },
    picketOffsetField: {
      type: String,
      default: "offset"
    },
    noPicketsMessage: {
      type: String,
      default: function _default() {
        return utils_locale.default.noPicketsMessage;
      }
    },
    picketDistanceMessage: {
      type: String,
      default: function _default() {
        return utils_locale.default.picketDistanceMessage;
      }
    }
  },
  mounted: function mounted() {
    this.$nextTick(this.create);
  },
  beforeDestroy: function beforeDestroy() {
    this.remove();
  },
  methods: {
    create: function create() {
      var mapObject = this.getMapObject();
      if (mapObject) {
        mapObject.on("mouseover", this.handleMouseOver);
      }
      this.listenEvent("data:changed", this.handleDataChanged);
    },
    remove: function remove() {
      var mapObject = this.getMapObject();
      if (mapObject) {
        mapObject.off("mouseover", this.handleMouseOver);
      }
      this.listenEvent("data:changed", this.handleDataChanged, true);
      if (this.picketController) {
        this.picketController.destroy();
        this.picketController = null;
      }
    },
    handleDataChanged: function handleDataChanged(_ref) {
      var _this = this;
      var data = _ref.data;
      if (!this.watchDataChanged) return;
      if (!this.picketController || this.picketController.isDestroyed) return;
      if (!this.idField) return;
      var destroy = function destroy() {
        _this.picketController.destroy();
        _this.picketController = null;
      };
      if (!data.length) {
        destroy();
        return;
      }
      var _this$picketControlle = this.picketController,
        targetId = _this$picketControlle.targetId,
        targetLayer = _this$picketControlle.targetLayer;
      if (!targetId) {
        return;
      }
      var itemData = null;
      var mapObject = null;
      for (var i = 0; i < data.length; i++) {
        var item = data[i];
        if (item[this.idField] != null && item[this.idField] === targetId) {
          itemData = item;
        }
      }
      if (!itemData) {
        destroy();
        return;
      }
      try {
        mapObject = external_leaflet_["GeoJSON"].geometryToLayer(itemData[this.geometryField]);
      } catch (e) {
        logger.error(e);
      }
      if (!mapObject) {
        destroy();
        return;
      }
      if (!external_leaflet_["leafletUtil"].isPath(mapObject)) {
        destroy();
        return;
      }
      var jsonArray1 = JSON.stringify(mapObject.getLatLngs());
      var jsonArray2 = JSON.stringify(targetLayer.getLatLngs());
      if (jsonArray1 === jsonArray2) {
        return;
      }
      this.picketController.refresh(mapObject, this.dataSource);
    },
    handleMouseOver: function handleMouseOver(_ref2) {
      var propagatedFrom = _ref2.propagatedFrom,
        latlng = _ref2.latlng;
      var data = propagatedFrom.options.data;
      var targetId = data ? data[this.idField] : null;
      var targetTitle = data ? data[this.titleField] : null;
      var isPoly = external_leaflet_["leafletUtil"].isPath(propagatedFrom);
      if (this.picketController && this.picketController.isDestroyed) {
        this.picketController = null;
      }
      if (this.picketController && (targetId && this.picketController.hasTargetId(targetId) || this.picketController.hasTargetLayer(propagatedFrom))) {
        if (!isPoly && !(propagatedFrom instanceof external_leaflet_["PathCenterMarker"])) {
          this.picketController.destroy();
          this.picketController = null;
        }
        return;
      }
      if (!isPoly) {
        return;
      }
      if (this.picketController) {
        this.picketController.destroy();
        this.picketController = null;
      }
      var picketTitleField = this.picketTitleField,
        picketGeometryField = this.picketGeometryField,
        picketOffsetField = this.picketOffsetField,
        snapTolerance = this.snapTolerance,
        circleOptions = this.circleOptions,
        tooltipOptions = this.tooltipOptions,
        showClosestPickets = this.showClosestPickets;
      var options = {
        snapTolerance: snapTolerance,
        circleOptions: circleOptions,
        tooltipOptions: tooltipOptions,
        showClosestPickets: showClosestPickets,
        fields: {
          picketTitleField: picketTitleField,
          picketGeometryField: picketGeometryField,
          picketOffsetField: picketOffsetField
        },
        messages: {
          noPickets: this.noPicketsMessage,
          distanceFromStart: this.picketDistanceMessage,
          headerText: this.showTargetTitle ? targetTitle : null,
          units: utils_locale.default.units
        }
      };
      this.picketController = new external_leaflet_["PicketController"](this.getMap(), targetId, propagatedFrom, latlng, this.dataSource, options);
    }
  },
  render: function render() {
    return null;
  }
});
// CONCATENATED MODULE: ./src/components/map/v-map-picket-handler.vue?vue&type=script&lang=js&
 /* harmony default export */ var map_v_map_picket_handlervue_type_script_lang_js_ = (v_map_picket_handlervue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/map/v-map-picket-handler.vue
var v_map_picket_handler_render, v_map_picket_handler_staticRenderFns




/* normalize component */

var v_map_picket_handler_component = normalizeComponent(
  map_v_map_picket_handlervue_type_script_lang_js_,
  v_map_picket_handler_render,
  v_map_picket_handler_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var v_map_picket_handler = (v_map_picket_handler_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/v-map-follow-handler.vue?vue&type=script&lang=js&


/* harmony default export */ var v_map_follow_handlervue_type_script_lang_js_ = ({
  name: "v-map-follow-handler",
  inject: ["getMap", "getMapObject"],
  props: {
    coverPanelClassName: {
      type: String,
      default: "v-map-sidebar"
    },
    coverPanelOpenClassName: {
      type: String,
      default: "v-map-sidebar--open"
    },
    extendLayerBounds: {
      type: Number,
      default: 10
    }
  },
  created: function created() {
    this.followLayer = null;
  },
  mounted: function mounted() {
    this.$nextTick(this.create);
  },
  beforeDestroy: function beforeDestroy() {
    this.remove();
  },
  methods: {
    create: function create() {
      var mapObject = this.getMapObject();
      if (mapObject) {
        mapObject.on("popupopen", this.onPopupOpen);
        mapObject.on("popupclose", this.onPopupClose);
      }
    },
    remove: function remove() {
      var mapObject = this.getMapObject();
      if (mapObject) {
        mapObject.off("popupopen", this.onPopupOpen);
        mapObject.off("popupclose", this.onPopupClose);
      }
      if (this.followLayer) {
        this.followLayer.off("move", this.onLayerMove);
        this.followLayer = null;
      }
      this.getMap().off("movestart", this.onMapMoveStart).off("moveend", this.onMapMoveEnd);
    },
    onPopupOpen: function onPopupOpen(e) {
      this.bindEvents(e.layer);
      this.$emit("follow-start");
    },
    onPopupClose: function onPopupClose(e) {
      this.unbindEvents(e.layer);
      this.$emit("follow-end");
    },
    bindEvents: function bindEvents(layer) {
      this.followLayer = layer;
      layer.on("move", this.onLayerMove);
      this.getMap().on("movestart", this.onMapMoveStart).on("moveend", this.onMapMoveEnd);
    },
    unbindEvents: function unbindEvents(layer) {
      if (this.followLayer) {
        this.followLayer.off("move", this.onLayerMove);
        this.followLayer = null;
      }
      layer.off("move", this.onLayerMove);
      this.getMap().off("movestart", this.onMapMoveStart).off("moveend", this.onMapMoveEnd);
    },
    onLayerMove: function onLayerMove(e) {
      var oldLatLng = e.oldLatLng,
        latlng = e.latlng,
        layer = e.sourceTarget;
      if (!this.layerPositionInView(layer, oldLatLng)) return;
      this.moveMapView(oldLatLng, latlng);
    },
    onMapMoveStart: function onMapMoveStart() {
      var _this$followLayer;
      (_this$followLayer = this.followLayer) === null || _this$followLayer === void 0 ? void 0 : _this$followLayer.off("move", this.onLayerMove);
    },
    onMapMoveEnd: function onMapMoveEnd() {
      var _this$followLayer2;
      (_this$followLayer2 = this.followLayer) === null || _this$followLayer2 === void 0 ? void 0 : _this$followLayer2.on("move", this.onLayerMove);
    },
    moveMapView: function moveMapView(oldLatLng, latlng) {
      var map = this.getMap();
      var oldPoint = map.latLngToLayerPoint(oldLatLng);
      var newPoint = map.latLngToLayerPoint(latlng);
      var offset = newPoint.subtract(oldPoint);
      map.panBy(offset, {
        animate: false
      });
    },
    layerPositionInView: function layerPositionInView(layer, pos) {
      var viewBounds = this.getMapContainerPixelBounds();
      var extendSize = this.lastInView === false ? this.extendLayerBounds : 0;
      var layerBounds = this.getLayerContainerPixelBounds(layer, pos, extendSize);
      this.lastInView = viewBounds.contains(layerBounds.min) && viewBounds.contains(layerBounds.max);
      return this.lastInView;
    },
    getLayerContainerPixelBounds: function getLayerContainerPixelBounds(layer, pos) {
      var extendSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var map = this.getMap();
      var center = map.latLngToContainerPoint(pos);
      var halfSize = this.getLayerSize(layer).divideBy(2);
      var bounds = new external_leaflet_default.a.Bounds(center.subtract(halfSize), center.add(halfSize));
      if (extendSize > 0) {
        var extendPoint = new external_leaflet_default.a.Point(extendSize, extendSize);
        bounds.extend(bounds.min.subtract(extendPoint));
        bounds.extend(bounds.max.add(extendPoint));
      }
      return bounds;
    },
    getLayerSize: function getLayerSize(layer) {
      var _layer$getElement$off, _layer$getElement, _layer$getElement$off2, _layer$getElement2;
      return new external_leaflet_default.a.Point((_layer$getElement$off = (_layer$getElement = layer.getElement()) === null || _layer$getElement === void 0 ? void 0 : _layer$getElement.offsetWidth) !== null && _layer$getElement$off !== void 0 ? _layer$getElement$off : 0, (_layer$getElement$off2 = (_layer$getElement2 = layer.getElement()) === null || _layer$getElement2 === void 0 ? void 0 : _layer$getElement2.offsetHeight) !== null && _layer$getElement$off2 !== void 0 ? _layer$getElement$off2 : 0);
    },
    getMapContainerPixelBounds: function getMapContainerPixelBounds() {
      var map = this.getMap();
      var bounds = new external_leaflet_default.a.Bounds(new external_leaflet_default.a.Point(this.getCoverPanelWidth(), 0), map.getSize());
      return bounds;
    },
    getCoverPanelElement: function getCoverPanelElement() {
      if (!this.coverPanelElement) {
        var map = this.getMap();
        var container = map === null || map === void 0 ? void 0 : map.getContainer();
        this.coverPanelElement = container === null || container === void 0 ? void 0 : container.querySelector(".".concat(this.coverPanelClassName));
      }
      return this.coverPanelElement;
    },
    getCoverPanelWidth: function getCoverPanelWidth() {
      if (!this.coverPanelClassName) {
        return 0;
      }
      var map = this.getMap();
      if (!map.getContainer()) return 0;
      var container = map.getContainer();
      var coverPanelElement = this.getCoverPanelElement();
      if (coverPanelElement && external_leaflet_default.a.DomUtil.hasClass(container, this.coverPanelOpenClassName)) {
        var _coverPanelElement$ge = coverPanelElement.getBoundingClientRect(),
          width = _coverPanelElement$ge.width;
        return width;
      }
      return 0;
    }
  },
  render: function render() {
    return null;
  }
});
// CONCATENATED MODULE: ./src/components/map/v-map-follow-handler.vue?vue&type=script&lang=js&
 /* harmony default export */ var map_v_map_follow_handlervue_type_script_lang_js_ = (v_map_follow_handlervue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/map/v-map-follow-handler.vue
var v_map_follow_handler_render, v_map_follow_handler_staticRenderFns




/* normalize component */

var v_map_follow_handler_component = normalizeComponent(
  map_v_map_follow_handlervue_type_script_lang_js_,
  v_map_follow_handler_render,
  v_map_follow_handler_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var v_map_follow_handler = (v_map_follow_handler_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"443a82ff-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/v-map-tooltip-handler.vue?vue&type=template&id=e75d2a64&
var v_map_tooltip_handlervue_type_template_id_e75d2a64_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.tooltipPane ? _c('v-map-pane', {
    attrs: {
      "name": _vm.tooltipPane
    }
  }) : _vm._e();
};
var v_map_tooltip_handlervue_type_template_id_e75d2a64_staticRenderFns = [];

// CONCATENATED MODULE: ./src/components/map/v-map-tooltip-handler.vue?vue&type=template&id=e75d2a64&

// CONCATENATED MODULE: ./src/utils/string.js

function truncate(str, maxLength) {
  return str && str.length > maxLength ? str.slice(0, maxLength - 1) + '…' : str;
}
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/v-map-tooltip-handler.vue?vue&type=script&lang=js&




/* harmony default export */ var v_map_tooltip_handlervue_type_script_lang_js_ = ({
  name: "v-map-tooltip-handler",
  inject: ["getMap", "getMapObject", "listenEvent"],
  components: {
    VMapPane: v_map_pane
  },
  props: {
    tooltipOffsetX: {
      type: Number,
      default: 10
    },
    tooltipOffsetY: {
      type: Number,
      default: -18
    },
    tooltipPane: {
      type: String,
      default: "objectTooltipPane"
    },
    displayField: {
      type: String,
      default: "title"
    },
    maxDisplayLength: {
      type: Number,
      default: 25
    }
  },
  mounted: function mounted() {
    this.$nextTick(this.create);
  },
  beforeDestroy: function beforeDestroy() {
    this.remove();
  },
  methods: {
    create: function create() {
      this.bindTooltips();
      this.listenEvent("data:changed", this.bindTooltips);
      var mapObject = this.getMapObject();
      mapObject === null || mapObject === void 0 ? void 0 : mapObject.on("popupopen", this.onPopupOpen);
      mapObject === null || mapObject === void 0 ? void 0 : mapObject.on("popupclose", this.onPopupClose);
    },
    remove: function remove() {
      var mapObject = this.getMapObject();
      mapObject === null || mapObject === void 0 ? void 0 : mapObject.off("popupopen", this.onPopupOpen);
      mapObject === null || mapObject === void 0 ? void 0 : mapObject.off("popupclose", this.onPopupClose);
    },
    bindTooltips: function bindTooltips() {
      var mapObject = this.getMapObject();
      mapObject === null || mapObject === void 0 ? void 0 : mapObject.eachLayer(this.bindTooltip);
    },
    bindTooltip: function bindTooltip(layer) {
      var data = layer.options.data;
      var content = data ? data[this.displayField] : null;
      if (!content || typeof content !== "string") return;
      layer.bindTooltip(truncate(content, this.maxDisplayLength), {
        pane: this.tooltipPane,
        opacity: 1,
        permanent: true,
        sticky: false,
        interactive: true,
        direction: "right",
        offset: Object(external_leaflet_["point"])(this.tooltipOffsetX, this.tooltipOffsetY),
        className: "v-map-object-tooltip"
      });
    },
    onPopupOpen: function onPopupOpen(e) {
      e.layer.closeTooltip();
    },
    onPopupClose: function onPopupClose(e) {
      e.layer.openTooltip();
    }
  }
});
// CONCATENATED MODULE: ./src/components/map/v-map-tooltip-handler.vue?vue&type=script&lang=js&
 /* harmony default export */ var map_v_map_tooltip_handlervue_type_script_lang_js_ = (v_map_tooltip_handlervue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/map/v-map-tooltip-handler.vue





/* normalize component */

var v_map_tooltip_handler_component = normalizeComponent(
  map_v_map_tooltip_handlervue_type_script_lang_js_,
  v_map_tooltip_handlervue_type_template_id_e75d2a64_render,
  v_map_tooltip_handlervue_type_template_id_e75d2a64_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var v_map_tooltip_handler = (v_map_tooltip_handler_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/map/v-map-line-point-handler.vue?vue&type=script&lang=js&





/* harmony default export */ var v_map_line_point_handlervue_type_script_lang_js_ = ({
  name: "v-map-line-point-handler",
  inject: ["getMap", "getMapObject", "listenEvent", "isVisible"],
  props: {
    showEdgePoints: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: null
    },
    radius: {
      type: Number,
      default: null
    },
    pointOptions: {
      type: Object,
      default: function _default() {
        return {
          color: "#EB5757",
          fill: true,
          fillOpacity: 1,
          radius: 3
        };
      }
    }
  },
  mounted: function mounted() {
    var map = this.getMap();
    this.mapObject = Object(external_leaflet_["layerGroup"])();
    this.edgePoints = Object(external_leaflet_["layerGroup"])();
    this.mapObject.addLayer(this.edgePoints);
    if (this.isVisible()) {
      map.addLayer(this.mapObject);
    }
    this.listenEvent("data:changed", this.handleDataChanged);
    this.listenEvent("update:visible", this.handleVisible);
  },
  beforeDestroy: function beforeDestroy() {
    this.listenEvent("data:changed", this.handleDataChanged, true);
    this.listenEvent("update:visible", this.handleVisible, true);
    this.mapObject.remove();
  },
  methods: {
    handleDataChanged: function handleDataChanged() {
      this.updatePoints();
    },
    handleVisible: function handleVisible(value) {
      var map = this.getMap();
      if (value) {
        map.addLayer(this.mapObject);
      } else {
        map.removeLayer(this.mapObject);
      }
    },
    getLineLayers: function getLineLayers() {
      var result = [];
      var parentLayer = this.getMapObject();
      parentLayer.eachLayer(function (layer) {
        if (external_leaflet_["leafletUtil"].isMultiPolyline(layer) || external_leaflet_["leafletUtil"].isPolyline(layer)) {
          result.push(layer);
        }
      });
      return result;
    },
    updatePoints: function updatePoints() {
      var lineLayers = this.getLineLayers();
      if (this.showEdgePoints) {
        this.updateEdgePoints(lineLayers);
      }
    },
    updateEdgePoints: function updateEdgePoints(lines) {
      this.edgePoints.clearLayers();
      for (var k = 0; k < lines.length; k++) {
        var line = lines[k];
        var points = this.createEndPoints(line);
        for (var i = 0; i < points.length; i++) {
          this.edgePoints.addLayer(points[i]);
        }
      }
    },
    getEdgeLatLngArray: function getEdgeLatLngArray(line) {
      var result = [];
      if (external_leaflet_["leafletUtil"].isMultiPolyline(line)) {
        var latlngs = line.getLatLngs();
        for (var i = 0; i < latlngs.length; i++) {
          if (Array.isArray(latlngs[i])) {
            this.addEdgeLatLng(result, latlngs[i]);
          }
        }
      } else if (external_leaflet_["leafletUtil"].isPolyline(line)) {
        var _latlngs = line.getLatLngs();
        this.addEdgeLatLng(result, _latlngs);
      }
      return result;
    },
    addEdgeLatLng: function addEdgeLatLng(result, latlngs) {
      var first = latlngs[0];
      var last = latlngs[latlngs.length - 1];
      if (first) {
        result.push(first.clone());
      }
      if (last) {
        result.push(last.clone());
      }
    },
    createEndPoints: function createEndPoints(line) {
      var result = [];
      var edgeLatLng = this.getEdgeLatLngArray(line);
      for (var i = 0; i < edgeLatLng.length; i++) {
        result.push(this.createCircleMarker(edgeLatLng[i]));
      }
      return result;
    },
    createCircleMarker: function createCircleMarker(latlng) {
      var options = _objectSpread2({}, this.pointOptions);
      if (isDefined(this.color)) {
        options.color = this.color;
      }
      if (isDefined(this.radius)) {
        options.radius = this.radius;
      }
      return Object(external_leaflet_["circleMarker"])(latlng, options);
    }
  },
  render: function render() {
    return null;
  }
});
// CONCATENATED MODULE: ./src/components/map/v-map-line-point-handler.vue?vue&type=script&lang=js&
 /* harmony default export */ var map_v_map_line_point_handlervue_type_script_lang_js_ = (v_map_line_point_handlervue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/map/v-map-line-point-handler.vue
var v_map_line_point_handler_render, v_map_line_point_handler_staticRenderFns




/* normalize component */

var v_map_line_point_handler_component = normalizeComponent(
  map_v_map_line_point_handlervue_type_script_lang_js_,
  v_map_line_point_handler_render,
  v_map_line_point_handler_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var v_map_line_point_handler = (v_map_line_point_handler_component.exports);
// CONCATENATED MODULE: ./src/components/map/index.js

































































// CONCATENATED MODULE: ./src/components/index.js

// CONCATENATED MODULE: ./src/index.js




var src_install = function install(Vue) {
  for (var component in components_namespaceObject) {
    Vue.component(components_namespaceObject[component].name, components_namespaceObject[component]);
  }
};
if (typeof window !== 'undefined' && window.Vue) {
  src_install(window.Vue);
}
/* harmony default export */ var src_0 = ({
  install: src_install
});


// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ var entry_lib = __webpack_exports__["default"] = (src_0);



/***/ }),

/***/ "fb6a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var isArray = __webpack_require__("e8b5");
var isConstructor = __webpack_require__("68ee");
var isObject = __webpack_require__("861d");
var toAbsoluteIndex = __webpack_require__("23cb");
var lengthOfArrayLike = __webpack_require__("07fa");
var toIndexedObject = __webpack_require__("fc6a");
var createProperty = __webpack_require__("8418");
var wellKnownSymbol = __webpack_require__("b622");
var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");
var nativeSlice = __webpack_require__("f36a");

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('slice');

var SPECIES = wellKnownSymbol('species');
var $Array = Array;
var max = Math.max;

// `Array.prototype.slice` method
// https://tc39.es/ecma262/#sec-array.prototype.slice
// fallback for not array-like ES3 strings and DOM objects
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  slice: function slice(start, end) {
    var O = toIndexedObject(this);
    var length = lengthOfArrayLike(O);
    var k = toAbsoluteIndex(start, length);
    var fin = toAbsoluteIndex(end === undefined ? length : end, length);
    // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
    var Constructor, result, n;
    if (isArray(O)) {
      Constructor = O.constructor;
      // cross-realm fallback
      if (isConstructor(Constructor) && (Constructor === $Array || isArray(Constructor.prototype))) {
        Constructor = undefined;
      } else if (isObject(Constructor)) {
        Constructor = Constructor[SPECIES];
        if (Constructor === null) Constructor = undefined;
      }
      if (Constructor === $Array || Constructor === undefined) {
        return nativeSlice(O, k, fin);
      }
    }
    result = new (Constructor === undefined ? $Array : Constructor)(max(fin - k, 0));
    for (n = 0; k < fin; k++, n++) if (k in O) createProperty(result, n, O[k]);
    result.length = n;
    return result;
  }
});


/***/ }),

/***/ "fc6a":
/***/ (function(module, exports, __webpack_require__) {

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __webpack_require__("44ad");
var requireObjectCoercible = __webpack_require__("1d80");

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};


/***/ }),

/***/ "fce3":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");
var global = __webpack_require__("da84");

// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $RegExp = global.RegExp;

module.exports = fails(function () {
  var re = $RegExp('.', 's');
  return !(re.dotAll && re.exec('\n') && re.flags === 's');
});


/***/ }),

/***/ "fd92":
/***/ (function(module, exports) {



/***/ }),

/***/ "fdbc":
/***/ (function(module, exports) {

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};


/***/ }),

/***/ "fdbf":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable es/no-symbol -- required for testing */
var NATIVE_SYMBOL = __webpack_require__("04f8");

module.exports = NATIVE_SYMBOL
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';


/***/ }),

/***/ "feb3":
/***/ (function(module, exports) {



/***/ })

/******/ });
//# sourceMappingURL=visary-map-vue.common.js.map